/**
 * Returns a list of all participles used for the Polish passive voice assessment.
 * For each participle, versions for all four possible suffixes (-y, -a, -e, -i) are included.
 * @returns {Array} The list with participles.
 */
export default [
	"abdykowany",
	"absorbowany",
	"adaptowany",
	"administrowany",
	"adoptowany",
	"adorowany",
	"adresowany",
	"afiszowany",
	"agitowany",
	"akcentowany",
	"akceptowany",
	"aklimatyzowany",
	"akompaniowany",
	"aktualizowany",
	"aktywowany",
	"akumulowany",
	"alaromowany",
	"alienowany",
	"amerykanizowany",
	"amortyzowany",
	"amputowany",
	"analizowany",
	"angażowany",
	"anihilowany",
	"animowany",
	"anonsowany",
	"antropomorfizowany",
	"antydatowany",
	"anulowany",
	"apelowany",
	"aportowany",
	"aranżowany",
	"archiwizowany",
	"aresztowany",
	"argumentowany",
	"artykułowany",
	"ascendowany",
	"asekurowany",
	"asymilowany",
	"asystowany",
	"atakowany",
	"autoryzowany",
	"awanturowany",
	"babrany",
	"baczony",
	"badany",
	"bagatelizowany",
	"bajerowany",
	"bałamucony",
	"balangowany",
	"balansowany",
	"banalizowany",
	"bandażowany",
	"bankrutowany",
	"baraszkowany",
	"barwiony",
	"bawiony",
	"bazgrany",
	"bazowany",
	"bębniony",
	"bełkotany",
	"besztany",
	"biadolony",
	"biczowany",
	"bity",
	"błagany",
	"błaznowany",
	"blefowany",
	"błogosławiony",
	"blokowany",
	"bluzgany",
	"błyskany",
	"błyszczący",
	"boczony",
	"bogacony",
	"bojkotowany",
	"boksowany",
	"bombardowany",
	"bopowany",
	"borowany",
	"brandzlowany",
	"brany",
	"brasowany",
	"bratany",
	"bredzony",
	"brnięty",
	"brodzony",
	"broniony",
	"brudzony",
	"brylowany",
	"budowany",
	"budzony",
	"bujany",
	"bulony",
	"bulwersowany",
	"bumelowany",
	"burzony",
	"butelkowany",
	"bywany",
	"cackany",
	"całowany",
	"capnięty",
	"cechowany",
	"celebrowany",
	"celowany",
	"ceniony",
	"cenzurowany",
	"chciany",
	"chlany",
	"chlapany",
	"chlapnięty",
	"chlastany",
	"chłodzony",
	"chlostany",
	"chlubiony",
	"chodowany",
	"chomikowany",
	"chorowany",
	"chowany",
	"chroniony",
	"chrupany",
	"chrzczony",
	"chuty",
	"chwalony",
	"chwycony",
	"chwytany",
	"chybotany",
	"chylony",
	"ciachnięty",
	"ciągany",
	"ciągnięty",
	"ciemiężony",
	"cierpiany",
	"cieszony",
	"cięty",
	"ciskany",
	"ciśnięty",
	"ciułany",
	"cmokany",
	"cmoknięty",
	"cofany",
	"cofnięty",
	"ćpany",
	"cucony",
	"cudzołożony",
	"cumowany",
	"ćwiartowany",
	"ćwiczony",
	"cykany",
	"cytowany",
	"czajony",
	"czarowany",
	"czczony",
	"czepiany",
	"czepiony",
	"czerpany",
	"czesany",
	"częstowany",
	"czochrany",
	"czołgany",
	"czuty",
	"czytany",
	"czyty",
	"darowany",
	"darty",
	"darzony",
	"datowany",
	"dawany",
	"dbany",
	"deaktywowany",
	"debatowany",
	"dedukowany",
	"dedykowany",
	"defibrylowany",
	"defilowany",
	"definiowany",
	"defraudowany",
	"degradowany",
	"degustowany",
	"deklamowany",
	"deklarowany",
	"dekodowany",
	"dekompresowany",
	"dekorowany",
	"dekretowany",
	"delegowany",
	"delektowany",
	"deliberowany",
	"demaskowany",
	"dementowany",
	"demolowany",
	"demonizowany",
	"demonstrowany",
	"demoralizowany",
	"denerwowany",
	"denuncjowany",
	"depeszowany",
	"depilowany",
	"deportowany",
	"deprawowany",
	"deptany",
	"deratyzowany",
	"destabilizowany",
	"destylowany",
	"desygnowany",
	"determinowany",
	"detonowany",
	"dewastowany",
	"dewaulowany",
	"dezaktywowany",
	"dezorientowany",
	"dezynfekowany",
	"diagnozowany",
	"dilowany",
	"dłubany",
	"dłużony",
	"dmuchany",
	"dmuchnięty",
	"dobiegany",
	"dobierany",
	"dobijany",
	"dobity",
	"dobrany",
	"dobudzony",
	"dobyty",
	"doceniany",
	"doceniony",
	"dochodzony",
	"dochowany",
	"dochowywany",
	"dociągnięty",
	"dociekany",
	"docięty",
	"docinany",
	"dociskany",
	"dociśnięty",
	"doczekany",
	"doczepiony",
	"doczołgany",
	"doczyszczony",
	"doczytany",
	"dodany",
	"dodawany",
	"dodrukowany",
	"dodrukowywany",
	"dofinansowany",
	"dofinansowywany",
	"dogadany",
	"dogadywany",
	"dogadzany",
	"doganiany",
	"doglądany",
	"doglądnięty",
	"dognany",
	"dogodzony",
	"dogoniony",
	"dograny",
	"dogryzany",
	"dogryziony",
	"dogrzany",
	"dogrzebany",
	"doinformowany",
	"dojeżdżany",
	"dojony",
	"dojrzany",
	"dojrzewany",
	"dokańczany",
	"dokarmiany",
	"dokarmiony",
	"dokazany",
	"dokazywany",
	"dokładany",
	"doklejony",
	"dokonany",
	"dokończony",
	"dokonywany",
	"dokopany",
	"dokopywany",
	"dokowany",
	"dokręcany",
	"dokręcony",
	"dokształcany",
	"dokształcony",
	"dokuczany",
	"dokumentowany",
	"dokupiony",
	"dołączany",
	"dołączony",
	"doładowany",
	"dolany",
	"dolewany",
	"doliczony",
	"dołowany",
	"dołożony",
	"domagany",
	"domalowany",
	"domknięty",
	"domniewywany",
	"domówiony",
	"domyślany",
	"domyślony",
	"domyty",
	"doniesiony",
	"donoszony",
	"dopadany",
	"dopadnięty",
	"dopakowany",
	"dopalony",
	"dopasowany",
	"dopasowywany",
	"dopatrywany",
	"dopatrzony",
	"dopchany",
	"dopchnięty",
	"dopełniany",
	"dopełniony",
	"dopieszczony",
	"dopięty",
	"dopijany",
	"dopilnowany",
	"dopingowany",
	"dopisany",
	"dopisywany",
	"dopity",
	"dopłacany",
	"dopłacony",
	"dopłynięty",
	"dopolerowany",
	"dopompowany",
	"dopowiedziany",
	"dopracowany",
	"dopracowywany",
	"doprany",
	"doprawiony",
	"doprecyzowany",
	"doproszony",
	"doprowadzany",
	"doprowadzony",
	"dopucowany",
	"dopuszczany",
	"dopuszczony",
	"dopytywany",
	"dorabiany",
	"doradzany",
	"doradzony",
	"doręczany",
	"doręczony",
	"dorobiony",
	"dorównany",
	"dorównywany",
	"dorwany",
	"dorysowany",
	"dorzucany",
	"dorzucony",
	"doścignięty",
	"dosiadany",
	"dosięgnięty",
	"doskoczony",
	"doskonalony",
	"dosładzany",
	"dosłany",
	"dosłyszany",
	"dosolony",
	"dośrodkowany",
	"dossany",
	"dostany",
	"dostąpiony",
	"dostarczany",
	"dostarczony",
	"dostawany",
	"dostawiany",
	"dostawiony",
	"dostosowany",
	"dostosowywany",
	"dostrajany",
	"dostrojony",
	"dostrzegany",
	"dosunięty",
	"dosuwany",
	"doświadczany",
	"Doświetlony",
	"dosypany",
	"dosypywany",
	"doszkolony",
	"doszlifowany",
	"doszorowany",
	"doszukany",
	"doszukiwany",
	"doszyty",
	"dotankowany",
	"dotankowywany",
	"dotargany",
	"dotaszczony",
	"dotknięty",
	"dotleniony",
	"dotłumaczony",
	"dotowany",
	"dotrwany",
	"dotrzymany",
	"dotrzymywany",
	"dotykany",
	"douczany",
	"douczony",
	"dowalony",
	"dowieziony",
	"dowodzony",
	"dowożony",
	"doznany",
	"doznawany",
	"dozorowany",
	"dozowany",
	"dożyty",
	"dożywiony",
	"dramatyzowany",
	"drapany",
	"drapnięty",
	"draśnięty",
	"drażniony",
	"drążony",
	"dręczony",
	"drenowany",
	"drgany",
	"drgnięty",
	"drukowany",
	"dryblowany",
	"dryfowany",
	"drzemany",
	"dubbingowany",
	"dublowany",
	"duplikowany",
	"duszony",
	"dworowany",
	"dygotany",
	"dyktowany",
	"dymany",
	"dymiony",
	"dyrygowany",
	"dyscyplinowany",
	"dyskredytowany",
	"dyskryminowany",
	"dyskutowany",
	"dyskwalifikowany",
	"dysponowany",
	"dystansowany",
	"dystrybuowany",
	"dywagowany",
	"dźgany",
	"dźgnięty",
	"dziabnięty",
	"dziedziczony",
	"dziękowany",
	"dzielony",
	"dziergany",
	"dzierżony",
	"dziobany",
	"dziurawiony",
	"dziurkowany",
	"dźwigany",
	"dźwignięty",
	"edukowany",
	"edytowany",
	"egzaminowany",
	"egzekutowany",
	"egzekwowany",
	"ekscytowany",
	"ekshumowany",
	"ekskomunikowany",
	"eksmitowany",
	"ekspandowany",
	"eksperymentowany",
	"eksploatowany",
	"eksplorowany",
	"eksponowany",
	"eksportowany",
	"eksterminowany",
	"ekstradowany",
	"ekstrapolowany",
	"eliminowany",
	"emancypowany",
	"emanoway",
	"emigrowany",
	"emitowany",
	"energetyzowany",
	"eskortowany",
	"etykietowany",
	"ewakuowany",
	"ewaluowany",
	"fabrykowany",
	"falowany",
	"fałszowany",
	"farbowany",
	"faszerowany",
	"faulowany",
	"faworyzowany",
	"fechtowany",
	"fermentowany",
	"ferowany",
	"figurowany",
	"filetowany",
	"filmowany",
	"filtrowany",
	"finalizowany",
	"finansowany",
	"firmowany",
	"fleszowany",
	"folgowany",
	"formułowany",
	"forsowany",
	"fotografowany",
	"fundowany",
	"gadany",
	"ganiany",
	"garbiony",
	"gardzony",
	"garnirowany",
	"gaszony",
	"gawędzony",
	"gaworzony",
	"gazowany",
	"gdakany",
	"gderany",
	"generalizowany",
	"generowany",
	"gięty",
	"gilgotany",
	"gładzony",
	"głaskany",
	"głodowany",
	"głodzony",
	"gloryfikowany",
	"głosowany",
	"głoszony",
	"głowiony",
	"gmatwany",
	"gmerany",
	"gnany",
	"gnębiony",
	"gnieciony",
	"gnity",
	"gnojony",
	"godzony",
	"gojony",
	"golnięty",
	"golony",
	"goniony",
	"googlowany",
	"gospodarowany",
	"goszczony",
	"gotowany",
	"grabiony",
	"grany",
	"grasowany",
	"gratulowany",
	"grillowany",
	"grilowany",
	"gromadzony",
	"gromiony",
	"grożony",
	"gruchany",
	"gruchnięty",
	"grupowany",
	"grywany",
	"gryziony",
	"grzany",
	"grzechotany",
	"gubiony",
	"gustowany",
	"gwałcony",
	"gwarantowany",
	"gwizdany",
	"gwizdnięty",
	"hackowany",
	"haftowany",
	"hajtnięty",
	"hamowany",
	"hańbiony",
	"handlowany",
	"harcowany",
	"harmonizowany",
	"harowany",
	"hartowany",
	"hibernowany",
	"hipnotyzowany",
	"hodowany",
	"holowany",
	"hołubiony",
	"honorowany",
	"hospitalizowany",
	"huknięty",
	"hulany",
	"huśtany",
	"idealizowany",
	"identyfikowany",
	"ignorowany",
	"igrany",
	"ilustrowany",
	"imitowany",
	"implantowany",
	"implodowany",
	"imponowany",
	"importowany",
	"improwizowany",
	"indokrynowany",
	"indukowany",
	"infekowany",
	"infiltrowany",
	"informowany",
	"ingerowany",
	"inhalowany",
	"inscenizowany",
	"inspirowany",
	"instalowany",
	"instruowany",
	"insynuowany",
	"integrowany",
	"interpretowany",
	"interweniowany",
	"intonowany",
	"intubowany",
	"inwestowany",
	"inwigilowany",
	"irytowany",
	"iskrzony",
	"izolowany",
	"jadany",
	"jawiony",
	"jazgotany",
	"jednoczony",
	"jedzony",
	"kablowany",
	"kadzony",
	"kalany",
	"kaleczony",
	"kalkulowany",
	"kamerowany",
	"kamienowany",
	"kamuflowany",
	"kanalizowany",
	"kantowanty",
	"kąpany",
	"kapitulowany",
	"kapowany",
	"karany",
	"karbonizowany",
	"karcony",
	"karczowany",
	"karmiony",
	"kartkowany",
	"kąsany",
	"kasowany",
	"kastrowany",
	"katalogowany",
	"katapultowany",
	"katowany",
	"katrupiony",
	"kierowany",
	"kimany",
	"kiszony",
	"kiwany",
	"kiwnięty",
	"kłaniany",
	"klapany",
	"klapnięty",
	"klarowany",
	"klasyfikowany",
	"klębiony",
	"klejony",
	"klepany",
	"klepnięty",
	"klikany",
	"kliknięty",
	"klonowany",
	"kłopotany",
	"kłuty",
	"knocony",
	"knuty",
	"kochany",
	"koczowany",
	"kodowany",
	"kojarzony",
	"kojfnięty",
	"kojony",
	"kolekcjonowany",
	"kolektywizowany",
	"kolidowany",
	"kolonizowany",
	"kolorowany",
	"koloryzowany",
	"kołowany",
	"kołysany",
	"kombinowany",
	"komenderowany",
	"komentowany",
	"komercjalizowany",
	"kompensowany",
	"komplementowany",
	"komplikowany",
	"komponowany",
	"kompromitowany",
	"komunikowany",
	"konany",
	"koncentrowany",
	"kończony",
	"konfabulowany",
	"konfiskowany",
	"konfrontowany",
	"konserwowany",
	"konspirowany",
	"konstruowany",
	"konsultowany",
	"konsumowany",
	"kontaktowany",
	"kontestowany",
	"kontrastowany",
	"kontrolowany",
	"kontrowany",
	"kontynuowany",
	"kontynuuowany",
	"konwertowany",
	"konwojowany",
	"koordynowany",
	"kopany",
	"kopcony",
	"kopiowany",
	"kopnięty",
	"kopulowany",
	"korelowany",
	"korkowany",
	"koronowany",
	"korygowany",
	"korzony",
	"korzystany",
	"koszony",
	"kotwiczony",
	"kozaczony",
	"kozłowany",
	"kpity",
	"kradziony",
	"krajany",
	"krążony",
	"kręcony",
	"kremowany",
	"kreowany",
	"krochmalony",
	"krojony",
	"kropiony",
	"kruszony",
	"krystalizowany",
	"kryty",
	"krytykowany",
	"krzepnięty",
	"krzyczany",
	"krzyknięty",
	"krzywdzony",
	"krzywiony",
	"krzyżowany",
	"kserowany",
	"księgowany",
	"kształcony",
	"kształtowany",
	"kulony",
	"kultywowany",
	"kumulowany",
	"kupczony",
	"kupiony",
	"kupowany",
	"kupywany",
	"kurczony",
	"kurowany",
	"kursowany",
	"kurzony",
	"kuszony",
	"kuty",
	"kwalifikowany",
	"kwestionowany",
	"łączony",
	"ładowany",
	"łagodzony",
	"łajdaczony",
	"lakierowany",
	"łamany",
	"lamentowany",
	"lansowany",
	"lany",
	"łapany",
	"łaskotany",
	"łaszony",
	"latany",
	"łatany",
	"lawirowany",
	"leczony",
	"legalizowany",
	"legitymowany",
	"lekceważony",
	"lepiony",
	"lewitowany",
	"liberowany",
	"licencjonowany",
	"licytowany",
	"liczony",
	"likwidowany",
	"linczowany",
	"liniowany",
	"literowany",
	"litowany",
	"lizany",
	"liznięty",
	"lobbowany",
	"lokalizowany",
	"losowany",
	"łowiony",
	"łożony",
	"lubiany",
	"łudzony",
	"lunatykowany",
	"łupany",
	"łupiony",
	"łuskany",
	"lustrowany",
	"łuszczony",
	"luzowany",
	"łykany",
	"łyknięty",
	"łyżeczkowany",
	"macany",
	"machany",
	"machnięty",
	"mącony",
	"maczany",
	"maganyzowany",
	"maglowany",
	"majaczony",
	"majsterkowany",
	"majtany",
	"maksymalizowany",
	"malowany",
	"maltretowany",
	"mamiony",
	"mamrotany",
	"manewrowany",
	"manifestowany",
	"manipulowany",
	"markowany",
	"marnotrawiony",
	"marnowany",
	"marszczony",
	"marynowany",
	"marznięty",
	"masakrowany",
	"maskowany",
	"masowany",
	"masturbowany",
	"mataczony",
	"materializowany",
	"mawiany",
	"mazany",
	"maznięty",
	"męczony",
	"meldowany",
	"merdany",
	"metabolizowany",
	"miażdżony",
	"mielony",
	"mierzony",
	"mierzwiony",
	"mieszany",
	"miętolony",
	"migany",
	"migdalony",
	"migotany",
	"mijany",
	"miksowany",
	"milowany",
	"minięty",
	"minimalizowany",
	"miotany",
	"mistyfikowany",
	"mitygowany",
	"mizdrzony",
	"mlany",
	"mniemany",
	"mnożony",
	"mobilizowany",
	"mocowany",
	"moczony",
	"modelowany",
	"modernizowany",
	"modlony",
	"modulowany",
	"modyfikowany",
	"molestowany",
	"monitorowany",
	"monopolizowany",
	"montowany",
	"mordowany",
	"motywowany",
	"mówiony",
	"mrożony",
	"mrugany",
	"mrużony",
	"muskany",
	"mutowany",
	"mydlony",
	"mylony",
	"myszkowany",
	"myty",
	"nabazgrany",
	"nabiegany",
	"nabierany",
	"nabity",
	"nabrany",
	"nabrojony",
	"nabrudzony",
	"nabyty",
	"nabywany",
	"nacelowany",
	"nachapany",
	"nachodzony",
	"nachwalony",
	"nachylony",
	"naciągany",
	"naciągnięty",
	"nacierany",
	"nacięty",
	"nacinany",
	"naciskany",
	"naciśnięty",
	"nacjonalizowany",
	"naczepiony",
	"nadany",
	"nadawany",
	"nadchodzony",
	"nadciągany",
	"nadciągnięty",
	"nadcięty",
	"nadesłany",
	"nadgoniony",
	"nadgryzany",
	"nadgryziony",
	"nadinterpretowany",
	"nadłożony",
	"nadmieniany",
	"nadmieniony",
	"nadmuchany",
	"nadrabiany",
	"nadrobiony",
	"nadskakiwany",
	"nadsłuchiwany",
	"nadstawiany",
	"nadstawiony",
	"nadszarpnięty",
	"naduszony",
	"nadużyty",
	"nadużywany",
	"nadwerężany",
	"nadwyrężany",
	"nadwyrężony",
	"nadziany",
	"nadzorowany",
	"naelektryzowany",
	"nafaszerowany",
	"nagabywany",
	"nagadany",
	"nagięty",
	"naginany",
	"nagłaszany",
	"nagłośniony",
	"nagoniony",
	"nagradzany",
	"nagrany",
	"nagrodzony",
	"nagromadzony",
	"nagrywany",
	"nagryzmolony",
	"nagrzany",
	"nagrzebany",
	"nagrzewany",
	"nagwizdany",
	"naigrywany",
	"najechany",
	"najęty",
	"najmowany",
	"nakarmiany",
	"nakarmiony",
	"nakazany",
	"nakazywany",
	"nakierowany",
	"nakierowywany",
	"nakładany",
	"nakłamany",
	"nakłaniany",
	"naklejany",
	"naklejony",
	"naklepany",
	"nakłoniony",
	"nakłuty",
	"nakłuwany",
	"nakopany",
	"nakręcany",
	"nakręcony",
	"nakreślany",
	"nakreślony",
	"nakruszony",
	"nakryty",
	"nakrywany",
	"nakrzyczany",
	"nakupiony",
	"naładowany",
	"nalany",
	"nałapany",
	"nalepiony",
	"nalewany",
	"naliczony",
	"nałowiony",
	"nałożony",
	"namaczany",
	"namagnetyzowany",
	"namalowany",
	"namaszczany",
	"namaszczony",
	"namawiany",
	"namęczony",
	"namierzany",
	"namieszany",
	"namoczony",
	"namówiony",
	"namydlany",
	"namyślony",
	"naniesiony",
	"naoliwiany",
	"naoliwiony",
	"naopowiadany",
	"naostrzony",
	"napadany",
	"napadnięty",
	"napakowany",
	"napalony",
	"naparzany",
	"napastowany",
	"napawany",
	"napchany",
	"napędzany",
	"napełniany",
	"napełniony",
	"napierany",
	"napiętnowany",
	"napięty",
	"napinany",
	"napisany",
	"napluty",
	"napływany",
	"napoczęty",
	"napojony",
	"napompowany",
	"napotkany",
	"napotykany",
	"napraszany",
	"naprawiany",
	"naprawiony",
	"naprężany",
	"naprężony",
	"napromieniowany",
	"naprostowany",
	"naprowadzany",
	"naprowadzony",
	"napsuty",
	"napuszczany",
	"napuszczony",
	"napychany",
	"napytany",
	"narąbany",
	"naradzany",
	"naradzony",
	"narastany",
	"narażany",
	"narażony",
	"nareperowany",
	"narkotyzowany",
	"narodzony",
	"naruszany",
	"naruszony",
	"narwany",
	"narysowany",
	"narzucany",
	"narzucony",
	"nasączany",
	"nasączony",
	"nasadzony",
	"nasiąkany",
	"nasilany",
	"nasilony",
	"naskakiwany",
	"naskoczony",
	"naskrobany",
	"naśladowany",
	"nasłany",
	"nasłuchany",
	"nasłuchiwany",
	"nasmarowany",
	"nastąpiony",
	"nastawiany",
	"nastawiony",
	"nastraszany",
	"nastrojony",
	"nastukany",
	"nasunięty",
	"nasuwany",
	"naświetlany",
	"nasycony",
	"nasyłany",
	"nasypany",
	"naszczany",
	"naszkicowany",
	"naszpikowany",
	"naszprycowany",
	"naszykowany",
	"naszyty",
	"naszywany",
	"natarty",
	"natchnięty",
	"natknięty",
	"natleniony",
	"natłuszczony",
	"natrafiony",
	"natrząsany",
	"natrząsnięty",
	"nauczany",
	"nauczony",
	"nawadniany",
	"nawalony",
	"nawiązany",
	"nawiązywany",
	"nawiedzany",
	"nawiedzony",
	"nawiercony",
	"nawiewany",
	"nawieziony",
	"nawigowany",
	"nawijany",
	"nawilżany",
	"nawilżony",
	"nawinięty",
	"nawlekany",
	"nawodniony",
	"nawoływany",
	"nawoskowany",
	"nawożony",
	"nawpychany",
	"nawracany",
	"nawrócony",
	"nawrzucany",
	"nawtykany",
	"nawymyślany",
	"nazbierany",
	"nazmyślany",
	"naznaczany",
	"naznaczony",
	"nazrywany",
	"nazwany",
	"nazywany",
	"nęcony",
	"negocjowany",
	"negowany",
	"nękany",
	"neutralizowany",
	"niańczony",
	"niecierpliwiony",
	"niedoceniany",
	"niedowidziany",
	"nienawidzony",
	"niesiony",
	"nikolony",
	"niszczony",
	"nitkowany",
	"niuchany",
	"niweczony",
	"niwelowany",
	"nokautowany",
	"nominowany",
	"notowany",
	"nucony",
	"numerowany",
	"nurtowany",
	"obaczony",
	"obadany",
	"obalany",
	"obalony",
	"obandażowany",
	"obarczany",
	"obarczony",
	"obawiany",
	"obchodzony",
	"obciągnięty",
	"obciążony",
	"obcięty",
	"obcinany",
	"obcyndalany",
	"obczajany",
	"obczajony",
	"obdarowany",
	"obdarty",
	"obdarzany",
	"obdarzony",
	"obdzielony",
	"obdzierany",
	"obdzwaniany",
	"obdzwoniony",
	"obejmowany",
	"oberwany",
	"obessany",
	"obezwładniany",
	"obezwładniony",
	"obfotografowany",
	"obfotografowywany",
	"obgadany",
	"obgadywany",
	"obgryzany",
	"obgryziony",
	"obiecany",
	"obiecywany",
	"obierany",
	"obijany",
	"obity",
	"objadany",
	"objaśniany",
	"objawiany",
	"objawiony",
	"objechany",
	"objęty",
	"objeżdżany",
	"obkręcany",
	"oblany",
	"obłapiany",
	"obłapywany",
	"obłaskawiany",
	"obłaskawiony",
	"obleciany",
	"obleganu",
	"oblewany",
	"obliczany",
	"obliczony",
	"oblizany",
	"obłowiony",
	"obłożony",
	"obluzowany",
	"obluzowywany",
	"obmacany",
	"obmacywany",
	"obmawiany",
	"obmyślany",
	"obmyślony",
	"obmyty",
	"obmywany",
	"obnażany",
	"obniżany",
	"obniżony",
	"obnoszony",
	"obowiązywany",
	"obozowany",
	"obrabiany",
	"obrabowany",
	"obracany",
	"obradowany",
	"obramowany",
	"obraniany",
	"obrany",
	"obrastany",
	"obrażany",
	"obrażony",
	"obrobiony",
	"obrócony",
	"obrodzony",
	"obroniony",
	"obrysowany",
	"obrywany",
	"obryzgany",
	"obrzezany",
	"obrzucany",
	"obrzucony",
	"obrzygany",
	"obsadzany",
	"obsadzony",
	"obściskiwany",
	"obserwowany",
	"obsiany",
	"obsikany",
	"obsikiwany",
	"obskakiwany",
	"obskoczony",
	"obskubany",
	"obskubywany",
	"obśliniany",
	"obśliniony",
	"obsługiwany",
	"obsłużony",
	"obsmarowany",
	"obstawiany",
	"obstawiony",
	"obstrzeliwany",
	"obsunięty",
	"obsuwany",
	"obsypany",
	"obsypywany",
	"obszukany",
	"obszukiwany",
	"obtaczany",
	"obtarty",
	"obtoczony",
	"obudzony",
	"obwąchany",
	"obwąchiwany",
	"obwiązany",
	"obwiązywany",
	"obwieszany",
	"obwieszczany",
	"obwieszczony",
	"obwieszony",
	"obwijany",
	"obwiniany",
	"obwinięty",
	"obwołany",
	"obyty",
	"obżerany",
	"ocalany",
	"ocalony",
	"ocechowany",
	"oceniany",
	"oceniony",
	"ocenzurowany",
	"ochładzany",
	"ochlapany",
	"ochlapywany",
	"ochłodzony",
	"ochłonięty",
	"ochraniany",
	"ochroniony",
	"ochrzaniany",
	"ochrzczony",
	"ociągany",
	"ocielony",
	"ocieplany",
	"ocieplony",
	"ocierany",
	"ocknięty",
	"ocucony",
	"ocuty",
	"oczarowywany",
	"oczekiwany",
	"oczerniany",
	"oczerniony",
	"oczyszczany",
	"oczyszczony",
	"odarty",
	"odbębniony",
	"odbetonowany",
	"odbezpieczany",
	"odbezpieczony",
	"odbijany",
	"odbity",
	"odblokowany",
	"odbudowany",
	"odbudowywany",
	"odbutowany",
	"odbyty",
	"odcedzany",
	"odchorowany",
	"odchowany",
	"odchudzany",
	"odchudzony",
	"odchylany",
	"odchylony",
	"odciągany",
	"odciągnięty",
	"odciążony",
	"odcierpiony",
	"odcięty",
	"odcinany",
	"odcisnięty",
	"odcumowany",
	"odcyfrowany",
	"odcyfrowywany",
	"odczarowany",
	"odczekany",
	"odczepiany",
	"odczepiony",
	"odczuty",
	"odczuwany",
	"odczyniony",
	"odczytany",
	"odczytywany",
	"oddalany",
	"oddany",
	"oddawany",
	"oddelegowany",
	"oddychany",
	"oddzielany",
	"oddzielony",
	"odebrany",
	"odegnany",
	"odegrany",
	"odejmowany",
	"odepchnięty",
	"oderwany",
	"odeskortowany",
	"odesłany",
	"odespany",
	"odessany",
	"odetkany",
	"odetnięty",
	"odezwany",
	"odfiltrowany",
	"odgadnięty",
	"odgadywany",
	"odganiany",
	"odgarniany",
	"odgarnięty",
	"odgięty",
	"odgniatany",
	"odgoniony",
	"odgradzany",
	"odgrażany",
	"odgrodzony",
	"odgruzowany",
	"odgrywany",
	"odgryzany",
	"odgryziony",
	"odgrzany",
	"odgrzebany",
	"odgrzebywany",
	"odgrzewany",
	"odgwizdany",
	"odhaczony",
	"odholowany",
	"odinstalowany",
	"odizolowany",
	"odjedzony",
	"odjęty",
	"odjonizowany",
	"odkażany",
	"odkażony",
	"odkładany",
	"odklejony",
	"odkochany",
	"odkodowany",
	"odkodowywany",
	"odkopany",
	"odkopywany",
	"odkorkowany",
	"odkręcany",
	"odkręcony",
	"odkrojony",
	"odkryty",
	"odkrywany",
	"odkupiony",
	"odkupywany",
	"odkurzany",
	"odkurzony",
	"odkuty",
	"odłączany",
	"odłączony",
	"odłamywany",
	"odlany",
	"odlatywany",
	"odlepiany",
	"odlewany",
	"odliczany",
	"odliczony",
	"odłożony",
	"odłupany",
	"odmachany",
	"odmachiwany",
	"odmalowany",
	"odmarszczony",
	"odmawiany",
	"odmeldowany",
	"odmieniany",
	"odmieniony",
	"odmierzany",
	"odmierzony",
	"odmieszany",
	"odmontowany",
	"odmówiony",
	"odmrażany",
	"odmrożony",
	"odnajdowany",
	"odnaleziony",
	"odnawiany",
	"odniesiony",
	"odnoszony",
	"odnotowany",
	"odnotowywany",
	"odnowiony",
	"odpakowany",
	"odpakowywany",
	"odpalany",
	"odpalony",
	"odpałzowany",
	"odparowany",
	"odparty",
	"odpędzany",
	"odpicowany",
	"odpieczętowany",
	"odpierany",
	"odpięty",
	"odpiłowany",
	"odpiłowywany",
	"odpinany",
	"odpisany",
	"odpisywany",
	"odpłacany",
	"odplamiony",
	"odplątany",
	"odpłynięty",
	"odpowietrzony",
	"odpracowany",
	"odpracowywany",
	"odprasowany",
	"odprawiany",
	"odprawiony",
	"odprężany",
	"odprostowany",
	"odprowadzany",
	"odprowadzony",
	"odpruty",
	"odpryskany",
	"odpukany",
	"odpukiwany",
	"odpuszczany",
	"odpuszczony",
	"odpychany",
	"odrąbany",
	"odrabiany",
	"odrąbywany",
	"odradzany",
	"odradzony",
	"odrapany",
	"odrastany",
	"odratowany",
	"odreagowany",
	"odremontowany",
	"odrestaurowany",
	"odrestaurowywany",
	"odrobaczany",
	"odrobiony",
	"odroczony",
	"odrodzony",
	"odrośnięty",
	"odróżniany",
	"odróżniony",
	"odrysowany",
	"odrywany",
	"odrzucany",
	"odrzucony",
	"odsączany",
	"odsączony",
	"odsadzony",
	"odseparowany",
	"odsiadywany",
	"odsiany",
	"odsiewany",
	"odsłaniany",
	"odsłonięty",
	"odsłuchany",
	"odsłuchiwany",
	"odsłużony",
	"odśnieżany",
	"odśnieżony",
	"odsolony",
	"odśpiewany",
	"odsprzedany",
	"odsprzedawany",
	"odstąpiony",
	"odstawiany",
	"odstawiony",
	"odstępowany",
	"odstraszany",
	"odstręczony",
	"odstresowany",
	"odstrzeliwany",
	"odstrzelony",
	"odsunięty",
	"odsuwany",
	"odświeżany",
	"odświeżony",
	"odsyłany",
	"odsypywany",
	"odsysany",
	"odszczekany",
	"odszczekiwany",
	"odsztafirowany",
	"odszukany",
	"odszyfrowany",
	"odszyfrowywany",
	"odszykowany",
	"odtrąbiony",
	"odtrącony",
	"odtruty",
	"odtwarzany",
	"odtworzony",
	"oduczony",
	"odurzony",
	"odwalany",
	"odwalony",
	"odwiązany",
	"odwiązywany",
	"odwiedzany",
	"odwiedzony",
	"odwieszony",
	"odwieziony",
	"odwijany",
	"odwinięty",
	"odwlekany",
	"odwodniony",
	"odwodzony",
	"odwołany",
	"odwoływany",
	"odwożony",
	"odwracany",
	"odwrócony",
	"odwzajemniony",
	"odwzorowany",
	"odżegnany",
	"odziany",
	"odziedziczony",
	"odznaczany",
	"odznaczony",
	"odzwieciedlony",
	"odzwierciedlany",
	"odzwoniony",
	"odzwyczajony",
	"odzyskany",
	"odzyskiwany",
	"odżyty",
	"odzywiany",
	"odżywiony",
	"oferowany",
	"ofiarowany",
	"ofiarowywany",
	"ogarniany",
	"ogarnięty",
	"oglądany",
	"ogłaszany",
	"ogłoszony",
	"ogłupiany",
	"ogłupiony",
	"ogłuszony",
	"ogołocony",
	"ogolony",
	"ograbiany",
	"ograbiony",
	"ograniczany",
	"ograniczony",
	"ograny",
	"ogrodzony",
	"ogryziony",
	"ogrzany",
	"ogrzewany",
	"okablowany",
	"okaleczony",
	"okantowany",
	"okąpany",
	"okazany",
	"okazywany",
	"okiełznany",
	"okładany",
	"okłamany",
	"okłamywany",
	"oklaskiwany",
	"oklejony",
	"oklepany",
	"okopany",
	"okopywany",
	"okpiony",
	"okradany",
	"okradziony",
	"okraszony",
	"okrążany",
	"okrążony",
	"okręcany",
	"okręcony",
	"określany",
	"określony",
	"okrojony",
	"okryty",
	"okrywany",
	"okrzyknięty",
	"okulawiony",
	"okupiony",
	"okupowany",
	"olany",
	"olewany",
	"olśnięty",
	"omamiony",
	"omawiany",
	"omdlewany",
	"omijany",
	"ominięty",
	"omotany",
	"omówiony",
	"onanizowany",
	"onieśmielany",
	"onieśmielony",
	"opadnięty",
	"opakowany",
	"opalany",
	"opalony",
	"opancerzony",
	"opanowany",
	"opanowywany",
	"oparty",
	"oparzony",
	"opasany",
	"opatentowany",
	"opatrywany",
	"opatrzony",
	"opatulony",
	"opchnięty",
	"opędzany",
	"opędzony",
	"operowany",
	"opętany",
	"opętywany",
	"opieczętowany",
	"opiekowany",
	"opierany",
	"opijany",
	"opisany",
	"opisywany",
	"opity",
	"opłacany",
	"opłacony",
	"opłakany",
	"opłakiwany",
	"opłukany",
	"opluty",
	"opluwany",
	"opływany",
	"opodatkowany",
	"opodatkowywany",
	"oponowany",
	"oporządzany",
	"oporządzony",
	"opowiadany",
	"opowiedziany",
	"opóźniany",
	"opóźniony",
	"opracowany",
	"opracowywany",
	"oprawiany",
	"oprawiony",
	"oprowadzany",
	"oprowadzony",
	"opróżniany",
	"opróżniony",
	"opryskany",
	"opryskiwany",
	"opublikowany",
	"opukany",
	"opuszczany",
	"opuszczony",
	"opychany",
	"opylony",
	"orany",
	"orbowany",
	"organizowany",
	"orientowany",
	"oroszony",
	"orzekany",
	"orżnięty",
	"osaczany",
	"osaczony",
	"osadzany",
	"osądzany",
	"osadzony",
	"osądzony",
	"oscylowany",
	"osiadany",
	"osiągany",
	"osiągnięty",
	"osiedlany",
	"osiedlony",
	"osiedzony",
	"osierocony",
	"osiodłany",
	"oskalpowany",
	"oskarżony",
	"oskrobany",
	"oskrzydlany",
	"oskrzydlony",
	"oskubany",
	"oskubywany",
	"osłabiany",
	"osłabiony",
	"oślepiany",
	"oślepiony",
	"oślepnięty",
	"ośliniany",
	"osłodzony",
	"osłoniony",
	"osłuchany",
	"osmalony",
	"ośmielony",
	"ośmieszany",
	"ośmieszony",
	"ostrzegany",
	"ostrzelany",
	"ostrzelity",
	"ostrzony",
	"ostudzony",
	"osunięty",
	"osuszany",
	"osuszony",
	"osuwany",
	"oswajany",
	"oświadczany",
	"oświadczony",
	"oświecany",
	"oświeciony",
	"oświetlany",
	"oświetlony",
	"oswobadzany",
	"oswobodzony",
	"oswojony",
	"oszacowany",
	"oszałamiany",
	"oszczany",
	"oszczędzany",
	"oszczędzony",
	"oszklony",
	"oszlifowany",
	"oszołomiony",
	"oszpecony",
	"oszukany",
	"oszukiwany",
	"oszwabiony",
	"otaczany",
	"otarty",
	"otoczony",
	"otruty",
	"otruwany",
	"otrząsany",
	"otrząśnięty",
	"otrzepany",
	"otrzeźwiony",
	"otrzymany",
	"otrzymywany",
	"otulony",
	"otumaniony",
	"otwierany",
	"otworzony",
	"otwarty",
	"owany",
	"owdowiony",
	"owiany",
	"owijany",
	"owinięty",
	"ozdabiany",
	"ozdobiony",
	"ozdrowiony",
	"ożeniony",
	"oznaczany",
	"oznaczony",
	"oznajmiany",
	"oznajmiony",
	"oznakowany",
	"ożyty",
	"ożywany",
	"ożywiany",
	"ożywiony",
	"pachnący",
	"pacnąty",
	"pakowany",
	"paktowany",
	"pałany",
	"pałaszowany",
	"palnięty",
	"palony",
	"pamiętany",
	"panoszony",
	"paprany",
	"parafrazowany",
	"paraliżowany",
	"parkowany",
	"parowany",
	"partaczony",
	"parzony",
	"pastowany",
	"paszony",
	"patrolowany",
	"patroszony",
	"patrzony",
	"pauzowany",
	"pchany",
	"pchnięty",
	"pdholowany",
	"pedałowany",
	"pękany",
	"pęknięty",
	"pełniony",
	"penetrowany",
	"perforowany",
	"perfumowany",
	"perswadowany",
	"piastowany",
	"pichcony",
	"pielęgnowany",
	"pielony",
	"pieniony",
	"pieszczony",
	"piętnowany",
	"pięty",
	"pijany",
	"pikietowany",
	"piknikowany",
	"pikowany",
	"pilnowany",
	"pilotowany",
	"piłowany",
	"pisany",
	"pisywany",
	"pity",
	"płacony",
	"plądrowany",
	"plamiony",
	"planowany",
	"płaszczony",
	"plątany",
	"płatany",
	"pławiony",
	"plewiony",
	"płonący",
	"płoszony",
	"plotkowany",
	"plugawiony",
	"płukany",
	"pluskany",
	"pluty",
	"pobaraszkowany",
	"pobierany",
	"pobity",
	"pobłażany",
	"pobłogosławiony",
	"pobrany",
	"pobrudzony",
	"pobudzany",
	"pobudzony",
	"pobujany",
	"pocałowany",
	"pocerowany",
	"pochłaniany",
	"pochlapany",
	"pochlebiany",
	"pochłonięty",
	"pochowany",
	"pochwalany",
	"pochwalony",
	"pochwycony",
	"pochylany",
	"pochylony",
	"pociachany",
	"pociągany",
	"pociągnięty",
	"pocierany",
	"pocieszany",
	"pocieszony",
	"pocięty",
	"pocony",
	"pocukrowany",
	"poćwiartowany",
	"poczesany",
	"poczęstowany",
	"poczęty",
	"poczochrany",
	"poczuty",
	"poczytany",
	"poczytywany",
	"podany",
	"podarowany",
	"podarty",
	"podawany",
	"podążony",
	"podbierany",
	"podbijany",
	"podbity",
	"podbudowany",
	"podbudowywany",
	"podburzany",
	"podburzony",
	"podchwycony",
	"podciągany",
	"podciągnięty",
	"podcierany",
	"podcięty",
	"podcinany",
	"podczepiony",
	"poddany",
	"poddawany",
	"podebrany",
	"podejmowany",
	"podejrzany",
	"podejrzewany",
	"podelektowany",
	"podeptany",
	"poderwany",
	"podesłany",
	"podglądany",
	"podgolony",
	"podgoniony",
	"podgryzany",
	"podgrzany",
	"podgrzewany",
	"podjadany",
	"podjedzony",
	"podjęty",
	"podkablowany",
	"podkarmiony",
	"podkładany",
	"podklejony",
	"podkolorowany",
	"podkołowany",
	"podkopany",
	"podkopywany",
	"podkradany",
	"podkradnięty",
	"podkręcany",
	"podkręcony",
	"podkreślany",
	"podkreślony",
	"podkształcony",
	"podkulony",
	"podkupiony",
	"podkurzony",
	"podkuty",
	"podłączany",
	"podłączony",
	"podładowany",
	"podłamany",
	"podlany",
	"podłapany",
	"podleczony",
	"podlegany",
	"podlewany",
	"podliczany",
	"podliczony",
	"podlizany",
	"podlizywany",
	"podłożony",
	"podmalowany",
	"podmieniany",
	"podmieniony",
	"podmuchany",
	"podmyty",
	"podnajęty",
	"podniecany",
	"podniecony",
	"podniesiony",
	"podnoszony",
	"podołany",
	"podopingowany",
	"podostrzony",
	"podotykany",
	"podpadnięty",
	"podpalany",
	"podpalony",
	"podparty",
	"podpatrywany",
	"podpatrzony",
	"podpieczętowany",
	"podpiekany",
	"podpierany",
	"podpięty",
	"podpiłowany",
	"podpinany",
	"podpisany",
	"podpisywany",
	"podpłacony",
	"podpłynięty",
	"podpompowany",
	"podporządkowany",
	"podporządkowywany",
	"podpowiadany",
	"podpowiedziany",
	"podprowadzany",
	"podpuszczany",
	"podpuszczony",
	"podpychany",
	"podpytany",
	"podrabiany",
	"podrapany",
	"podrasowany",
	"podratowany",
	"podrażniony",
	"podręczony",
	"podregulowany",
	"podreperowany",
	"podretuszowany",
	"podrobiony",
	"podroczony",
	"podróżowany",
	"podrygiwany",
	"podrywany",
	"podrzucany",
	"podrzucony",
	"podrzynany",
	"podsadzony",
	"podskubywany",
	"podsłuchany",
	"podsłuchiwany",
	"podsmażany",
	"podsmażony",
	"podśpiewywany",
	"podstawiany",
	"podstawiony",
	"podstemplowany",
	"podstrojony",
	"podsumowany",
	"podsumowywany",
	"podsunięty",
	"podsuwany",
	"podświetlany",
	"podsycany",
	"podsycony",
	"podsyłany",
	"podsypany",
	"podszczypywany",
	"podszkolony",
	"podszlifowany",
	"podszykowany",
	"podszyty",
	"podszywany",
	"podtapiany",
	"podtarty",
	"podtopiony",
	"podtrzymany",
	"podtrzymywany",
	"podtuczony",
	"poduczany",
	"podupadany",
	"poduszony",
	"podwajany",
	"podwalany",
	"podważany",
	"podwędzony",
	"podwiązany",
	"podwieszany",
	"podwieziony",
	"podwijany",
	"podwinięty",
	"podwojony",
	"podwożony",
	"podwyżany",
	"podwyższany",
	"podwyższony",
	"podyktowany",
	"podyskutowany",
	"podziabany",
	"podziałany",
	"podziałkowany",
	"podziękowany",
	"podzielony",
	"podziurawiony",
	"podziwiany",
	"podźwignięty",
	"poeksperymentowany",
	"pofarbowany",
	"pofatygowany",
	"pofilmowany",
	"poganiany",
	"pogardzany",
	"pogardzony",
	"pogarszany",
	"pogaszony",
	"pogładzony",
	"pogłaskany",
	"pogłębiany",
	"pogłębiony",
	"pogłośniony",
	"pogmatwany",
	"pognębiony",
	"pognieciony",
	"pogodzony",
	"pogoniony",
	"pogorszony",
	"pogotowany",
	"pograbiony",
	"pogrążany",
	"pogrążony",
	"pogrożony",
	"pogrubiany",
	"pogrubiony",
	"pogruchany",
	"pogruchotany",
	"pogrupowany",
	"pogrywany",
	"pogryzany",
	"pogryziony",
	"pogrzany",
	"pogrzebany",
	"pogubiony",
	"pogwałcany",
	"pohamowany",
	"pohandlowany",
	"poharatowany",
	"pohuśtany",
	"poinformowany",
	"poinstruowany",
	"pojednany",
	"pojęty",
	"pojmięty",
	"pojmowany",
	"pojony",
	"pokajany",
	"pokaleczony",
	"pokarany",
	"pokarmiony",
	"pokąsany",
	"pokatalogowany",
	"pokazany",
	"pokazywany",
	"pokiereszowany",
	"pokierowany",
	"pokiwany",
	"pokładany",
	"poklepany",
	"poklepywany",
	"pokłoniony",
	"pokłuty",
	"pokochany",
	"pokolorowany",
	"pokoloryzowany",
	"pokołysany",
	"pokombinowany",
	"pokomplikowany",
	"pokonany",
	"pokończony",
	"pokonywany",
	"pokopany",
	"pokrajany",
	"pokrążony",
	"pokręcony",
	"pokrojony",
	"pokruszony",
	"pokryty",
	"pokrywany",
	"pokrzepiany",
	"pokrzepiony",
	"pokrzyżowany",
	"pokuszony",
	"pokutowany",
	"połączony",
	"polakierowany",
	"połamany",
	"polany",
	"połapany",
	"połaskotany",
	"połatany",
	"polecany",
	"połechtany",
	"polecony",
	"poleczony",
	"polegany",
	"polemizowany",
	"polepszany",
	"polepszony",
	"polerowany",
	"polewany",
	"policzkowany",
	"policzony",
	"polimeryzowany",
	"polizany",
	"połknięty",
	"polowany",
	"połowiony",
	"położony",
	"polubiony",
	"poluźniony",
	"poluzowany",
	"połykany",
	"pomacany",
	"pomachany",
	"pomagany",
	"pomalowany",
	"pomarynowany",
	"pomasowany",
	"pomazany",
	"pomęczony",
	"pomiatany",
	"pomieszany",
	"pomieszczony",
	"pomijany",
	"pominięty",
	"pomiziany",
	"pomknięty",
	"pomnażany",
	"pomniejszany",
	"pomniejszony",
	"pomnożony",
	"pomoczony",
	"pompowany",
	"pomydlony",
	"pomylony",
	"pomyszkowany",
	"pomywany",
	"ponabijany",
	"ponaciskany",
	"ponadziewany",
	"ponaglany",
	"ponaglony",
	"ponagrywany",
	"ponaklejany",
	"ponakłuwany",
	"ponakrywany",
	"ponaprawiany",
	"ponawiany",
	"poniańczony",
	"poniechany",
	"ponieiwerany",
	"poniesiony",
	"poniszczony",
	"poniżany",
	"poniżony",
	"ponoszony",
	"ponowiony",
	"ponudzony",
	"poobcinany",
	"poobcowany",
	"poobczajany",
	"poobijany",
	"poobmacywany",
	"poobracany",
	"poobserwowany",
	"poodbijany",
	"poodcinany",
	"poodgryzany",
	"poodkurzany",
	"poodprawiany",
	"poodsuwany",
	"poodwalany",
	"pooglądany",
	"poograniczany",
	"poopalany",
	"poopiekany",
	"poopwiadany",
	"pootwierany",
	"popadany",
	"popakowany",
	"popalony",
	"poparty",
	"poparzony",
	"popchany",
	"popchnięty",
	"popędzany",
	"popędzony",
	"popękany",
	"popełniany",
	"popełniony",
	"poperfumowany",
	"popierany",
	"popieszczony",
	"popijany",
	"popilnowany",
	"popisany",
	"popity",
	"popłacony",
	"popłakiwany",
	"poplamiony",
	"poplątany",
	"popluskany",
	"popodcinany",
	"popodziwiany",
	"popoprawiany",
	"poprany",
	"poprasowany",
	"poprawiany",
	"poprawiony",
	"poproszony",
	"poprowadzony",
	"popryskany",
	"poprzebierany",
	"poprzeciągany",
	"poprzecinany",
	"poprzedzany",
	"poprzeglądany",
	"poprzeklinany",
	"poprzekopywany",
	"poprzemieszczany",
	"poprzenoszony",
	"poprzesadzany",
	"poprześladowany",
	"poprzestawiany",
	"poprzesuwany",
	"poprzewieszany",
	"poprzewracany",
	"poprzycinany",
	"poprzymierzany",
	"poprzytulany",
	"poprzywiązywany",
	"popsuty",
	"popudrowany",
	"popukany",
	"popularyzowany",
	"popuszczany",
	"popuszczony",
	"popychany",
	"popykany",
	"popytany",
	"porabiany",
	"porachowany",
	"poraniony",
	"poratowany",
	"porażony",
	"poręczony",
	"porównany",
	"porozbierany",
	"porozbijany",
	"porozciągany",
	"porozcinany",
	"porozdawany",
	"porozdzielany",
	"porozmieszczany",
	"poróżniony",
	"porozpędzany",
	"porozpieszczany",
	"porozprowadzany",
	"porozpruwany",
	"porozrzucany",
	"porozstawiany",
	"porozsyłany",
	"porozumiewany",
	"porozwalany",
	"porozwiązywany",
	"porozwieszany",
	"porozwożony",
	"portretowany",
	"poruszany",
	"poruszony",
	"porwany",
	"porysowany",
	"porywany",
	"porządkowany",
	"porządzony",
	"porzucany",
	"porzucony",
	"posądzany",
	"posadzony",
	"posądzony",
	"pościągany",
	"pościelony",
	"pościerany",
	"pościgany",
	"pościnany",
	"pościskany",
	"posegregowany",
	"posiadany",
	"posiany",
	"posiekany",
	"posilany",
	"posiłkowany",
	"posilony",
	"posiłowany",
	"posiniaczony",
	"posiorbany",
	"poskąpiony",
	"poskładany",
	"posklejany",
	"poskramiany",
	"poskręcany",
	"poskrobany",
	"poskromiony",
	"poskubany",
	"posłany",
	"posłodzony",
	"poślubiany",
	"poślubiony",
	"posługiwany",
	"posmakowany",
	"posmarowany",
	"posolony",
	"posortowany",
	"pospekulowany",
	"pospieszany",
	"pośpieszany",
	"pośpiewany",
	"pospinany",
	"pospłacany",
	"posprawdzany",
	"posprzątany",
	"posprzedawany",
	"pośredniczony",
	"possany",
	"postanowiony",
	"postany",
	"postarany",
	"postawiony",
	"postemplowany",
	"posterowany",
	"postradany",
	"postraszony",
	"postrugany",
	"postrzegany",
	"postrzelany",
	"postrzelony",
	"postukany",
	"postymulowany",
	"posunięty",
	"posuwany",
	"poświącany",
	"poświadczony",
	"poświecony",
	"poświęcony",
	"poświętowany",
	"poświntuszony",
	"posyłany",
	"posypany",
	"posypywany",
	"poszarpany",
	"poszastany",
	"poszatkowany",
	"poszczuty",
	"poszczycony",
	"poszczypany",
	"poszerzany",
	"poszerzony",
	"poszorowany",
	"poszpiegowany",
	"poszturchany",
	"poszukany",
	"poszukiwany",
	"poszwędany",
	"poszybowany",
	"potakiwany",
	"potarmoszony",
	"potarty",
	"potasowany",
	"potęgowany",
	"potępiany",
	"potępiony",
	"potknięty",
	"potoczony",
	"potopiony",
	"potorturowany",
	"potrącany",
	"potrącony",
	"potraktowany",
	"potrojony",
	"potruty",
	"potrząsany",
	"potrzaskany",
	"potrząsnięty",
	"potrząśnięty",
	"potrzymany",
	"Poturbowany",
	"poturlany",
	"potwierdzony",
	"potykany",
	"poucinany",
	"pouczany",
	"pouczony",
	"poudawany",
	"poukładany",
	"pouprawiany",
	"poupychany",
	"pourywany",
	"poustawiany",
	"poużywany",
	"powąchany",
	"powachlowany",
	"powalany",
	"powalony",
	"poważany",
	"powbijany",
	"powciągany",
	"powciskany",
	"powdychany",
	"powęszony",
	"powetowany",
	"powiadamiany",
	"powiadomiony",
	"powiązany",
	"powiedziany",
	"powiedzony",
	"powiększany",
	"powielany",
	"powielony",
	"powierzany",
	"powierzony",
	"powieszony",
	"powiewany",
	"powinszowany",
	"powitany",
	"powity",
	"powkładany",
	"powlekany",
	"powłóczony",
	"powodowany",
	"powołany",
	"powoływany",
	"powożony",
	"powpychany",
	"powrócony",
	"powrzucany",
	"powsadzany",
	"powściągnięty",
	"powspominany",
	"powstrzymany",
	"powtarzany",
	"powtórzony",
	"powybierany",
	"powybijany",
	"powycierany",
	"powycinany",
	"powyciskany",
	"powydawany",
	"powyganiany",
	"powyginany",
	"powyjaśniany",
	"powyjmowany",
	"powyłączany",
	"powymiatany",
	"powymieniany",
	"powynoszony",
	"powypełniany",
	"powypisywany",
	"powyrywany",
	"powyrzucany",
	"powystrzelany",
	"powysyłany",
	"powywalany",
	"powywieszany",
	"powywracany",
	"powzięty",
	"pozabawiany",
	"pozabijany",
	"pozacierany",
	"pożądany",
	"pożądlony",
	"pozadzierany",
	"pozakładany",
	"pozaklinany",
	"pozałatwiany",
	"pozamiatany",
	"pozamieniany",
	"pozamrażany",
	"pozamykany",
	"pozapalany",
	"pozapinany",
	"pozapisywany",
	"pozapraszany",
	"pożarty",
	"pozasłaniany",
	"pozastrzelany",
	"pozatykany",
	"pozbawiany",
	"pozbawiony",
	"pozbierany",
	"pozbyty",
	"pozbywany",
	"pozdejmowany",
	"pozdrawiany",
	"pozdrowiony",
	"pożegnany",
	"pożerany",
	"pozmiatany",
	"pozmieniany",
	"pozmywany",
	"poznaczony",
	"poznany",
	"poznawany",
	"poznęcany",
	"pozorowany",
	"pozostawiany",
	"pozostawiony",
	"pozowany",
	"pozrywany",
	"pozszywany",
	"pożuty",
	"pozwalniany",
	"pozwany",
	"pozwiązywany",
	"pozwiedzany",
	"pozwolony",
	"pożyczany",
	"pożyczony",
	"pozyskany",
	"pożyty",
	"pozywany",
	"pożywiany",
	"pożywiony",
	"praktykowany",
	"prany",
	"prasowany",
	"prawiony",
	"prażony",
	"precyzowany",
	"preferowany",
	"prenumerowany",
	"prezentowany",
	"próbowany",
	"procesowany",
	"produkowany",
	"profanowany",
	"profilowany",
	"prognozowany",
	"programowany",
	"projektowany",
	"proklamowany",
	"prolongowany",
	"promieniowany",
	"promowany",
	"propagowany",
	"proponowany",
	"prosperowany",
	"prostowany",
	"proszkowany",
	"proszony",
	"protestowany",
	"protokołowany",
	"prowadzony",
	"prowokowany",
	"pruty",
	"pryskany",
	"pryśnięty",
	"przeanalizowany",
	"przearanżowany",
	"przebaczany",
	"przebaczony",
	"przebadany",
	"przebiegnięty",
	"przebierany",
	"przebijany",
	"przebity",
	"przebolony",
	"przebrany",
	"przebudowany",
	"przebudowywany",
	"przebudzany",
	"przebudzony",
	"przebukowany",
	"przebyty",
	"przebywany",
	"przeceniany",
	"przeceniony",
	"przechlapany",
	"przechodzony",
	"przechowany",
	"przechowywany",
	"przechrzcony",
	"przechwycony",
	"przechwytywany",
	"przechylany",
	"przechylony",
	"przechytrzany",
	"przechytrzony",
	"przeciągany",
	"przeciągnięty",
	"przeciążany",
	"przeciążony",
	"przeciekany",
	"przecierany",
	"przecierpiany",
	"przecięty",
	"przecinany",
	"przeciskany",
	"przeciśnięty",
	"przeciwstawiany",
	"przećwiczony",
	"przeczekany",
	"przeczesany",
	"przeczesywany",
	"przeczołgany",
	"przeczuty",
	"przeczuwany",
	"przeczyszczony",
	"przeczytany",
	"przedarty",
	"przedawkowany",
	"przedawkowywany",
	"przedekorowany",
	"przedłożony",
	"przedłużany",
	"przedłużony",
	"przedmuchany",
	"przedobrzony",
	"przedostany",
	"przedostawany",
	"przedsiewzięty",
	"przedstawiany",
	"przedstawiony",
	"przedymany",
	"przedyskutowany",
	"przedzierany",
	"przedziurawiony",
	"przedziurkowany",
	"przeegzaminowany",
	"przefaksowany",
	"przefarbowany",
	"przefasonowany",
	"przefasowany",
	"przefaxowany",
	"przefiltrowany",
	"przeformowany",
	"przeforsowany",
	"przegadany",
	"przeganany",
	"przeganiany",
	"przegapiany",
	"przegapiony",
	"przegięty",
	"przeginany",
	"przeglądany",
	"przeglądnięty",
	"przegłodzony",
	"przegłosowany",
	"przegoniony",
	"przegotowany",
	"przegotowywany",
	"przegrabiony",
	"przegradzany",
	"przegrany",
	"przegrupowany",
	"przegrupowywany",
	"przegrywany",
	"przegryzany",
	"przegryziony",
	"przegrzany",
	"przegrzebany",
	"przegrzewany",
	"przehandlowany",
	"przeholowany",
	"przeinstalowany",
	"przeistoczony",
	"przejadany",
	"przejaskrawiany",
	"przejaśniony",
	"przejawiany",
	"przejawiony",
	"przejechany",
	"przejęty",
	"przejeżdżany",
	"przejmowany",
	"przejrzany",
	"przekabacany",
	"przekabacony",
	"przekablowany",
	"przekalibrowany",
	"przekalkulowany",
	"przekarmiany",
	"przekąszony",
	"przekazywany",
	"przekierowany",
	"przekierowywany",
	"przekimany",
	"przekładany",
	"przeklejony",
	"przeklęty",
	"przeklinany",
	"przeklnięty",
	"przekłuty",
	"przekonany",
	"przekonfigurowany",
	"przekonstruowany",
	"przekonwertowany",
	"przekonywany",
	"przekopany",
	"przekopywany",
	"przekoziołkowany",
	"przekraczany",
	"przekręcany",
	"przekręcony",
	"przekreślany",
	"przekreślony",
	"przekroczony",
	"przekrojony",
	"przekrzyczony",
	"przekrzywiony",
	"przekształcany",
	"przekształcony",
	"przekupiony",
	"przekupywany",
	"przekuty",
	"przekwalifikowany",
	"przełączany",
	"przełączony",
	"przeładowany",
	"przeładowywany",
	"przełamany",
	"przełamywany",
	"przelany",
	"przelatywany",
	"przeleciany",
	"przelewany",
	"przeleżany",
	"przelicytowany",
	"przeliczany",
	"przeliczony",
	"przeliterowany",
	"przełknięty",
	"przełożony",
	"przełykany",
	"przełyknięty",
	"przemalowany",
	"przemalowywany",
	"przemaszerowany",
	"przemawiany",
	"przemeblowany",
	"przemęczony",
	"przemielony",
	"przemieniany",
	"przemierzony",
	"przemieszczany",
	"przemieszczony",
	"przemijany",
	"przemilczany",
	"przemilczony",
	"przeminięty",
	"przemknięty",
	"przemodelowany",
	"przemusztrowany",
	"przemycany",
	"przemycony",
	"przemyślany",
	"przemyślony",
	"przemyty",
	"przemywany",
	"przenegocjowany",
	"przeniesiony",
	"przenikany",
	"przeniknięty",
	"przenoszony",
	"przeobrażany",
	"przeobrażony",
	"przeoczany",
	"przeoczony",
	"przeorany",
	"przeorganizowany",
	"przeorientowany",
	"przepadany",
	"przepakowany",
	"przepalony",
	"przeparkowany",
	"przepchany",
	"przepchnięty",
	"przepędzany",
	"przepędzony",
	"przepełniany",
	"przepełniony",
	"przepijany",
	"przepiłowany",
	"przepisany",
	"przepisywany",
	"przepity",
	"przepłacany",
	"przepłacony",
	"przepłakany",
	"przeplanowany",
	"przepłoszony",
	"przepłukany",
	"przepłukiwany",
	"przepłynięty",
	"przepływany",
	"przepompowany",
	"przepompowywany",
	"przepowiadany",
	"przepowiedziany",
	"przepracowany",
	"przepracowywany",
	"przeprany",
	"przeprawiany",
	"przeprawiony",
	"przeprogramowany",
	"przeprojektowany",
	"przeprowadzany",
	"przeprowadzony",
	"przepuszczany",
	"przepuszczony",
	"przepychany",
	"przepytany",
	"przepytywany",
	"przerąbany",
	"przerabiany",
	"przeradzany",
	"przerastany",
	"przerażony",
	"przeredagowany",
	"przerejestrowany",
	"przerobiony",
	"przerodzony",
	"przerośnięty",
	"przerwany",
	"przerysowany",
	"przerywany",
	"przerzedzany",
	"przerzucany",
	"przerzucony",
	"przesączony",
	"przesadzany",
	"przesądzany",
	"przesadzony",
	"przesądzony",
	"prześcigany",
	"prześcignięty",
	"przesiadany",
	"przesiadywany",
	"przesiany",
	"przesiedlany",
	"przesiedlony",
	"przesiedziany",
	"przesiewany",
	"przesilony",
	"przeskakiwany",
	"przeskalowany",
	"przeskanowany",
	"przeskoczony",
	"przeskrobany",
	"prześladowany",
	"przesłaniany",
	"przesłany",
	"prześledzony",
	"prześlizgnięty",
	"przesłodzony",
	"przesłonięty",
	"przesłuchany",
	"przesłuchiwany",
	"przesmarowany",
	"przesolony",
	"przesortowany",
	"przespany",
	"prześpiewany",
	"przessany",
	"przestawiany",
	"przestawiony",
	"przestemplowany",
	"przestraszony",
	"przestrojony",
	"przestrzegany",
	"przestrzelony",
	"przestudiowany",
	"przesunięty",
	"przesuwany",
	"prześwietlany",
	"prześwietlony",
	"przesyłany",
	"przesypany",
	"przesypiany",
	"przesypywany",
	"przeszarżowany",
	"przeszczepiany",
	"przeszczepiony",
	"przeszkadzany",
	"przeszkolony",
	"przeszmuglowany",
	"przeszukany",
	"przeszukiwany",
	"przeszyty",
	"przeszywany",
	"przetaczany",
	"przetańczony",
	"przetapetowany",
	"przetarty",
	"przetestowany",
	"przetkany",
	"przetoczony",
	"przetopiony",
	"przetrącony",
	"przetransformowany",
	"przetransmitowany",
	"przetransponowany",
	"przetransportowany",
	"przetrawiony",
	"przetrwany",
	"przetrząsany",
	"przetrząśnięty",
	"przetrzepany",
	"przetrzymany",
	"przetrzymywany",
	"przetwarzany",
	"przetworzony",
	"przewalany",
	"przewalczony",
	"przewaletowany",
	"przewalony",
	"przeważany",
	"przeważony",
	"przewertowany",
	"przewiązany",
	"przewiązywany",
	"przewidywany",
	"przewidziany",
	"przewiercany",
	"przewiercony",
	"przewieszany",
	"przewieszony",
	"przewietrzony",
	"przewieziony",
	"przewijany",
	"przewinięty",
	"przewitany",
	"przewodniczony",
	"przewodzony",
	"przewożony",
	"przewracany",
	"przewrócony",
	"przewyższany",
	"przeymierzany",
	"przeżarty",
	"przeżeglowany",
	"przeżegnany",
	"przeziębiony",
	"przezimowany",
	"przeznaczany",
	"przeznaczony",
	"przeżuty",
	"przezwyciężany",
	"przezwyciężony",
	"przeżyty",
	"przezywany",
	"przeżywany",
	"przodowany",
	"przpochlebiony",
	"przwdziewany",
	"przybastowany",
	"przybierany",
	"przybijany",
	"przybity",
	"przybliżany",
	"przybliżony",
	"przybrany",
	"przycelowany",
	"przycepiony",
	"przychylony",
	"przyciągany",
	"przyciągnięty",
	"przyciemniony",
	"przycięty",
	"przycinany",
	"przyciskany",
	"przyciśnięty",
	"przyciszony",
	"przyćmiewany",
	"przyćmiony",
	"przycumowany",
	"przyczepiany",
	"przyczesany",
	"przyczołgany",
	"przyczyniony",
	"przydepnięty",
	"przydeptany",
	"przyduszony",
	"przydzielany",
	"przydzielony",
	"przygarnięty",
	"przygaszony",
	"przygazowany",
	"przygładzany",
	"przygnębiany",
	"przygniatany",
	"przygnieciony",
	"przygotowany",
	"przygruchany",
	"przygrywany",
	"przygryzany",
	"przygryziony",
	"przygrzany",
	"przygwożdżony",
	"przyhamowany",
	"przyholowany",
	"przyjany",
	"przyjęty",
	"przyjmowany",
	"przyjrzany",
	"przykładany",
	"przyklejony",
	"przyklepany",
	"przykopany",
	"przykręcany",
	"przykręcony",
	"przykrócony",
	"przykryty",
	"przykrywany",
	"przykurzony",
	"przykuty",
	"przykuwany",
	"przyłączany",
	"przyłączony",
	"przylany",
	"przyłapany",
	"przylegany",
	"przylepiany",
	"przylepiony",
	"przyłożony",
	"przymierzony",
	"przymilany",
	"przymknięty",
	"przymocowany",
	"przymuszany",
	"przynależony",
	"przyniesiony",
	"przynoszony",
	"przynudzany",
	"przyostrzony",
	"przyozdabiany",
	"przyozdobiony",
	"przypadnięty",
	"przypakowany",
	"przypakowywany",
	"przypalany",
	"przypalony",
	"przyparty",
	"przypasowany",
	"przypatrywany",
	"przypatrzony",
	"przypieczętowany",
	"przypiekany",
	"przypierany",
	"przypięty",
	"przypilnowany",
	"przypiłowany",
	"przypinany",
	"przypisany",
	"przypisywany",
	"przypłacony",
	"przyplątany",
	"przypłynięty",
	"przypodobany",
	"przypominany",
	"przypomniany",
	"przyporządkowany",
	"przyprawiany",
	"przyprawiony",
	"przyprowadzony",
	"przypucowany",
	"przypudrowany",
	"przypuszczany",
	"przypuszczony",
	"przyrównany",
	"przyrządzany",
	"przyrządzony",
	"przysiadany",
	"przysiągnięty",
	"przyskrzydlony",
	"przyskrzyniany",
	"przyskrzyniony",
	"przysłaniany",
	"przysłany",
	"przysłodzony",
	"przysłoniony",
	"przysłuchiwany",
	"przysługiwany",
	"przysłużony",
	"przysmażany",
	"przysmażony",
	"przyspieszany",
	"przyspieszony",
	"przysporzony",
	"przysposobiony",
	"przyśrubowywany",
	"przyssany",
	"przystąpiony",
	"przystawiany",
	"przystawiony",
	"przystemplowany",
	"przystopowany",
	"przystosowany",
	"przystrojony",
	"przysunięty",
	"przysuwany",
	"przyswajany",
	"przyświecany",
	"przyświęcony",
	"przyswojony",
	"przysyłany",
	"przysypany",
	"przyszpilony",
	"przyszykowany",
	"przyszyty",
	"przyszywany",
	"przytaczany",
	"przytargany",
	"przytarty",
	"przytaszczany",
	"przytępiany",
	"przytępiony",
	"przytkany",
	"przytłaczany",
	"przytłoczony",
	"przytłumiony",
	"przytoczony",
	"przytrafiony",
	"przytroczony",
	"przytruwany",
	"przytrzasnięty",
	"przytrzymany",
	"przytrzymywany",
	"przytulany",
	"przytulony",
	"przytwierdzany",
	"przytwierdzony",
	"przytykany",
	"przyuczony",
	"przyuważony",
	"przywabiony",
	"przywalany",
	"przywalony",
	"przywarowany",
	"przywarty",
	"przywdziany",
	"przywiązany",
	"przywiązywany",
	"przywidziany",
	"przywieziony",
	"przywitany",
	"przywłaszczany",
	"przywłaszczony",
	"przywołany",
	"przywoływany",
	"przywożony",
	"przywracany",
	"przywrócony",
	"przyznaczony",
	"przyznany",
	"przyznawany",
	"przyzwalany",
	"przyzwany",
	"przyzwyczajany",
	"przyzwyczajony",
	"przyzywany",
	"psiamany",
	"pstrykany",
	"pstryknięty",
	"psuty",
	"publikowany",
	"puchnięty",
	"pucowany",
	"pudłowany",
	"pudrowany",
	"puknięty",
	"punktowany",
	"pustoszony",
	"puszczany",
	"puszczony",
	"puszkowany",
	"puszony",
	"pykany",
	"pytany",
	"rabowany",
	"rachowany",
	"racjonalizowany",
	"racjonowany",
	"raczony",
	"radowany",
	"raniony",
	"raportowany",
	"ratowany",
	"ratyfikowany",
	"reaktywowany",
	"realizowany",
	"reanimowany",
	"recytowany",
	"ręczony",
	"redagowany",
	"redukowany",
	"reformowany",
	"refowany",
	"regenerowany",
	"regionalizowany",
	"regulowany",
	"reinkarnowany",
	"rejestrowany",
	"reklamowany",
	"rekomendowany",
	"rekompensowany",
	"rekonstruowany",
	"rekreowany",
	"rekrutowany",
	"rekwirowany",
	"relacjonowany",
	"relaksowany",
	"remodulowany",
	"remontowany",
	"renegocjowany",
	"reorganizowany",
	"reperowany",
	"replikowany",
	"represejonowany",
	"reprezentowany",
	"reprodukowany",
	"resetowany",
	"resocjalizowany",
	"respektowany",
	"resuscytowany",
	"retuszowany",
	"rewanżowany",
	"rewidowany",
	"rezerwowany",
	"rezonowany",
	"rezygnowany",
	"reżyserowany",
	"robiony",
	"rodzony",
	"rojony",
	"rolowany",
	"romansowany",
	"roniony",
	"rozbawiany",
	"rozbawiony",
	"rozbierany",
	"rozbijany",
	"rozbity",
	"rozbłyśnięty",
	"rozbrajany",
	"rozbrojony",
	"rozbudowany",
	"rozbudowywany",
	"rozbudzany",
	"rozbudzony",
	"rozbujany",
	"rozcapierzony",
	"rozchmurzony",
	"rozchodzony",
	"rozchylany",
	"rozchylony",
	"rozciągany",
	"rozciągnięty",
	"rozcieńczany",
	"rozcieńczony",
	"rozcierany",
	"rozcięty",
	"rozcinany",
	"rozczarowany",
	"rozczarowywany",
	"rozczesany",
	"rozczłonkowany",
	"rozczulany",
	"rozczytany",
	"rozdany",
	"rozdawany",
	"rozdeptany",
	"rozdmuchany",
	"rozdmuchiwany",
	"rozdrabniany",
	"rozdrapany",
	"rozdrapywany",
	"rozdrażniany",
	"rozdrażniony",
	"rozduszony",
	"rozdwojony",
	"rozdysponowany",
	"rozdzielany",
	"rozdzielony",
	"rozdzierany",
	"rozdziewiczony",
	"rozebrany",
	"rozedrany",
	"rozegrany",
	"rozegrywany",
	"rozepchany",
	"rozerwany",
	"rozesłany",
	"rozgarnięty",
	"rozgaszczany",
	"rozgięty",
	"rozglaszany",
	"rozgłoszony",
	"rozgniatany",
	"rozgnieciony",
	"rozgniewany",
	"rozgoniony",
	"rozgraniczony",
	"rozgrany",
	"rozgromiony",
	"rozgrywany",
	"rozgryzany",
	"rozgryziony",
	"rozgrzany",
	"rozgrzebywany",
	"rozgrzeszony",
	"rozgrzewany",
	"rozhuśtany",
	"rozjaśniany",
	"rozjaśniony",
	"rozjechany",
	"rozjedzony",
	"rozjuszany",
	"rozjuszony",
	"rozkazany",
	"rozkazywany",
	"rozkładany",
	"rozklejany",
	"rozklejony",
	"rozkołysany",
	"rozkopany",
	"rozkopywany",
	"rozkoszowany",
	"rozkręcany",
	"rozkręcony",
	"rozkrojony",
	"rozkruszony",
	"rozkuty",
	"rozkuwany",
	"rozkwaszony",
	"rozkwaterowany",
	"rozkwitany",
	"rozkwitnięty",
	"rozłączony",
	"rozładowany",
	"rozładowywany",
	"rozłamany",
	"rozlany",
	"rozlewany",
	"rozliczany",
	"rozliczony",
	"rozlokowany",
	"rozłożony",
	"rozłupany",
	"rozluźniany",
	"rozmanażany",
	"rozmasowany",
	"rozmawiany",
	"rozmazany",
	"rozmazywany",
	"rozmiękczony",
	"rozmieniany",
	"rozmieniony",
	"rozmieszczany",
	"rozmieszczony",
	"rozminięty",
	"rozmnożony",
	"rozmontowany",
	"rozmówiony",
	"rozmrażany",
	"rozmrożony",
	"rozmyślany",
	"rozmyty",
	"różnicowany",
	"rozniecany",
	"roznieciony",
	"rozniesiony",
	"różniony",
	"roznoszony",
	"rozochocony",
	"rozpaczany",
	"rozpakowany",
	"rozpakowywany",
	"rozpalany",
	"rozpalony",
	"rozpamiętywany",
	"rozpaskudzany",
	"rozpatrywany",
	"rozpatrzony",
	"rozpędzany",
	"rozpędzony",
	"rozpętany",
	"rozpieszczany",
	"rozpieszczony",
	"rozpięty",
	"rozpiłowany",
	"rozpinany",
	"rozpisany",
	"rozpisywany",
	"rozplanowany",
	"rozpłaszczany",
	"rozpłaszczony",
	"rozplątany",
	"rozplątywany",
	"rozpłynięty",
	"rozpoczęty",
	"rozpoczynany",
	"rozpogodzony",
	"rozporządzany",
	"rozporządzony",
	"rozpościerany",
	"rozpostrzony",
	"rozpowiadany",
	"rozpowiedziany",
	"rozpowszechniany",
	"rozpowszechniony",
	"rozpoznany",
	"rozpoznawany",
	"rozpracowany",
	"rozpraszany",
	"rozprawiany",
	"rozprawiczony",
	"rozprawiony",
	"rozprostowany",
	"rozproszony",
	"rozprowadzany",
	"rozprowadzony",
	"rozpruty",
	"rozpruwany",
	"rozprzestrzeniany",
	"rozprzestrzeniony",
	"rozpuszczany",
	"rozpuszczony",
	"rozpychany",
	"rozpylany",
	"rozpylony",
	"rozpytany",
	"rozpytywany",
	"rozrastany",
	"rozreklamowany",
	"rozrobiony",
	"rozrośnięty",
	"rozróżniany",
	"rozróżniony",
	"rozruszany",
	"rozrysowany",
	"rozrywany",
	"rozrzucany",
	"rozsadzany",
	"rozsadzony",
	"rozsądzony",
	"rozścielony",
	"rozsiany",
	"rozsiekany",
	"rozsiewany",
	"rozsiodłany",
	"rozsławiany",
	"rozsławiony",
	"rozsmarowany",
	"rozsmarowywany",
	"rozśmieszany",
	"rozstany",
	"rozstąpiony",
	"rozstawany",
	"rozstawiany",
	"rozstawiony",
	"rozstrojony",
	"rozstrząsany",
	"rozstrzeliwany",
	"rozstrzelony",
	"rozstrzygany",
	"rozstrzygnięty",
	"rozsunięty",
	"rozsupłany",
	"rozświetlany",
	"rozświetlony",
	"rozsyłany",
	"rozsypany",
	"rozsypywany",
	"rozszarpany",
	"rozszarpywany",
	"rozszczepiany",
	"rozszczepiony",
	"rozszerzany",
	"rozszerzony",
	"rozszyfrowany",
	"roztaczany",
	"roztapiany",
	"roztarty",
	"roztoczony",
	"roztopiony",
	"roztrwoniony",
	"roztrząsany",
	"roztrzaskany",
	"rozumiany",
	"rozumowany",
	"rozwalany",
	"rozwalony",
	"rozwarty",
	"rozważany",
	"rozważony",
	"rozweselany",
	"rozweselony",
	"rozwiany",
	"rozwiązany",
	"rozwiązywany",
	"rozwidniany",
	"rozwiedziony",
	"rozwierany",
	"rozwiercony",
	"rozwieszany",
	"rozwieszony",
	"rozwiewany",
	"rozwieziony",
	"rozwikłany",
	"rozwinięty",
	"rozwlekany",
	"rozwodzony",
	"rozwścieczany",
	"rozwścieczony",
	"rozzłoszczony",
	"rugany",
	"ruinowany",
	"rujnowany",
	"runięty",
	"ruszany",
	"ruszony",
	"rwany",
	"ryczany",
	"ryglowany",
	"rymowany",
	"rysowany",
	"ryty",
	"ryzykowany",
	"rządzony",
	"rzeźbiony",
	"rżnięty",
	"rzucany",
	"rzucony",
	"rzygany",
	"sabotażowany",
	"sączony",
	"sadzany",
	"sadzony",
	"sądzony",
	"salutowany",
	"salwowany",
	"sankcjonowany",
	"satysfakcjonowany",
	"scalony",
	"scementowany",
	"scentrowany",
	"scharakteryzowany",
	"schładzany",
	"schlany",
	"schlapany",
	"schlebiony",
	"schłodzony",
	"schowany",
	"schroniony",
	"schrupany",
	"schrzaniony",
	"schwytany",
	"schylany",
	"ściągnięty",
	"ścielony",
	"ściemniany",
	"ściemniony",
	"ścierany",
	"ścierpiony",
	"ścięty",
	"ścigany",
	"ścinany",
	"ściskany",
	"ściśnięty",
	"ściszany",
	"ściszony",
	"sędziowany",
	"segregowany",
	"selekcjonowany",
	"separowany",
	"sępiony",
	"serwowany",
	"sfabrykowany",
	"sfajczony",
	"sfałszowany",
	"sfaulowany",
	"sfilmowany",
	"sfinalizowany",
	"sfinansowany",
	"sfingowany",
	"sformalizowany",
	"sformatowany",
	"sformowany",
	"sformułowany",
	"sforsowany",
	"sfotografowany",
	"shimmerowany",
	"siany",
	"siekany",
	"siorbany",
	"skadrowany",
	"skakany",
	"skalany",
	"skaleczony",
	"skalibrowany",
	"skalkulowany",
	"skalpowany",
	"skanalizowany",
	"skandowany",
	"skanowany",
	"skapitulowany",
	"skarcony",
	"skarżony",
	"skasowany",
	"skatalogowany",
	"skazany",
	"skażony",
	"skazywany",
	"skierowany",
	"składany",
	"składowany",
	"skłaniany",
	"sklasyfikowany",
	"skleciony",
	"sklejany",
	"sklejony",
	"sklepany",
	"skłócony",
	"skłoniony",
	"sklonowany",
	"sknocony",
	"skojarzony",
	"skolonizowany",
	"skołowany",
	"skombinowany",
	"skomentowany",
	"skompensowany",
	"skompletowany",
	"skomplikowany",
	"skomponowany",
	"skompresowany",
	"skompromitowany",
	"skomunikowany",
	"skonany",
	"skoncentrowany",
	"skończony",
	"skondensowany",
	"skonfigurowany",
	"skonfiskowany",
	"skonfrontowany",
	"skonkretyzowany",
	"skonsolidowany",
	"skonstruowany",
	"skonsultowany",
	"skonsumowany",
	"skontaktowany",
	"skontrolowany",
	"skoordynowany",
	"skopany",
	"skopiowany",
	"skorektowany",
	"skorumpowany",
	"skorygowany",
	"skorzystany",
	"skoszony",
	"skracany",
	"skradziony",
	"skręcany",
	"skręcony",
	"skremowany",
	"skreślany",
	"skreślony",
	"skrobany",
	"skrobnięty",
	"skrócony",
	"skrojony",
	"skropiony",
	"skruszony",
	"skrystalizowany",
	"skryty",
	"skrytykowany",
	"skrywany",
	"skrzecowany",
	"skrzepnięty",
	"skrzyczany",
	"skrzyty",
	"skrzywdzony",
	"skrzyżowany",
	"skserowany",
	"skubany",
	"skubnięty",
	"skulony",
	"skumulowany",
	"skupiany",
	"skupiony",
	"skupowany",
	"skurczony",
	"skuszony",
	"skuty",
	"skuwany",
	"skwitowany",
	"słany",
	"sławiony",
	"śledzony",
	"śliniony",
	"ślizgany",
	"słodzony",
	"słuchany",
	"słyszany",
	"smagany",
	"smarowany",
	"smażony",
	"śmiecony",
	"smuty",
	"smyrany",
	"snuty",
	"sondowany",
	"sortowany",
	"spafycikowany",
	"spakowany",
	"spalany",
	"spałaszowany",
	"spalony",
	"spałowany",
	"spamiętany",
	"spaprany",
	"sparafrazowany",
	"sparaliżowany",
	"sparowany",
	"spartaczony",
	"spartolony",
	"sparzony",
	"spasowany",
	"spatałaszony",
	"spauzowany",
	"spawany",
	"spawiony",
	"specjalizowany",
	"spędzany",
	"spędzony",
	"spekulowany",
	"spełniany",
	"spełniony",
	"spenetrowany",
	"spętany",
	"spierany",
	"spięty",
	"śpiewany",
	"spiłowany",
	"spinany",
	"spisany",
	"spiskowany",
	"spisywany",
	"spity",
	"spłacany",
	"spłacony",
	"splądrowany",
	"splajtowany",
	"splamiony",
	"spłaszczony",
	"splatany",
	"splątany",
	"spłatany",
	"spławiany",
	"spławiony",
	"spłodzony",
	"spłonięty",
	"spłoszony",
	"spłukany",
	"spłukiwany",
	"spluwany",
	"spływany",
	"spoczęty",
	"spoczywany",
	"spodziewany",
	"spojony",
	"spolaryzowany",
	"spoliczkowany",
	"sponiewierany",
	"sponsorowany",
	"spopielany",
	"spopielony",
	"spopularyzowany",
	"sportretowany",
	"sporządzany",
	"sporządzony",
	"spostrzegany",
	"spotęgowany",
	"spotkany",
	"spotykany",
	"spoufalany",
	"spowalniany",
	"spowiadany",
	"spowodowany",
	"spowolniony",
	"spoźniony",
	"spóźniony",
	"spożytkowany",
	"spożyty",
	"spożywany",
	"sprany",
	"sprasowany",
	"spraszany",
	"sprawdzony",
	"sprawiony",
	"sprawowany",
	"sprecyzowany",
	"spreparowany",
	"sprężany",
	"sprężony",
	"spróbowany",
	"sprofanowany",
	"sprofilowany",
	"sprostowany",
	"sproszkowany",
	"sproszony",
	"sprowadzany",
	"sprowadzony",
	"sprowokowany",
	"spryskany",
	"spryskiwany",
	"sprywatyzowany",
	"sprzątany",
	"sprzątnięty",
	"sprzeczany",
	"sprzedany",
	"sprzedawany",
	"sprzeniewierzony",
	"spudłowany",
	"spustoszony",
	"spuszczany",
	"spuszczony",
	"spychany",
	"ssany",
	"stabilizowany",
	"stacjonowany",
	"staczany",
	"staranowany",
	"starczany",
	"stargowany",
	"startowany",
	"stawiany",
	"stawiony",
	"stemplowany",
	"stenografowany",
	"stepowany",
	"sterowany",
	"sterroryzowany",
	"sterylizowany",
	"stłamszony",
	"stłumiony",
	"stnięty",
	"stoczony",
	"stołowany",
	"stonowany",
	"stopiony",
	"stopniowany",
	"storpedowany",
	"stosowany",
	"strącany",
	"stracony",
	"strącony",
	"strajkowany",
	"straszony",
	"stratowany",
	"strawiony",
	"streamowany",
	"stresowany",
	"streszczany",
	"streszczony",
	"strofowany",
	"strojony",
	"stroszony",
	"strugany",
	"struty",
	"strymowany",
	"strząsany",
	"strzaskany",
	"strząśnięty",
	"strzelony",
	"strzepany",
	"strzępiony",
	"strzepnięty",
	"strzepywany",
	"studiowany",
	"studzony",
	"stukany",
	"stuknięty",
	"stulony",
	"stwardniony",
	"stwarzany",
	"stwierdzany",
	"stwierdzony",
	"stworzony",
	"stykany",
	"stylizowany",
	"stymulowany",
	"sugerowany",
	"sumowany",
	"sunięty",
	"swatany",
	"swawolony",
	"świadczony",
	"świecony",
	"święcony",
	"świerzbiony",
	"świętowany",
	"świntuszony",
	"sycony",
	"sygnalizowany",
	"symulowany",
	"synchronizowany",
	"sypany",
	"sypnięty",
	"szachrowany",
	"szacowany",
	"szafowany",
	"szamotany",
	"szanowany",
	"szargany",
	"szarpany",
	"szarpnięty",
	"szarżowany",
	"szasowany",
	"szastany",
	"szatkowany",
	"szczędzony",
	"szczepiony",
	"szczerzony",
	"szczuty",
	"szczycony",
	"szczypany",
	"szczytowany",
	"szefowany",
	"szemrany",
	"szepnięty",
	"szeptany",
	"szerzony",
	"szkalowany",
	"szkicowany",
	"szklony",
	"szkodzony",
	"szkolony",
	"szlachtowany",
	"szlifowany",
	"szmuglowany",
	"szokowany",
	"szorowany",
	"szpachlowany",
	"szpanowany",
	"szperany",
	"szprycowany",
	"sztachnięty",
	"szturchany",
	"szturchnięty",
	"szturmowany",
	"szufladkowany",
	"szuflowany",
	"szukany",
	"szulerowany",
	"szwankowany",
	"szydełkowany",
	"szydzony",
	"szyfrowany",
	"szykanowany",
	"szykowany",
	"szyty",
	"taktowany",
	"tamowany",
	"tankowany",
	"tapetowany",
	"taplany",
	"taranowany",
	"targany",
	"targnięty",
	"targowany",
	"tarmoszony",
	"tarty",
	"tarzany",
	"tasowany",
	"taszczony",
	"tatuowany",
	"tchnięty",
	"telefonowany",
	"telegrfowany",
	"teleportowany",
	"temperowany",
	"teoretyzowany",
	"tępiony",
	"terroryzowany",
	"testowany",
	"tkany",
	"tknięty",
	"tłamszony",
	"tłoczony",
	"tłumaczony",
	"tłumiony",
	"toczony",
	"tolerowany",
	"tonowany",
	"topiony",
	"torowany",
	"torturowany",
	"towarzyszony",
	"trąbiony",
	"trącany",
	"tracony",
	"trącony",
	"trafiany",
	"trafiony",
	"tragizowany",
	"traktowany",
	"transferowany",
	"transformowany",
	"transmitowany",
	"transportowany",
	"tratowany",
	"trawiony",
	"trenowany",
	"tresowany",
	"triumfowany",
	"tropiony",
	"troszczony",
	"truty",
	"trwoniony",
	"trymowany",
	"tryskany",
	"tryśnięty",
	"tryumfowany",
	"trywializowany",
	"trzaskany",
	"trzasnięty",
	"trzepany",
	"trzepnięty",
	"trzepotany",
	"trzęsiony",
	"trzymany",
	"tuczony",
	"tułany",
	"tulony",
	"turlany",
	"tuszowany",
	"twistowany",
	"tworzony",
	"tykany",
	"tyranizowany",
	"tyrany",
	"tytułowany",
	"uaktualniany",
	"uaktualniony",
	"uaktywniany",
	"uaktywniony",
	"uargumentowany",
	"uatrakcyjniony",
	"ubabrany",
	"ubarwiany",
	"ubarwiony",
	"ubawiony",
	"ubezpieczany",
	"ubezpieczony",
	"ubezwłasnowolniony",
	"ubiczowany",
	"ubiegany",
	"ubierany",
	"ubijany",
	"ubity",
	"ubłagany",
	"ubliżany",
	"ubliżony",
	"ubolewany",
	"ubóstwiany",
	"ubrany",
	"ubroczony",
	"ubrudzony",
	"ucałowany",
	"ucharakteryzowany",
	"uchowany",
	"uchroniony",
	"uchwalany",
	"uchwalony",
	"uchwycony",
	"uchylany",
	"uchylony",
	"uciągnięty",
	"ucieleśniany",
	"ucierany",
	"ucierpiany",
	"ucięty",
	"ucinany",
	"uciskany",
	"uciśnięty",
	"uciszany",
	"uciszony",
	"uciułany",
	"ucywilizowany",
	"uczczony",
	"uczepiony",
	"uczesany",
	"uczęszczany",
	"uczony",
	"ucztowany",
	"uczuty",
	"uczyniony",
	"udany",
	"udaremniony",
	"udawany",
	"udekorowany",
	"udeptywany",
	"uderzany",
	"uderzony",
	"udobruchany",
	"udokumentowany",
	"udomawiany",
	"udomowiony",
	"udoskonalany",
	"udoskonalony",
	"udostępniany",
	"udostępniony",
	"udowadniany",
	"udowodniony",
	"Udramatyzowany",
	"udręczony",
	"udrożniony",
	"udupiony",
	"uduszony",
	"udzielany",
	"udzielony",
	"udźwignięty",
	"ueiwarygodniony",
	"ufany",
	"ufarbowany",
	"uformowany",
	"ufortyfikowany",
	"ufundowany",
	"ugadany",
	"uganiany",
	"ugaszany",
	"ugaszony",
	"ugięty",
	"uginany",
	"ugłaskany",
	"ugniatany",
	"ugodzony",
	"ugoszczony",
	"ugotowany",
	"ugrany",
	"ugruntowany",
	"ugryziony",
	"ugrzęznięty",
	"uhistoryzowany",
	"uhonorowany",
	"uiścity",
	"ujadany",
	"ujarzmiany",
	"ujarzmiony",
	"ujawniany",
	"ujawniony",
	"ujęty",
	"ujeżdżany",
	"ujeżdżony",
	"ujmowany",
	"ujrzany",
	"ukamieniowany",
	"ukarany",
	"ukartowany",
	"ukąszony",
	"ukatrupiony",
	"ukazany",
	"ukazywany",
	"ukierowany",
	"ukierunkowany",
	"układany",
	"uklepany",
	"ukłoniony",
	"ukłuty",
	"uknuty",
	"ukojony",
	"ukołysany",
	"ukończony",
	"ukonkretniony",
	"ukoronowany",
	"ukradziony",
	"ukręcany",
	"ukręcony",
	"ukrojony",
	"ukryty",
	"ukrywany",
	"ukrzyżowany",
	"ukształtowany",
	"ukuty",
	"ułagodzony",
	"ułaskawiany",
	"ułaskawiony",
	"ulatniany",
	"ułatwiany",
	"ułatwiony",
	"uleczany",
	"uleczony",
	"ulegany",
	"ulepiony",
	"ulepszany",
	"ulepszony",
	"ulokowany",
	"ulotniony",
	"ułożony",
	"umacniany",
	"umalowany",
	"umartwiany",
	"umawiany",
	"umazany",
	"umeblowany",
	"umiejscowiony",
	"umieszczany",
	"umieszczony",
	"umilany",
	"umilony",
	"umknięty",
	"umniejszany",
	"umniejszony",
	"umocniony",
	"umocowany",
	"umoczony",
	"umodelowany",
	"umorzony",
	"umotywowany",
	"umówiony",
	"umożliwiany",
	"umożliwiony",
	"umroczniony",
	"umyty",
	"unaoczniony",
	"unicestwiany",
	"unicestwiony",
	"uniemożliwainy",
	"uniemożliwiony",
	"unierochomiony",
	"uniesiony",
	"unieszczęśliwiany",
	"unieszczęśliwiony",
	"unieszkodliwiany",
	"unieszkodliwiony",
	"unieważniany",
	"unieważniony",
	"uniewinniony",
	"uniezależniony",
	"unikany",
	"uniknięty",
	"unormowany",
	"unoszony",
	"unowoczesniany",
	"unowocześniany",
	"uodporniony",
	"uogólniany",
	"upakowany",
	"upalany",
	"upalony",
	"upamiętniany",
	"upamiętniony",
	"upaństwowiony",
	"upaprany",
	"uparty",
	"upaskudzony",
	"upchany",
	"upchnięty",
	"upewniany",
	"upewniony",
	"upgradowany",
	"upichcony",
	"upiększany",
	"upiększony",
	"upierany",
	"upierdolony",
	"upięty",
	"upijany",
	"upilnowany",
	"upinany",
	"upity",
	"uplastyczniony",
	"upłynięty",
	"upodabniany",
	"upodobniony",
	"upojony",
	"upokorzany",
	"upokorzony",
	"upolowany",
	"upominany",
	"uporządkowany",
	"upowszechniony",
	"upozorowany",
	"upozowany",
	"uprany",
	"uprasowany",
	"upraszczany",
	"uprawdopodobniony",
	"uprawiany",
	"uproszczony",
	"uproszony",
	"uprowadzany",
	"uprowadzony",
	"uprzątany",
	"uprzątnięty",
	"uprzedony",
	"uprzedzany",
	"uprzyjemniany",
	"uprzyjemniony",
	"uprzykrzany",
	"uprzytomniony",
	"upubliczniany",
	"upubliczniony",
	"upudrowany",
	"upuszczany",
	"upuszczony",
	"upychany",
	"urabiany",
	"uraczany",
	"uradowany",
	"Urągany",
	"uratowany",
	"urażany",
	"urażony",
	"uregulowany",
	"urobiony",
	"uroniony",
	"urośnięty",
	"urozmaicany",
	"urozmaicony",
	"uruchamiany",
	"uruchomiony",
	"urwany",
	"urywany",
	"urządzany",
	"urządzony",
	"urzeczywistniany",
	"urzeczywistniony",
	"urżnięty",
	"usadowiony",
	"usadzony",
	"usamowolniony",
	"usankcjonowany",
	"usatyfakcjonowany",
	"uschnięty",
	"uściskany",
	"uścislony",
	"uściśnięty",
	"usidlony",
	"usiedzony",
	"uskładany",
	"uskoczony",
	"uskuteczniany",
	"uskuteczniony",
	"usłuchany",
	"usługiwany",
	"usłużony",
	"usłyszany",
	"usmażony",
	"uśmiany",
	"uśmiercany",
	"uśmiercony",
	"uśmierzony",
	"uspany",
	"uśpiony",
	"uspokajany",
	"uspokojony",
	"uspołeczniany",
	"usprawiedliwiany",
	"usprawiedliwiony",
	"usprawniony",
	"usprzątany",
	"ustabilizowany",
	"ustalany",
	"ustalony",
	"ustanawiany",
	"ustanowiony",
	"ustąpiony",
	"ustatkowany",
	"ustawiany",
	"ustawiony",
	"ustępowany",
	"ustosunkowany",
	"ustrojony",
	"ustrzegany",
	"ustrzelony",
	"usunięty",
	"ususzony",
	"usuwany",
	"uświadamiany",
	"uświadczony",
	"uświadomiony",
	"uświęcony",
	"uświniony",
	"usychany",
	"usypany",
	"usypiany",
	"usystematyzowany",
	"usytuowany",
	"uszanowany",
	"uszczelniany",
	"uszczęśliwiany",
	"uszczęśliwiony",
	"uszczuplony",
	"uszczypnięty",
	"uszkadzany",
	"uszkodzony",
	"uszlachetniany",
	"uszlachetniony",
	"usztywniony",
	"uszykowany",
	"uszyty",
	"utajniony",
	"utargowany",
	"utarty",
	"utemperowany",
	"utkany",
	"utknięty",
	"utkwiony",
	"utoczony",
	"utopiony",
	"utorowany",
	"utożsamiany",
	"utożsamiony",
	"utracony",
	"utrącony",
	"utrudniany",
	"utrudniony",
	"utrwalany",
	"utrwalony",
	"utrzymywany",
	"utuczony",
	"utulony",
	"utwierdzany",
	"utwierdzony",
	"utworzony",
	"utylizowany",
	"uwalniany",
	"uwalony",
	"uwarunkowany",
	"uważany",
	"uwiązany",
	"uwiązywany",
	"uwidoczniony",
	"uwieczniany",
	"uwieczniony",
	"uwielbiany",
	"uwielbiony",
	"uwieńczony",
	"uwierany",
	"uwierzony",
	"uwieszony",
	"uwieziony",
	"uwięziony",
	"uwijany",
	"uwikłany",
	"uwinięty",
	"uwity",
	"uwłaczany",
	"uwłaszczony",
	"uwodzony",
	"uwolniony",
	"uwsteczniany",
	"uwsteczniony",
	"uwydatniany",
	"uwypiklony",
	"uwzględniany",
	"uwzględniony",
	"użądlony",
	"uzależniany",
	"uzależniony",
	"uzasadniany",
	"uzasadniony",
	"uzbierany",
	"uzbrajany",
	"uzbrojony",
	"uzdrawiany",
	"uzdrowiony",
	"użerany",
	"uzewnętrzniany",
	"uzewnętrzniony",
	"uzgadniany",
	"uzgodniony",
	"uziemiony",
	"uzmysłowiony",
	"uznany",
	"uznawany",
	"uzupełniany",
	"uzupełniony",
	"uzurpowany",
	"użyczany",
	"użyczony",
	"uzyskany",
	"uzyskiwany",
	"użyty",
	"używany",
	"wabiony",
	"wąchany",
	"wachlowany",
	"wahany",
	"walczony",
	"wałkowany",
	"walnięty",
	"walony",
	"ważony",
	"wbijany",
	"wbity",
	"wcelowany",
	"wchłonięty",
	"wciągany",
	"wciągnięty",
	"wcielany",
	"wcielony",
	"wcierany",
	"wcięty",
	"wcinany",
	"wciskany",
	"wciśnięty",
	"wczepiony",
	"wczołgany",
	"wczuty",
	"wczytany",
	"wczytywany",
	"wdany",
	"wdarty",
	"wdawany",
	"wdepnięty",
	"wdeptany",
	"wdetonowany",
	"wdmuchiwany",
	"wdrapany",
	"wdrapywany",
	"wdrażany",
	"wdrążony",
	"wdrożony",
	"wduszony",
	"wdychany",
	"wdzierany",
	"wędkowany",
	"wentylowany",
	"wepchany",
	"wepchnięty",
	"werbowany",
	"weryfikowany",
	"wessany",
	"wetkany",
	"wetknięty",
	"wezwany",
	"wgłębiany",
	"wgniatany",
	"wgnieciony",
	"wgrany",
	"wgryzany",
	"wgryziony",
	"wiązany",
	"wibrowany",
	"widywany",
	"widziany",
	"wiedzony",
	"wielbiony",
	"wiercony",
	"wierzgany",
	"wierzony",
	"wieszany",
	"wietrzony",
	"więżony",
	"wikłany",
	"windowany",
	"winszowany",
	"wiosłowany",
	"wirowany",
	"witany",
	"wity",
	"wizualizowany",
	"wjeżdżany",
	"wkalkulowany",
	"wkładany",
	"wklejany",
	"wklejony",
	"wklepany",
	"wkłuty",
	"wkomponowany",
	"wkopany",
	"wkopywany",
	"wkraczany",
	"wkradany",
	"wkradziony",
	"wkręcany",
	"wkręcony",
	"wkupiony",
	"wkurwiany",
	"wkuty",
	"wkuwany",
	"włączany",
	"włączony",
	"władany",
	"władowany",
	"włamany",
	"włamywany",
	"wlany",
	"wlepiany",
	"wlepiony",
	"wlewany",
	"wliczany",
	"wliczony",
	"włożony",
	"wmanewrowany",
	"wmanipulowany",
	"wmawiany",
	"wmieszany",
	"wmówiony",
	"wmurowany",
	"wmuszony",
	"wnerwiany",
	"wnerwiony",
	"wniesiony",
	"wnikany",
	"wniknięty",
	"wnioskowany",
	"wnoszony",
	"wodowany",
	"wojowany",
	"wołany",
	"woskowany",
	"wożony",
	"wpajany",
	"wpakowany",
	"wparowany",
	"wpasowany",
	"wpatrywany",
	"wpędzany",
	"wpędzony",
	"wperswadowany",
	"wpieniony",
	"wpięty",
	"wpisany",
	"wpisywany",
	"wpłacany",
	"wpłacony",
	"wplatany",
	"wplątany",
	"wplątywany",
	"wpojony",
	"wpompowany",
	"wpraszany",
	"wprawiany",
	"wproszony",
	"wprowadzany",
	"wprowadzony",
	"wpuszczony",
	"wpychany",
	"wrabiany",
	"wręczany",
	"wrobiony",
	"wróżony",
	"wryty",
	"wrzucany",
	"wrzucony",
	"wrzynany",
	"wsadzany",
	"wsadzony",
	"wskazany",
	"wskazywany",
	"wskórany",
	"wskrzeszany",
	"wskrzeszony",
	"wślizgiwany",
	"wślizgnięty",
	"wsłuchany",
	"wsparty",
	"wspierany",
	"wspięty",
	"współczuty",
	"współodczuwany",
	"współtworzony",
	"współżyty",
	"wspomagany",
	"wspominany",
	"wspomniany",
	"wstąpiony",
	"wstawiany",
	"wstawiony",
	"wstrząsany",
	"wstrząśnięty",
	"wstrzelony",
	"wstrzykiwany",
	"wstrzyknięty",
	"wstrzymany",
	"wstrzymywany",
	"wstukany",
	"wsunięty",
	"wsuwany",
	"wsypany",
	"wszamany",
	"wszczepiany",
	"wszczepiony",
	"wszczęty",
	"wszczynany",
	"wszyty",
	"wtajemniczany",
	"wtajemniczony",
	"wtapiany",
	"wtargnięty",
	"wtarty",
	"wtaszczony",
	"wtłoczony",
	"wtopiony",
	"wtrącony",
	"wtryniany",
	"wtulany",
	"wtulony",
	"wtykany",
	"wwalony",
	"wwiercany",
	"wwiercony",
	"wwieziony",
	"wwożony",
	"wyartykułowany",
	"wyautowany",
	"wybaczany",
	"wybaczony",
	"wybadany",
	"wybatożony",
	"wybawiony",
	"wybebeszony",
	"wybełkotany",
	"wybiczowany",
	"wybielany",
	"wybielony",
	"wybierany",
	"wybijany",
	"wybity",
	"wybłagany",
	"wyblaknięty",
	"wybrandzlowany",
	"wybrany",
	"wybroniony",
	"wybrzydzany",
	"wybuchany",
	"wybuchnięty",
	"wybudowany",
	"wybudzany",
	"wybudzony",
	"wyburzany",
	"wyburzony",
	"wycackany",
	"wycałowany",
	"wyceniany",
	"wyceniony",
	"wychlany",
	"wychłostany",
	"wychodowany",
	"wychowany",
	"wychowywany",
	"wychrobotany",
	"wychwalany",
	"wychwycony",
	"wychylany",
	"wychylony",
	"wyciągany",
	"wyciągnięty",
	"wyciekany",
	"wycieniowany",
	"wycierany",
	"wycięty",
	"wycinany",
	"wyciskany",
	"wyciśnięty",
	"wyciszany",
	"wyciszony",
	"wycofany",
	"wyćwiczony",
	"wycyckany",
	"wycyganiony",
	"wyczarowany",
	"wyczarterowany",
	"wyczekany",
	"wyczekiwany",
	"wyczerpany",
	"wyczesany",
	"wyczołgany",
	"wyczołgiwany",
	"wyczuty",
	"wyczuwany",
	"wyczyniany",
	"wyczyszczony",
	"wyczytany",
	"wyczytywany",
	"wydalany",
	"wydalony",
	"wydany",
	"wydębiony",
	"wydedukowany",
	"wydelegowany",
	"wydepilowany",
	"wydeptywany",
	"wydłubany",
	"wydłubywany",
	"wydłużany",
	"wydłużony",
	"wydmuchany",
	"wydmuchiwany",
	"wydobyty",
	"wydobywany",
	"wydojony",
	"wydoroślany",
	"wydostany",
	"wydrany",
	"wydrapany",
	"wydrapywany",
	"wydrążony",
	"wydrukowany",
	"wydukany",
	"wyduszony",
	"wydychany",
	"wydziedziczony",
	"wydzielany",
	"wydzielony",
	"wydzierany",
	"wydzierżawiony",
	"wydziobany",
	"wydziwiany",
	"wydzwaniany",
	"wyedukowany",
	"wyedytowany",
	"wyeeliminowany",
	"wyegzekwowany",
	"wyeksmitowany",
	"wyekspediowany",
	"wyeksploatowany",
	"wyeksponowany",
	"wyeksportowany",
	"wyeliminowany",
	"wyemigrowany",
	"wyemitowany",
	"wyewoluowany",
	"wyfrunięty",
	"wygadany",
	"wygadywany",
	"wyganiany",
	"wygarbowany",
	"wygarniany",
	"wygarnięty",
	"wygasany",
	"wygaśnięty",
	"wygaszany",
	"wygaszony",
	"wygenerowany",
	"wygięty",
	"wyginany",
	"wygładzany",
	"wygładzony",
	"wygłaszany",
	"wygłodzony",
	"wygłosowany",
	"wygłoszony",
	"wygłówkowany",
	"wygnany",
	"wygolony",
	"wygoniony",
	"wygooglowany",
	"wygospodarowany",
	"wygotowany",
	"wygrany",
	"wygrawerowany",
	"wygrażany",
	"wygrywany",
	"wygryziony",
	"wygrzany",
	"wygrzebany",
	"wygrzebywany",
	"wygrzewany",
	"wygubiony",
	"wyhaczony",
	"wyhaftowany",
	"wyhamowany",
	"wyhodowany",
	"wyizolowany",
	"wyjadany",
	"wyjaśniany",
	"wyjaśniony",
	"wyjawiany",
	"wyjawiony",
	"wyjedzony",
	"wyjęty",
	"wyjmowany",
	"wykadrowany",
	"wykalibrowany",
	"wykalkulowany",
	"wykańczany",
	"wykantowany",
	"wykąpany",
	"wykaraskany",
	"wykarczowany",
	"wykarmiany",
	"wykasowany",
	"wykastrowany",
	"wykazany",
	"wykazywany",
	"wykierowany",
	"wykitowany",
	"wykiwany",
	"wykładany",
	"wyklarowany",
	"wyklepany",
	"wyklinany",
	"wykłócany",
	"wykluczany",
	"wykluczony",
	"wykluty",
	"wykłuty",
	"wykminiony",
	"wykolejony",
	"wykołowany",
	"wykombinowany",
	"wykonany",
	"wykończony",
	"wykonywany",
	"wykopany",
	"wykopnięty",
	"wykopywany",
	"wykorkowany",
	"wykorzeniany",
	"wykorzeniony",
	"wykorzystany",
	"wykorzystywany",
	"wykoszony",
	"wykpity",
	"wykradany",
	"wykradnięty",
	"wykręcany",
	"wykręcony",
	"wykreowany",
	"wykreślany",
	"wykreślony",
	"wykrochmalony",
	"wykrojony",
	"wykrwawiany",
	"wykrwawiony",
	"wykryty",
	"wykrywany",
	"wykrzesany",
	"wykrztuszony",
	"wykrzyczony",
	"wykrzykiwany",
	"wykrzyknięty",
	"wykrzywiany",
	"wykształcony",
	"wyksztuszony",
	"wykupiony",
	"wykupywany",
	"wykuty",
	"wykuwany",
	"wyłączany",
	"wyłączony",
	"wylądowany",
	"wyładowany",
	"wyładowywany",
	"wyłajany",
	"wyłamany",
	"wyłamywany",
	"wyłaniany",
	"wylansowany",
	"wylany",
	"wyłapany",
	"wyłapywany",
	"wyławiany",
	"wyleasingowany",
	"wyleczony",
	"wylęgany",
	"wylegimytowany",
	"wylewany",
	"wyłgany",
	"wylicytowany",
	"wyliczany",
	"wyliczony",
	"wylizany",
	"wylizywany",
	"wylogowany",
	"wyłoniony",
	"wylosowany",
	"wyłowiony",
	"wyłożony",
	"wyłudzany",
	"wyłudzony",
	"wyłupany",
	"wyłuskany",
	"wyłuskiwany",
	"wyłuszczony",
	"wyluzowany",
	"wymacany",
	"wymachiwany",
	"wymagany",
	"wymahiwany",
	"wymalowany",
	"wymamrotany",
	"wymanewrowany",
	"wymarzony",
	"wymasowany",
	"wymawiany",
	"wymazany",
	"wymazywany",
	"wymeldowany",
	"wymeldowywany",
	"wymiatany",
	"wymieciony",
	"wymieniany",
	"wymieniony",
	"wymierzany",
	"wymieszany",
	"wymigany",
	"wymigiwany",
	"wymijany",
	"wyminięty",
	"wymknięty",
	"wymoczony",
	"wymodelowany",
	"wymontowany",
	"wymordowany",
	"wymsknięty",
	"wymuszany",
	"wymyślany",
	"wymyślony",
	"wymyty",
	"wynagradzany",
	"wynagrodzony",
	"wynajdowany",
	"wynajdywany",
	"wynajęty",
	"wynajmowany",
	"wynaleziony",
	"wynarodowiony",
	"wynegocjowany",
	"wyniesiony",
	"wyniknięty",
	"wyniszczany",
	"wyniszczony",
	"wyniuchany",
	"wynoszony",
	"wynurzany",
	"wyobrażany",
	"wyobrażony",
	"wyodrębniony",
	"wyolbrzymiany",
	"wyolbrzymiony",
	"wyorbowany",
	"wyosiowany",
	"wyostrzany",
	"wyostrzony",
	"wypaczany",
	"wypakowany",
	"wypakowywany",
	"wypalany",
	"wypalony",
	"wypałowany",
	"wyparowany",
	"wyparty",
	"wypasany",
	"wypastowany",
	"wypatroszony",
	"wypatrywany",
	"wypatrzony",
	"wypchany",
	"wypchnięty",
	"wypędzany",
	"wypędzlowany",
	"wypełniany",
	"wypełniony",
	"wypersfadowany",
	"wyperswadowany",
	"wypierany",
	"wypięty",
	"wypijany",
	"wypinany",
	"wypisany",
	"wypisywany",
	"wypity",
	"wypłacany",
	"wypłacony",
	"wypłakany",
	"wypłakiwany",
	"wypłaszczony",
	"wyplatany",
	"wyplątany",
	"wypleniony",
	"wyplewiony",
	"wypłoszony",
	"wypłukany",
	"wypłukiwany",
	"wypluty",
	"wypluwany",
	"wypocony",
	"wypoczęty",
	"wypolerowany",
	"wypominany",
	"wypomniany",
	"wypompowany",
	"wypompowywany",
	"wyposażony",
	"wypowiadany",
	"wypowiedziany",
	"wypoziomowany",
	"wypożyczany",
	"wypracowany",
	"wypracowywany",
	"wyprany",
	"wyprasowany",
	"wypraszany",
	"wyprawiany",
	"wyprawiony",
	"wypróbowany",
	"wyprodukowany",
	"wyprojektowany",
	"wypromieniowany",
	"wypromowany",
	"wyprostowany",
	"wyprostowywany",
	"wyproszony",
	"wyprowadzany",
	"wyprowadzony",
	"wypróżniany",
	"wypróżniony",
	"wypruty",
	"wypruwany",
	"wyprzedany",
	"wyprzedawany",
	"wyprzedzany",
	"wyprzedzony",
	"wyprzęgany",
	"wypstrykany",
	"wypucowany",
	"wypuszczany",
	"wypuszczony",
	"wypychany",
	"wypytany",
	"wypytywany",
	"wyrąbany",
	"wyrabiany",
	"wyrąbywany",
	"wyratowany",
	"wyrażany",
	"wyrażony",
	"wyrecytowany",
	"wyręczany",
	"wyręczony",
	"wyregulowany",
	"wyrejestrowany",
	"wyremontowany",
	"wyreżyserowany",
	"wyrobiony",
	"wyrolowany",
	"wyrośnięty",
	"wyrównany",
	"wyrównywany",
	"wyróżniany",
	"wyróżniony",
	"wyrugowany",
	"wyruszany",
	"wyrwany",
	"wyrypany",
	"wyrysowany",
	"wyryty",
	"wyrywany",
	"wyrządzony",
	"wyrzeźbiony",
	"wyrżnięty",
	"wyrzucany",
	"wyrzucony",
	"wyrzygany",
	"wyrzynany",
	"wyrzywany",
	"wysączony",
	"wysadzany",
	"wysadzony",
	"wyschnięty",
	"wyściskany",
	"wyselekcjonowany",
	"wysępiony",
	"wysiadywany",
	"wysiedzony",
	"wysilany",
	"wysilony",
	"wyskakiwany",
	"wyskalowany",
	"wyskoczony",
	"wyskrobany",
	"wyskubywany",
	"wysłany",
	"wyśledzony",
	"wyślizgiwany",
	"wyślizgnięty",
	"wysłowiony",
	"wysłuchany",
	"wysłuchiwany",
	"wysmagany",
	"wysmarkany",
	"wysmarowany",
	"wysmażany",
	"wysmażony",
	"wyśmiany",
	"wyśmiewany",
	"wysmołowany",
	"wysmyrany",
	"wyśniony",
	"wysnuty",
	"wysnuwany",
	"wysondowany",
	"wyspecjalizowany",
	"wyśpiewany",
	"wyśpiewywany",
	"wyspowiadany",
	"wysprzątany",
	"wysprzedany",
	"wyssany",
	"wystartowany",
	"wystawiony",
	"wysterelizowany",
	"wysterylizowany",
	"wystosowany",
	"wystosowywany",
	"wystraszony",
	"wystrojony",
	"wystrugany",
	"wystrychnięty",
	"wystrzegany",
	"wystrzelany",
	"wystrzeliwany",
	"wystrzelony",
	"wystudzony",
	"wystukany",
	"wystukiwany",
	"wystygnięty",
	"wysunięty",
	"wysuszany",
	"wysuwany",
	"wyswatany",
	"wyświadczany",
	"wyświadczony",
	"wyświetlany",
	"wyświetlony",
	"wyswobodzony",
	"wysyłany",
	"wysypany",
	"wysypywany",
	"wysysany",
	"wyszabrowany",
	"wyszalany",
	"wyszarpany",
	"wyszarpnięty",
	"wyszasowany",
	"wyszczotkowany",
	"wyszczuplony",
	"wyszeptany",
	"wyszkolony",
	"wyszlifowany",
	"wyszorowany",
	"wyszperany",
	"wyszukany",
	"wyszukiwany",
	"wyszumiony",
	"wyszykowany",
	"wyszyty",
	"wytapetowany",
	"wytargany",
	"wytargowany",
	"wytarty",
	"wytarzany",
	"wytaszczony",
	"wytatuowany",
	"wytchnięty",
	"wytępiony",
	"wytknięty",
	"wytłoczony",
	"wytłumaczony",
	"wytłumiony",
	"wytoczony",
	"wytrąbiony",
	"wytrącany",
	"wytrącony",
	"wytransmitowany",
	"wytransportowany",
	"wytrenowany",
	"wytresowany",
	"wytriangulowany",
	"wytropiony",
	"wytruty",
	"wytrząsany",
	"wytrzasnięty",
	"wytrząśnięty",
	"wytrzebiony",
	"wytrzepany",
	"wytrzeszczany",
	"wytrzeźwiany",
	"wytrzymany",
	"wytrzymywany",
	"wytwarzany",
	"wytworzony",
	"wytyczony",
	"wytykany",
	"wytypowany",
	"wyuczony",
	"wywabiany",
	"wywabiony",
	"wywąchany",
	"wywalany",
	"wywalczony",
	"wywalony",
	"wywarty",
	"wywarzany",
	"wyważany",
	"wyważony",
	"wywęszany",
	"wywężykowany",
	"wywiany",
	"wywiązany",
	"wywiązywany",
	"wywierany",
	"wywiercony",
	"wywieszany",
	"wywieszony",
	"wywietrzony",
	"wywieziony",
	"wywijany",
	"wywindowany",
	"wywinięty",
	"wywłaszczony",
	"wywlekany",
	"wywnętrzniony",
	"wywnioskowany",
	"wywodzony",
	"wywolany",
	"wywoływany",
	"wywoskowany",
	"wywożony",
	"wywracany",
	"wywrócony",
	"wywróżony",
	"wywyższany",
	"wyżalony",
	"wyzbyty",
	"wyzdrowiony",
	"wyżebrany",
	"wyżerany",
	"wyzerowany",
	"wyzionięty",
	"wyznaczany",
	"wyznaczony",
	"wyznany",
	"wyznawany",
	"wyzwalany",
	"wyzwany",
	"wyzwolony",
	"wyzygzakowany",
	"wyżynany",
	"wyzyskany",
	"wyzyskiwany",
	"wyżyty",
	"wyzywany",
	"wyżywany",
	"wyżywiony",
	"wzbijany",
	"wzbity",
	"wzbogacany",
	"wzbogacony",
	"wzbraniany",
	"wzbudzany",
	"wzbudzony",
	"wzburzany",
	"wzburzony",
	"wżeniony",
	"wzięty",
	"wzmacniony",
	"wzmagany",
	"wzmocniony",
	"wznawiany",
	"wzniecany",
	"wznieciony",
	"wzniesięty",
	"wznoszony",
	"wznowiony",
	"wzorowany",
	"wzrośnięty",
	"wzruszony",
	"wzwyżany",
	"wzywany",
	"zaabordowany",
	"zaadaptowany",
	"zaadoptowany",
	"zaadresowany",
	"zaakcentowany",
	"zaakceptowany",
	"zaaklimatyzowany",
	"zaalarmowany",
	"zaanektowany",
	"zaangażowany",
	"zaanonsowany",
	"zaapelowany",
	"zaaplikowany",
	"zaaportowany",
	"zaaprobowany",
	"zaaranżowany",
	"zaaresztowany",
	"zaatakowany",
	"zabaczony",
	"zabalowany",
	"zabandażowany",
	"zabarwiony",
	"zabarykadowany",
	"zabawiany",
	"zabawiony",
	"zabepieczany",
	"zabetonowany",
	"zabezpieczony",
	"zabierany",
	"zabity",
	"zabłądzony",
	"zablefowany",
	"zabłocony",
	"zablokowany",
	"zabraniany",
	"zabrany",
	"zabrnięty",
	"zabroniony",
	"zabrudzony",
	"zabudowany",
	"zabukowany",
	"zabulony",
	"zaburzony",
	"zabutelkowany",
	"zacementowany",
	"zacerowany",
	"zachciany",
	"zachęcany",
	"zachęcony",
	"zachlapany",
	"zachodzony",
	"zachomikowany",
	"zachorowany",
	"zachowany",
	"zachowywany",
	"zachwalany",
	"zachwalony",
	"zachwiany",
	"zachwycony",
	"zaciągany",
	"zaciągnięty",
	"zaciążony",
	"zaciekawiony",
	"zaciemniany",
	"zaciemniony",
	"zacierany",
	"zacieśniony",
	"zacięty",
	"zacinany",
	"zaciskany",
	"zaciśnięty",
	"zaćmiony",
	"zacumowany",
	"zacytowany",
	"zaczadzony",
	"zaczarowany",
	"Zaczepiany",
	"zaczepiony",
	"zaczerpany",
	"zaczesany",
	"zaczęty",
	"zaczołgany",
	"zaczynany",
	"zadarty",
	"zadawalany",
	"zadawany",
	"zadbany",
	"zadebiutowany",
	"zadedykowany",
	"zadeklamowany",
	"zadeklarowany",
	"zademonstrowany",
	"zadenucjowany",
	"zadepeszowany",
	"zadeptany",
	"zadeptywany",
	"zadęty",
	"zadławiony",
	"żądlony",
	"zadłużany",
	"zadłużony",
	"zadokowany",
	"zadomowiony",
	"zadowalany",
	"zadrapany",
	"zadraśnięty",
	"zadręczany",
	"zadręczony",
	"zadrutowany",
	"zadurzany",
	"zadurzony",
	"zaduszony",
	"zadymiony",
	"zadźgany",
	"zadziobany",
	"zadziwiany",
	"zadziwiony",
	"zafakturowany",
	"zafałszowany",
	"zafarbowany",
	"zafiksowany",
	"zafundowany",
	"zagadany",
	"zagadnięty",
	"zagadywany",
	"zagajony",
	"zaganiany",
	"zagapiony",
	"zagarażowany",
	"zagarniany",
	"zagarnięty",
	"zagaszony",
	"zagazowany",
	"zagęszczony",
	"zagięty",
	"zaginany",
	"zaginięty",
	"zagłębiany",
	"zagłębiony",
	"zagłodzony",
	"zagłuszany",
	"zagłuszony",
	"zagmatwany",
	"zagnany",
	"zagnieżdżony",
	"zagojony",
	"zagoniony",
	"zagospodarowany",
	"zagotowany",
	"zagrabiony",
	"zagradzany",
	"zagrażany",
	"zagrodzony",
	"zagrywany",
	"zagryzany",
	"zagryziony",
	"zagrzany",
	"zagrzebany",
	"zagrzewany",
	"zagubiony",
	"zagwarantowany",
	"zahaczony",
	"zahamowany",
	"zahandlowany",
	"zaharowany",
	"zahartowany",
	"zahipnotyzowany",
	"zaholowany",
	"zaimitowany",
	"zaimplantowany",
	"zaimplementowany",
	"zaimprowizowany",
	"zainaugurowany",
	"zainfekowany",
	"zainicjowany",
	"zainkasowany",
	"zainscenizowany",
	"zainspirowany",
	"zainstalowany",
	"zainteresowany",
	"zaintrygowany",
	"zaintubowany",
	"zainwestowany",
	"zaizolowany",
	"zajadany",
	"zajany",
	"zajarany",
	"zajechany",
	"zajęty",
	"zajmowany",
	"zakablowany",
	"zakamuflowany",
	"zakasany",
	"zakasowany",
	"zakąszany",
	"zakatalogowany",
	"zakatowany",
	"zakatrupiony",
	"zakazany",
	"zakażany",
	"zakazywany",
	"zakiszony",
	"zakładany",
	"zaklasyfikowany",
	"zaklejany",
	"zaklejony",
	"zaklepany",
	"zaklepywany",
	"zaklinany",
	"zaklinowany",
	"zakłócany",
	"zakłócony",
	"zaklopotany",
	"zakłuty",
	"zakneblowany",
	"zakodowany",
	"zakolczykowany",
	"zakolorowany",
	"zakołysany",
	"zakomunikowany",
	"zakończony",
	"zakonserwowany",
	"zakopany",
	"zakopywany",
	"zakorzeniany",
	"zakorzeniony",
	"zakoszony",
	"zakosztowany",
	"zakotwiczany",
	"zakotwiczony",
	"zakpiony",
	"zakradany",
	"zakręcany",
	"zakręcony",
	"zakreślany",
	"zakreślony",
	"zakrwawiony",
	"zakryty",
	"zakrywany",
	"zakrzyczany",
	"zakrzyknięty",
	"zakrzywiany",
	"zakrzywiony",
	"zaksięgowany",
	"zaktualizowany",
	"zaktywizowany",
	"zaktywowany",
	"zakumany",
	"zakupiony",
	"zakurzony",
	"zakuty",
	"zakuwany",
	"zakwaterowany",
	"zakwestionować",
	"zakwitnięty",
	"załączony",
	"załadowany",
	"załagodzony",
	"zalamany",
	"zalaminowany",
	"załamywany",
	"zalany",
	"załapany",
	"załatany",
	"załatwiany",
	"załatwiony",
	"zalatywany",
	"zalecany",
	"zalecony",
	"zaleczony",
	"zalegalizowany",
	"zalegany",
	"zalepiany",
	"zalepiony",
	"zalewany",
	"zaliczany",
	"zaliczony",
	"załkany",
	"zalogowany",
	"żałowany",
	"założony",
	"zaludniony",
	"zamacany",
	"zamachnięty",
	"zamącony",
	"zamalowany",
	"zamanewrowany",
	"zamanifestowany",
	"zamarkowany",
	"zamartwiany",
	"zamarynowany",
	"zamarzany",
	"zamarznięty",
	"zamaskowany",
	"zamawiany",
	"zamazany",
	"zamazywany",
	"zamęczany",
	"zamęczony",
	"zameldowany",
	"zamelinowany",
	"zamerykanizowany",
	"zamiatany",
	"zamieniany",
	"zamieniony",
	"zamieszany",
	"zamieszczany",
	"zamieszczony",
	"zamieszkany",
	"zamieszkiwany",
	"zaminowany",
	"zamknięty",
	"zamocowany",
	"zamoczony",
	"zamontowany",
	"zamordowany",
	"zamortyzowany",
	"zamotany",
	"zamówiony",
	"zamrażany",
	"zamroczony",
	"zamrożony",
	"zamulany",
	"zamurowany",
	"zamydlony",
	"zamykany",
	"zanalizowany",
	"zanegowany",
	"zaniechany",
	"zanieczyszczany",
	"zanieczyszczony",
	"zaniedbany",
	"zaniedbywany",
	"zaniepokojony",
	"zaniesiony",
	"zanihilowany",
	"zanikany",
	"zaniknięty",
	"zaniżany",
	"zaniżony",
	"zanoszony",
	"zanotowany",
	"zanucony",
	"zanudzany",
	"zanudzony",
	"zanurzany",
	"zanurzony",
	"zanużony",
	"zaobaczony",
	"zaobserwowany",
	"zaoferowany",
	"zaofiarowany",
	"zaogniany",
	"zaogniony",
	"zaokrąglany",
	"zaokrąglony",
	"zaokrętowany",
	"zaopatrywany",
	"zaopatrzony",
	"zaopiekowany",
	"zaorany",
	"zaostrzany",
	"zaostrzony",
	"zaoszczędzony",
	"zapadany",
	"zapakowany",
	"zapalany",
	"zapalony",
	"zapamiętany",
	"zapamiętywany",
	"zapanowany",
	"zaparkowany",
	"zaparowywany",
	"zaparzany",
	"zaparzony",
	"zapaskudzony",
	"zapauzowany",
	"zapchany",
	"zapędzany",
	"zapełniany",
	"zapełniony",
	"zaperfumowany",
	"zapeszany",
	"zapewniany",
	"zapewniony",
	"zapieczętowany",
	"zapierany",
	"zapięty",
	"zapijany",
	"zapinany",
	"zapisany",
	"zapisuwany",
	"zapity",
	"zapłacony",
	"zapładniany",
	"zaplamiony",
	"zaplanowany",
	"zaplątany",
	"zapłodniony",
	"zaplombowany",
	"zapobiegany",
	"zapodany",
	"zapodawany",
	"zapodziany",
	"zapokojony",
	"zapolowany",
	"zapominany",
	"zapomniany",
	"zapowiadany",
	"zapowiedziany",
	"zapoznany",
	"zapoznawany",
	"zapożyczony",
	"zapracowywany",
	"zaprany",
	"zaprasowywany",
	"zapraszany",
	"zaprawiony",
	"zaprenumerowany",
	"zaprezentowany",
	"Zaprogramowany",
	"zaprojektowany",
	"zaproponowany",
	"zaproszony",
	"zaprotokołowany",
	"zaprowadzany",
	"zaprowadzony",
	"zaprzątany",
	"zaprzeczany",
	"zaprzeczony",
	"zaprzedany",
	"zaprzedawany",
	"zaprzęgany",
	"zaprzepaszczany",
	"zaprzestany",
	"zaprzestawany",
	"zaprzyjaźniony",
	"zapudłowany",
	"zapunktowany",
	"zapuszczany",
	"zapuszczony",
	"zapuszkowany",
	"zapychany",
	"zapylany",
	"zapylony",
	"zapytany",
	"zarabiany",
	"zaranżowany",
	"zarażany",
	"zarażony",
	"zarecytowany",
	"zaręczany",
	"zaręczony",
	"zarejestrowany",
	"zareklamowany",
	"zarekomendowany",
	"zarekomondowany",
	"zarekwirowany",
	"zarezerwowany",
	"zarobiony",
	"żartowany",
	"zarwany",
	"zaryglowany",
	"zarymowany",
	"zarysowany",
	"zarywany",
	"zaryzykowany",
	"zarządzany",
	"zarżnięty",
	"zarzucany",
	"zarzynany",
	"zasadzony",
	"zaścielony",
	"zasegurowany",
	"zaserwowany",
	"zasiadany",
	"zasiany",
	"zasiedlony",
	"zasięgany",
	"zasięgnięty",
	"zasiewany",
	"zasilany",
	"zasilony",
	"zaskakiwany",
	"zaskarbiony",
	"zaskoczony",
	"zaskrobany",
	"zasłaniany",
	"zaślepiany",
	"zaślepiony",
	"zasłodzony",
	"zasłoniony",
	"zasłużony",
	"zasmakowany",
	"zaśmiecany",
	"zaśmiecony",
	"zasmradzany",
	"zasmrodzony",
	"zasmucany",
	"zasmucony",
	"zasolony",
	"zaspakajany",
	"zaśpiewany",
	"zaspokajany",
	"zaspokojony",
	"zasponsorowany",
	"zaśrubowywany",
	"zassany",
	"zastany",
	"zastąpiony",
	"zastawiany",
	"zastawiony",
	"zastępowany",
	"zastopowany",
	"zastosowany",
	"zastraszany",
	"zastraszony",
	"zastrzelony",
	"zasugerowany",
	"zasunięty",
	"zasuwany",
	"zaświadczony",
	"zaświecony",
	"zaświoniony",
	"zasyfiony",
	"zasygnalizowany",
	"zasymilowany",
	"zasymulowany",
	"zasypany",
	"zasypywany",
	"zasysany",
	"zaszachowany",
	"zaszantażowany",
	"zaszargany",
	"zaszczepiany",
	"zaszczepiony",
	"zaszczuty",
	"zaszczycany",
	"zaszczycony",
	"zaszeptany",
	"zaszeregowany",
	"zaszlachtowany",
	"zasznurowany",
	"zaszpachlowany",
	"zasztyletowany",
	"zaszufladkowany",
	"zaszyfrowany",
	"zaszyty",
	"zaszywany",
	"zataczany",
	"zatajany",
	"zatajony",
	"zatamowany",
	"zatankowany",
	"zatapiany",
	"zatargany",
	"zatarty",
	"zatelegrafowany",
	"zatemperowany",
	"zatęskniony",
	"zatkany",
	"zatknięty",
	"zatoczony",
	"zatonięty",
	"zatopiony",
	"zatracany",
	"zatracony",
	"zatriumfowany",
	"zatrudniany",
	"zatrudniony",
	"zatruty",
	"zatruwany",
	"zatrzaskiwany",
	"zatrzaśnięty",
	"zatrząśnięty",
	"zatrzymany",
	"zatrzymywany",
	"zatuszowany",
	"zatwierdzany",
	"zatwierdzony",
	"zatykany",
	"zatynkowany",
	"zatytułowany",
	"zauploadowany",
	"zauroczony",
	"zautomatyzowany",
	"zauważany",
	"zauważony",
	"zawadzany",
	"zawalany",
	"zawalczony",
	"zawalony",
	"zawarty",
	"zaważony",
	"zawdzięczany",
	"zawetowany",
	"zawężony",
	"zawiadamiany",
	"zawiadomiony",
	"zawiązany",
	"zawiązywany",
	"zawiedzony",
	"zawierany",
	"zawierzony",
	"zawieszany",
	"zawieszony",
	"zawieziony",
	"zawijany",
	"zawinięty",
	"zawiniony",
	"zawiśnięty",
	"zawitany",
	"zawładnięty",
	"zawłaszczony",
	"zawodzony",
	"zawojowany",
	"zawołany",
	"zawoskowany",
	"zawożony",
	"zawracany",
	"zawrócony",
	"zawstydzany",
	"zażądany",
	"zażartowany",
	"zazdroszczony",
	"zażegnany",
	"zażenowany",
	"zaznaczany",
	"zaznajomiony",
	"zaznany",
	"zaznawany",
	"zażyczony",
	"zażyty",
	"zażywany",
	"zbaczany",
	"zbadany",
	"zbagatelizowany",
	"zbajerowany",
	"zbałamucony",
	"zbalansowany",
	"zbalsamowany",
	"zbankrutowany",
	"zbawiany",
	"zbawiony",
	"zbesztany",
	"zbezczeszczony",
	"zbierany",
	"zbijany",
	"zbity",
	"zbliżony",
	"zbluzgany",
	"zbojkotowany",
	"zbrojony",
	"zbrukany",
	"zbszczecony",
	"zbudowany",
	"zbudzony",
	"zbuntowany",
	"zburzony",
	"zbyty",
	"zbywany",
	"zchwytany",
	"zcięty",
	"zciszony",
	"zdany",
	"zdarty",
	"zdeaktywowany",
	"zdecydowany",
	"zdefiniowany",
	"zdeflorowany",
	"zdegradowany",
	"zdejmowany",
	"zdeklarowany",
	"zdekodowany",
	"zdekompresowany",
	"zdekoncentrowany",
	"zdekonstruowany",
	"zdelegalizowany",
	"zdemaskowany",
	"zdementowany",
	"zdemolowany",
	"zdemontowany",
	"zdemoralizowany",
	"zdenerwowany",
	"zdeponowany",
	"zdeprymowany",
	"zdeptany",
	"zderzany",
	"zderzony",
	"zdestabilizowany",
	"Zdetonowany",
	"zdetronizowany",
	"zdewastowany",
	"zdewaulowany",
	"zdezerterowany",
	"zdezintegrowany",
	"zdezorientowany",
	"zdezynfektowany",
	"zdiagnozowany",
	"zdjęty",
	"zdławiony",
	"zdmuchiwany",
	"zdmuchnięty",
	"zdobyty",
	"zdobywany",
	"zdołowany",
	"zdominowany",
	"zdopingowany",
	"zdrabniany",
	"zdradzany",
	"zdradzony",
	"zdrapany",
	"zdrapywany",
	"zdrutowany",
	"zdruzgotany",
	"zduplikowany",
	"zduszony",
	"zdwojony",
	"zdyscyplinowany",
	"zdyskredytowany",
	"zdyskwalifikowany",
	"zdystansowany",
	"zdzielony",
	"zdzierany",
	"zdzierżony",
	"zdziesiątkowany",
	"Zdzwoniony",
	"zebrany",
	"zechciany",
	"zedytowany",
	"żegnany",
	"żeniony",
	"zepchnięty",
	"zepsuty",
	"żerowany",
	"zerwany",
	"zerżnięty",
	"zeskakiwany",
	"zeskanowany",
	"zeskrobywany",
	"zesłany",
	"ześlizgiwany",
	"ześlizgnięty",
	"zesmolony",
	"zespawiany",
	"zespolony",
	"zessany",
	"zestawiany",
	"zestawiony",
	"zestresowany",
	"zestrzeliwany",
	"zestrzelony",
	"zeswatany",
	"zeszklony",
	"zeszlifowany",
	"zetknięty",
	"zezłoszczony",
	"zeznany",
	"zeznawany",
	"zezwalany",
	"zezwolony",
	"zfinansowany",
	"zgadany",
	"zgadywany",
	"zgajany",
	"zganiony",
	"zgarnięty",
	"zgaśnięty",
	"zgaszony",
	"zgięty",
	"zginany",
	"zgładzony",
	"zgłaszany",
	"zgłębiany",
	"zgłębiony",
	"zgłośniony",
	"zgłoszony",
	"zgłuszony",
	"zgniatany",
	"zgnieciony",
	"zgnity",
	"zgnojony",
	"zgodzony",
	"zgolony",
	"zgoniony",
	"zgotowany",
	"zgrabiony",
	"zgrillowany",
	"zgromadzany",
	"zgromadzony",
	"zgrupowany",
	"zgrzeszony",
	"zgrzytany",
	"zgubiony",
	"zgwałcony",
	"zhackowany",
	"zhakowany",
	"zhańbiony",
	"zhandlowany",
	"zharmonizowany",
	"zidentyfikowany",
	"ziewany",
	"zignorowany",
	"zilustrowany",
	"zinfiltrowany",
	"zintegrowany",
	"zintensyfikowany",
	"zinterpretowany",
	"zinwentaryzowany",
	"zirytowany",
	"zjadany",
	"zjawiany",
	"zjednany",
	"zjednoczony",
	"zjedzony",
	"zjeżdżony",
	"zkontaktowany",
	"zkserowany",
	"złączony",
	"złagodzony",
	"złajany",
	"złamany",
	"zlany",
	"złapany",
	"zlecany",
	"zlecony",
	"zlekceważony",
	"zlepiany",
	"zlepiony",
	"zlewany",
	"zlicytowany",
	"zliczany",
	"zliczony",
	"zlikwidowany",
	"zlinczowany",
	"zlitowany",
	"zlizany",
	"zlizywany",
	"złoity",
	"zlokalizowany",
	"złomowany",
	"żłopany",
	"złowiony",
	"złożony",
	"złupiony",
	"złuszczany",
	"zluzowany",
	"zmacany",
	"zmącony",
	"zmagany",
	"zmagazynowany",
	"zmajstrowany",
	"zmaksylizowany",
	"zmanipulowany",
	"zmarnowany",
	"zmartwychwstany",
	"zmarznięty",
	"zmasakrowany",
	"zmaterializowany",
	"zmawiany",
	"zmazany",
	"zmazywany",
	"zmbobardowany",
	"zmiatany",
	"zmiażdżony",
	"zmiękczony",
	"zmielony",
	"zmieniany",
	"zmieniony",
	"zmierzany",
	"zmierzony",
	"zmierzwiony",
	"zmieszany",
	"zmieszczony",
	"zmiksowany",
	"zminiaturyzowany",
	"zminimalizowany",
	"zmniejszany",
	"zmniejszony",
	"zmobilizowany",
	"zmoczony",
	"zmodernizowany",
	"zmodyfikowany",
	"zmoknięty",
	"zmonopolizowany",
	"zmontowany",
	"zmostkowany",
	"zmotywowany",
	"zmówiony",
	"zmrożony",
	"zmrużony",
	"zmumifikowany",
	"zmuszany",
	"zmuszony",
	"zmutowany",
	"zmyślany",
	"zmyty",
	"zmywany",
	"znacjonalizowany",
	"znajdowany",
	"znajdywany",
	"znakowany",
	"znaleziony",
	"znany",
	"znęcany",
	"zneutralizowany",
	"zniechęcony",
	"znieczulony",
	"zniekształcany",
	"zniekształcony",
	"znienawidzony",
	"znieprawiony",
	"zniesiony",
	"zniesławiany",
	"zniesławiony",
	"zniewalany",
	"znieważany",
	"znieważony",
	"zniewolony",
	"zniszczony",
	"zniweczony",
	"zniwelowany",
	"zniżany",
	"zniżony",
	"znokautowany",
	"znormalniony",
	"znoszony",
	"znudzony",
	"zobaczony",
	"zobowiązany",
	"zobrazowany",
	"zogniskowany",
	"żonglowany",
	"zoomowany",
	"zoperowany",
	"zoptymalizowany",
	"zorbity",
	"zorganizowany",
	"zorientowany",
	"zostawiany",
	"zostawiony",
	"zpłacony",
	"zprowokowany",
	"zrabowany",
	"zrachowany",
	"zracjonalizowany",
	"zraniony",
	"zraportowany",
	"zrażany",
	"zrażony",
	"zrealizowany",
	"zrecenzowany",
	"zredagowany",
	"zredukowany",
	"zreferowany",
	"zreformowany",
	"zrefowany",
	"zrefundowany",
	"zregenerowany",
	"zrehabilitowany",
	"zreinkarnowany",
	"zreintegrowany",
	"zrekonfigurowany",
	"zrekonstruowany",
	"zrekrutowany",
	"zrekrystalizowany",
	"zrelacjonowany",
	"zrelaksowany",
	"zremiksowany",
	"zremisowany",
	"zreorganizowany",
	"zreperowany",
	"zreplikowany",
	"zresetowany",
	"zresocjalizowany",
	"zrestartowany",
	"zrestrukturyzowany",
	"zrewanżowany",
	"zrewidowany",
	"zrewolucjonizowany",
	"zrezygnowany",
	"zrobiony",
	"zrolowany",
	"zroszony",
	"zrównany",
	"zrównoważony",
	"zrównywany",
	"zróżnicowany",
	"zrozumiany",
	"zrugany",
	"zruinowany",
	"zrujnowany",
	"zrymowany",
	"zrywany",
	"zrzędzony",
	"zrzeszony",
	"zrzucany",
	"zrzucony",
	"zsumowany",
	"zsunięty",
	"zsuwany",
	"zsynchronizowany",
	"zsyntetyzowany",
	"zsypywany",
	"zszargany",
	"zszokowany",
	"zszyty",
	"zszywany",
	"ztarty",
	"żuty",
	"zutylizowany",
	"zużyty",
	"zużywany",
	"zwabiany",
	"zwabiony",
	"zwalany",
	"zwalczony",
	"zwalniany",
	"zwalony",
	"zwany",
	"zwaporyzowany",
	"zwątpiony",
	"zważany",
	"zważony",
	"zwędzony",
	"zwerbalizowany",
	"zwerbowany",
	"zweryfikowany",
	"zwęszony",
	"zwężony",
	"zwiastowany",
	"związany",
	"związywany",
	"zwichnięty",
	"zwiedzany",
	"zwiedzony",
	"zwiększony",
	"zwieńczony",
	"zwierzany",
	"zwieszany",
	"zwieszony",
	"zwietrzony",
	"zwijany",
	"zwilżony",
	"zwinięty",
	"zwizualizowany",
	"zwlekany",
	"zwodowany",
	"zwodzony",
	"zwołany",
	"zwolniony",
	"zwoływany",
	"zwożony",
	"zwracany",
	"zwrócony",
	"zwyciężany",
	"zwymiotowany",
	"życzony",
	"żygany",
	"zygzakowany",
	"zyskany",
	"zyskiwany",
	"żyty",
	"zżarty",
	"zżerany",
	"zżynany",
	"zżyty",
	"abdykowana",
	"absorbowana",
	"adaptowana",
	"administrowana",
	"adoptowana",
	"adorowana",
	"adresowana",
	"afiszowana",
	"agitowana",
	"akcentowana",
	"akceptowana",
	"aklimatyzowana",
	"akompaniowana",
	"aktualizowana",
	"aktywowana",
	"akumulowana",
	"alaromowana",
	"alienowana",
	"amerykanizowana",
	"amortyzowana",
	"amputowana",
	"analizowana",
	"angażowana",
	"anihilowana",
	"animowana",
	"anonsowana",
	"antropomorfizowana",
	"antydatowana",
	"anulowana",
	"apelowana",
	"aportowana",
	"aranżowana",
	"archiwizowana",
	"aresztowana",
	"argumentowana",
	"artykułowana",
	"ascendowana",
	"asekurowana",
	"asymilowana",
	"asystowana",
	"atakowana",
	"autoryzowana",
	"awanturowana",
	"babrana",
	"baczona",
	"badana",
	"bagatelizowana",
	"bajerowana",
	"bałamucona",
	"balangowana",
	"balansowana",
	"banalizowana",
	"bandażowana",
	"bankrutowana",
	"baraszkowana",
	"barwiona",
	"bawiona",
	"bazgrana",
	"bazowana",
	"bębniona",
	"bełkotana",
	"besztana",
	"biadolona",
	"biczowana",
	"bita",
	"błagana",
	"błaznowana",
	"blefowana",
	"błogosławiona",
	"blokowana",
	"bluzgana",
	"błyskana",
	"błyszcząca",
	"boczona",
	"bogacona",
	"bojkotowana",
	"boksowana",
	"bombardowana",
	"bopowana",
	"borowana",
	"brandzlowana",
	"brana",
	"brasowana",
	"bratana",
	"bredzona",
	"brnięta",
	"brodzona",
	"broniona",
	"brudzona",
	"brylowana",
	"budowana",
	"budzona",
	"bujana",
	"bulona",
	"bulwersowana",
	"bumelowana",
	"burzona",
	"butelkowana",
	"bywana",
	"cackana",
	"całowana",
	"capnięta",
	"cechowana",
	"celebrowana",
	"celowana",
	"ceniona",
	"cenzurowana",
	"chciana",
	"chlana",
	"chlapana",
	"chlapnięta",
	"chlastana",
	"chłodzona",
	"chlostana",
	"chlubiona",
	"chodowana",
	"chomikowana",
	"chorowana",
	"chowana",
	"chroniona",
	"chrupana",
	"chrzczona",
	"chuta",
	"chwalona",
	"chwycona",
	"chwytana",
	"chybotana",
	"chylona",
	"ciachnięta",
	"ciągana",
	"ciągnięta",
	"ciemiężona",
	"cierpiana",
	"cieszona",
	"cięta",
	"ciskana",
	"ciśnięta",
	"ciułana",
	"cmokana",
	"cmoknięta",
	"cofana",
	"cofnięta",
	"ćpana",
	"cucona",
	"cudzołożona",
	"cumowana",
	"ćwiartowana",
	"ćwiczona",
	"cykana",
	"cytowana",
	"czajona",
	"czarowana",
	"czczona",
	"czepiana",
	"czepiona",
	"czerpana",
	"czesana",
	"częstowana",
	"czochrana",
	"czołgana",
	"czuta",
	"czytana",
	"czyta",
	"darowana",
	"darta",
	"darzona",
	"datowana",
	"dawana",
	"dbana",
	"deaktywowana",
	"debatowana",
	"dedukowana",
	"dedykowana",
	"defibrylowana",
	"defilowana",
	"definiowana",
	"defraudowana",
	"degradowana",
	"degustowana",
	"deklamowana",
	"deklarowana",
	"dekodowana",
	"dekompresowana",
	"dekorowana",
	"dekretowana",
	"delegowana",
	"delektowana",
	"deliberowana",
	"demaskowana",
	"dementowana",
	"demolowana",
	"demonizowana",
	"demonstrowana",
	"demoralizowana",
	"denerwowana",
	"denuncjowana",
	"depeszowana",
	"depilowana",
	"deportowana",
	"deprawowana",
	"deptana",
	"deratyzowana",
	"destabilizowana",
	"destylowana",
	"desygnowana",
	"determinowana",
	"detonowana",
	"dewastowana",
	"dewaulowana",
	"dezaktywowana",
	"dezorientowana",
	"dezynfekowana",
	"diagnozowana",
	"dilowana",
	"dłubana",
	"dłużona",
	"dmuchana",
	"dmuchnięta",
	"dobiegana",
	"dobierana",
	"dobijana",
	"dobita",
	"dobrana",
	"dobudzona",
	"dobyta",
	"doceniana",
	"doceniona",
	"dochodzona",
	"dochowana",
	"dochowywana",
	"dociągnięta",
	"dociekana",
	"docięta",
	"docinana",
	"dociskana",
	"dociśnięta",
	"doczekana",
	"doczepiona",
	"doczołgana",
	"doczyszczona",
	"doczytana",
	"dodana",
	"dodawana",
	"dodrukowana",
	"dodrukowywana",
	"dofinansowana",
	"dofinansowywana",
	"dogadana",
	"dogadywana",
	"dogadzana",
	"doganiana",
	"doglądana",
	"doglądnięta",
	"dognana",
	"dogodzona",
	"dogoniona",
	"dograna",
	"dogryzana",
	"dogryziona",
	"dogrzana",
	"dogrzebana",
	"doinformowana",
	"dojeżdżana",
	"dojona",
	"dojrzana",
	"dojrzewana",
	"dokańczana",
	"dokarmiana",
	"dokarmiona",
	"dokazana",
	"dokazywana",
	"dokładana",
	"doklejona",
	"dokonana",
	"dokończona",
	"dokonywana",
	"dokopana",
	"dokopywana",
	"dokowana",
	"dokręcana",
	"dokręcona",
	"dokształcana",
	"dokształcona",
	"dokuczana",
	"dokumentowana",
	"dokupiona",
	"dołączana",
	"dołączona",
	"doładowana",
	"dolana",
	"dolewana",
	"doliczona",
	"dołowana",
	"dołożona",
	"domagana",
	"domalowana",
	"domknięta",
	"domniewywana",
	"domówiona",
	"domyślana",
	"domyślona",
	"domyta",
	"doniesiona",
	"donoszona",
	"dopadana",
	"dopadnięta",
	"dopakowana",
	"dopalona",
	"dopasowana",
	"dopasowywana",
	"dopatrywana",
	"dopatrzona",
	"dopchana",
	"dopchnięta",
	"dopełniana",
	"dopełniona",
	"dopieszczona",
	"dopięta",
	"dopijana",
	"dopilnowana",
	"dopingowana",
	"dopisana",
	"dopisywana",
	"dopita",
	"dopłacana",
	"dopłacona",
	"dopłynięta",
	"dopolerowana",
	"dopompowana",
	"dopowiedziana",
	"dopracowana",
	"dopracowywana",
	"doprana",
	"doprawiona",
	"doprecyzowana",
	"doproszona",
	"doprowadzana",
	"doprowadzona",
	"dopucowana",
	"dopuszczana",
	"dopuszczona",
	"dopytywana",
	"dorabiana",
	"doradzana",
	"doradzona",
	"doręczana",
	"doręczona",
	"dorobiona",
	"dorównana",
	"dorównywana",
	"dorwana",
	"dorysowana",
	"dorzucana",
	"dorzucona",
	"doścignięta",
	"dosiadana",
	"dosięgnięta",
	"doskoczona",
	"doskonalona",
	"dosładzana",
	"dosłana",
	"dosłyszana",
	"dosolona",
	"dośrodkowana",
	"dossana",
	"dostana",
	"dostąpiona",
	"dostarczana",
	"dostarczona",
	"dostawana",
	"dostawiana",
	"dostawiona",
	"dostosowana",
	"dostosowywana",
	"dostrajana",
	"dostrojona",
	"dostrzegana",
	"dosunięta",
	"dosuwana",
	"doświadczana",
	"doświetlona",
	"dosypana",
	"dosypywana",
	"doszkolona",
	"doszlifowana",
	"doszorowana",
	"doszukana",
	"doszukiwana",
	"doszyta",
	"dotankowana",
	"dotankowywana",
	"dotargana",
	"dotaszczona",
	"dotknięta",
	"dotleniona",
	"dotłumaczona",
	"dotowana",
	"dotrwana",
	"dotrzymana",
	"dotrzymywana",
	"dotykana",
	"douczana",
	"douczona",
	"dowalona",
	"dowieziona",
	"dowodzona",
	"dowożona",
	"doznana",
	"doznawana",
	"dozorowana",
	"dozowana",
	"dożyta",
	"dożywiona",
	"dramatyzowana",
	"drapana",
	"drapnięta",
	"draśnięta",
	"drażniona",
	"drążona",
	"dręczona",
	"drenowana",
	"drgana",
	"drgnięta",
	"drukowana",
	"dryblowana",
	"dryfowana",
	"drzemana",
	"dubbingowana",
	"dublowana",
	"duplikowana",
	"duszona",
	"dworowana",
	"dygotana",
	"dyktowana",
	"dymana",
	"dymiona",
	"dyrygowana",
	"dyscyplinowana",
	"dyskredytowana",
	"dyskryminowana",
	"dyskutowana",
	"dyskwalifikowana",
	"dysponowana",
	"dystansowana",
	"dystrybuowana",
	"dywagowana",
	"dźgana",
	"dźgnięta",
	"dziabnięta",
	"dziedziczona",
	"dziękowana",
	"dzielona",
	"dziergana",
	"dzierżona",
	"dziobana",
	"dziurawiona",
	"dziurkowana",
	"dźwigana",
	"dźwignięta",
	"edukowana",
	"edytowana",
	"egzaminowana",
	"egzekutowana",
	"egzekwowana",
	"ekscytowana",
	"ekshumowana",
	"ekskomunikowana",
	"eksmitowana",
	"ekspandowana",
	"eksperymentowana",
	"eksploatowana",
	"eksplorowana",
	"eksponowana",
	"eksportowana",
	"eksterminowana",
	"ekstradowana",
	"ekstrapolowana",
	"eliminowana",
	"emancypowana",
	"emanowaa",
	"emigrowana",
	"emitowana",
	"energetyzowana",
	"eskortowana",
	"etykietowana",
	"ewakuowana",
	"ewaluowana",
	"fabrykowana",
	"falowana",
	"fałszowana",
	"farbowana",
	"faszerowana",
	"faulowana",
	"faworyzowana",
	"fechtowana",
	"fermentowana",
	"ferowana",
	"figurowana",
	"filetowana",
	"filmowana",
	"filtrowana",
	"finalizowana",
	"finansowana",
	"firmowana",
	"fleszowana",
	"folgowana",
	"formułowana",
	"forsowana",
	"fotografowana",
	"fundowana",
	"gadana",
	"ganiana",
	"garbiona",
	"gardzona",
	"garnirowana",
	"gaszona",
	"gawędzona",
	"gaworzona",
	"gazowana",
	"gdakana",
	"gderana",
	"generalizowana",
	"generowana",
	"gięta",
	"gilgotana",
	"gładzona",
	"głaskana",
	"głodowana",
	"głodzona",
	"gloryfikowana",
	"głosowana",
	"głoszona",
	"głowiona",
	"gmatwana",
	"gmerana",
	"gnana",
	"gnębiona",
	"gnieciona",
	"gnita",
	"gnojona",
	"godzona",
	"gojona",
	"golnięta",
	"golona",
	"goniona",
	"googlowana",
	"gospodarowana",
	"goszczona",
	"gotowana",
	"grabiona",
	"grana",
	"grasowana",
	"gratulowana",
	"grillowana",
	"grilowana",
	"gromadzona",
	"gromiona",
	"grożona",
	"gruchana",
	"gruchnięta",
	"grupowana",
	"grywana",
	"gryziona",
	"grzana",
	"grzechotana",
	"gubiona",
	"gustowana",
	"gwałcona",
	"gwarantowana",
	"gwizdana",
	"gwizdnięta",
	"hackowana",
	"haftowana",
	"hajtnięta",
	"hamowana",
	"hańbiona",
	"handlowana",
	"harcowana",
	"harmonizowana",
	"harowana",
	"hartowana",
	"hibernowana",
	"hipnotyzowana",
	"hodowana",
	"holowana",
	"hołubiona",
	"honorowana",
	"hospitalizowana",
	"huknięta",
	"hulana",
	"huśtana",
	"idealizowana",
	"identyfikowana",
	"ignorowana",
	"igrana",
	"ilustrowana",
	"imitowana",
	"implantowana",
	"implodowana",
	"imponowana",
	"importowana",
	"improwizowana",
	"indokrynowana",
	"indukowana",
	"infekowana",
	"infiltrowana",
	"informowana",
	"ingerowana",
	"inhalowana",
	"inscenizowana",
	"inspirowana",
	"instalowana",
	"instruowana",
	"insynuowana",
	"integrowana",
	"interpretowana",
	"interweniowana",
	"intonowana",
	"intubowana",
	"inwestowana",
	"inwigilowana",
	"irytowana",
	"iskrzona",
	"izolowana",
	"jadana",
	"jawiona",
	"jazgotana",
	"jednoczona",
	"jedzona",
	"kablowana",
	"kadzona",
	"kalana",
	"kaleczona",
	"kalkulowana",
	"kamerowana",
	"kamienowana",
	"kamuflowana",
	"kanalizowana",
	"kantowanta",
	"kąpana",
	"kapitulowana",
	"kapowana",
	"karana",
	"karbonizowana",
	"karcona",
	"karczowana",
	"karmiona",
	"kartkowana",
	"kąsana",
	"kasowana",
	"kastrowana",
	"katalogowana",
	"katapultowana",
	"katowana",
	"katrupiona",
	"kierowana",
	"kimana",
	"kiszona",
	"kiwana",
	"kiwnięta",
	"kłaniana",
	"klapana",
	"klapnięta",
	"klarowana",
	"klasyfikowana",
	"klębiona",
	"klejona",
	"klepana",
	"klepnięta",
	"klikana",
	"kliknięta",
	"klonowana",
	"kłopotana",
	"kłuta",
	"knocona",
	"knuta",
	"kochana",
	"koczowana",
	"kodowana",
	"kojarzona",
	"kojfnięta",
	"kojona",
	"kolekcjonowana",
	"kolektywizowana",
	"kolidowana",
	"kolonizowana",
	"kolorowana",
	"koloryzowana",
	"kołowana",
	"kołysana",
	"kombinowana",
	"komenderowana",
	"komentowana",
	"komercjalizowana",
	"kompensowana",
	"komplementowana",
	"komplikowana",
	"komponowana",
	"kompromitowana",
	"komunikowana",
	"konana",
	"koncentrowana",
	"kończona",
	"konfabulowana",
	"konfiskowana",
	"konfrontowana",
	"konserwowana",
	"konspirowana",
	"konstruowana",
	"konsultowana",
	"konsumowana",
	"kontaktowana",
	"kontestowana",
	"kontrastowana",
	"kontrolowana",
	"kontrowana",
	"kontynuowana",
	"konwertowana",
	"konwojowana",
	"koordynowana",
	"kopana",
	"kopcona",
	"kopiowana",
	"kopnięta",
	"kopulowana",
	"korelowana",
	"korkowana",
	"koronowana",
	"korygowana",
	"korzona",
	"korzystana",
	"koszona",
	"kotwiczona",
	"kozaczona",
	"kozłowana",
	"kpita",
	"kradziona",
	"krajana",
	"krążona",
	"kręcona",
	"kremowana",
	"kreowana",
	"krochmalona",
	"krojona",
	"kropiona",
	"kruszona",
	"krystalizowana",
	"kryta",
	"krytykowana",
	"krzepnięta",
	"krzyczana",
	"krzyknięta",
	"krzywdzona",
	"krzywiona",
	"krzyżowana",
	"kserowana",
	"księgowana",
	"kształcona",
	"kształtowana",
	"kulona",
	"kultywowana",
	"kumulowana",
	"kupczona",
	"kupiona",
	"kupowana",
	"kupywana",
	"kurczona",
	"kurowana",
	"kursowana",
	"kurzona",
	"kuszona",
	"kuta",
	"kwalifikowana",
	"kwestionowana",
	"łączona",
	"ładowana",
	"łagodzona",
	"łajdaczona",
	"lakierowana",
	"łamana",
	"lamentowana",
	"lansowana",
	"lana",
	"łapana",
	"łaskotana",
	"łaszona",
	"latana",
	"łatana",
	"lawirowana",
	"leczona",
	"legalizowana",
	"legitymowana",
	"lekceważona",
	"lepiona",
	"lewitowana",
	"liberowana",
	"licencjonowana",
	"licytowana",
	"liczona",
	"likwidowana",
	"linczowana",
	"liniowana",
	"literowana",
	"litowana",
	"lizana",
	"liznięta",
	"lobbowana",
	"lokalizowana",
	"losowana",
	"łowiona",
	"łożona",
	"lubiana",
	"łudzona",
	"lunatykowana",
	"łupana",
	"łupiona",
	"łuskana",
	"lustrowana",
	"łuszczona",
	"luzowana",
	"łykana",
	"łyknięta",
	"łyżeczkowana",
	"macana",
	"machana",
	"machnięta",
	"mącona",
	"maczana",
	"maganyzowana",
	"maglowana",
	"majaczona",
	"majsterkowana",
	"majtana",
	"maksymalizowana",
	"malowana",
	"maltretowana",
	"mamiona",
	"mamrotana",
	"manewrowana",
	"manifestowana",
	"manipulowana",
	"markowana",
	"marnotrawiona",
	"marnowana",
	"marszczona",
	"marynowana",
	"marznięta",
	"masakrowana",
	"maskowana",
	"masowana",
	"masturbowana",
	"mataczona",
	"materializowana",
	"mawiana",
	"mazana",
	"maznięta",
	"męczona",
	"meldowana",
	"merdana",
	"metabolizowana",
	"miażdżona",
	"mielona",
	"mierzona",
	"mierzwiona",
	"mieszana",
	"miętolona",
	"migana",
	"migdalona",
	"migotana",
	"mijana",
	"miksowana",
	"milowana",
	"minięta",
	"minimalizowana",
	"miotana",
	"mistyfikowana",
	"mitygowana",
	"mizdrzona",
	"mlana",
	"mniemana",
	"mnożona",
	"mobilizowana",
	"mocowana",
	"moczona",
	"modelowana",
	"modernizowana",
	"modlona",
	"modulowana",
	"modyfikowana",
	"molestowana",
	"monitorowana",
	"monopolizowana",
	"montowana",
	"mordowana",
	"motywowana",
	"mówiona",
	"mrożona",
	"mrugana",
	"mrużona",
	"muskana",
	"mutowana",
	"mydlona",
	"mylona",
	"myszkowana",
	"myta",
	"nabazgrana",
	"nabiegana",
	"nabierana",
	"nabita",
	"nabrana",
	"nabrojona",
	"nabrudzona",
	"nabyta",
	"nabywana",
	"nacelowana",
	"nachapana",
	"nachodzona",
	"nachwalona",
	"nachylona",
	"naciągana",
	"naciągnięta",
	"nacierana",
	"nacięta",
	"nacinana",
	"naciskana",
	"naciśnięta",
	"nacjonalizowana",
	"naczepiona",
	"nadana",
	"nadawana",
	"nadchodzona",
	"nadciągana",
	"nadciągnięta",
	"nadcięta",
	"nadesłana",
	"nadgoniona",
	"nadgryzana",
	"nadgryziona",
	"nadinterpretowana",
	"nadłożona",
	"nadmieniana",
	"nadmieniona",
	"nadmuchana",
	"nadrabiana",
	"nadrobiona",
	"nadskakiwana",
	"nadsłuchiwana",
	"nadstawiana",
	"nadstawiona",
	"nadszarpnięta",
	"naduszona",
	"nadużyta",
	"nadużywana",
	"nadwerężana",
	"nadwyrężana",
	"nadwyrężona",
	"nadziana",
	"nadzorowana",
	"naelektryzowana",
	"nafaszerowana",
	"nagabywana",
	"nagadana",
	"nagięta",
	"naginana",
	"nagłaszana",
	"nagłośniona",
	"nagoniona",
	"nagradzana",
	"nagrana",
	"nagrodzona",
	"nagromadzona",
	"nagrywana",
	"nagryzmolona",
	"nagrzana",
	"nagrzebana",
	"nagrzewana",
	"nagwizdana",
	"naigrywana",
	"najechana",
	"najęta",
	"najmowana",
	"nakarmiana",
	"nakarmiona",
	"nakazana",
	"nakazywana",
	"nakierowana",
	"nakierowywana",
	"nakładana",
	"nakłamana",
	"nakłaniana",
	"naklejana",
	"naklejona",
	"naklepana",
	"nakłoniona",
	"nakłuta",
	"nakłuwana",
	"nakopana",
	"nakręcana",
	"nakręcona",
	"nakreślana",
	"nakreślona",
	"nakruszona",
	"nakryta",
	"nakrywana",
	"nakrzyczana",
	"nakupiona",
	"naładowana",
	"nalana",
	"nałapana",
	"nalepiona",
	"nalewana",
	"naliczona",
	"nałowiona",
	"nałożona",
	"namaczana",
	"namagnetyzowana",
	"namalowana",
	"namaszczana",
	"namaszczona",
	"namawiana",
	"namęczona",
	"namierzana",
	"namieszana",
	"namoczona",
	"namówiona",
	"namydlana",
	"namyślona",
	"naniesiona",
	"naoliwiana",
	"naoliwiona",
	"naopowiadana",
	"naostrzona",
	"napadana",
	"napadnięta",
	"napakowana",
	"napalona",
	"naparzana",
	"napastowana",
	"napawana",
	"napchana",
	"napędzana",
	"napełniana",
	"napełniona",
	"napierana",
	"napiętnowana",
	"napięta",
	"napinana",
	"napisana",
	"napluta",
	"napływana",
	"napoczęta",
	"napojona",
	"napompowana",
	"napotkana",
	"napotykana",
	"napraszana",
	"naprawiana",
	"naprawiona",
	"naprężana",
	"naprężona",
	"napromieniowana",
	"naprostowana",
	"naprowadzana",
	"naprowadzona",
	"napsuta",
	"napuszczana",
	"napuszczona",
	"napychana",
	"napytana",
	"narąbana",
	"naradzana",
	"naradzona",
	"narastana",
	"narażana",
	"narażona",
	"nareperowana",
	"narkotyzowana",
	"narodzona",
	"naruszana",
	"naruszona",
	"narwana",
	"narysowana",
	"narzucana",
	"narzucona",
	"nasączana",
	"nasączona",
	"nasadzona",
	"nasiąkana",
	"nasilana",
	"nasilona",
	"naskakiwana",
	"naskoczona",
	"naskrobana",
	"naśladowana",
	"nasłana",
	"nasłuchana",
	"nasłuchiwana",
	"nasmarowana",
	"nastąpiona",
	"nastawiana",
	"nastawiona",
	"nastraszana",
	"nastrojona",
	"nastukana",
	"nasunięta",
	"nasuwana",
	"naświetlana",
	"nasycona",
	"nasyłana",
	"nasypana",
	"naszczana",
	"naszkicowana",
	"naszpikowana",
	"naszprycowana",
	"naszykowana",
	"naszyta",
	"naszywana",
	"natarta",
	"natchnięta",
	"natknięta",
	"natleniona",
	"natłuszczona",
	"natrafiona",
	"natrząsana",
	"natrząsnięta",
	"nauczana",
	"nauczona",
	"nawadniana",
	"nawalona",
	"nawiązana",
	"nawiązywana",
	"nawiedzana",
	"nawiedzona",
	"nawiercona",
	"nawiewana",
	"nawieziona",
	"nawigowana",
	"nawijana",
	"nawilżana",
	"nawilżona",
	"nawinięta",
	"nawlekana",
	"nawodniona",
	"nawoływana",
	"nawoskowana",
	"nawożona",
	"nawpychana",
	"nawracana",
	"nawrócona",
	"nawrzucana",
	"nawtykana",
	"nawymyślana",
	"nazbierana",
	"nazmyślana",
	"naznaczana",
	"naznaczona",
	"nazrywana",
	"nazwana",
	"nazywana",
	"nęcona",
	"negocjowana",
	"negowana",
	"nękana",
	"neutralizowana",
	"niańczona",
	"niecierpliwiona",
	"niedoceniana",
	"niedowidziana",
	"nienawidzona",
	"niesiona",
	"nikolona",
	"niszczona",
	"nitkowana",
	"niuchana",
	"niweczona",
	"niwelowana",
	"nokautowana",
	"nominowana",
	"notowana",
	"nucona",
	"numerowana",
	"nurtowana",
	"obaczona",
	"obadana",
	"obalana",
	"obalona",
	"obandażowana",
	"obarczana",
	"obarczona",
	"obawiana",
	"obchodzona",
	"obciągnięta",
	"obciążona",
	"obcięta",
	"obcinana",
	"obcyndalana",
	"obczajana",
	"obczajona",
	"obdarowana",
	"obdarta",
	"obdarzana",
	"obdarzona",
	"obdzielona",
	"obdzierana",
	"obdzwaniana",
	"obdzwoniona",
	"obejmowana",
	"oberwana",
	"obessana",
	"obezwładniana",
	"obezwładniona",
	"obfotografowana",
	"obfotografowywana",
	"obgadana",
	"obgadywana",
	"obgryzana",
	"obgryziona",
	"obiecana",
	"obiecywana",
	"obierana",
	"obijana",
	"obita",
	"objadana",
	"objaśniana",
	"objawiana",
	"objawiona",
	"objechana",
	"objęta",
	"objeżdżana",
	"obkręcana",
	"oblana",
	"obłapiana",
	"obłapywana",
	"obłaskawiana",
	"obłaskawiona",
	"obleciana",
	"oblegana",
	"oblewana",
	"obliczana",
	"obliczona",
	"oblizana",
	"obłowiona",
	"obłożona",
	"obluzowana",
	"obluzowywana",
	"obmacana",
	"obmacywana",
	"obmawiana",
	"obmyślana",
	"obmyślona",
	"obmyta",
	"obmywana",
	"obnażana",
	"obniżana",
	"obniżona",
	"obnoszona",
	"obowiązywana",
	"obozowana",
	"obrabiana",
	"obrabowana",
	"obracana",
	"obradowana",
	"obramowana",
	"obraniana",
	"obrana",
	"obrastana",
	"obrażana",
	"obrażona",
	"obrobiona",
	"obrócona",
	"obrodzona",
	"obroniona",
	"obrysowana",
	"obrywana",
	"obryzgana",
	"obrzezana",
	"obrzucana",
	"obrzucona",
	"obrzygana",
	"obsadzana",
	"obsadzona",
	"obściskiwana",
	"obserwowana",
	"obsiana",
	"obsikana",
	"obsikiwana",
	"obskakiwana",
	"obskoczona",
	"obskubana",
	"obskubywana",
	"obśliniana",
	"obśliniona",
	"obsługiwana",
	"obsłużona",
	"obsmarowana",
	"obstawiana",
	"obstawiona",
	"obstrzeliwana",
	"obsunięta",
	"obsuwana",
	"obsypana",
	"obsypywana",
	"obszukana",
	"obszukiwana",
	"obtaczana",
	"obtarta",
	"obtoczona",
	"obudzona",
	"obwąchana",
	"obwąchiwana",
	"obwiązana",
	"obwiązywana",
	"obwieszana",
	"obwieszczana",
	"obwieszczona",
	"obwieszona",
	"obwijana",
	"obwiniana",
	"obwinięta",
	"obwołana",
	"obyta",
	"obżerana",
	"ocalana",
	"ocalona",
	"ocechowana",
	"oceniana",
	"oceniona",
	"ocenzurowana",
	"ochładzana",
	"ochlapana",
	"ochlapywana",
	"ochłodzona",
	"ochłonięta",
	"ochraniana",
	"ochroniona",
	"ochrzaniana",
	"ochrzczona",
	"ociągana",
	"ocielona",
	"ocieplana",
	"ocieplona",
	"ocierana",
	"ocknięta",
	"ocucona",
	"ocuta",
	"oczarowywana",
	"oczekiwana",
	"oczerniana",
	"oczerniona",
	"oczyszczana",
	"oczyszczona",
	"odarta",
	"odbębniona",
	"odbetonowana",
	"odbezpieczana",
	"odbezpieczona",
	"odbijana",
	"odbita",
	"odblokowana",
	"odbudowana",
	"odbudowywana",
	"odbutowana",
	"odbyta",
	"odcedzana",
	"odchorowana",
	"odchowana",
	"odchudzana",
	"odchudzona",
	"odchylana",
	"odchylona",
	"odciągana",
	"odciągnięta",
	"odciążona",
	"odcierpiona",
	"odcięta",
	"odcinana",
	"odcisnięta",
	"odcumowana",
	"odcyfrowana",
	"odcyfrowywana",
	"odczarowana",
	"odczekana",
	"odczepiana",
	"odczepiona",
	"odczuta",
	"odczuwana",
	"odczyniona",
	"odczytana",
	"odczytywana",
	"oddalana",
	"oddana",
	"oddawana",
	"oddelegowana",
	"oddychana",
	"oddzielana",
	"oddzielona",
	"odebrana",
	"odegnana",
	"odegrana",
	"odejmowana",
	"odepchnięta",
	"oderwana",
	"odeskortowana",
	"odesłana",
	"odespana",
	"odessana",
	"odetkana",
	"odetnięta",
	"odezwana",
	"odfiltrowana",
	"odgadnięta",
	"odgadywana",
	"odganiana",
	"odgarniana",
	"odgarnięta",
	"odgięta",
	"odgniatana",
	"odgoniona",
	"odgradzana",
	"odgrażana",
	"odgrodzona",
	"odgruzowana",
	"odgrywana",
	"odgryzana",
	"odgryziona",
	"odgrzana",
	"odgrzebana",
	"odgrzebywana",
	"odgrzewana",
	"odgwizdana",
	"odhaczona",
	"odholowana",
	"odinstalowana",
	"odizolowana",
	"odjedzona",
	"odjęta",
	"odjonizowana",
	"odkażana",
	"odkażona",
	"odkładana",
	"odklejona",
	"odkochana",
	"odkodowana",
	"odkodowywana",
	"odkopana",
	"odkopywana",
	"odkorkowana",
	"odkręcana",
	"odkręcona",
	"odkrojona",
	"odkryta",
	"odkrywana",
	"odkupiona",
	"odkupywana",
	"odkurzana",
	"odkurzona",
	"odkuta",
	"odłączana",
	"odłączona",
	"odłamywana",
	"odlana",
	"odlatywana",
	"odlepiana",
	"odlewana",
	"odliczana",
	"odliczona",
	"odłożona",
	"odłupana",
	"odmachana",
	"odmachiwana",
	"odmalowana",
	"odmarszczona",
	"odmawiana",
	"odmeldowana",
	"odmieniana",
	"odmieniona",
	"odmierzana",
	"odmierzona",
	"odmieszana",
	"odmontowana",
	"odmówiona",
	"odmrażana",
	"odmrożona",
	"odnajdowana",
	"odnaleziona",
	"odnawiana",
	"odniesiona",
	"odnoszona",
	"odnotowana",
	"odnotowywana",
	"odnowiona",
	"odpakowana",
	"odpakowywana",
	"odpalana",
	"odpalona",
	"odpałzowana",
	"odparowana",
	"odparta",
	"odpędzana",
	"odpicowana",
	"odpieczętowana",
	"odpierana",
	"odpięta",
	"odpiłowana",
	"odpiłowywana",
	"odpinana",
	"odpisana",
	"odpisywana",
	"odpłacana",
	"odplamiona",
	"odplątana",
	"odpłynięta",
	"odpowietrzona",
	"odpracowana",
	"odpracowywana",
	"odprasowana",
	"odprawiana",
	"odprawiona",
	"odprężana",
	"odprostowana",
	"odprowadzana",
	"odprowadzona",
	"odpruta",
	"odpryskana",
	"odpukana",
	"odpukiwana",
	"odpuszczana",
	"odpuszczona",
	"odpychana",
	"odrąbana",
	"odrabiana",
	"odrąbywana",
	"odradzana",
	"odradzona",
	"odrapana",
	"odrastana",
	"odratowana",
	"odreagowana",
	"odremontowana",
	"odrestaurowana",
	"odrestaurowywana",
	"odrobaczana",
	"odrobiona",
	"odroczona",
	"odrodzona",
	"odrośnięta",
	"odróżniana",
	"odróżniona",
	"odrysowana",
	"odrywana",
	"odrzucana",
	"odrzucona",
	"odsączana",
	"odsączona",
	"odsadzona",
	"odseparowana",
	"odsiadywana",
	"odsiana",
	"odsiewana",
	"odsłaniana",
	"odsłonięta",
	"odsłuchana",
	"odsłuchiwana",
	"odsłużona",
	"odśnieżana",
	"odśnieżona",
	"odsolona",
	"odśpiewana",
	"odsprzedana",
	"odsprzedawana",
	"odstąpiona",
	"odstawiana",
	"odstawiona",
	"odstępowana",
	"odstraszana",
	"odstręczona",
	"odstresowana",
	"odstrzeliwana",
	"odstrzelona",
	"odsunięta",
	"odsuwana",
	"odświeżana",
	"odświeżona",
	"odsyłana",
	"odsypywana",
	"odsysana",
	"odszczekana",
	"odszczekiwana",
	"odsztafirowana",
	"odszukana",
	"odszyfrowana",
	"odszyfrowywana",
	"odszykowana",
	"odtrąbiona",
	"odtrącona",
	"odtruta",
	"odtwarzana",
	"odtworzona",
	"oduczona",
	"odurzona",
	"odwalana",
	"odwalona",
	"odwiązana",
	"odwiązywana",
	"odwiedzana",
	"odwiedzona",
	"odwieszona",
	"odwieziona",
	"odwijana",
	"odwinięta",
	"odwlekana",
	"odwodniona",
	"odwodzona",
	"odwołana",
	"odwoływana",
	"odwożona",
	"odwracana",
	"odwrócona",
	"odwzajemniona",
	"odwzorowana",
	"odżegnana",
	"odziana",
	"odziedziczona",
	"odznaczana",
	"odznaczona",
	"odzwieciedlona",
	"odzwierciedlana",
	"odzwoniona",
	"odzwyczajona",
	"odzyskana",
	"odzyskiwana",
	"odżyta",
	"odzywiana",
	"odżywiona",
	"oferowana",
	"ofiarowana",
	"ofiarowywana",
	"ogarniana",
	"ogarnięta",
	"oglądana",
	"ogłaszana",
	"ogłoszona",
	"ogłupiana",
	"ogłupiona",
	"ogłuszona",
	"ogołocona",
	"ogolona",
	"ograbiana",
	"ograbiona",
	"ograniczana",
	"ograniczona",
	"ograna",
	"ogrodzona",
	"ogryziona",
	"ogrzana",
	"ogrzewana",
	"okablowana",
	"okaleczona",
	"okantowana",
	"okąpana",
	"okazana",
	"okazywana",
	"okiełznana",
	"okładana",
	"okłamana",
	"okłamywana",
	"oklaskiwana",
	"oklejona",
	"oklepana",
	"okopana",
	"okopywana",
	"okpiona",
	"okradana",
	"okradziona",
	"okraszona",
	"okrążana",
	"okrążona",
	"okręcana",
	"okręcona",
	"określana",
	"określona",
	"okrojona",
	"okryta",
	"okrywana",
	"okrzyknięta",
	"okulawiona",
	"okupiona",
	"okupowana",
	"olana",
	"olewana",
	"olśnięta",
	"omamiona",
	"omawiana",
	"omdlewana",
	"omijana",
	"ominięta",
	"omotana",
	"omówiona",
	"onanizowana",
	"onieśmielana",
	"onieśmielona",
	"opadnięta",
	"opakowana",
	"opalana",
	"opalona",
	"opancerzona",
	"opanowana",
	"opanowywana",
	"oparta",
	"oparzona",
	"opasana",
	"opatentowana",
	"opatrywana",
	"opatrzona",
	"opatulona",
	"opchnięta",
	"opędzana",
	"opędzona",
	"operowana",
	"opętana",
	"opętywana",
	"opieczętowana",
	"opiekowana",
	"opierana",
	"opijana",
	"opisana",
	"opisywana",
	"opita",
	"opłacana",
	"opłacona",
	"opłakana",
	"opłakiwana",
	"opłukana",
	"opluta",
	"opluwana",
	"opływana",
	"opodatkowana",
	"opodatkowywana",
	"oponowana",
	"oporządzana",
	"oporządzona",
	"opowiadana",
	"opowiedziana",
	"opóźniana",
	"opóźniona",
	"opracowana",
	"opracowywana",
	"oprawiana",
	"oprawiona",
	"oprowadzana",
	"oprowadzona",
	"opróżniana",
	"opróżniona",
	"opryskana",
	"opryskiwana",
	"opublikowana",
	"opukana",
	"opuszczana",
	"opuszczona",
	"opychana",
	"opylona",
	"orana",
	"orbowana",
	"organizowana",
	"orientowana",
	"oroszona",
	"orzekana",
	"orżnięta",
	"osaczana",
	"osaczona",
	"osadzana",
	"osądzana",
	"osadzona",
	"osądzona",
	"oscylowana",
	"osiadana",
	"osiągana",
	"osiągnięta",
	"osiedlana",
	"osiedlona",
	"osiedzona",
	"osierocona",
	"osiodłana",
	"oskalpowana",
	"oskarżona",
	"oskrobana",
	"oskrzydlana",
	"oskrzydlona",
	"oskubana",
	"oskubywana",
	"osłabiana",
	"osłabiona",
	"oślepiana",
	"oślepiona",
	"oślepnięta",
	"ośliniana",
	"osłodzona",
	"osłoniona",
	"osłuchana",
	"osmalona",
	"ośmielona",
	"ośmieszana",
	"ośmieszona",
	"ostrzegana",
	"ostrzelana",
	"ostrzelita",
	"ostrzona",
	"ostudzona",
	"osunięta",
	"osuszana",
	"osuszona",
	"osuwana",
	"oswajana",
	"oświadczana",
	"oświadczona",
	"oświecana",
	"oświeciona",
	"oświetlana",
	"oświetlona",
	"oswobadzana",
	"oswobodzona",
	"oswojona",
	"oszacowana",
	"oszałamiana",
	"oszczana",
	"oszczędzana",
	"oszczędzona",
	"oszklona",
	"oszlifowana",
	"oszołomiona",
	"oszpecona",
	"oszukana",
	"oszukiwana",
	"oszwabiona",
	"otaczana",
	"otarta",
	"otoczona",
	"otruta",
	"otruwana",
	"otrząsana",
	"otrząśnięta",
	"otrzepana",
	"otrzeźwiona",
	"otrzymana",
	"otrzymywana",
	"otulona",
	"otumaniona",
	"otwierana",
	"otworzona",
	"otwarta",
	"owana",
	"owdowiona",
	"owiana",
	"owijana",
	"owinięta",
	"ozdabiana",
	"ozdobiona",
	"ozdrowiona",
	"ożeniona",
	"oznaczana",
	"oznaczona",
	"oznajmiana",
	"oznajmiona",
	"oznakowana",
	"ożyta",
	"ożywana",
	"ożywiana",
	"ożywiona",
	"pachnąca",
	"pacnąta",
	"pakowana",
	"paktowana",
	"pałana",
	"pałaszowana",
	"palnięta",
	"palona",
	"pamiętana",
	"panoszona",
	"paprana",
	"parafrazowana",
	"paraliżowana",
	"parkowana",
	"parowana",
	"partaczona",
	"parta",
	"parzona",
	"pastowana",
	"paszona",
	"patrolowana",
	"patroszona",
	"patrzona",
	"pauzowana",
	"pchana",
	"pchnięta",
	"pdholowana",
	"pedałowana",
	"pękana",
	"pęknięta",
	"pełniona",
	"penetrowana",
	"perforowana",
	"perfumowana",
	"perswadowana",
	"piastowana",
	"pichcona",
	"pielęgnowana",
	"pielona",
	"pieniona",
	"pieszczona",
	"piętnowana",
	"pięta",
	"pijana",
	"pikietowana",
	"piknikowana",
	"pikowana",
	"pilnowana",
	"pilotowana",
	"piłowana",
	"pisana",
	"pisywana",
	"pita",
	"płacona",
	"plądrowana",
	"plamiona",
	"planowana",
	"płaszczona",
	"plątana",
	"płatana",
	"pławiona",
	"plewiona",
	"płonąca",
	"płoszona",
	"plotkowana",
	"plugawiona",
	"płukana",
	"pluskana",
	"pluta",
	"pobaraszkowana",
	"pobierana",
	"pobita",
	"pobłażana",
	"pobłogosławiona",
	"pobrana",
	"pobrudzona",
	"pobudzana",
	"pobudzona",
	"pobujana",
	"pocałowana",
	"pocerowana",
	"pochłaniana",
	"pochlapana",
	"pochlebiana",
	"pochłonięta",
	"pochowana",
	"pochwalana",
	"pochwalona",
	"pochwycona",
	"pochylana",
	"pochylona",
	"pociachana",
	"pociągana",
	"pociągnięta",
	"pocierana",
	"pocieszana",
	"pocieszona",
	"pocięta",
	"pocona",
	"pocukrowana",
	"poćwiartowana",
	"poczesana",
	"poczęstowana",
	"poczęta",
	"poczochrana",
	"poczuta",
	"poczytana",
	"poczytywana",
	"podana",
	"podarowana",
	"podarta",
	"podawana",
	"podążona",
	"podbierana",
	"podbijana",
	"podbita",
	"podbudowana",
	"podbudowywana",
	"podburzana",
	"podburzona",
	"podchwycona",
	"podciągana",
	"podciągnięta",
	"podcierana",
	"podcięta",
	"podcinana",
	"podczepiona",
	"poddana",
	"poddawana",
	"podebrana",
	"podejmowana",
	"podejrzana",
	"podejrzewana",
	"podelektowana",
	"podeptana",
	"poderwana",
	"podesłana",
	"podglądana",
	"podgolona",
	"podgoniona",
	"podgryzana",
	"podgrzana",
	"podgrzewana",
	"podjadana",
	"podjedzona",
	"podjęta",
	"podkablowana",
	"podkarmiona",
	"podkładana",
	"podklejona",
	"podkolorowana",
	"podkołowana",
	"podkopana",
	"podkopywana",
	"podkradana",
	"podkradnięta",
	"podkręcana",
	"podkręcona",
	"podkreślana",
	"podkreślona",
	"podkształcona",
	"podkulona",
	"podkupiona",
	"podkurzona",
	"podkuta",
	"podłączana",
	"podłączona",
	"podładowana",
	"podłamana",
	"podlana",
	"podłapana",
	"podleczona",
	"podlegana",
	"podlewana",
	"podliczana",
	"podliczona",
	"podlizana",
	"podlizywana",
	"podłożona",
	"podmalowana",
	"podmieniana",
	"podmieniona",
	"podmuchana",
	"podmyta",
	"podnajęta",
	"podniecana",
	"podniecona",
	"podniesiona",
	"podnoszona",
	"podołana",
	"podopingowana",
	"podostrzona",
	"podotykana",
	"podpadnięta",
	"podpalana",
	"podpalona",
	"podparta",
	"podpatrywana",
	"podpatrzona",
	"podpieczętowana",
	"podpiekana",
	"podpierana",
	"podpięta",
	"podpiłowana",
	"podpinana",
	"podpisana",
	"podpisywana",
	"podpłacona",
	"podpłynięta",
	"podpompowana",
	"podporządkowana",
	"podporządkowywana",
	"podpowiadana",
	"podpowiedziana",
	"podprowadzana",
	"podpuszczana",
	"podpuszczona",
	"podpychana",
	"podpytana",
	"podrabiana",
	"podrapana",
	"podrasowana",
	"podratowana",
	"podrażniona",
	"podręczona",
	"podregulowana",
	"podreperowana",
	"podretuszowana",
	"podrobiona",
	"podroczona",
	"podróżowana",
	"podrygiwana",
	"podrywana",
	"podrzucana",
	"podrzucona",
	"podrzynana",
	"podsadzona",
	"podskubywana",
	"podsłuchana",
	"podsłuchiwana",
	"podsmażana",
	"podsmażona",
	"podśpiewywana",
	"podstawiana",
	"podstawiona",
	"podstemplowana",
	"podstrojona",
	"podsumowana",
	"podsumowywana",
	"podsunięta",
	"podsuwana",
	"podświetlana",
	"podsycana",
	"podsycona",
	"podsyłana",
	"podsypana",
	"podszczypywana",
	"podszkolona",
	"podszlifowana",
	"podszykowana",
	"podszyta",
	"podszywana",
	"podtapiana",
	"podtarta",
	"podtopiona",
	"podtrzymana",
	"podtrzymywana",
	"podtuczona",
	"poduczana",
	"podupadana",
	"poduszona",
	"podwajana",
	"podwalana",
	"podważana",
	"podwędzona",
	"podwiązana",
	"podwieszana",
	"podwieziona",
	"podwijana",
	"podwinięta",
	"podwojona",
	"podwożona",
	"podwyżana",
	"podwyższana",
	"podwyższona",
	"podyktowana",
	"podyskutowana",
	"podziabana",
	"podziałana",
	"podziałkowana",
	"podziękowana",
	"podzielona",
	"podziurawiona",
	"podziwiana",
	"podźwignięta",
	"poeksperymentowana",
	"pofarbowana",
	"pofatygowana",
	"pofilmowana",
	"poganiana",
	"pogardzana",
	"pogardzona",
	"pogarszana",
	"pogaszona",
	"pogładzona",
	"pogłaskana",
	"pogłębiana",
	"pogłębiona",
	"pogłośniona",
	"pogmatwana",
	"pognębiona",
	"pognieciona",
	"pogodzona",
	"pogoniona",
	"pogorszona",
	"pogotowana",
	"pograbiona",
	"pogrążana",
	"pogrążona",
	"pogrożona",
	"pogrubiana",
	"pogrubiona",
	"pogruchana",
	"pogruchotana",
	"pogrupowana",
	"pogrywana",
	"pogryzana",
	"pogryziona",
	"pogrzana",
	"pogrzebana",
	"pogubiona",
	"pogwałcana",
	"pohamowana",
	"pohandlowana",
	"poharatowana",
	"pohuśtana",
	"poinformowana",
	"poinstruowana",
	"pojednana",
	"pojęta",
	"pojmięta",
	"pojmowana",
	"pojona",
	"pokajana",
	"pokaleczona",
	"pokarana",
	"pokarmiona",
	"pokąsana",
	"pokatalogowana",
	"pokazana",
	"pokazywana",
	"pokiereszowana",
	"pokierowana",
	"pokiwana",
	"pokładana",
	"poklepana",
	"poklepywana",
	"pokłoniona",
	"pokłuta",
	"pokochana",
	"pokolorowana",
	"pokoloryzowana",
	"pokołysana",
	"pokombinowana",
	"pokomplikowana",
	"pokonana",
	"pokończona",
	"pokonywana",
	"pokopana",
	"pokrajana",
	"pokrążona",
	"pokręcona",
	"pokrojona",
	"pokruszona",
	"pokryta",
	"pokrywana",
	"pokrzepiana",
	"pokrzepiona",
	"pokrzyżowana",
	"pokuszona",
	"pokutowana",
	"połączona",
	"polakierowana",
	"połamana",
	"polana",
	"połapana",
	"połaskotana",
	"połatana",
	"polecana",
	"połechtana",
	"polecona",
	"poleczona",
	"polegana",
	"polemizowana",
	"polepszana",
	"polepszona",
	"polerowana",
	"polewana",
	"policzkowana",
	"policzona",
	"polimeryzowana",
	"polizana",
	"połknięta",
	"polowana",
	"połowiona",
	"położona",
	"polubiona",
	"poluźniona",
	"poluzowana",
	"połykana",
	"pomacana",
	"pomachana",
	"pomagana",
	"pomalowana",
	"pomarynowana",
	"pomasowana",
	"pomazana",
	"pomęczona",
	"pomiatana",
	"pomieszana",
	"pomieszczona",
	"pomijana",
	"pominięta",
	"pomiziana",
	"pomknięta",
	"pomnażana",
	"pomniejszana",
	"pomniejszona",
	"pomnożona",
	"pomoczona",
	"pompowana",
	"pomydlona",
	"pomylona",
	"pomyszkowana",
	"pomywana",
	"ponabijana",
	"ponaciskana",
	"ponadziewana",
	"ponaglana",
	"ponaglona",
	"ponagrywana",
	"ponaklejana",
	"ponakłuwana",
	"ponakrywana",
	"ponaprawiana",
	"ponawiana",
	"poniańczona",
	"poniechana",
	"ponieiwerana",
	"poniesiona",
	"poniszczona",
	"poniżana",
	"poniżona",
	"ponoszona",
	"ponowiona",
	"ponudzona",
	"poobcinana",
	"poobcowana",
	"poobczajana",
	"poobijana",
	"poobmacywana",
	"poobracana",
	"poobserwowana",
	"poodbijana",
	"poodcinana",
	"poodgryzana",
	"poodkurzana",
	"poodprawiana",
	"poodsuwana",
	"poodwalana",
	"pooglądana",
	"poograniczana",
	"poopalana",
	"poopiekana",
	"poopwiadana",
	"pootwierana",
	"popadana",
	"popakowana",
	"popalona",
	"poparta",
	"poparzona",
	"popchana",
	"popchnięta",
	"popędzana",
	"popędzona",
	"popękana",
	"popełniana",
	"popełniona",
	"poperfumowana",
	"popierana",
	"popieszczona",
	"popijana",
	"popilnowana",
	"popisana",
	"popita",
	"popłacona",
	"popłakiwana",
	"poplamiona",
	"poplątana",
	"popluskana",
	"popodcinana",
	"popodziwiana",
	"popoprawiana",
	"poprana",
	"poprasowana",
	"poprawiana",
	"poprawiona",
	"poproszona",
	"poprowadzona",
	"popryskana",
	"poprzebierana",
	"poprzeciągana",
	"poprzecinana",
	"poprzedzana",
	"poprzeglądana",
	"poprzeklinana",
	"poprzekopywana",
	"poprzemieszczana",
	"poprzenoszona",
	"poprzesadzana",
	"poprześladowana",
	"poprzestawiana",
	"poprzesuwana",
	"poprzewieszana",
	"poprzewracana",
	"poprzycinana",
	"poprzymierzana",
	"poprzytulana",
	"poprzywiązywana",
	"popsuta",
	"popudrowana",
	"popukana",
	"popularyzowana",
	"popuszczana",
	"popuszczona",
	"popychana",
	"popykana",
	"popytana",
	"porabiana",
	"porachowana",
	"poraniona",
	"poratowana",
	"porażona",
	"poręczona",
	"porównana",
	"porozbierana",
	"porozbijana",
	"porozciągana",
	"porozcinana",
	"porozdawana",
	"porozdzielana",
	"porozmieszczana",
	"poróżniona",
	"porozpędzana",
	"porozpieszczana",
	"porozprowadzana",
	"porozpruwana",
	"porozrzucana",
	"porozstawiana",
	"porozsyłana",
	"porozumiewana",
	"porozwalana",
	"porozwiązywana",
	"porozwieszana",
	"porozwożona",
	"portretowana",
	"poruszana",
	"poruszona",
	"porwana",
	"porysowana",
	"porywana",
	"porządkowana",
	"porządzona",
	"porzucana",
	"porzucona",
	"posądzana",
	"posadzona",
	"posądzona",
	"pościągana",
	"pościelona",
	"pościerana",
	"pościgana",
	"pościnana",
	"pościskana",
	"posegregowana",
	"posiadana",
	"posiana",
	"posiekana",
	"posilana",
	"posiłkowana",
	"posilona",
	"posiłowana",
	"posiniaczona",
	"posiorbana",
	"poskąpiona",
	"poskładana",
	"posklejana",
	"poskramiana",
	"poskręcana",
	"poskrobana",
	"poskromiona",
	"poskubana",
	"posłana",
	"posłodzona",
	"poślubiana",
	"poślubiona",
	"posługiwana",
	"posmakowana",
	"posmarowana",
	"posolona",
	"posortowana",
	"pospekulowana",
	"pospieszana",
	"pośpieszana",
	"pośpiewana",
	"pospinana",
	"pospłacana",
	"posprawdzana",
	"posprzątana",
	"posprzedawana",
	"pośredniczona",
	"possana",
	"postanowiona",
	"postana",
	"postarana",
	"postawiona",
	"postemplowana",
	"posterowana",
	"postradana",
	"postraszona",
	"postrugana",
	"postrzegana",
	"postrzelana",
	"postrzelona",
	"postukana",
	"postymulowana",
	"posunięta",
	"posuwana",
	"poświącana",
	"poświadczona",
	"poświecona",
	"poświęcona",
	"poświętowana",
	"poświntuszona",
	"posyłana",
	"posypana",
	"posypywana",
	"poszarpana",
	"poszastana",
	"poszatkowana",
	"poszczuta",
	"poszczycona",
	"poszczypana",
	"poszerzana",
	"poszerzona",
	"poszorowana",
	"poszpiegowana",
	"poszturchana",
	"poszukana",
	"poszukiwana",
	"poszwędana",
	"poszybowana",
	"potakiwana",
	"potarmoszona",
	"potarta",
	"potasowana",
	"potęgowana",
	"potępiana",
	"potępiona",
	"potknięta",
	"potoczona",
	"potopiona",
	"potorturowana",
	"potrącana",
	"potrącona",
	"potraktowana",
	"potrojona",
	"potruta",
	"potrząsana",
	"potrzaskana",
	"potrząsnięta",
	"potrząśnięta",
	"potrzymana",
	"Poturbowana",
	"poturlana",
	"potwierdzona",
	"potykana",
	"poucinana",
	"pouczana",
	"pouczona",
	"poudawana",
	"poukładana",
	"pouprawiana",
	"poupychana",
	"pourywana",
	"poustawiana",
	"poużywana",
	"powąchana",
	"powachlowana",
	"powalana",
	"powalona",
	"poważana",
	"powbijana",
	"powciągana",
	"powciskana",
	"powdychana",
	"powęszona",
	"powetowana",
	"powiadamiana",
	"powiadomiona",
	"powiązana",
	"powiedziana",
	"powiedzona",
	"powiększana",
	"powielana",
	"powielona",
	"powierzana",
	"powierzona",
	"powieszona",
	"powiewana",
	"powinszowana",
	"powitana",
	"powita",
	"powkładana",
	"powlekana",
	"powłóczona",
	"powodowana",
	"powołana",
	"powoływana",
	"powożona",
	"powpychana",
	"powrócona",
	"powrzucana",
	"powsadzana",
	"powściągnięta",
	"powspominana",
	"powstrzymana",
	"powtarzana",
	"powtórzona",
	"powybierana",
	"powybijana",
	"powycierana",
	"powycinana",
	"powyciskana",
	"powydawana",
	"powyganiana",
	"powyginana",
	"powyjaśniana",
	"powyjmowana",
	"powyłączana",
	"powymiatana",
	"powymieniana",
	"powynoszona",
	"powypełniana",
	"powypisywana",
	"powyrywana",
	"powyrzucana",
	"powystrzelana",
	"powysyłana",
	"powywalana",
	"powywieszana",
	"powywracana",
	"powzięta",
	"pozabawiana",
	"pozabijana",
	"pozacierana",
	"pożądana",
	"pożądlona",
	"pozadzierana",
	"pozakładana",
	"pozaklinana",
	"pozałatwiana",
	"pozamiatana",
	"pozamieniana",
	"pozamrażana",
	"pozamykana",
	"pozapalana",
	"pozapinana",
	"pozapisywana",
	"pozapraszana",
	"pożarta",
	"pozasłaniana",
	"pozastrzelana",
	"pozatykana",
	"pozbawiana",
	"pozbawiona",
	"pozbierana",
	"pozbyta",
	"pozbywana",
	"pozdejmowana",
	"pozdrawiana",
	"pozdrowiona",
	"pożegnana",
	"pożerana",
	"pozmiatana",
	"pozmieniana",
	"pozmywana",
	"poznaczona",
	"poznana",
	"poznawana",
	"poznęcana",
	"pozorowana",
	"pozostawiana",
	"pozostawiona",
	"pozowana",
	"pozrywana",
	"pozszywana",
	"pożuta",
	"pozwalniana",
	"pozwana",
	"pozwiązywana",
	"pozwiedzana",
	"pozwolona",
	"pożyczana",
	"pożyczona",
	"pozyskana",
	"pożyta",
	"pozywana",
	"pożywiana",
	"pożywiona",
	"praktykowana",
	"prana",
	"prasowana",
	"prawiona",
	"prażona",
	"precyzowana",
	"preferowana",
	"prenumerowana",
	"prezentowana",
	"próbowana",
	"procesowana",
	"produkowana",
	"profanowana",
	"profilowana",
	"prognozowana",
	"programowana",
	"projektowana",
	"proklamowana",
	"prolongowana",
	"promieniowana",
	"promowana",
	"propagowana",
	"proponowana",
	"prosperowana",
	"prostowana",
	"proszkowana",
	"proszona",
	"protestowana",
	"protokołowana",
	"prowadzona",
	"prowokowana",
	"pruta",
	"pryskana",
	"pryśnięta",
	"przeanalizowana",
	"przearanżowana",
	"przebaczana",
	"przebaczona",
	"przebadana",
	"przebiegnięta",
	"przebierana",
	"przebijana",
	"przebita",
	"przebolona",
	"przebrana",
	"przebudowana",
	"przebudowywana",
	"przebudzana",
	"przebudzona",
	"przebukowana",
	"przebyta",
	"przebywana",
	"przeceniana",
	"przeceniona",
	"przechlapana",
	"przechodzona",
	"przechowana",
	"przechowywana",
	"przechrzcona",
	"przechwycona",
	"przechwytywana",
	"przechylana",
	"przechylona",
	"przechytrzana",
	"przechytrzona",
	"przeciągana",
	"przeciągnięta",
	"przeciążana",
	"przeciążona",
	"przeciekana",
	"przecierana",
	"przecierpiana",
	"przecięta",
	"przecinana",
	"przeciskana",
	"przeciśnięta",
	"przeciwstawiana",
	"przećwiczona",
	"przeczekana",
	"przeczesana",
	"przeczesywana",
	"przeczołgana",
	"przeczuta",
	"przeczuwana",
	"przeczyszczona",
	"przeczytana",
	"przedarta",
	"przedawkowana",
	"przedawkowywana",
	"przedekorowana",
	"przedłożona",
	"przedłużana",
	"przedłużona",
	"przedmuchana",
	"przedobrzona",
	"przedostana",
	"przedostawana",
	"przedsiewzięta",
	"przedstawiana",
	"przedstawiona",
	"przedymana",
	"przedyskutowana",
	"przedzierana",
	"przedziurawiona",
	"przedziurkowana",
	"przeegzaminowana",
	"przefaksowana",
	"przefarbowana",
	"przefasonowana",
	"przefasowana",
	"przefaxowana",
	"przefiltrowana",
	"przeformowana",
	"przeforsowana",
	"przegadana",
	"przeganana",
	"przeganiana",
	"przegapiana",
	"przegapiona",
	"przegięta",
	"przeginana",
	"przeglądana",
	"przeglądnięta",
	"przegłodzona",
	"przegłosowana",
	"przegoniona",
	"przegotowana",
	"przegotowywana",
	"przegrabiona",
	"przegradzana",
	"przegrana",
	"przegrupowana",
	"przegrupowywana",
	"przegrywana",
	"przegryzana",
	"przegryziona",
	"przegrzana",
	"przegrzebana",
	"przegrzewana",
	"przehandlowana",
	"przeholowana",
	"przeinstalowana",
	"przeistoczona",
	"przejadana",
	"przejaskrawiana",
	"przejaśniona",
	"przejawiana",
	"przejawiona",
	"przejechana",
	"przejęta",
	"przejeżdżana",
	"przejmowana",
	"przejrzana",
	"przekabacana",
	"przekabacona",
	"przekablowana",
	"przekalibrowana",
	"przekalkulowana",
	"przekarmiana",
	"przekąszona",
	"przekazywana",
	"przekierowana",
	"przekierowywana",
	"przekimana",
	"przekładana",
	"przeklejona",
	"przeklęta",
	"przeklinana",
	"przeklnięta",
	"przekłuta",
	"przekonana",
	"przekonfigurowana",
	"przekonstruowana",
	"przekonwertowana",
	"przekonywana",
	"przekopana",
	"przekopywana",
	"przekoziołkowana",
	"przekraczana",
	"przekręcana",
	"przekręcona",
	"przekreślana",
	"przekreślona",
	"przekroczona",
	"przekrojona",
	"przekrzyczona",
	"przekrzywiona",
	"przekształcana",
	"przekształcona",
	"przekupiona",
	"przekupywana",
	"przekuta",
	"przekwalifikowana",
	"przełączana",
	"przełączona",
	"przeładowana",
	"przeładowywana",
	"przełamana",
	"przełamywana",
	"przelana",
	"przelatywana",
	"przeleciana",
	"przelewana",
	"przeleżana",
	"przelicytowana",
	"przeliczana",
	"przeliczona",
	"przeliterowana",
	"przełknięta",
	"przełożona",
	"przełykana",
	"przełyknięta",
	"przemalowana",
	"przemalowywana",
	"przemaszerowana",
	"przemawiana",
	"przemeblowana",
	"przemęczona",
	"przemielona",
	"przemieniana",
	"przemierzona",
	"przemieszczana",
	"przemieszczona",
	"przemijana",
	"przemilczana",
	"przemilczona",
	"przeminięta",
	"przemknięta",
	"przemodelowana",
	"przemusztrowana",
	"przemycana",
	"przemycona",
	"przemyślana",
	"przemyślona",
	"przemyta",
	"przemywana",
	"przenegocjowana",
	"przeniesiona",
	"przenikana",
	"przeniknięta",
	"przenoszona",
	"przeobrażana",
	"przeobrażona",
	"przeoczana",
	"przeoczona",
	"przeorana",
	"przeorganizowana",
	"przeorientowana",
	"przepadana",
	"przepakowana",
	"przepalona",
	"przeparkowana",
	"przepchana",
	"przepchnięta",
	"przepędzana",
	"przepędzona",
	"przepełniana",
	"przepełniona",
	"przepijana",
	"przepiłowana",
	"przepisana",
	"przepisywana",
	"przepita",
	"przepłacana",
	"przepłacona",
	"przepłakana",
	"przeplanowana",
	"przepłoszona",
	"przepłukana",
	"przepłukiwana",
	"przepłynięta",
	"przepływana",
	"przepompowana",
	"przepompowywana",
	"przepowiadana",
	"przepowiedziana",
	"przepracowana",
	"przepracowywana",
	"przeprana",
	"przeprawiana",
	"przeprawiona",
	"przeprogramowana",
	"przeprojektowana",
	"przeprowadzana",
	"przeprowadzona",
	"przepuszczana",
	"przepuszczona",
	"przepychana",
	"przepytana",
	"przepytywana",
	"przerąbana",
	"przerabiana",
	"przeradzana",
	"przerastana",
	"przerażona",
	"przeredagowana",
	"przerejestrowana",
	"przerobiona",
	"przerodzona",
	"przerośnięta",
	"przerwana",
	"przerysowana",
	"przerywana",
	"przerzedzana",
	"przerzucana",
	"przerzucona",
	"przesączona",
	"przesadzana",
	"przesądzana",
	"przesadzona",
	"przesądzona",
	"prześcigana",
	"prześcignięta",
	"przesiadana",
	"przesiadywana",
	"przesiana",
	"przesiedlana",
	"przesiedlona",
	"przesiedziana",
	"przesiewana",
	"przesilona",
	"przeskakiwana",
	"przeskalowana",
	"przeskanowana",
	"przeskoczona",
	"przeskrobana",
	"prześladowana",
	"przesłaniana",
	"przesłana",
	"prześledziona",
	"prześlizgnięta",
	"przesłodzona",
	"przesłonięta",
	"przesłuchana",
	"przesłuchiwana",
	"przesmarowana",
	"przesolona",
	"przesortowana",
	"przespana",
	"prześpiewana",
	"przessana",
	"przestawiana",
	"przestawiona",
	"przestemplowana",
	"przestraszona",
	"przestrojona",
	"przestrzegana",
	"przestrzelona",
	"przestudiowana",
	"przesunięta",
	"przesuwana",
	"prześwietlana",
	"prześwietlona",
	"przesyłana",
	"przesypana",
	"przesypiana",
	"przesypywana",
	"przeszarżowana",
	"przeszczepiana",
	"przeszczepiona",
	"przeszkadzana",
	"przeszkolona",
	"przeszmuglowana",
	"przeszukana",
	"przeszukiwana",
	"przeszyta",
	"przeszywana",
	"przetaczana",
	"przetańczona",
	"przetapetowana",
	"przetarta",
	"przetestowana",
	"przetkana",
	"przetoczona",
	"przetopiona",
	"przetrącona",
	"przetransformowana",
	"przetransmitowana",
	"przetransponowana",
	"przetransportowana",
	"przetrawiona",
	"przetrwana",
	"przetrząsana",
	"przetrząśnięta",
	"przetrzepana",
	"przetrzymana",
	"przetrzymywana",
	"przetwarzana",
	"przetworzona",
	"przewalana",
	"przewalczona",
	"przewaletowana",
	"przewalona",
	"przeważana",
	"przeważona",
	"przewertowana",
	"przewiązana",
	"przewiązywana",
	"przewidywana",
	"przewidziana",
	"przewiercana",
	"przewiercona",
	"przewieszana",
	"przewieszona",
	"przewietrzona",
	"przewieziona",
	"przewijana",
	"przewinięta",
	"przewitana",
	"przewodniczona",
	"przewodzona",
	"przewożona",
	"przewracana",
	"przewrócona",
	"przewyższana",
	"przeymierzana",
	"przeżarta",
	"przeżeglowana",
	"przeżegnana",
	"przeziębiona",
	"przezimowana",
	"przeznaczana",
	"przeznaczona",
	"przeżuta",
	"przezwyciężana",
	"przezwyciężona",
	"przeżyta",
	"przezywana",
	"przeżywana",
	"przodowana",
	"przpochlebiona",
	"przwdziewana",
	"przybastowana",
	"przybierana",
	"przybijana",
	"przybita",
	"przybliżana",
	"przybliżona",
	"przybrana",
	"przycelowana",
	"przycepiona",
	"przychylona",
	"przyciągana",
	"przyciągnięta",
	"przyciemniona",
	"przycięta",
	"przycinana",
	"przyciskana",
	"przyciśnięta",
	"przyciszona",
	"przyćmiewana",
	"przyćmiona",
	"przycumowana",
	"przyczepiana",
	"przyczesana",
	"przyczołgana",
	"przyczyniona",
	"przydepnięta",
	"przydeptana",
	"przyduszona",
	"przydzielana",
	"przydzielona",
	"przygarnięta",
	"przygaszona",
	"przygazowana",
	"przygładzana",
	"przygnębiana",
	"przygniatana",
	"przygnieciona",
	"przygotowana",
	"przygruchana",
	"przygrywana",
	"przygryzana",
	"przygryziona",
	"przygrzana",
	"przygwożdżona",
	"przyhamowana",
	"przyholowana",
	"przyjana",
	"przyjęta",
	"przyjmowana",
	"przyjrzana",
	"przykładana",
	"przyklejona",
	"przyklepana",
	"przykopana",
	"przykręcana",
	"przykręcona",
	"przykrócona",
	"przykryta",
	"przykrywana",
	"przykurzona",
	"przykuta",
	"przykuwana",
	"przyłączana",
	"przyłączona",
	"przylana",
	"przyłapana",
	"przylegana",
	"przylepiana",
	"przylepiona",
	"przyłożona",
	"przymierzona",
	"przymilana",
	"przymknięta",
	"przymocowana",
	"przymuszana",
	"przynależona",
	"przyniesiona",
	"przynoszona",
	"przynudzana",
	"przyostrzona",
	"przyozdabiana",
	"przyozdobiona",
	"przypadnięta",
	"przypakowana",
	"przypakowywana",
	"przypalana",
	"przypalona",
	"przyparta",
	"przypasowana",
	"przypatrywana",
	"przypatrzona",
	"przypieczętowana",
	"przypiekana",
	"przypierana",
	"przypięta",
	"przypilnowana",
	"przypiłowana",
	"przypinana",
	"przypisana",
	"przypisywana",
	"przypłacona",
	"przyplątana",
	"przypłynięta",
	"przypodobana",
	"przypominana",
	"przypomniana",
	"przyporządkowana",
	"przyprawiana",
	"przyprawiona",
	"przyprowadzona",
	"przypucowana",
	"przypudrowana",
	"przypuszczana",
	"przypuszczona",
	"przyrównana",
	"przyrządzana",
	"przyrządzona",
	"przysiadana",
	"przysiągnięta",
	"przyskrzydlona",
	"przyskrzyniana",
	"przyskrzyniona",
	"przysłaniana",
	"przysłana",
	"przysłodzona",
	"przysłoniona",
	"przysłuchiwana",
	"przysługiwana",
	"przysłużona",
	"przysmażana",
	"przysmażona",
	"przyspieszana",
	"przyspieszona",
	"przysporzona",
	"przysposobiona",
	"przyśrubowywana",
	"przyssana",
	"przystąpiona",
	"przystawiana",
	"przystawiona",
	"przystemplowana",
	"przystopowana",
	"przystosowana",
	"przystrojona",
	"przysunięta",
	"przysuwana",
	"przyswajana",
	"przyświecana",
	"przyświęcona",
	"przyswojona",
	"przysyłana",
	"przysypana",
	"przyszpilona",
	"przyszykowana",
	"przyszyta",
	"przyszywana",
	"przytaczana",
	"przytargana",
	"przytarta",
	"przytaszczana",
	"przytępiana",
	"przytępiona",
	"przytkana",
	"przytłaczana",
	"przytłoczona",
	"przytłumiona",
	"przytoczona",
	"przytrafiona",
	"przytroczona",
	"przytruwana",
	"przytrzasnięta",
	"przytrzymana",
	"przytrzymywana",
	"przytulana",
	"przytulona",
	"przytwierdzana",
	"przytwierdzona",
	"przytykana",
	"przyuczona",
	"przyuważona",
	"przywabiona",
	"przywalana",
	"przywalona",
	"przywarowana",
	"przywarta",
	"przywdziana",
	"przywiązana",
	"przywiązywana",
	"przywidziana",
	"przywieziona",
	"przywitana",
	"przywłaszczana",
	"przywłaszczona",
	"przywołana",
	"przywoływana",
	"przywożona",
	"przywracana",
	"przywrócona",
	"przyznaczona",
	"przyznana",
	"przyznawana",
	"przyzwalana",
	"przyzwana",
	"przyzwyczajana",
	"przyzwyczajona",
	"przyzywana",
	"psiamana",
	"pstrykana",
	"pstryknięta",
	"psuta",
	"publikowana",
	"puchnięta",
	"pucowana",
	"pudłowana",
	"pudrowana",
	"puknięta",
	"punktowana",
	"pustoszona",
	"puszczana",
	"puszczona",
	"puszkowana",
	"puszona",
	"pykana",
	"pytana",
	"rabowana",
	"rachowana",
	"racjonalizowana",
	"racjonowana",
	"raczona",
	"radowana",
	"raniona",
	"raportowana",
	"ratowana",
	"ratyfikowana",
	"reaktywowana",
	"realizowana",
	"reanimowana",
	"recytowana",
	"ręczona",
	"redagowana",
	"redukowana",
	"reformowana",
	"refowana",
	"regenerowana",
	"regionalizowana",
	"regulowana",
	"reinkarnowana",
	"rejestrowana",
	"reklamowana",
	"rekomendowana",
	"rekompensowana",
	"rekonstruowana",
	"rekreowana",
	"rekrutowana",
	"rekwirowana",
	"relacjonowana",
	"relaksowana",
	"remodulowana",
	"remontowana",
	"renegocjowana",
	"reorganizowana",
	"reperowana",
	"replikowana",
	"represejonowana",
	"reprezentowana",
	"reprodukowana",
	"resetowana",
	"resocjalizowana",
	"respektowana",
	"resuscytowana",
	"retuszowana",
	"rewanżowana",
	"rewidowana",
	"rezerwowana",
	"rezonowana",
	"rezygnowana",
	"reżyserowana",
	"robiona",
	"rodzona",
	"rojona",
	"rolowana",
	"romansowana",
	"roniona",
	"rozbawiana",
	"rozbawiona",
	"rozbierana",
	"rozbijana",
	"rozbita",
	"rozbłyśnięta",
	"rozbrajana",
	"rozbrojona",
	"rozbudowana",
	"rozbudowywana",
	"rozbudzana",
	"rozbudzona",
	"rozbujana",
	"rozcapierzona",
	"rozchmurzona",
	"rozchodzona",
	"rozchylana",
	"rozchylona",
	"rozciągana",
	"rozciągnięta",
	"rozcieńczana",
	"rozcieńczona",
	"rozcierana",
	"rozcięta",
	"rozcinana",
	"rozczarowana",
	"rozczarowywana",
	"rozczesana",
	"rozczłonkowana",
	"rozczulana",
	"rozczytana",
	"rozdana",
	"rozdawana",
	"rozdeptana",
	"rozdmuchana",
	"rozdmuchiwana",
	"rozdrabniana",
	"rozdrapana",
	"rozdrapywana",
	"rozdrażniana",
	"rozdrażniona",
	"rozduszona",
	"rozdwojona",
	"rozdysponowana",
	"rozdzielana",
	"rozdzielona",
	"rozdzierana",
	"rozdziewiczona",
	"rozebrana",
	"rozedrana",
	"rozegrana",
	"rozegrywana",
	"rozepchana",
	"rozerwana",
	"rozesłana",
	"rozgarnięta",
	"rozgaszczana",
	"rozgięta",
	"rozglaszana",
	"rozgłoszona",
	"rozgniatana",
	"rozgnieciona",
	"rozgniewana",
	"rozgoniona",
	"rozgraniczona",
	"rozgrana",
	"rozgromiona",
	"rozgrywana",
	"rozgryzana",
	"rozgryziona",
	"rozgrzana",
	"rozgrzebywana",
	"rozgrzeszona",
	"rozgrzewana",
	"rozhuśtana",
	"rozjaśniana",
	"rozjaśniona",
	"rozjechana",
	"rozjedzona",
	"rozjuszana",
	"rozjuszona",
	"rozkazana",
	"rozkazywana",
	"rozkładana",
	"rozklejana",
	"rozklejona",
	"rozkołysana",
	"rozkopana",
	"rozkopywana",
	"rozkoszowana",
	"rozkręcana",
	"rozkręcona",
	"rozkrojona",
	"rozkruszona",
	"rozkuta",
	"rozkuwana",
	"rozkwaszona",
	"rozkwaterowana",
	"rozkwitana",
	"rozkwitnięta",
	"rozłączona",
	"rozładowana",
	"rozładowywana",
	"rozłamana",
	"rozlana",
	"rozlewana",
	"rozliczana",
	"rozliczona",
	"rozlokowana",
	"rozłożona",
	"rozłupana",
	"rozluźniana",
	"rozmanażana",
	"rozmasowana",
	"rozmawiana",
	"rozmazana",
	"rozmazywana",
	"rozmiękczona",
	"rozmieniana",
	"rozmieniona",
	"rozmieszczana",
	"rozmieszczona",
	"rozminięta",
	"rozmnożona",
	"rozmontowana",
	"rozmówiona",
	"rozmrażana",
	"rozmrożona",
	"rozmyślana",
	"rozmyta",
	"różnicowana",
	"rozniecana",
	"roznieciona",
	"rozniesiona",
	"różniona",
	"roznoszona",
	"rozochocona",
	"rozpaczana",
	"rozpakowana",
	"rozpakowywana",
	"rozpalana",
	"rozpalona",
	"rozpamiętywana",
	"rozpaskudzana",
	"rozpatrywana",
	"rozpatrzona",
	"rozpędzana",
	"rozpędzona",
	"rozpętana",
	"rozpieszczana",
	"rozpieszczona",
	"rozpięta",
	"rozpiłowana",
	"rozpinana",
	"rozpisana",
	"rozpisywana",
	"rozplanowana",
	"rozpłaszczana",
	"rozpłaszczona",
	"rozplątana",
	"rozplątywana",
	"rozpłynięta",
	"rozpoczęta",
	"rozpoczynana",
	"rozpogodzona",
	"rozporządzana",
	"rozporządzona",
	"rozpościerana",
	"rozpostrzona",
	"rozpowiadana",
	"rozpowiedziana",
	"rozpowszechniana",
	"rozpowszechniona",
	"rozpoznana",
	"rozpoznawana",
	"rozpracowana",
	"rozpraszana",
	"rozprawiana",
	"rozprawiczona",
	"rozprawiona",
	"rozprostowana",
	"rozproszona",
	"rozprowadzana",
	"rozprowadzona",
	"rozpruta",
	"rozpruwana",
	"rozprzestrzeniana",
	"rozprzestrzeniona",
	"rozpuszczana",
	"rozpuszczona",
	"rozpychana",
	"rozpylana",
	"rozpylona",
	"rozpytana",
	"rozpytywana",
	"rozrastana",
	"rozreklamowana",
	"rozrobiona",
	"rozrośnięta",
	"rozróżniana",
	"rozróżniona",
	"rozruszana",
	"rozrysowana",
	"rozrywana",
	"rozrzucana",
	"rozsadzana",
	"rozsadzona",
	"rozsądzona",
	"rozścielona",
	"rozsiana",
	"rozsiekana",
	"rozsiewana",
	"rozsiodłana",
	"rozsławiana",
	"rozsławiona",
	"rozsmarowana",
	"rozsmarowywana",
	"rozśmieszana",
	"rozstana",
	"rozstąpiona",
	"rozstawana",
	"rozstawiana",
	"rozstawiona",
	"rozstrojona",
	"rozstrząsana",
	"rozstrzeliwana",
	"rozstrzelona",
	"rozstrzygana",
	"rozstrzygnięta",
	"rozsunięta",
	"rozsupłana",
	"rozświetlana",
	"rozświetlona",
	"rozsyłana",
	"rozsypana",
	"rozsypywana",
	"rozszarpana",
	"rozszarpywana",
	"rozszczepiana",
	"rozszczepiona",
	"rozszerzana",
	"rozszerzona",
	"rozszyfrowana",
	"roztaczana",
	"roztapiana",
	"roztarta",
	"roztoczona",
	"roztopiona",
	"roztrwoniona",
	"roztrząsana",
	"roztrzaskana",
	"rozumiana",
	"rozumowana",
	"rozwalana",
	"rozwalona",
	"rozwarta",
	"rozważana",
	"rozważona",
	"rozweselana",
	"rozweselona",
	"rozwiana",
	"rozwiązana",
	"rozwiązywana",
	"rozwidniana",
	"rozwiedziona",
	"rozwierana",
	"rozwiercona",
	"rozwieszana",
	"rozwieszona",
	"rozwiewana",
	"rozwieziona",
	"rozwikłana",
	"rozwinięta",
	"rozwlekana",
	"rozwodzona",
	"rozwścieczana",
	"rozwścieczona",
	"rozzłoszczona",
	"rugana",
	"ruinowana",
	"rujnowana",
	"runięta",
	"ruszana",
	"ruszona",
	"rwana",
	"ryczana",
	"ryglowana",
	"rymowana",
	"rysowana",
	"ryta",
	"ryzykowana",
	"rządzona",
	"rzeźbiona",
	"rżnięta",
	"rzucana",
	"rzucona",
	"rzygana",
	"sabotażowana",
	"sączona",
	"sadzana",
	"sadzona",
	"sądzona",
	"salutowana",
	"salwowana",
	"sankcjonowana",
	"satysfakcjonowana",
	"scalona",
	"scementowana",
	"scentrowana",
	"scharakteryzowana",
	"schładzana",
	"schlana",
	"schlapana",
	"schlebiona",
	"schłodzona",
	"schowana",
	"schroniona",
	"schrupana",
	"schrzaniona",
	"schwytana",
	"schylana",
	"ściągnięta",
	"ścielona",
	"ściemniana",
	"ściemniona",
	"ścierana",
	"ścierpiona",
	"ścięta",
	"ścigana",
	"ścinana",
	"ściskana",
	"ściśnięta",
	"ściszana",
	"ściszona",
	"sędziowana",
	"segregowana",
	"selekcjonowana",
	"separowana",
	"sępiona",
	"serwowana",
	"sfabrykowana",
	"sfajczona",
	"sfałszowana",
	"sfaulowana",
	"sfilmowana",
	"sfinalizowana",
	"sfinansowana",
	"sfingowana",
	"sformalizowana",
	"sformatowana",
	"sformowana",
	"sformułowana",
	"sforsowana",
	"sfotografowana",
	"shimmerowana",
	"siana",
	"siekana",
	"siorbana",
	"skadrowana",
	"skakana",
	"skalana",
	"skaleczona",
	"skalibrowana",
	"skalkulowana",
	"skalpowana",
	"skanalizowana",
	"skandowana",
	"skanowana",
	"skapitulowana",
	"skarcona",
	"skarżona",
	"skasowana",
	"skatalogowana",
	"skazana",
	"skażona",
	"skazywana",
	"skierowana",
	"składana",
	"składowana",
	"skłaniana",
	"sklasyfikowana",
	"skleciona",
	"sklejana",
	"sklejona",
	"sklepana",
	"skłócona",
	"skłoniona",
	"sklonowana",
	"sknocona",
	"skojarzona",
	"skolonizowana",
	"skołowana",
	"skombinowana",
	"skomentowana",
	"skompensowana",
	"skompletowana",
	"skomplikowana",
	"skomponowana",
	"skompresowana",
	"skompromitowana",
	"skomunikowana",
	"skonana",
	"skoncentrowana",
	"skończona",
	"skondensowana",
	"skonfigurowana",
	"skonfiskowana",
	"skonfrontowana",
	"skonkretyzowana",
	"skonsolidowana",
	"skonstruowana",
	"skonsultowana",
	"skonsumowana",
	"skontaktowana",
	"skontrolowana",
	"skoordynowana",
	"skopana",
	"skopiowana",
	"skorektowana",
	"skorumpowana",
	"skorygowana",
	"skorzystana",
	"skoszona",
	"skracana",
	"skradziona",
	"skręcana",
	"skręcona",
	"skremowana",
	"skreślana",
	"skreślona",
	"skrobana",
	"skrobnięta",
	"skrócona",
	"skrojona",
	"skropiona",
	"skruszona",
	"skrystalizowana",
	"skryta",
	"skrytykowana",
	"skrywana",
	"skrzecowana",
	"skrzepnięta",
	"skrzyczana",
	"skrzyta",
	"skrzywdzona",
	"skrzyżowana",
	"skserowana",
	"skubana",
	"skubnięta",
	"skulona",
	"skumulowana",
	"skupiana",
	"skupiona",
	"skupowana",
	"skurczona",
	"skuszona",
	"skuta",
	"skuwana",
	"skwitowana",
	"słana",
	"sławiona",
	"śledzona",
	"śliniona",
	"ślizgana",
	"słodzona",
	"słuchana",
	"słyszana",
	"smagana",
	"smarowana",
	"smażona",
	"śmiecona",
	"smuta",
	"smyrana",
	"snuta",
	"sondowana",
	"sortowana",
	"spafycikowana",
	"spakowana",
	"spalana",
	"spałaszowana",
	"spalona",
	"spałowana",
	"spamiętana",
	"spaprana",
	"sparafrazowana",
	"sparaliżowana",
	"sparowana",
	"spartaczona",
	"spartolona",
	"sparzona",
	"spasowana",
	"spatałaszona",
	"spauzowana",
	"spawana",
	"spawiona",
	"specjalizowana",
	"spędzana",
	"spędzona",
	"spekulowana",
	"spełniana",
	"spełniona",
	"spenetrowana",
	"spętana",
	"spierana",
	"spięta",
	"śpiewana",
	"spiłowana",
	"spinana",
	"spisana",
	"spiskowana",
	"spisywana",
	"spita",
	"spłacana",
	"spłacona",
	"splądrowana",
	"splajtowana",
	"splamiona",
	"spłaszczona",
	"splatana",
	"splątana",
	"spłatana",
	"spławiana",
	"spławiona",
	"spłodzona",
	"spłonięta",
	"spłoszona",
	"spłukana",
	"spłukiwana",
	"spluwana",
	"spływana",
	"spoczęta",
	"spoczywana",
	"spodziewana",
	"spojona",
	"spolaryzowana",
	"spoliczkowana",
	"sponiewierana",
	"sponsorowana",
	"spopielana",
	"spopielona",
	"spopularyzowana",
	"sportretowana",
	"sporządzana",
	"sporządzona",
	"spostrzegana",
	"spotęgowana",
	"spotkana",
	"spotykana",
	"spoufalana",
	"spowalniana",
	"spowiadana",
	"spowodowana",
	"spowolniona",
	"spoźniona",
	"spóźniona",
	"spożytkowana",
	"spożyta",
	"spożywana",
	"sprana",
	"sprasowana",
	"spraszana",
	"sprawdzona",
	"sprawiona",
	"sprawowana",
	"sprecyzowana",
	"spreparowana",
	"sprężana",
	"sprężona",
	"spróbowana",
	"sprofanowana",
	"sprofilowana",
	"sprostowana",
	"sproszkowana",
	"sproszona",
	"sprowadzana",
	"sprowadzona",
	"sprowokowana",
	"spryskana",
	"spryskiwana",
	"sprywatyzowana",
	"sprzątana",
	"sprzątnięta",
	"sprzeczana",
	"sprzedana",
	"sprzedawana",
	"sprzeniewierzona",
	"spudłowana",
	"spustoszona",
	"spuszczana",
	"spuszczona",
	"spychana",
	"ssana",
	"stabilizowana",
	"stacjonowana",
	"staczana",
	"staranowana",
	"starczana",
	"stargowana",
	"startowana",
	"stawiana",
	"stawiona",
	"stemplowana",
	"stenografowana",
	"stepowana",
	"sterowana",
	"sterroryzowana",
	"sterylizowana",
	"stłamszona",
	"stłumiona",
	"stnięta",
	"stoczona",
	"stołowana",
	"stonowana",
	"stopiona",
	"stopniowana",
	"storpedowana",
	"stosowana",
	"strącana",
	"stracona",
	"strącona",
	"strajkowana",
	"straszona",
	"stratowana",
	"strawiona",
	"streamowana",
	"stresowana",
	"streszczana",
	"streszczona",
	"strofowana",
	"strojona",
	"stroszona",
	"strugana",
	"struta",
	"strymowana",
	"strząsana",
	"strzaskana",
	"strząśnięta",
	"strzelona",
	"strzepana",
	"strzępiona",
	"strzepnięta",
	"strzepywana",
	"studiowana",
	"studzona",
	"stukana",
	"stuknięta",
	"stulona",
	"stwardniona",
	"stwarzana",
	"stwierdzana",
	"stwierdzona",
	"stworzona",
	"stykana",
	"stylizowana",
	"stymulowana",
	"sugerowana",
	"sumowana",
	"sunięta",
	"swatana",
	"swawolona",
	"świadczona",
	"świecona",
	"święcona",
	"świerzbiona",
	"świętowana",
	"świntuszona",
	"sycona",
	"sygnalizowana",
	"symulowana",
	"synchronizowana",
	"sypana",
	"sypnięta",
	"szachrowana",
	"szacowana",
	"szafowana",
	"szamotana",
	"szanowana",
	"szargana",
	"szarpana",
	"szarpnięta",
	"szarżowana",
	"szasowana",
	"szastana",
	"szatkowana",
	"szczędzona",
	"szczepiona",
	"szczerzona",
	"szczuta",
	"szczycona",
	"szczypana",
	"szczytowana",
	"szefowana",
	"szemrana",
	"szepnięta",
	"szeptana",
	"szerzona",
	"szkalowana",
	"szkicowana",
	"szklona",
	"szkodzona",
	"szkolona",
	"szlachtowana",
	"szlifowana",
	"szmuglowana",
	"szokowana",
	"szorowana",
	"szpachlowana",
	"szpanowana",
	"szperana",
	"szprycowana",
	"sztachnięta",
	"szturchana",
	"szturchnięta",
	"szturmowana",
	"szufladkowana",
	"szuflowana",
	"szukana",
	"szulerowana",
	"szwankowana",
	"szydełkowana",
	"szydzona",
	"szyfrowana",
	"szykanowana",
	"szykowana",
	"szyta",
	"taktowana",
	"tamowana",
	"tankowana",
	"tapetowana",
	"taplana",
	"taranowana",
	"targana",
	"targnięta",
	"targowana",
	"tarmoszona",
	"tarta",
	"tarzana",
	"tasowana",
	"taszczona",
	"tatuowana",
	"tchnięta",
	"telefonowana",
	"telegrfowana",
	"teleportowana",
	"temperowana",
	"teoretyzowana",
	"tępiona",
	"terroryzowana",
	"testowana",
	"tkana",
	"tknięta",
	"tłamszona",
	"tłoczona",
	"tłumaczona",
	"tłumiona",
	"toczona",
	"tolerowana",
	"tonowana",
	"topiona",
	"torowana",
	"torturowana",
	"towarzyszona",
	"trąbiona",
	"trącana",
	"tracona",
	"trącona",
	"trafiana",
	"trafiona",
	"tragizowana",
	"traktowana",
	"transferowana",
	"transformowana",
	"transmitowana",
	"transportowana",
	"tratowana",
	"trawiona",
	"trenowana",
	"tresowana",
	"triumfowana",
	"tropiona",
	"troszczona",
	"truta",
	"trwoniona",
	"trymowana",
	"tryskana",
	"tryśnięta",
	"tryumfowana",
	"trywializowana",
	"trzaskana",
	"trzasnięta",
	"trzepana",
	"trzepnięta",
	"trzepotana",
	"trzęsiona",
	"trzymana",
	"tuczona",
	"tułana",
	"tulona",
	"turlana",
	"tuszowana",
	"twistowana",
	"tworzona",
	"tykana",
	"tyranizowana",
	"tyrana",
	"tytułowana",
	"uaktualniana",
	"uaktualniona",
	"uaktywniana",
	"uaktywniona",
	"uargumentowana",
	"uatrakcyjniona",
	"ubabrana",
	"ubarwiana",
	"ubarwiona",
	"ubawiona",
	"ubezpieczana",
	"ubezpieczona",
	"ubezwłasnowolniona",
	"ubiczowana",
	"ubiegana",
	"ubierana",
	"ubijana",
	"ubita",
	"ubłagana",
	"ubliżana",
	"ubliżona",
	"ubolewana",
	"ubóstwiana",
	"ubrana",
	"ubroczona",
	"ubrudzona",
	"ucałowana",
	"ucharakteryzowana",
	"uchowana",
	"uchroniona",
	"uchwalana",
	"uchwalona",
	"uchwycona",
	"uchylana",
	"uchylona",
	"uciągnięta",
	"ucieleśniana",
	"ucierana",
	"ucierpiana",
	"ucięta",
	"ucinana",
	"uciskana",
	"uciśnięta",
	"uciszana",
	"uciszona",
	"uciułana",
	"ucywilizowana",
	"uczczona",
	"uczepiona",
	"uczesana",
	"uczęszczana",
	"uczona",
	"ucztowana",
	"uczuta",
	"uczyniona",
	"udana",
	"udaremniona",
	"udawana",
	"udekorowana",
	"udeptywana",
	"uderzana",
	"uderzona",
	"udobruchana",
	"udokumentowana",
	"udomawiana",
	"udomowiona",
	"udoskonalana",
	"udoskonalona",
	"udostępniana",
	"udostępniona",
	"udowadniana",
	"udowodniona",
	"Udramatyzowana",
	"udręczona",
	"udrożniona",
	"udupiona",
	"uduszona",
	"udzielana",
	"udzielona",
	"udźwignięta",
	"ueiwarygodniona",
	"ufana",
	"ufarbowana",
	"uformowana",
	"ufortyfikowana",
	"ufundowana",
	"ugadana",
	"uganiana",
	"ugaszana",
	"ugaszona",
	"ugięta",
	"uginana",
	"ugłaskana",
	"ugniatana",
	"ugodzona",
	"ugoszczona",
	"ugotowana",
	"ugrana",
	"ugruntowana",
	"ugryziona",
	"ugrzęznięta",
	"uhistoryzowana",
	"uhonorowana",
	"uiścita",
	"ujadana",
	"ujarzmiana",
	"ujarzmiona",
	"ujawniana",
	"ujawniona",
	"ujęta",
	"ujeżdżana",
	"ujeżdżona",
	"ujmowana",
	"ujrzana",
	"ukamieniowana",
	"ukarana",
	"ukartowana",
	"ukąszona",
	"ukatrupiona",
	"ukazana",
	"ukazywana",
	"ukierowana",
	"ukierunkowana",
	"układana",
	"uklepana",
	"ukłoniona",
	"ukłuta",
	"uknuta",
	"ukojona",
	"ukołysana",
	"ukończona",
	"ukonkretniona",
	"ukoronowana",
	"ukradziona",
	"ukręcana",
	"ukręcona",
	"ukrojona",
	"ukryta",
	"ukrywana",
	"ukrzyżowana",
	"ukształtowana",
	"ukuta",
	"ułagodzona",
	"ułaskawiana",
	"ułaskawiona",
	"ulatniana",
	"ułatwiana",
	"ułatwiona",
	"uleczana",
	"uleczona",
	"ulegana",
	"ulepiona",
	"ulepszana",
	"ulepszona",
	"ulokowana",
	"ulotniona",
	"ułożona",
	"umacniana",
	"umalowana",
	"umartwiana",
	"umawiana",
	"umazana",
	"umeblowana",
	"umiejscowiona",
	"umieszczana",
	"umieszczona",
	"umilana",
	"umilona",
	"umknięta",
	"umniejszana",
	"umniejszona",
	"umocniona",
	"umocowana",
	"umoczona",
	"umodelowana",
	"umorzona",
	"umotywowana",
	"umówiona",
	"umożliwiana",
	"umożliwiona",
	"umroczniona",
	"umyta",
	"unaoczniona",
	"unicestwiana",
	"unicestwiona",
	"uniemożliwaina",
	"uniemożliwiona",
	"unierochomiona",
	"uniesiona",
	"unieszczęśliwiana",
	"unieszczęśliwiona",
	"unieszkodliwiana",
	"unieszkodliwiona",
	"unieważniana",
	"unieważniona",
	"uniewinniona",
	"uniezależniona",
	"unikana",
	"uniknięta",
	"unormowana",
	"unoszona",
	"unowoczesniana",
	"unowocześniana",
	"uodporniona",
	"uogólniana",
	"upakowana",
	"upalana",
	"upalona",
	"upamiętniana",
	"upamiętniona",
	"upaństwowiona",
	"upaprana",
	"uparta",
	"upaskudzona",
	"upchana",
	"upchnięta",
	"upewniana",
	"upewniona",
	"upgradowana",
	"upichcona",
	"upiększana",
	"upiększona",
	"upierana",
	"upierdolona",
	"upięta",
	"upijana",
	"upilnowana",
	"upinana",
	"upita",
	"uplastyczniona",
	"upłynięta",
	"upodabniana",
	"upodobniona",
	"upojona",
	"upokorzana",
	"upokorzona",
	"upolowana",
	"upominana",
	"uporządkowana",
	"upowszechniona",
	"upozorowana",
	"upozowana",
	"uprana",
	"uprasowana",
	"upraszczana",
	"uprawdopodobniona",
	"uprawiana",
	"uproszczona",
	"uproszona",
	"uprowadzana",
	"uprowadzona",
	"uprzątana",
	"uprzątnięta",
	"uprzedona",
	"uprzedzana",
	"uprzyjemniana",
	"uprzyjemniona",
	"uprzykrzana",
	"uprzytomniona",
	"upubliczniana",
	"upubliczniona",
	"upudrowana",
	"upuszczana",
	"upuszczona",
	"upychana",
	"urabiana",
	"uraczana",
	"uradowana",
	"Urągana",
	"uratowana",
	"urażana",
	"urażona",
	"uregulowana",
	"urobiona",
	"uroniona",
	"urośnięta",
	"urozmaicana",
	"urozmaicona",
	"uruchamiana",
	"uruchomiona",
	"urwana",
	"urywana",
	"urządzana",
	"urządzona",
	"urzeczywistniana",
	"urzeczywistniona",
	"urżnięta",
	"usadowiona",
	"usadzona",
	"usamowolniona",
	"usankcjonowana",
	"usatyfakcjonowana",
	"uschnięta",
	"uściskana",
	"uścislona",
	"uściśnięta",
	"usidlona",
	"usiedzona",
	"uskładana",
	"uskoczona",
	"uskuteczniana",
	"uskuteczniona",
	"usłuchana",
	"usługiwana",
	"usłużona",
	"usłyszana",
	"usmażona",
	"uśmiana",
	"uśmiercana",
	"uśmiercona",
	"uśmierzona",
	"uspana",
	"uśpiona",
	"uspokajana",
	"uspokojona",
	"uspołeczniana",
	"usprawiedliwiana",
	"usprawiedliwiona",
	"usprawniona",
	"usprzątana",
	"ustabilizowana",
	"ustalana",
	"ustalona",
	"ustanawiana",
	"ustanowiona",
	"ustąpiona",
	"ustatkowana",
	"ustawiana",
	"ustawiona",
	"ustępowana",
	"ustosunkowana",
	"ustrojona",
	"ustrzegana",
	"ustrzelona",
	"usunięta",
	"ususzona",
	"usuwana",
	"uświadamiana",
	"uświadczona",
	"uświadomiona",
	"uświęcona",
	"uświniona",
	"usychana",
	"usypana",
	"usypiana",
	"usystematyzowana",
	"usytuowana",
	"uszanowana",
	"uszczelniana",
	"uszczęśliwiana",
	"uszczęśliwiona",
	"uszczuplona",
	"uszczypnięta",
	"uszkadzana",
	"uszkodzona",
	"uszlachetniana",
	"uszlachetniona",
	"usztywniona",
	"uszykowana",
	"uszyta",
	"utajniona",
	"utargowana",
	"utarta",
	"utemperowana",
	"utkana",
	"utknięta",
	"utkwiona",
	"utoczona",
	"utopiona",
	"utorowana",
	"utożsamiana",
	"utożsamiona",
	"utracona",
	"utrącona",
	"utrudniana",
	"utrudniona",
	"utrwalana",
	"utrwalona",
	"utrzymywana",
	"utuczona",
	"utulona",
	"utwierdzana",
	"utwierdzona",
	"utworzona",
	"utylizowana",
	"uwalniana",
	"uwalona",
	"uwarunkowana",
	"uważana",
	"uwiązana",
	"uwiązywana",
	"uwidoczniona",
	"uwieczniana",
	"uwieczniona",
	"uwielbiana",
	"uwielbiona",
	"uwieńczona",
	"uwierana",
	"uwierzona",
	"uwieszona",
	"uwieziona",
	"uwięziona",
	"uwijana",
	"uwikłana",
	"uwinięta",
	"uwita",
	"uwłaczana",
	"uwłaszczona",
	"uwodzona",
	"uwolniona",
	"uwsteczniana",
	"uwsteczniona",
	"uwydatniana",
	"uwypiklona",
	"uwzględniana",
	"uwzględniona",
	"użądlona",
	"uzależniana",
	"uzależniona",
	"uzasadniana",
	"uzasadniona",
	"uzbierana",
	"uzbrajana",
	"uzbrojona",
	"uzdrawiana",
	"uzdrowiona",
	"użerana",
	"uzewnętrzniana",
	"uzewnętrzniona",
	"uzgadniana",
	"uzgodniona",
	"uziemiona",
	"uzmysłowiona",
	"uznana",
	"uznawana",
	"uzupełniana",
	"uzupełniona",
	"uzurpowana",
	"użyczana",
	"użyczona",
	"uzyskana",
	"uzyskiwana",
	"użyta",
	"używana",
	"wabiona",
	"wąchana",
	"wachlowana",
	"wahana",
	"walczona",
	"wałkowana",
	"walnięta",
	"walona",
	"ważona",
	"wbijana",
	"wbita",
	"wcelowana",
	"wchłonięta",
	"wciągana",
	"wciągnięta",
	"wcielana",
	"wcielona",
	"wcierana",
	"wcięta",
	"wcinana",
	"wciskana",
	"wciśnięta",
	"wczepiona",
	"wczołgana",
	"wczuta",
	"wczytana",
	"wczytywana",
	"wdana",
	"wdarta",
	"wdawana",
	"wdepnięta",
	"wdeptana",
	"wdetonowana",
	"wdmuchiwana",
	"wdrapana",
	"wdrapywana",
	"wdrażana",
	"wdrążona",
	"wdrożona",
	"wduszona",
	"wdychana",
	"wdzierana",
	"wędkowana",
	"wentylowana",
	"wepchana",
	"wepchnięta",
	"werbowana",
	"weryfikowana",
	"wessana",
	"wetkana",
	"wetknięta",
	"wezwana",
	"wgłębiana",
	"wgniatana",
	"wgnieciona",
	"wgrana",
	"wgryzana",
	"wgryziona",
	"wiązana",
	"wibrowana",
	"widywana",
	"widziana",
	"wiedzona",
	"wielbiona",
	"wiercona",
	"wierzgana",
	"wierzona",
	"wieszana",
	"wietrzona",
	"więżona",
	"wikłana",
	"windowana",
	"winszowana",
	"wiosłowana",
	"wirowana",
	"witana",
	"wita",
	"wizualizowana",
	"wjeżdżana",
	"wkalkulowana",
	"wkładana",
	"wklejana",
	"wklejona",
	"wklepana",
	"wkłuta",
	"wkomponowana",
	"wkopana",
	"wkopywana",
	"wkraczana",
	"wkradana",
	"wkradziona",
	"wkręcana",
	"wkręcona",
	"wkupiona",
	"wkurwiana",
	"wkuta",
	"wkuwana",
	"włączana",
	"włączona",
	"władana",
	"władowana",
	"włamana",
	"włamywana",
	"wlana",
	"wlepiana",
	"wlepiona",
	"wlewana",
	"wliczana",
	"wliczona",
	"włożona",
	"wmanewrowana",
	"wmanipulowana",
	"wmawiana",
	"wmieszana",
	"wmówiona",
	"wmurowana",
	"wmuszona",
	"wnerwiana",
	"wnerwiona",
	"wniesiona",
	"wnikana",
	"wniknięta",
	"wnioskowana",
	"wnoszona",
	"wodowana",
	"wojowana",
	"wołana",
	"woskowana",
	"wożona",
	"wpajana",
	"wpakowana",
	"wparowana",
	"wpasowana",
	"wpatrywana",
	"wpędzana",
	"wpędzona",
	"wperswadowana",
	"wpieniona",
	"wpięta",
	"wpisana",
	"wpisywana",
	"wpłacana",
	"wpłacona",
	"wplatana",
	"wplątana",
	"wplątywana",
	"wpojona",
	"wpompowana",
	"wpraszana",
	"wprawiana",
	"wproszona",
	"wprowadzana",
	"wprowadzona",
	"wpuszczona",
	"wpychana",
	"wrabiana",
	"wręczana",
	"wrobiona",
	"wróżona",
	"wryta",
	"wrzucana",
	"wrzucona",
	"wrzynana",
	"wsadzana",
	"wsadzona",
	"wskazana",
	"wskazywana",
	"wskórana",
	"wskrzeszana",
	"wskrzeszona",
	"wślizgiwana",
	"wślizgnięta",
	"wsłuchana",
	"wsparta",
	"wspierana",
	"wspięta",
	"współczuta",
	"współodczuwana",
	"współtworzona",
	"współżyta",
	"wspomagana",
	"wspominana",
	"wspomniana",
	"wstąpiona",
	"wstawiana",
	"wstawiona",
	"wstrząsana",
	"wstrząśnięta",
	"wstrzelona",
	"wstrzykiwana",
	"wstrzyknięta",
	"wstrzymana",
	"wstrzymywana",
	"wstukana",
	"wsunięta",
	"wsuwana",
	"wsypana",
	"wszamana",
	"wszczepiana",
	"wszczepiona",
	"wszczęta",
	"wszczynana",
	"wszyta",
	"wtajemniczana",
	"wtajemniczona",
	"wtapiana",
	"wtargnięta",
	"wtarta",
	"wtaszczona",
	"wtłoczona",
	"wtopiona",
	"wtrącona",
	"wtryniana",
	"wtulana",
	"wtulona",
	"wtykana",
	"wwalona",
	"wwiercana",
	"wwiercona",
	"wwieziona",
	"wwożona",
	"wyartykułowana",
	"wyautowana",
	"wybaczana",
	"wybaczona",
	"wybadana",
	"wybatożona",
	"wybawiona",
	"wybebeszona",
	"wybełkotana",
	"wybiczowana",
	"wybielana",
	"wybielona",
	"wybierana",
	"wybijana",
	"wybita",
	"wybłagana",
	"wyblaknięta",
	"wybrandzlowana",
	"wybrana",
	"wybroniona",
	"wybrzydzana",
	"wybuchana",
	"wybuchnięta",
	"wybudowana",
	"wybudzana",
	"wybudzona",
	"wyburzana",
	"wyburzona",
	"wycackana",
	"wycałowana",
	"wyceniana",
	"wyceniona",
	"wychlana",
	"wychłostana",
	"wychodowana",
	"wychowana",
	"wychowywana",
	"wychrobotana",
	"wychwalana",
	"wychwycona",
	"wychylana",
	"wychylona",
	"wyciągana",
	"wyciągnięta",
	"wyciekana",
	"wycieniowana",
	"wycierana",
	"wycięta",
	"wycinana",
	"wyciskana",
	"wyciśnięta",
	"wyciszana",
	"wyciszona",
	"wycofana",
	"wyćwiczona",
	"wycyckana",
	"wycyganiona",
	"wyczarowana",
	"wyczarterowana",
	"wyczekana",
	"wyczekiwana",
	"wyczerpana",
	"wyczesana",
	"wyczołgana",
	"wyczołgiwana",
	"wyczuta",
	"wyczuwana",
	"wyczyniana",
	"wyczyszczona",
	"wyczytana",
	"wyczytywana",
	"wydalana",
	"wydalona",
	"wydana",
	"wydębiona",
	"wydedukowana",
	"wydelegowana",
	"wydepilowana",
	"wydeptywana",
	"wydłubana",
	"wydłubywana",
	"wydłużana",
	"wydłużona",
	"wydmuchana",
	"wydmuchiwana",
	"wydobyta",
	"wydobywana",
	"wydojona",
	"wydoroślana",
	"wydostana",
	"wydrana",
	"wydrapana",
	"wydrapywana",
	"wydrążona",
	"wydrukowana",
	"wydukana",
	"wyduszona",
	"wydychana",
	"wydziedziczona",
	"wydzielana",
	"wydzielona",
	"wydzierana",
	"wydzierżawiona",
	"wydziobana",
	"wydziwiana",
	"wydzwaniana",
	"wyedukowana",
	"wyedytowana",
	"wyeeliminowana",
	"wyegzekwowana",
	"wyeksmitowana",
	"wyekspediowana",
	"wyeksploatowana",
	"wyeksponowana",
	"wyeksportowana",
	"wyeliminowana",
	"wyemigrowana",
	"wyemitowana",
	"wyewoluowana",
	"wyfrunięta",
	"wygadana",
	"wygadywana",
	"wyganiana",
	"wygarbowana",
	"wygarniana",
	"wygarnięta",
	"wygasana",
	"wygaśnięta",
	"wygaszana",
	"wygaszona",
	"wygenerowana",
	"wygięta",
	"wyginana",
	"wygładzana",
	"wygładzona",
	"wygłaszana",
	"wygłodzona",
	"wygłosowana",
	"wygłoszona",
	"wygłówkowana",
	"wygnana",
	"wygolona",
	"wygoniona",
	"wygooglowana",
	"wygospodarowana",
	"wygotowana",
	"wygrana",
	"wygrawerowana",
	"wygrażana",
	"wygrywana",
	"wygryziona",
	"wygrzana",
	"wygrzebana",
	"wygrzebywana",
	"wygrzewana",
	"wygubiona",
	"wyhaczona",
	"wyhaftowana",
	"wyhamowana",
	"wyhodowana",
	"wyizolowana",
	"wyjadana",
	"wyjaśniana",
	"wyjaśniona",
	"wyjawiana",
	"wyjawiona",
	"wyjedzona",
	"wyjęta",
	"wyjmowana",
	"wykadrowana",
	"wykalibrowana",
	"wykalkulowana",
	"wykańczana",
	"wykantowana",
	"wykąpana",
	"wykaraskana",
	"wykarczowana",
	"wykarmiana",
	"wykasowana",
	"wykastrowana",
	"wykazana",
	"wykazywana",
	"wykierowana",
	"wykitowana",
	"wykiwana",
	"wykładana",
	"wyklarowana",
	"wyklepana",
	"wyklinana",
	"wykłócana",
	"wykluczana",
	"wykluczona",
	"wykluta",
	"wykłuta",
	"wykminiona",
	"wykolejona",
	"wykołowana",
	"wykombinowana",
	"wykonana",
	"wykończona",
	"wykonywana",
	"wykopana",
	"wykopnięta",
	"wykopywana",
	"wykorkowana",
	"wykorzeniana",
	"wykorzeniona",
	"wykorzystana",
	"wykorzystywana",
	"wykoszona",
	"wykpita",
	"wykradana",
	"wykradnięta",
	"wykręcana",
	"wykręcona",
	"wykreowana",
	"wykreślana",
	"wykreślona",
	"wykrochmalona",
	"wykrojona",
	"wykrwawiana",
	"wykrwawiona",
	"wykryta",
	"wykrywana",
	"wykrzesana",
	"wykrztuszona",
	"wykrzyczona",
	"wykrzykiwana",
	"wykrzyknięta",
	"wykrzywiana",
	"wykształcona",
	"wyksztuszona",
	"wykupiona",
	"wykupywana",
	"wykuta",
	"wykuwana",
	"wyłączana",
	"wyłączona",
	"wylądowana",
	"wyładowana",
	"wyładowywana",
	"wyłajana",
	"wyłamana",
	"wyłamywana",
	"wyłaniana",
	"wylansowana",
	"wylana",
	"wyłapana",
	"wyłapywana",
	"wyławiana",
	"wyleasingowana",
	"wyleczona",
	"wylęgana",
	"wylegimytowana",
	"wylewana",
	"wyłgana",
	"wylicytowana",
	"wyliczana",
	"wyliczona",
	"wylizana",
	"wylizywana",
	"wylogowana",
	"wyłoniona",
	"wylosowana",
	"wyłowiona",
	"wyłożona",
	"wyłudzana",
	"wyłudzona",
	"wyłupana",
	"wyłuskana",
	"wyłuskiwana",
	"wyłuszczona",
	"wyluzowana",
	"wymacana",
	"wymachiwana",
	"wymagana",
	"wymahiwana",
	"wymalowana",
	"wymamrotana",
	"wymanewrowana",
	"wymarzona",
	"wymasowana",
	"wymawiana",
	"wymazana",
	"wymazywana",
	"wymeldowana",
	"wymeldowywana",
	"wymiatana",
	"wymieciona",
	"wymieniana",
	"wymieniona",
	"wymierzana",
	"wymieszana",
	"wymigana",
	"wymigiwana",
	"wymijana",
	"wyminięta",
	"wymknięta",
	"wymoczona",
	"wymodelowana",
	"wymontowana",
	"wymordowana",
	"wymsknięta",
	"wymuszana",
	"wymyślana",
	"wymyślona",
	"wymyta",
	"wynagradzana",
	"wynagrodzona",
	"wynajdowana",
	"wynajdywana",
	"wynajęta",
	"wynajmowana",
	"wynaleziona",
	"wynarodowiona",
	"wynegocjowana",
	"wyniesiona",
	"wyniknięta",
	"wyniszczana",
	"wyniszczona",
	"wyniuchana",
	"wynoszona",
	"wynurzana",
	"wyobrażana",
	"wyobrażona",
	"wyodrębniona",
	"wyolbrzymiana",
	"wyolbrzymiona",
	"wyorbowana",
	"wyosiowana",
	"wyostrzana",
	"wyostrzona",
	"wypaczana",
	"wypakowana",
	"wypakowywana",
	"wypalana",
	"wypalona",
	"wypałowana",
	"wyparowana",
	"wyparta",
	"wypasana",
	"wypastowana",
	"wypatroszona",
	"wypatrywana",
	"wypatrzona",
	"wypchana",
	"wypchnięta",
	"wypędzana",
	"wypędzlowana",
	"wypełniana",
	"wypełniona",
	"wypersfadowana",
	"wyperswadowana",
	"wypierana",
	"wypięta",
	"wypijana",
	"wypinana",
	"wypisana",
	"wypisywana",
	"wypita",
	"wypłacana",
	"wypłacona",
	"wypłakana",
	"wypłakiwana",
	"wypłaszczona",
	"wyplatana",
	"wyplątana",
	"wypleniona",
	"wyplewiona",
	"wypłoszona",
	"wypłukana",
	"wypłukiwana",
	"wypluta",
	"wypluwana",
	"wypocona",
	"wypoczęta",
	"wypolerowana",
	"wypominana",
	"wypomniana",
	"wypompowana",
	"wypompowywana",
	"wyposażona",
	"wypowiadana",
	"wypowiedziana",
	"wypoziomowana",
	"wypożyczana",
	"wypracowana",
	"wypracowywana",
	"wyprana",
	"wyprasowana",
	"wypraszana",
	"wyprawiana",
	"wyprawiona",
	"wypróbowana",
	"wyprodukowana",
	"wyprojektowana",
	"wypromieniowana",
	"wypromowana",
	"wyprostowana",
	"wyprostowywana",
	"wyproszona",
	"wyprowadzana",
	"wyprowadzona",
	"wypróżniana",
	"wypróżniona",
	"wypruta",
	"wypruwana",
	"wyprzedana",
	"wyprzedawana",
	"wyprzedzana",
	"wyprzedzona",
	"wyprzęgana",
	"wypstrykana",
	"wypucowana",
	"wypuszczana",
	"wypuszczona",
	"wypychana",
	"wypytana",
	"wypytywana",
	"wyrąbana",
	"wyrabiana",
	"wyrąbywana",
	"wyratowana",
	"wyrażana",
	"wyrażona",
	"wyrecytowana",
	"wyręczana",
	"wyręczona",
	"wyregulowana",
	"wyrejestrowana",
	"wyremontowana",
	"wyreżyserowana",
	"wyrobiona",
	"wyrolowana",
	"wyrośnięta",
	"wyrównana",
	"wyrównywana",
	"wyróżniana",
	"wyróżniona",
	"wyrugowana",
	"wyruszana",
	"wyrwana",
	"wyrypana",
	"wyrysowana",
	"wyryta",
	"wyrywana",
	"wyrządzona",
	"wyrzeźbiona",
	"wyrżnięta",
	"wyrzucana",
	"wyrzucona",
	"wyrzygana",
	"wyrzynana",
	"wyrzywana",
	"wysączona",
	"wysadzana",
	"wysadzona",
	"wyschnięta",
	"wyściskana",
	"wyselekcjonowana",
	"wysępiona",
	"wysiadywana",
	"wysiedzona",
	"wysilana",
	"wysilona",
	"wyskakiwana",
	"wyskalowana",
	"wyskoczona",
	"wyskrobana",
	"wyskubywana",
	"wysłana",
	"wyśledzona",
	"wyślizgiwana",
	"wyślizgnięta",
	"wysłowiona",
	"wysłuchana",
	"wysłuchiwana",
	"wysmagana",
	"wysmarkana",
	"wysmarowana",
	"wysmażana",
	"wysmażona",
	"wyśmiana",
	"wyśmiewana",
	"wysmołowana",
	"wysmyrana",
	"wyśniona",
	"wysnuta",
	"wysnuwana",
	"wysondowana",
	"wyspecjalizowana",
	"wyśpiewana",
	"wyśpiewywana",
	"wyspowiadana",
	"wysprzątana",
	"wysprzedana",
	"wyssana",
	"wystartowana",
	"wystawiona",
	"wysterelizowana",
	"wysterylizowana",
	"wystosowana",
	"wystosowywana",
	"wystraszona",
	"wystrojona",
	"wystrugana",
	"wystrychnięta",
	"wystrzegana",
	"wystrzelana",
	"wystrzeliwana",
	"wystrzelona",
	"wystudzona",
	"wystukana",
	"wystukiwana",
	"wystygnięta",
	"wysunięta",
	"wysuszana",
	"wysuwana",
	"wyswatana",
	"wyświadczana",
	"wyświadczona",
	"wyświetlana",
	"wyświetlona",
	"wyswobodzona",
	"wysyłana",
	"wysypana",
	"wysypywana",
	"wysysana",
	"wyszabrowana",
	"wyszalana",
	"wyszarpana",
	"wyszarpnięta",
	"wyszasowana",
	"wyszczotkowana",
	"wyszczuplona",
	"wyszeptana",
	"wyszkolona",
	"wyszlifowana",
	"wyszorowana",
	"wyszperana",
	"wyszukana",
	"wyszukiwana",
	"wyszumiona",
	"wyszykowana",
	"wyszyta",
	"wytapetowana",
	"wytargana",
	"wytargowana",
	"wytarta",
	"wytarzana",
	"wytaszczona",
	"wytatuowana",
	"wytchnięta",
	"wytępiona",
	"wytknięta",
	"wytłoczona",
	"wytłumaczona",
	"wytłumiona",
	"wytoczona",
	"wytrąbiona",
	"wytrącana",
	"wytrącona",
	"wytransmitowana",
	"wytransportowana",
	"wytrenowana",
	"wytresowana",
	"wytriangulowana",
	"wytropiona",
	"wytruta",
	"wytrząsana",
	"wytrzasnięta",
	"wytrząśnięta",
	"wytrzebiona",
	"wytrzepana",
	"wytrzeszczana",
	"wytrzeźwiana",
	"wytrzymana",
	"wytrzymywana",
	"wytwarzana",
	"wytworzona",
	"wytyczona",
	"wytykana",
	"wytypowana",
	"wyuczona",
	"wywabiana",
	"wywabiona",
	"wywąchana",
	"wywalana",
	"wywalczona",
	"wywalona",
	"wywarta",
	"wywarzana",
	"wyważana",
	"wyważona",
	"wywęszana",
	"wywężykowana",
	"wywiana",
	"wywiązana",
	"wywiązywana",
	"wywierana",
	"wywiercona",
	"wywieszana",
	"wywieszona",
	"wywietrzona",
	"wywieziona",
	"wywijana",
	"wywindowana",
	"wywinięta",
	"wywłaszczona",
	"wywlekana",
	"wywnętrzniona",
	"wywnioskowana",
	"wywodzona",
	"wywolana",
	"wywoływana",
	"wywoskowana",
	"wywożona",
	"wywracana",
	"wywrócona",
	"wywróżona",
	"wywyższana",
	"wyżalona",
	"wyzbyta",
	"wyzdrowiona",
	"wyżebrana",
	"wyżerana",
	"wyzerowana",
	"wyzionięta",
	"wyznaczana",
	"wyznaczona",
	"wyznana",
	"wyznawana",
	"wyzwalana",
	"wyzwana",
	"wyzwolona",
	"wyzygzakowana",
	"wyżynana",
	"wyzyskana",
	"wyzyskiwana",
	"wyżyta",
	"wyzywana",
	"wyżywana",
	"wyżywiona",
	"wzbijana",
	"wzbita",
	"wzbogacana",
	"wzbogacona",
	"wzbraniana",
	"wzbudzana",
	"wzbudzona",
	"wzburzana",
	"wzburzona",
	"wżeniona",
	"wzięta",
	"wzmacniona",
	"wzmagana",
	"wzmocniona",
	"wznawiana",
	"wzniecana",
	"wznieciona",
	"wzniesięta",
	"wznoszona",
	"wznowiona",
	"wzorowana",
	"wzrośnięta",
	"wzruszona",
	"wzwyżana",
	"wzywana",
	"zaabordowana",
	"zaadaptowana",
	"zaadoptowana",
	"zaadresowana",
	"zaakcentowana",
	"zaakceptowana",
	"zaaklimatyzowana",
	"zaalarmowana",
	"zaanektowana",
	"zaangażowana",
	"zaanonsowana",
	"zaapelowana",
	"zaaplikowana",
	"zaaportowana",
	"zaaprobowana",
	"zaaranżowana",
	"zaaresztowana",
	"zaatakowana",
	"zabaczona",
	"zabalowana",
	"zabandażowana",
	"zabarwiona",
	"zabarykadowana",
	"zabawiana",
	"zabawiona",
	"zabepieczana",
	"zabetonowana",
	"zabezpieczona",
	"zabierana",
	"zabita",
	"zabłądzona",
	"zablefowana",
	"zabłocona",
	"zablokowana",
	"zabraniana",
	"zabrana",
	"zabrnięta",
	"zabroniona",
	"zabrudzona",
	"zabudowana",
	"zabukowana",
	"zabulona",
	"zaburzona",
	"zabutelkowana",
	"zacementowana",
	"zacerowana",
	"zachciana",
	"zachęcana",
	"zachęcona",
	"zachlapana",
	"zachodzona",
	"zachomikowana",
	"zachorowana",
	"zachowana",
	"zachowywana",
	"zachwalana",
	"zachwalona",
	"zachwiana",
	"zachwycona",
	"zaciągana",
	"zaciągnięta",
	"zaciążona",
	"zaciekawiona",
	"zaciemniana",
	"zaciemniona",
	"zacierana",
	"zacieśniona",
	"zacięta",
	"zacinana",
	"zaciskana",
	"zaciśnięta",
	"zaćmiona",
	"zacumowana",
	"zacytowana",
	"zaczadzona",
	"zaczarowana",
	"Zaczepiana",
	"zaczepiona",
	"zaczerpana",
	"zaczesana",
	"zaczęta",
	"zaczołgana",
	"zaczynana",
	"zadarta",
	"zadawalana",
	"zadawana",
	"zadbana",
	"zadebiutowana",
	"zadedykowana",
	"zadeklamowana",
	"zadeklarowana",
	"zademonstrowana",
	"zadenucjowana",
	"zadepeszowana",
	"zadeptana",
	"zadeptywana",
	"zadęta",
	"zadławiona",
	"żądlona",
	"zadłużana",
	"zadłużona",
	"zadokowana",
	"zadomowiona",
	"zadowalana",
	"zadrapana",
	"zadraśnięta",
	"zadręczana",
	"zadręczona",
	"zadrutowana",
	"zadurzana",
	"zadurzona",
	"zaduszona",
	"zadymiona",
	"zadźgana",
	"zadziobana",
	"zadziwiana",
	"zadziwiona",
	"zafakturowana",
	"zafałszowana",
	"zafarbowana",
	"zafiksowana",
	"zafundowana",
	"zagadana",
	"zagadnięta",
	"zagadywana",
	"zagajona",
	"zaganiana",
	"zagapiona",
	"zagarażowana",
	"zagarniana",
	"zagarnięta",
	"zagaszona",
	"zagazowana",
	"zagęszczona",
	"zagięta",
	"zaginana",
	"zaginięta",
	"zagłębiana",
	"zagłębiona",
	"zagłodzona",
	"zagłuszana",
	"zagłuszona",
	"zagmatwana",
	"zagnana",
	"zagnieżdżona",
	"zagojona",
	"zagoniona",
	"zagospodarowana",
	"zagotowana",
	"zagrabiona",
	"zagradzana",
	"zagrażana",
	"zagrodzona",
	"zagrywana",
	"zagryzana",
	"zagryziona",
	"zagrzana",
	"zagrzebana",
	"zagrzewana",
	"zagubiona",
	"zagwarantowana",
	"zahaczona",
	"zahamowana",
	"zahandlowana",
	"zaharowana",
	"zahartowana",
	"zahipnotyzowana",
	"zaholowana",
	"zaimitowana",
	"zaimplantowana",
	"zaimplementowana",
	"zaimprowizowana",
	"zainaugurowana",
	"zainfekowana",
	"zainicjowana",
	"zainkasowana",
	"zainscenizowana",
	"zainspirowana",
	"zainstalowana",
	"zainteresowana",
	"zaintrygowana",
	"zaintubowana",
	"zainwestowana",
	"zaizolowana",
	"zajadana",
	"zajana",
	"zajarana",
	"zajechana",
	"zajęta",
	"zajmowana",
	"zakablowana",
	"zakamuflowana",
	"zakasana",
	"zakasowana",
	"zakąszana",
	"zakatalogowana",
	"zakatowana",
	"zakatrupiona",
	"zakazana",
	"zakażana",
	"zakazywana",
	"zakiszona",
	"zakładana",
	"zaklasyfikowana",
	"zaklejana",
	"zaklejona",
	"zaklepana",
	"zaklepywana",
	"zaklinana",
	"zaklinowana",
	"zakłócana",
	"zakłócona",
	"zaklopotana",
	"zakłuta",
	"zakneblowana",
	"zakodowana",
	"zakolczykowana",
	"zakolorowana",
	"zakołysana",
	"zakomunikowana",
	"zakończona",
	"zakonserwowana",
	"zakopana",
	"zakopywana",
	"zakorzeniana",
	"zakorzeniona",
	"zakoszona",
	"zakosztowana",
	"zakotwiczana",
	"zakotwiczona",
	"zakpiona",
	"zakradana",
	"zakręcana",
	"zakręcona",
	"zakreślana",
	"zakreślona",
	"zakrwawiona",
	"zakryta",
	"zakrywana",
	"zakrzyczana",
	"zakrzyknięta",
	"zakrzywiana",
	"zakrzywiona",
	"zaksięgowana",
	"zaktualizowana",
	"zaktywizowana",
	"zaktywowana",
	"zakumana",
	"zakupiona",
	"zakurzona",
	"zakuta",
	"zakuwana",
	"zakwaterowana",
	"zakwestionowaa",
	"zakwitnięta",
	"załączona",
	"załadowana",
	"załagodzona",
	"zalamana",
	"zalaminowana",
	"załamywana",
	"zalana",
	"załapana",
	"załatana",
	"załatwiana",
	"załatwiona",
	"zalatywana",
	"zalecana",
	"zalecona",
	"zaleczona",
	"zalegalizowana",
	"zalegana",
	"zalepiana",
	"zalepiona",
	"zalewana",
	"zaliczana",
	"zaliczona",
	"załkana",
	"zalogowana",
	"żałowana",
	"założona",
	"zaludniona",
	"zamacana",
	"zamachnięta",
	"zamącona",
	"zamalowana",
	"zamanewrowana",
	"zamanifestowana",
	"zamarkowana",
	"zamartwiana",
	"zamarynowana",
	"zamarzana",
	"zamarznięta",
	"zamaskowana",
	"zamawiana",
	"zamazana",
	"zamazywana",
	"zamęczana",
	"zamęczona",
	"zameldowana",
	"zamelinowana",
	"zamerykanizowana",
	"zamiatana",
	"zamieniana",
	"zamieniona",
	"zamieszana",
	"zamieszczana",
	"zamieszczona",
	"zamieszkana",
	"zamieszkiwana",
	"zaminowana",
	"zamknięta",
	"zamocowana",
	"zamoczona",
	"zamontowana",
	"zamordowana",
	"zamortyzowana",
	"zamotana",
	"zamówiona",
	"zamrażana",
	"zamroczona",
	"zamrożona",
	"zamulana",
	"zamurowana",
	"zamydlona",
	"zamykana",
	"zanalizowana",
	"zanegowana",
	"zaniechana",
	"zanieczyszczana",
	"zanieczyszczona",
	"zaniedbana",
	"zaniedbywana",
	"zaniepokojona",
	"zaniesiona",
	"zanihilowana",
	"zanikana",
	"zaniknięta",
	"zaniżana",
	"zaniżona",
	"zanoszona",
	"zanotowana",
	"zanucona",
	"zanudzana",
	"zanudzona",
	"zanurzana",
	"zanurzona",
	"zanużona",
	"zaobaczona",
	"zaobserwowana",
	"zaoferowana",
	"zaofiarowana",
	"zaogniana",
	"zaogniona",
	"zaokrąglana",
	"zaokrąglona",
	"zaokrętowana",
	"zaopatrywana",
	"zaopatrzona",
	"zaopiekowana",
	"zaorana",
	"zaostrzana",
	"zaostrzona",
	"zaoszczędzona",
	"zapadana",
	"zapakowana",
	"zapalana",
	"zapalona",
	"zapamiętana",
	"zapamiętywana",
	"zapanowana",
	"zaparkowana",
	"zaparowywana",
	"zaparzana",
	"zaparzona",
	"zapaskudzona",
	"zapauzowana",
	"zapchana",
	"zapędzana",
	"zapełniana",
	"zapełniona",
	"zaperfumowana",
	"zapeszana",
	"zapewniana",
	"zapewniona",
	"zapieczętowana",
	"zapierana",
	"zapięta",
	"zapijana",
	"zapinana",
	"zapisana",
	"zapisuwana",
	"zapita",
	"zapłacona",
	"zapładniana",
	"zaplamiona",
	"zaplanowana",
	"zaplątana",
	"zapłodniona",
	"zaplombowana",
	"zapobiegana",
	"zapodana",
	"zapodawana",
	"zapodziana",
	"zapokojona",
	"zapolowana",
	"zapominana",
	"zapomniana",
	"zapowiadana",
	"zapowiedziana",
	"zapoznana",
	"zapoznawana",
	"zapożyczona",
	"zapracowywana",
	"zaprana",
	"zaprasowywana",
	"zapraszana",
	"zaprawiona",
	"zaprenumerowana",
	"zaprezentowana",
	"Zaprogramowana",
	"zaprojektowana",
	"zaproponowana",
	"zaproszona",
	"zaprotokołowana",
	"zaprowadzana",
	"zaprowadzona",
	"zaprzątana",
	"zaprzeczana",
	"zaprzeczona",
	"zaprzedana",
	"zaprzedawana",
	"zaprzęgana",
	"zaprzepaszczana",
	"zaprzestana",
	"zaprzestawana",
	"zaprzyjaźniona",
	"zapudłowana",
	"zapunktowana",
	"zapuszczana",
	"zapuszczona",
	"zapuszkowana",
	"zapychana",
	"zapylana",
	"zapylona",
	"zapytana",
	"zarabiana",
	"zaranżowana",
	"zarażana",
	"zarażona",
	"zarecytowana",
	"zaręczana",
	"zaręczona",
	"zarejestrowana",
	"zareklamowana",
	"zarekomendowana",
	"zarekomondowana",
	"zarekwirowana",
	"zarezerwowana",
	"zarobiona",
	"żartowana",
	"zarwana",
	"zaryglowana",
	"zarymowana",
	"zarysowana",
	"zarywana",
	"zaryzykowana",
	"zarządzana",
	"zarżnięta",
	"zarzucana",
	"zarzynana",
	"zasadzona",
	"zaścielona",
	"zasegurowana",
	"zaserwowana",
	"zasiadana",
	"zasiana",
	"zasiedlona",
	"zasięgana",
	"zasięgnięta",
	"zasiewana",
	"zasilana",
	"zasilona",
	"zaskakiwana",
	"zaskarbiona",
	"zaskoczona",
	"zaskrobana",
	"zasłaniana",
	"zaślepiana",
	"zaślepiona",
	"zasłodzona",
	"zasłoniona",
	"zasłużona",
	"zasmakowana",
	"zaśmiecana",
	"zaśmiecona",
	"zasmradzana",
	"zasmrodzona",
	"zasmucana",
	"zasmucona",
	"zasolona",
	"zaspakajana",
	"zaśpiewana",
	"zaspokajana",
	"zaspokojona",
	"zasponsorowana",
	"zaśrubowywana",
	"zassana",
	"zastana",
	"zastąpiona",
	"zastawiana",
	"zastawiona",
	"zastępowana",
	"zastopowana",
	"zastosowana",
	"zastraszana",
	"zastraszona",
	"zastrzelona",
	"zasugerowana",
	"zasunięta",
	"zasuwana",
	"zaświadczona",
	"zaświecona",
	"zaświoniona",
	"zasyfiona",
	"zasygnalizowana",
	"zasymilowana",
	"zasymulowana",
	"zasypana",
	"zasypywana",
	"zasysana",
	"zaszachowana",
	"zaszantażowana",
	"zaszargana",
	"zaszczepiana",
	"zaszczepiona",
	"zaszczuta",
	"zaszczycana",
	"zaszczycona",
	"zaszeptana",
	"zaszeregowana",
	"zaszlachtowana",
	"zasznurowana",
	"zaszpachlowana",
	"zasztyletowana",
	"zaszufladkowana",
	"zaszyfrowana",
	"zaszyta",
	"zaszywana",
	"zataczana",
	"zatajana",
	"zatajona",
	"zatamowana",
	"zatankowana",
	"zatapiana",
	"zatargana",
	"zatarta",
	"zatelegrafowana",
	"zatemperowana",
	"zatęskniona",
	"zatkana",
	"zatknięta",
	"zatoczona",
	"zatonięta",
	"zatopiona",
	"zatracana",
	"zatracona",
	"zatriumfowana",
	"zatrudniana",
	"zatrudniona",
	"zatruta",
	"zatruwana",
	"zatrzaskiwana",
	"zatrzaśnięta",
	"zatrząśnięta",
	"zatrzymana",
	"zatrzymywana",
	"zatuszowana",
	"zatwierdzana",
	"zatwierdzona",
	"zatykana",
	"zatynkowana",
	"zatytułowana",
	"zauploadowana",
	"zauroczona",
	"zautomatyzowana",
	"zauważana",
	"zauważona",
	"zawadzana",
	"zawalana",
	"zawalczona",
	"zawalona",
	"zawarta",
	"zaważona",
	"zawdzięczana",
	"zawetowana",
	"zawężona",
	"zawiadamiana",
	"zawiadomiona",
	"zawiązana",
	"zawiązywana",
	"zawiedzona",
	"zawierana",
	"zawierzona",
	"zawieszana",
	"zawieszona",
	"zawieziona",
	"zawijana",
	"zawinięta",
	"zawiniona",
	"zawiśnięta",
	"zawitana",
	"zawładnięta",
	"zawłaszczona",
	"zawodzona",
	"zawojowana",
	"zawołana",
	"zawoskowana",
	"zawożona",
	"zawracana",
	"zawrócona",
	"zawstydzana",
	"zażądana",
	"zażartowana",
	"zazdroszczona",
	"zażegnana",
	"zażenowana",
	"zaznaczana",
	"zaznajomiona",
	"zaznana",
	"zaznawana",
	"zażyczona",
	"zażyta",
	"zażywana",
	"zbaczana",
	"zbadana",
	"zbagatelizowana",
	"zbajerowana",
	"zbałamucona",
	"zbalansowana",
	"zbalsamowana",
	"zbankrutowana",
	"zbawiana",
	"zbawiona",
	"zbesztana",
	"zbezczeszczona",
	"zbierana",
	"zbijana",
	"zbita",
	"zbliżona",
	"zbluzgana",
	"zbojkotowana",
	"zbrojona",
	"zbrukana",
	"zbszczecona",
	"zbudowana",
	"zbudzona",
	"zbuntowana",
	"zburzona",
	"zbyta",
	"zbywana",
	"zchwytana",
	"zcięta",
	"zciszona",
	"zdana",
	"zdarta",
	"zdeaktywowana",
	"zdecydowana",
	"zdefiniowana",
	"zdeflorowana",
	"zdegradowana",
	"zdejmowana",
	"zdeklarowana",
	"zdekodowana",
	"zdekompresowana",
	"zdekoncentrowana",
	"zdekonstruowana",
	"zdelegalizowana",
	"zdemaskowana",
	"zdementowana",
	"zdemolowana",
	"zdemontowana",
	"zdemoralizowana",
	"zdenerwowana",
	"zdeponowana",
	"zdeprymowana",
	"zdeptana",
	"zderzana",
	"zderzona",
	"zdestabilizowana",
	"Zdetonowana",
	"zdetronizowana",
	"zdewastowana",
	"zdewaulowana",
	"zdezerterowana",
	"zdezintegrowana",
	"zdezorientowana",
	"zdezynfektowana",
	"zdiagnozowana",
	"zdjęta",
	"zdławiona",
	"zdmuchiwana",
	"zdmuchnięta",
	"zdobyta",
	"zdobywana",
	"zdołowana",
	"zdominowana",
	"zdopingowana",
	"zdrabniana",
	"zdradzana",
	"zdradzona",
	"zdrapana",
	"zdrapywana",
	"zdrutowana",
	"zdruzgotana",
	"zduplikowana",
	"zduszona",
	"zdwojona",
	"zdyscyplinowana",
	"zdyskredytowana",
	"zdyskwalifikowana",
	"zdystansowana",
	"zdzielona",
	"zdzierana",
	"zdzierżona",
	"zdziesiątkowana",
	"Zdzwoniona",
	"zebrana",
	"zechciana",
	"zedytowana",
	"żegnana",
	"żeniona",
	"zepchnięta",
	"zepsuta",
	"żerowana",
	"zerwana",
	"zerżnięta",
	"zeskakiwana",
	"zeskanowana",
	"zeskrobywana",
	"zesłana",
	"ześlizgiwana",
	"ześlizgnięta",
	"zesmolona",
	"zespawiana",
	"zespolona",
	"zessana",
	"zestawiana",
	"zestawiona",
	"zestresowana",
	"zestrzeliwana",
	"zestrzelona",
	"zeswatana",
	"zeszklona",
	"zeszlifowana",
	"zetknięta",
	"zezłoszczona",
	"zeznana",
	"zeznawana",
	"zezwalana",
	"zezwolona",
	"zfinansowana",
	"zgadana",
	"zgadywana",
	"zgajana",
	"zganiona",
	"zgarnięta",
	"zgaśnięta",
	"zgaszona",
	"zgięta",
	"zginana",
	"zgładzona",
	"zgłaszana",
	"zgłębiana",
	"zgłębiona",
	"zgłośniona",
	"zgłoszona",
	"zgłuszona",
	"zgniatana",
	"zgnieciona",
	"zgnita",
	"zgnojona",
	"zgodzona",
	"zgolona",
	"zgoniona",
	"zgotowana",
	"zgrabiona",
	"zgrillowana",
	"zgromadzana",
	"zgromadzona",
	"zgrupowana",
	"zgrzeszona",
	"zgrzytana",
	"zgubiona",
	"zgwałcona",
	"zhackowana",
	"zhakowana",
	"zhańbiona",
	"zhandlowana",
	"zharmonizowana",
	"zidentyfikowana",
	"ziewana",
	"zignorowana",
	"zilustrowana",
	"zinfiltrowana",
	"zintegrowana",
	"zintensyfikowana",
	"zinterpretowana",
	"zinwentaryzowana",
	"zirytowana",
	"zjadana",
	"zjawiana",
	"zjednana",
	"zjednoczona",
	"zjedzona",
	"zjeżdżona",
	"zkontaktowana",
	"zkserowana",
	"złączona",
	"złagodzona",
	"złajana",
	"złamana",
	"zlana",
	"złapana",
	"zlecana",
	"zlecona",
	"zlekceważona",
	"zlepiana",
	"zlepiona",
	"zlewana",
	"zlicytowana",
	"zliczana",
	"zliczona",
	"zlikwidowana",
	"zlinczowana",
	"zlitowana",
	"zlizana",
	"zlizywana",
	"złoita",
	"zlokalizowana",
	"złomowana",
	"żłopana",
	"złowiona",
	"złożona",
	"złupiona",
	"złuszczana",
	"zluzowana",
	"zmacana",
	"zmącona",
	"zmagana",
	"zmagazynowana",
	"zmajstrowana",
	"zmaksylizowana",
	"zmanipulowana",
	"zmarnowana",
	"zmartwychwstana",
	"zmarznięta",
	"zmasakrowana",
	"zmaterializowana",
	"zmawiana",
	"zmazana",
	"zmazywana",
	"zmbobardowana",
	"zmiatana",
	"zmiażdżona",
	"zmiękczona",
	"zmielona",
	"zmieniana",
	"zmieniona",
	"zmierzana",
	"zmierzona",
	"zmierzwiona",
	"zmieszana",
	"zmieszczona",
	"zmiksowana",
	"zminiaturyzowana",
	"zminimalizowana",
	"zmniejszana",
	"zmniejszona",
	"zmobilizowana",
	"zmoczona",
	"zmodernizowana",
	"zmodyfikowana",
	"zmoknięta",
	"zmonopolizowana",
	"zmontowana",
	"zmostkowana",
	"zmotywowana",
	"zmówiona",
	"zmrożona",
	"zmrużona",
	"zmumifikowana",
	"zmuszana",
	"zmuszona",
	"zmutowana",
	"zmyślana",
	"zmyta",
	"zmywana",
	"znacjonalizowana",
	"znajdowana",
	"znajdywana",
	"znakowana",
	"znaleziona",
	"znana",
	"znęcana",
	"zneutralizowana",
	"zniechęcona",
	"znieczulona",
	"zniekształcana",
	"zniekształcona",
	"znienawidzona",
	"znieprawiona",
	"zniesiona",
	"zniesławiana",
	"zniesławiona",
	"zniewalana",
	"znieważana",
	"znieważona",
	"zniewolona",
	"zniszczona",
	"zniweczona",
	"zniwelowana",
	"zniżana",
	"zniżona",
	"znokautowana",
	"znormalniona",
	"znoszona",
	"znudzona",
	"zobaczona",
	"zobowiązana",
	"zobrazowana",
	"zogniskowana",
	"żonglowana",
	"zoomowana",
	"zoperowana",
	"zoptymalizowana",
	"zorbita",
	"zorganizowana",
	"zorientowana",
	"zostawiana",
	"zostawiona",
	"zpłacona",
	"zprowokowana",
	"zrabowana",
	"zrachowana",
	"zracjonalizowana",
	"zraniona",
	"zraportowana",
	"zrażana",
	"zrażona",
	"zrealizowana",
	"zrecenzowana",
	"zredagowana",
	"zredukowana",
	"zreferowana",
	"zreformowana",
	"zrefowana",
	"zrefundowana",
	"zregenerowana",
	"zrehabilitowana",
	"zreinkarnowana",
	"zreintegrowana",
	"zrekonfigurowana",
	"zrekonstruowana",
	"zrekrutowana",
	"zrekrystalizowana",
	"zrelacjonowana",
	"zrelaksowana",
	"zremiksowana",
	"zremisowana",
	"zreorganizowana",
	"zreperowana",
	"zreplikowana",
	"zresetowana",
	"zresocjalizowana",
	"zrestartowana",
	"zrestrukturyzowana",
	"zrewanżowana",
	"zrewidowana",
	"zrewolucjonizowana",
	"zrezygnowana",
	"zrobiona",
	"zrolowana",
	"zroszona",
	"zrównana",
	"zrównoważona",
	"zrównywana",
	"zróżnicowana",
	"zrozumiana",
	"zrugana",
	"zruinowana",
	"zrujnowana",
	"zrymowana",
	"zrywana",
	"zrzędzona",
	"zrzeszona",
	"zrzucana",
	"zrzucona",
	"zsumowana",
	"zsunięta",
	"zsuwana",
	"zsynchronizowana",
	"zsyntetyzowana",
	"zsypywana",
	"zszargana",
	"zszokowana",
	"zszyta",
	"zszywana",
	"ztarta",
	"żuta",
	"zutylizowana",
	"zużyta",
	"zużywana",
	"zwabiana",
	"zwabiona",
	"zwalana",
	"zwalczona",
	"zwalniana",
	"zwalona",
	"zwana",
	"zwaporyzowana",
	"zwątpiona",
	"zważana",
	"zważona",
	"zwędzona",
	"zwerbalizowana",
	"zwerbowana",
	"zweryfikowana",
	"zwęszona",
	"zwężona",
	"zwiastowana",
	"związana",
	"związywana",
	"zwichnięta",
	"zwiedzana",
	"zwiedzona",
	"zwiększona",
	"zwieńczona",
	"zwierzana",
	"zwieszana",
	"zwieszona",
	"zwietrzona",
	"zwijana",
	"zwilżona",
	"zwinięta",
	"zwizualizowana",
	"zwlekana",
	"zwodowana",
	"zwodzona",
	"zwołana",
	"zwolniona",
	"zwoływana",
	"zwożona",
	"zwracana",
	"zwrócona",
	"zwyciężana",
	"zwymiotowana",
	"życzona",
	"żygana",
	"zygzakowana",
	"zyskana",
	"zyskiwana",
	"żyta",
	"zżarta",
	"zżerana",
	"zżynana",
	"zżyta",
	"abdykowane",
	"absorbowane",
	"adaptowane",
	"administrowane",
	"adoptowane",
	"adorowane",
	"adresowane",
	"afiszowane",
	"agitowane",
	"akcentowane",
	"akceptowane",
	"aklimatyzowane",
	"akompaniowane",
	"aktualizowane",
	"aktywowane",
	"akumulowane",
	"alaromowane",
	"alienowane",
	"amerykanizowane",
	"amortyzowane",
	"amputowane",
	"analizowane",
	"angażowane",
	"anihilowane",
	"animowane",
	"anonsowane",
	"antropomorfizowane",
	"antydatowane",
	"anulowane",
	"apelowane",
	"aportowane",
	"aranżowane",
	"archiwizowane",
	"aresztowane",
	"argumentowane",
	"artykułowane",
	"ascendowane",
	"asekurowane",
	"asymilowane",
	"asystowane",
	"atakowane",
	"autoryzowane",
	"awanturowane",
	"babrane",
	"baczone",
	"badane",
	"bagatelizowane",
	"bajerowane",
	"bałamucone",
	"balangowane",
	"balansowane",
	"banalizowane",
	"bandażowane",
	"bankrutowane",
	"baraszkowane",
	"barwione",
	"bawione",
	"bazgrane",
	"bazowane",
	"bębnione",
	"bełkotane",
	"besztane",
	"biadolone",
	"biczowane",
	"bite",
	"błagane",
	"błaznowane",
	"blefowane",
	"błogosławione",
	"blokowane",
	"bluzgane",
	"błyskane",
	"błyszczące",
	"boczone",
	"bogacone",
	"bojkotowane",
	"boksowane",
	"bombardowane",
	"bopowane",
	"borowane",
	"brandzlowane",
	"brane",
	"brasowane",
	"bratane",
	"bredzone",
	"brnięte",
	"brodzone",
	"bronione",
	"brudzone",
	"brylowane",
	"budowane",
	"budzone",
	"bujane",
	"bulone",
	"bulwersowane",
	"bumelowane",
	"burzone",
	"butelkowane",
	"bywane",
	"cackane",
	"całowane",
	"capnięte",
	"cechowane",
	"celebrowane",
	"celowane",
	"cenione",
	"cenzurowane",
	"chciane",
	"chlane",
	"chlapane",
	"chlapnięte",
	"chlastane",
	"chłodzone",
	"chlostane",
	"chlubione",
	"chodowane",
	"chomikowane",
	"chorowane",
	"chowane",
	"chronione",
	"chrupane",
	"chrzczone",
	"chute",
	"chwalone",
	"chwycone",
	"chwytane",
	"chybotane",
	"chylone",
	"ciachnięte",
	"ciągane",
	"ciągnięte",
	"ciemiężone",
	"cierpiane",
	"cieszone",
	"cięte",
	"ciskane",
	"ciśnięte",
	"ciułane",
	"cmokane",
	"cmoknięte",
	"cofane",
	"cofnięte",
	"ćpane",
	"cucone",
	"cudzołożone",
	"cumowane",
	"ćwiartowane",
	"ćwiczone",
	"cykane",
	"cytowane",
	"czajone",
	"czarowane",
	"czczone",
	"czepiane",
	"czepione",
	"czerpane",
	"czesane",
	"częstowane",
	"czochrane",
	"czołgane",
	"czute",
	"czytane",
	"czyte",
	"darowane",
	"darte",
	"darzone",
	"datowane",
	"dawane",
	"dbane",
	"deaktywowane",
	"debatowane",
	"dedukowane",
	"dedykowane",
	"defibrylowane",
	"defilowane",
	"definiowane",
	"defraudowane",
	"degradowane",
	"degustowane",
	"deklamowane",
	"deklarowane",
	"dekodowane",
	"dekompresowane",
	"dekorowane",
	"dekretowane",
	"delegowane",
	"delektowane",
	"deliberowane",
	"demaskowane",
	"dementowane",
	"demolowane",
	"demonizowane",
	"demonstrowane",
	"demoralizowane",
	"denerwowane",
	"denuncjowane",
	"depeszowane",
	"depilowane",
	"deportowane",
	"deprawowane",
	"deptane",
	"deratyzowane",
	"destabilizowane",
	"destylowane",
	"desygnowane",
	"determinowane",
	"detonowane",
	"dewastowane",
	"dewaulowane",
	"dezaktywowane",
	"dezorientowane",
	"dezynfekowane",
	"diagnozowane",
	"dilowane",
	"dłubane",
	"dłużone",
	"dmuchane",
	"dmuchnięte",
	"dobiegane",
	"dobierane",
	"dobijane",
	"dobite",
	"dobrane",
	"dobudzone",
	"dobyte",
	"doceniane",
	"docenione",
	"dochodzone",
	"dochowane",
	"dochowywane",
	"dociągnięte",
	"dociekane",
	"docięte",
	"docinane",
	"dociskane",
	"dociśnięte",
	"doczekane",
	"doczepione",
	"doczołgane",
	"doczyszczone",
	"doczytane",
	"dodane",
	"dodawane",
	"dodrukowane",
	"dodrukowywane",
	"dofinansowane",
	"dofinansowywane",
	"dogadane",
	"dogadywane",
	"dogadzane",
	"doganiane",
	"doglądane",
	"doglądnięte",
	"dognane",
	"dogodzone",
	"dogonione",
	"dograne",
	"dogryzane",
	"dogryzione",
	"dogrzane",
	"dogrzebane",
	"doinformowane",
	"dojeżdżane",
	"dojone",
	"dojrzane",
	"dojrzewane",
	"dokańczane",
	"dokarmiane",
	"dokarmione",
	"dokazane",
	"dokazywane",
	"dokładane",
	"doklejone",
	"dokonane",
	"dokończone",
	"dokonywane",
	"dokopane",
	"dokopywane",
	"dokowane",
	"dokręcane",
	"dokręcone",
	"dokształcane",
	"dokształcone",
	"dokuczane",
	"dokumentowane",
	"dokupione",
	"dołączane",
	"dołączone",
	"doładowane",
	"dolane",
	"dolewane",
	"doliczone",
	"dołowane",
	"dołożone",
	"domagane",
	"domalowane",
	"domknięte",
	"domniewywane",
	"domówione",
	"domyślane",
	"domyślone",
	"domyte",
	"doniesione",
	"donoszone",
	"dopadane",
	"dopadnięte",
	"dopakowane",
	"dopalone",
	"dopasowane",
	"dopasowywane",
	"dopatrywane",
	"dopatrzone",
	"dopchane",
	"dopchnięte",
	"dopełniane",
	"dopełnione",
	"dopieszczone",
	"dopięte",
	"dopijane",
	"dopilnowane",
	"dopingowane",
	"dopisane",
	"dopisywane",
	"dopite",
	"dopłacane",
	"dopłacone",
	"dopłynięte",
	"dopolerowane",
	"dopompowane",
	"dopowiedziane",
	"dopracowane",
	"dopracowywane",
	"doprane",
	"doprawione",
	"doprecyzowane",
	"doproszone",
	"doprowadzane",
	"doprowadzone",
	"dopucowane",
	"dopuszczane",
	"dopuszczone",
	"dopytywane",
	"dorabiane",
	"doradzane",
	"doradzone",
	"doręczane",
	"doręczone",
	"dorobione",
	"dorównane",
	"dorównywane",
	"dorwane",
	"dorysowane",
	"dorzucane",
	"dorzucone",
	"doścignięte",
	"dosiadane",
	"dosięgnięte",
	"doskoczone",
	"doskonalone",
	"dosładzane",
	"dosłane",
	"dosłyszane",
	"dosolone",
	"dośrodkowane",
	"dossane",
	"dostane",
	"dostąpione",
	"dostarczane",
	"dostarczone",
	"dostawane",
	"dostawiane",
	"dostawione",
	"dostosowane",
	"dostosowywane",
	"dostrajane",
	"dostrojone",
	"dostrzegane",
	"dosunięte",
	"dosuwane",
	"doświadczane",
	"Doświetlone",
	"dosypane",
	"dosypywane",
	"doszkolone",
	"doszlifowane",
	"doszorowane",
	"doszukane",
	"doszukiwane",
	"doszyte",
	"dotankowane",
	"dotankowywane",
	"dotargane",
	"dotaszczone",
	"dotknięte",
	"dotlenione",
	"dotłumaczone",
	"dotowane",
	"dotrwane",
	"dotrzymane",
	"dotrzymywane",
	"dotykane",
	"douczane",
	"douczone",
	"dowalone",
	"dowiezione",
	"dowodzone",
	"dowożone",
	"doznane",
	"doznawane",
	"dozorowane",
	"dozowane",
	"dożyte",
	"dożywione",
	"dramatyzowane",
	"drapane",
	"drapnięte",
	"draśnięte",
	"drażnione",
	"drążone",
	"dręczone",
	"drenowane",
	"drgane",
	"drgnięte",
	"drukowane",
	"dryblowane",
	"dryfowane",
	"drzemane",
	"dubbingowane",
	"dublowane",
	"duplikowane",
	"duszone",
	"dworowane",
	"dygotane",
	"dyktowane",
	"dymane",
	"dymione",
	"dyrygowane",
	"dyscyplinowane",
	"dyskredytowane",
	"dyskryminowane",
	"dyskutowane",
	"dyskwalifikowane",
	"dysponowane",
	"dystansowane",
	"dystrybuowane",
	"dywagowane",
	"dźgane",
	"dźgnięte",
	"dziabnięte",
	"dziedziczone",
	"dziękowane",
	"dzielone",
	"dziergane",
	"dzierżone",
	"dziobane",
	"dziurawione",
	"dziurkowane",
	"dźwigane",
	"dźwignięte",
	"edukowane",
	"edytowane",
	"egzaminowane",
	"egzekutowane",
	"egzekwowane",
	"ekscytowane",
	"ekshumowane",
	"ekskomunikowane",
	"eksmitowane",
	"ekspandowane",
	"eksperymentowane",
	"eksploatowane",
	"eksplorowane",
	"eksponowane",
	"eksportowane",
	"eksterminowane",
	"ekstradowane",
	"ekstrapolowane",
	"eliminowane",
	"emancypowane",
	"emanowae",
	"emigrowane",
	"emitowane",
	"energetyzowane",
	"eskortowane",
	"etykietowane",
	"ewakuowane",
	"ewaluowane",
	"fabrykowane",
	"falowane",
	"fałszowane",
	"farbowane",
	"faszerowane",
	"faulowane",
	"faworyzowane",
	"fechtowane",
	"fermentowane",
	"ferowane",
	"figurowane",
	"filetowane",
	"filmowane",
	"filtrowane",
	"finalizowane",
	"finansowane",
	"firmowane",
	"fleszowane",
	"folgowane",
	"formułowane",
	"forsowane",
	"fotografowane",
	"fundowane",
	"gadane",
	"ganiane",
	"garbione",
	"gardzone",
	"garnirowane",
	"gaszone",
	"gawędzone",
	"gaworzone",
	"gazowane",
	"gdakane",
	"gderane",
	"generalizowane",
	"generowane",
	"gięte",
	"gilgotane",
	"gładzone",
	"głaskane",
	"głodowane",
	"głodzone",
	"gloryfikowane",
	"głosowane",
	"głoszone",
	"głowione",
	"gmatwane",
	"gmerane",
	"gnane",
	"gnębione",
	"gniecione",
	"gnite",
	"gnojone",
	"godzone",
	"gojone",
	"golnięte",
	"golone",
	"gonione",
	"googlowane",
	"gospodarowane",
	"goszczone",
	"gotowane",
	"grabione",
	"grane",
	"grasowane",
	"gratulowane",
	"grillowane",
	"grilowane",
	"gromadzone",
	"gromione",
	"grożone",
	"gruchane",
	"gruchnięte",
	"grupowane",
	"grywane",
	"gryzione",
	"grzane",
	"grzechotane",
	"gubione",
	"gustowane",
	"gwałcone",
	"gwarantowane",
	"gwizdane",
	"gwizdnięte",
	"hackowane",
	"haftowane",
	"hajtnięte",
	"hamowane",
	"hańbione",
	"handlowane",
	"harcowane",
	"harmonizowane",
	"harowane",
	"hartowane",
	"hibernowane",
	"hipnotyzowane",
	"hodowane",
	"holowane",
	"hołubione",
	"honorowane",
	"hospitalizowane",
	"huknięte",
	"hulane",
	"huśtane",
	"idealizowane",
	"identyfikowane",
	"ignorowane",
	"igrane",
	"ilustrowane",
	"imitowane",
	"implantowane",
	"implodowane",
	"imponowane",
	"importowane",
	"improwizowane",
	"indokrynowane",
	"indukowane",
	"infekowane",
	"infiltrowane",
	"informowane",
	"ingerowane",
	"inhalowane",
	"inscenizowane",
	"inspirowane",
	"instalowane",
	"instruowane",
	"insynuowane",
	"integrowane",
	"interpretowane",
	"interweniowane",
	"intonowane",
	"intubowane",
	"inwestowane",
	"inwigilowane",
	"irytowane",
	"iskrzone",
	"izolowane",
	"jadane",
	"jawione",
	"jazgotane",
	"jednoczone",
	"jedzone",
	"kablowane",
	"kadzone",
	"kalane",
	"kaleczone",
	"kalkulowane",
	"kamerowane",
	"kamienowane",
	"kamuflowane",
	"kanalizowane",
	"kantowante",
	"kąpane",
	"kapitulowane",
	"kapowane",
	"karane",
	"karbonizowane",
	"karcone",
	"karczowane",
	"karmione",
	"kartkowane",
	"kąsane",
	"kasowane",
	"kastrowane",
	"katalogowane",
	"katapultowane",
	"katowane",
	"katrupione",
	"kierowane",
	"kimane",
	"kiszone",
	"kiwane",
	"kiwnięte",
	"kłaniane",
	"klapane",
	"klapnięte",
	"klarowane",
	"klasyfikowane",
	"klębione",
	"klejone",
	"klepane",
	"klepnięte",
	"klikane",
	"kliknięte",
	"klonowane",
	"kłopotane",
	"kłute",
	"knocone",
	"knute",
	"kochane",
	"koczowane",
	"kodowane",
	"kojarzone",
	"kojfnięte",
	"kojone",
	"kolekcjonowane",
	"kolektywizowane",
	"kolidowane",
	"kolonizowane",
	"kolorowane",
	"koloryzowane",
	"kołowane",
	"kołysane",
	"kombinowane",
	"komenderowane",
	"komentowane",
	"komercjalizowane",
	"kompensowane",
	"komplementowane",
	"komplikowane",
	"komponowane",
	"kompromitowane",
	"komunikowane",
	"konane",
	"koncentrowane",
	"kończone",
	"konfabulowane",
	"konfiskowane",
	"konfrontowane",
	"konserwowane",
	"konspirowane",
	"konstruowane",
	"konsultowane",
	"konsumowane",
	"kontaktowane",
	"kontestowane",
	"kontrastowane",
	"kontrolowane",
	"kontrowane",
	"kontynuowane",
	"kontynuuowane",
	"konwertowane",
	"konwojowane",
	"koordynowane",
	"kopane",
	"kopcone",
	"kopiowane",
	"kopnięte",
	"kopulowane",
	"korelowane",
	"korkowane",
	"koronowane",
	"korygowane",
	"korzone",
	"korzystane",
	"koszone",
	"kotwiczone",
	"kozaczone",
	"kozłowane",
	"kpite",
	"kradzione",
	"krajane",
	"krążone",
	"kręcone",
	"kremowane",
	"kreowane",
	"krochmalone",
	"krojone",
	"kropione",
	"kruszone",
	"krystalizowane",
	"kryte",
	"krytykowane",
	"krzepnięte",
	"krzyczane",
	"krzyknięte",
	"krzywdzone",
	"krzywione",
	"krzyżowane",
	"kserowane",
	"księgowane",
	"kształcone",
	"kształtowane",
	"kulone",
	"kultywowane",
	"kumulowane",
	"kupczone",
	"kupione",
	"kupowane",
	"kupywane",
	"kurczone",
	"kurowane",
	"kursowane",
	"kurzone",
	"kuszone",
	"kute",
	"kwalifikowane",
	"kwestionowane",
	"łączone",
	"ładowane",
	"łagodzone",
	"łajdaczone",
	"lakierowane",
	"łamane",
	"lamentowane",
	"lansowane",
	"lane",
	"łapane",
	"łaskotane",
	"łaszone",
	"latane",
	"łatane",
	"lawirowane",
	"leczone",
	"legalizowane",
	"legitymowane",
	"lekceważone",
	"lepione",
	"lewitowane",
	"liberowane",
	"licencjonowane",
	"licytowane",
	"liczone",
	"likwidowane",
	"linczowane",
	"liniowane",
	"literowane",
	"litowane",
	"lizane",
	"liznięte",
	"lobbowane",
	"lokalizowane",
	"losowane",
	"łowione",
	"łożone",
	"lubiane",
	"łudzone",
	"lunatykowane",
	"łupane",
	"łupione",
	"łuskane",
	"lustrowane",
	"łuszczone",
	"luzowane",
	"łykane",
	"łyknięte",
	"łyżeczkowane",
	"macane",
	"machane",
	"machnięte",
	"mącone",
	"maczane",
	"maganyzowane",
	"maglowane",
	"majaczone",
	"majsterkowane",
	"majtane",
	"maksymalizowane",
	"malowane",
	"maltretowane",
	"mamione",
	"mamrotane",
	"manewrowane",
	"manifestowane",
	"manipulowane",
	"markowane",
	"marnotrawione",
	"marnowane",
	"marszczone",
	"marynowane",
	"marznięte",
	"masakrowane",
	"maskowane",
	"masowane",
	"masturbowane",
	"mataczone",
	"materializowane",
	"mawiane",
	"mazane",
	"maznięte",
	"męczone",
	"meldowane",
	"merdane",
	"metabolizowane",
	"miażdżone",
	"mielone",
	"mierzone",
	"mierzwione",
	"mieszane",
	"miętolone",
	"migane",
	"migdalone",
	"migotane",
	"mijane",
	"miksowane",
	"milowane",
	"minięte",
	"minimalizowane",
	"miotane",
	"mistyfikowane",
	"mitygowane",
	"mizdrzone",
	"mlane",
	"mniemane",
	"mnożone",
	"mobilizowane",
	"mocowane",
	"moczone",
	"modelowane",
	"modernizowane",
	"modlone",
	"modulowane",
	"modyfikowane",
	"molestowane",
	"monitorowane",
	"monopolizowane",
	"montowane",
	"mordowane",
	"motywowane",
	"mówione",
	"mrożone",
	"mrugane",
	"mrużone",
	"muskane",
	"mutowane",
	"mydlone",
	"mylone",
	"myszkowane",
	"myte",
	"nabazgrane",
	"nabiegane",
	"nabierane",
	"nabite",
	"nabrane",
	"nabrojone",
	"nabrudzone",
	"nabyte",
	"nabywane",
	"nacelowane",
	"nachapane",
	"nachodzone",
	"nachwalone",
	"nachylone",
	"naciągane",
	"naciągnięte",
	"nacierane",
	"nacięte",
	"nacinane",
	"naciskane",
	"naciśnięte",
	"nacjonalizowane",
	"naczepione",
	"nadane",
	"nadawane",
	"nadchodzone",
	"nadciągane",
	"nadciągnięte",
	"nadcięte",
	"nadesłane",
	"nadgonione",
	"nadgryzane",
	"nadgryzione",
	"nadinterpretowane",
	"nadłożone",
	"nadmieniane",
	"nadmienione",
	"nadmuchane",
	"nadrabiane",
	"nadrobione",
	"nadskakiwane",
	"nadsłuchiwane",
	"nadstawiane",
	"nadstawione",
	"nadszarpnięte",
	"naduszone",
	"nadużyte",
	"nadużywane",
	"nadwerężane",
	"nadwyrężane",
	"nadwyrężone",
	"nadziane",
	"nadzorowane",
	"naelektryzowane",
	"nafaszerowane",
	"nagabywane",
	"nagadane",
	"nagięte",
	"naginane",
	"nagłaszane",
	"nagłośnione",
	"nagonione",
	"nagradzane",
	"nagrane",
	"nagrodzone",
	"nagromadzone",
	"nagrywane",
	"nagryzmolone",
	"nagrzane",
	"nagrzebane",
	"nagrzewane",
	"nagwizdane",
	"naigrywane",
	"najechane",
	"najęte",
	"najmowane",
	"nakarmiane",
	"nakarmione",
	"nakazane",
	"nakazywane",
	"nakierowane",
	"nakierowywane",
	"nakładane",
	"nakłamane",
	"nakłaniane",
	"naklejane",
	"naklejone",
	"naklepane",
	"nakłonione",
	"nakłute",
	"nakłuwane",
	"nakopane",
	"nakręcane",
	"nakręcone",
	"nakreślane",
	"nakreślone",
	"nakruszone",
	"nakryte",
	"nakrywane",
	"nakrzyczane",
	"nakupione",
	"naładowane",
	"nalane",
	"nałapane",
	"nalepione",
	"nalewane",
	"naliczone",
	"nałowione",
	"nałożone",
	"namaczane",
	"namagnetyzowane",
	"namalowane",
	"namaszczane",
	"namaszczone",
	"namawiane",
	"namęczone",
	"namierzane",
	"namieszane",
	"namoczone",
	"namówione",
	"namydlane",
	"namyślone",
	"naniesione",
	"naoliwiane",
	"naoliwione",
	"naopowiadane",
	"naostrzone",
	"napadane",
	"napadnięte",
	"napakowane",
	"napalone",
	"naparzane",
	"napastowane",
	"napawane",
	"napchane",
	"napędzane",
	"napełniane",
	"napełnione",
	"napierane",
	"napiętnowane",
	"napięte",
	"napinane",
	"napisane",
	"naplute",
	"napływane",
	"napoczęte",
	"napojone",
	"napompowane",
	"napotkane",
	"napotykane",
	"napraszane",
	"naprawiane",
	"naprawione",
	"naprężane",
	"naprężone",
	"napromieniowane",
	"naprostowane",
	"naprowadzane",
	"naprowadzone",
	"napsute",
	"napuszczane",
	"napuszczone",
	"napychane",
	"napytane",
	"narąbane",
	"naradzane",
	"naradzone",
	"narastane",
	"narażane",
	"narażone",
	"nareperowane",
	"narkotyzowane",
	"narodzone",
	"naruszane",
	"naruszone",
	"narwane",
	"narysowane",
	"narzucane",
	"narzucone",
	"nasączane",
	"nasączone",
	"nasadzone",
	"nasiąkane",
	"nasilane",
	"nasilone",
	"naskakiwane",
	"naskoczone",
	"naskrobane",
	"naśladowane",
	"nasłane",
	"nasłuchane",
	"nasłuchiwane",
	"nasmarowane",
	"nastąpione",
	"nastawiane",
	"nastawione",
	"nastraszane",
	"nastrojone",
	"nastukane",
	"nasunięte",
	"nasuwane",
	"naświetlane",
	"nasycone",
	"nasyłane",
	"nasypane",
	"naszczane",
	"naszkicowane",
	"naszpikowane",
	"naszprycowane",
	"naszykowane",
	"naszyte",
	"naszywane",
	"natarte",
	"natchnięte",
	"natknięte",
	"natlenione",
	"natłuszczone",
	"natrafione",
	"natrząsane",
	"natrząsnięte",
	"nauczane",
	"nauczone",
	"nawadniane",
	"nawalone",
	"nawiązane",
	"nawiązywane",
	"nawiedzane",
	"nawiedzone",
	"nawiercone",
	"nawiewane",
	"nawiezione",
	"nawigowane",
	"nawijane",
	"nawilżane",
	"nawilżone",
	"nawinięte",
	"nawlekane",
	"nawodnione",
	"nawoływane",
	"nawoskowane",
	"nawożone",
	"nawpychane",
	"nawracane",
	"nawrócone",
	"nawrzucane",
	"nawtykane",
	"nawymyślane",
	"nazbierane",
	"nazmyślane",
	"naznaczane",
	"naznaczone",
	"nazrywane",
	"nazwane",
	"nazywane",
	"nęcone",
	"negocjowane",
	"negowane",
	"nękane",
	"neutralizowane",
	"niańczone",
	"niecierpliwione",
	"niedoceniane",
	"niedowidziane",
	"nienawidzone",
	"niesione",
	"nikolone",
	"niszczone",
	"nitkowane",
	"niuchane",
	"niweczone",
	"niwelowane",
	"nokautowane",
	"nominowane",
	"notowane",
	"nucone",
	"numerowane",
	"nurtowane",
	"obaczone",
	"obadane",
	"obalane",
	"obalone",
	"obandażowane",
	"obarczane",
	"obarczone",
	"obawiane",
	"obchodzone",
	"obciągnięte",
	"obciążone",
	"obcięte",
	"obcinane",
	"obcyndalane",
	"obczajane",
	"obczajone",
	"obdarowane",
	"obdarte",
	"obdarzane",
	"obdarzone",
	"obdzielone",
	"obdzierane",
	"obdzwaniane",
	"obdzwonione",
	"obejmowane",
	"oberwane",
	"obessane",
	"obezwładniane",
	"obezwładnione",
	"obfotografowane",
	"obfotografowywane",
	"obgadane",
	"obgadywane",
	"obgryzane",
	"obgryzione",
	"obiecane",
	"obiecywane",
	"obierane",
	"obijane",
	"obite",
	"objadane",
	"objaśniane",
	"objawiane",
	"objawione",
	"objechane",
	"objęte",
	"objeżdżane",
	"obkręcane",
	"oblane",
	"obłapiane",
	"obłapywane",
	"obłaskawiane",
	"obłaskawione",
	"obleciane",
	"oblegane",
	"oblewane",
	"obliczane",
	"obliczone",
	"oblizane",
	"obłowione",
	"obłożone",
	"obluzowane",
	"obluzowywane",
	"obmacane",
	"obmacywane",
	"obmawiane",
	"obmyślane",
	"obmyślone",
	"obmyte",
	"obmywane",
	"obnażane",
	"obniżane",
	"obniżone",
	"obnoszone",
	"obowiązywane",
	"obozowane",
	"obrabiane",
	"obrabowane",
	"obracane",
	"obradowane",
	"obramowane",
	"obraniane",
	"obrane",
	"obrastane",
	"obrażane",
	"obrażone",
	"obrobione",
	"obrócone",
	"obrodzone",
	"obronione",
	"obrysowane",
	"obrywane",
	"obryzgane",
	"obrzezane",
	"obrzucane",
	"obrzucone",
	"obrzygane",
	"obsadzane",
	"obsadzone",
	"obściskiwane",
	"obserwowane",
	"obsiane",
	"obsikane",
	"obsikiwane",
	"obskakiwane",
	"obskoczone",
	"obskubane",
	"obskubywane",
	"obśliniane",
	"obślinione",
	"obsługiwane",
	"obsłużone",
	"obsmarowane",
	"obstawiane",
	"obstawione",
	"obstrzeliwane",
	"obsunięte",
	"obsuwane",
	"obsypane",
	"obsypywane",
	"obszukane",
	"obszukiwane",
	"obtaczane",
	"obtarte",
	"obtoczone",
	"obudzone",
	"obwąchane",
	"obwąchiwane",
	"obwiązane",
	"obwiązywane",
	"obwieszane",
	"obwieszczane",
	"obwieszczone",
	"obwieszone",
	"obwijane",
	"obwiniane",
	"obwinięte",
	"obwołane",
	"obyte",
	"obżerane",
	"ocalane",
	"ocalone",
	"ocechowane",
	"oceniane",
	"ocenione",
	"ocenzurowane",
	"ochładzane",
	"ochlapane",
	"ochlapywane",
	"ochłodzone",
	"ochłonięte",
	"ochraniane",
	"ochronione",
	"ochrzaniane",
	"ochrzczone",
	"ociągane",
	"ocielone",
	"ocieplane",
	"ocieplone",
	"ocierane",
	"ocknięte",
	"ocucone",
	"ocute",
	"oczarowywane",
	"oczekiwane",
	"oczerniane",
	"oczernione",
	"oczyszczane",
	"oczyszczone",
	"odarte",
	"odbębnione",
	"odbetonowane",
	"odbezpieczane",
	"odbezpieczone",
	"odbijane",
	"odbite",
	"odblokowane",
	"odbudowane",
	"odbudowywane",
	"odbutowane",
	"odbyte",
	"odcedzane",
	"odchorowane",
	"odchowane",
	"odchudzane",
	"odchudzone",
	"odchylane",
	"odchylone",
	"odciągane",
	"odciągnięte",
	"odciążone",
	"odcierpione",
	"odcięte",
	"odcinane",
	"odcisnięte",
	"odcumowane",
	"odcyfrowane",
	"odcyfrowywane",
	"odczarowane",
	"odczekane",
	"odczepiane",
	"odczepione",
	"odczute",
	"odczuwane",
	"odczynione",
	"odczytane",
	"odczytywane",
	"oddalane",
	"oddane",
	"oddawane",
	"oddelegowane",
	"oddychane",
	"oddzielane",
	"oddzielone",
	"odebrane",
	"odegnane",
	"odegrane",
	"odejmowane",
	"odepchnięte",
	"oderwane",
	"odeskortowane",
	"odesłane",
	"odespane",
	"odessane",
	"odetkane",
	"odetnięte",
	"odezwane",
	"odfiltrowane",
	"odgadnięte",
	"odgadywane",
	"odganiane",
	"odgarniane",
	"odgarnięte",
	"odgięte",
	"odgniatane",
	"odgonione",
	"odgradzane",
	"odgrażane",
	"odgrodzone",
	"odgruzowane",
	"odgrywane",
	"odgryzane",
	"odgryzione",
	"odgrzane",
	"odgrzebane",
	"odgrzebywane",
	"odgrzewane",
	"odgwizdane",
	"odhaczone",
	"odholowane",
	"odinstalowane",
	"odizolowane",
	"odjedzone",
	"odjęte",
	"odjonizowane",
	"odkażane",
	"odkażone",
	"odkładane",
	"odklejone",
	"odkochane",
	"odkodowane",
	"odkodowywane",
	"odkopane",
	"odkopywane",
	"odkorkowane",
	"odkręcane",
	"odkręcone",
	"odkrojone",
	"odkryte",
	"odkrywane",
	"odkupione",
	"odkupywane",
	"odkurzane",
	"odkurzone",
	"odkute",
	"odłączane",
	"odłączone",
	"odłamywane",
	"odlane",
	"odlatywane",
	"odlepiane",
	"odlewane",
	"odliczane",
	"odliczone",
	"odłożone",
	"odłupane",
	"odmachane",
	"odmachiwane",
	"odmalowane",
	"odmarszczone",
	"odmawiane",
	"odmeldowane",
	"odmieniane",
	"odmienione",
	"odmierzane",
	"odmierzone",
	"odmieszane",
	"odmontowane",
	"odmówione",
	"odmrażane",
	"odmrożone",
	"odnajdowane",
	"odnalezione",
	"odnawiane",
	"odniesione",
	"odnoszone",
	"odnotowane",
	"odnotowywane",
	"odnowione",
	"odpakowane",
	"odpakowywane",
	"odpalane",
	"odpalone",
	"odpałzowane",
	"odparowane",
	"odparte",
	"odpędzane",
	"odpicowane",
	"odpieczętowane",
	"odpierane",
	"odpięte",
	"odpiłowane",
	"odpiłowywane",
	"odpinane",
	"odpisane",
	"odpisywane",
	"odpłacane",
	"odplamione",
	"odplątane",
	"odpłynięte",
	"odpowietrzone",
	"odpracowane",
	"odpracowywane",
	"odprasowane",
	"odprawiane",
	"odprawione",
	"odprężane",
	"odprostowane",
	"odprowadzane",
	"odprowadzone",
	"odprute",
	"odpryskane",
	"odpukane",
	"odpukiwane",
	"odpuszczane",
	"odpuszczone",
	"odpychane",
	"odrąbane",
	"odrabiane",
	"odrąbywane",
	"odradzane",
	"odradzone",
	"odrapane",
	"odrastane",
	"odratowane",
	"odreagowane",
	"odremontowane",
	"odrestaurowane",
	"odrestaurowywane",
	"odrobaczane",
	"odrobione",
	"odroczone",
	"odrodzone",
	"odrośnięte",
	"odróżniane",
	"odróżnione",
	"odrysowane",
	"odrywane",
	"odrzucane",
	"odrzucone",
	"odsączane",
	"odsączone",
	"odsadzone",
	"odseparowane",
	"odsiadywane",
	"odsiane",
	"odsiewane",
	"odsłaniane",
	"odsłonięte",
	"odsłuchane",
	"odsłuchiwane",
	"odsłużone",
	"odśnieżane",
	"odśnieżone",
	"odsolone",
	"odśpiewane",
	"odsprzedane",
	"odsprzedawane",
	"odstąpione",
	"odstawiane",
	"odstawione",
	"odstępowane",
	"odstraszane",
	"odstręczone",
	"odstresowane",
	"odstrzeliwane",
	"odstrzelone",
	"odsunięte",
	"odsuwane",
	"odświeżane",
	"odświeżone",
	"odsyłane",
	"odsypywane",
	"odsysane",
	"odszczekane",
	"odszczekiwane",
	"odsztafirowane",
	"odszukane",
	"odszyfrowane",
	"odszyfrowywane",
	"odszykowane",
	"odtrąbione",
	"odtrącone",
	"odtrute",
	"odtwarzane",
	"odtworzone",
	"oduczone",
	"odurzone",
	"odwalane",
	"odwalone",
	"odwiązane",
	"odwiązywane",
	"odwiedzane",
	"odwiedzone",
	"odwieszone",
	"odwiezione",
	"odwijane",
	"odwinięte",
	"odwlekane",
	"odwodnione",
	"odwodzone",
	"odwołane",
	"odwoływane",
	"odwożone",
	"odwracane",
	"odwrócone",
	"odwzajemnione",
	"odwzorowane",
	"odżegnane",
	"odziane",
	"odziedziczone",
	"odznaczane",
	"odznaczone",
	"odzwieciedlone",
	"odzwierciedlane",
	"odzwonione",
	"odzwyczajone",
	"odzyskane",
	"odzyskiwane",
	"odżyte",
	"odzywiane",
	"odżywione",
	"oferowane",
	"ofiarowane",
	"ofiarowywane",
	"ogarniane",
	"ogarnięte",
	"oglądane",
	"ogłaszane",
	"ogłoszone",
	"ogłupiane",
	"ogłupione",
	"ogłuszone",
	"ogołocone",
	"ogolone",
	"ograbiane",
	"ograbione",
	"ograniczane",
	"ograniczone",
	"ograne",
	"ogrodzone",
	"ogryzione",
	"ogrzane",
	"ogrzewane",
	"okablowane",
	"okaleczone",
	"okantowane",
	"okąpane",
	"okazane",
	"okazywane",
	"okiełznane",
	"okładane",
	"okłamane",
	"okłamywane",
	"oklaskiwane",
	"oklejone",
	"oklepane",
	"okopane",
	"okopywane",
	"okpione",
	"okradane",
	"okradzione",
	"okraszone",
	"okrążane",
	"okrążone",
	"okręcane",
	"okręcone",
	"określane",
	"określone",
	"okrojone",
	"okryte",
	"okrywane",
	"okrzyknięte",
	"okulawione",
	"okupione",
	"okupowane",
	"olane",
	"olewane",
	"olśnięte",
	"omamione",
	"omawiane",
	"omdlewane",
	"omijane",
	"ominięte",
	"omotane",
	"omówione",
	"onanizowane",
	"onieśmielane",
	"onieśmielone",
	"opadnięte",
	"opakowane",
	"opalane",
	"opalone",
	"opancerzone",
	"opanowane",
	"opanowywane",
	"oparte",
	"oparzone",
	"opasane",
	"opatentowane",
	"opatrywane",
	"opatrzone",
	"opatulone",
	"opchnięte",
	"opędzane",
	"opędzone",
	"operowane",
	"opętane",
	"opętywane",
	"opieczętowane",
	"opiekowane",
	"opierane",
	"opijane",
	"opisane",
	"opisywane",
	"opite",
	"opłacane",
	"opłacone",
	"opłakane",
	"opłakiwane",
	"opłukane",
	"oplute",
	"opluwane",
	"opływane",
	"opodatkowane",
	"opodatkowywane",
	"oponowane",
	"oporządzane",
	"oporządzone",
	"opowiadane",
	"opowiedziane",
	"opóźniane",
	"opóźnione",
	"opracowane",
	"opracowywane",
	"oprawiane",
	"oprawione",
	"oprowadzane",
	"oprowadzone",
	"opróżniane",
	"opróżnione",
	"opryskane",
	"opryskiwane",
	"opublikowane",
	"opukane",
	"opuszczane",
	"opuszczone",
	"opychane",
	"opylone",
	"orane",
	"orbowane",
	"organizowane",
	"orientowane",
	"oroszone",
	"orzekane",
	"orżnięte",
	"osaczane",
	"osaczone",
	"osadzane",
	"osądzane",
	"osadzone",
	"osądzone",
	"oscylowane",
	"osiadane",
	"osiągane",
	"osiągnięte",
	"osiedlane",
	"osiedlone",
	"osiedzone",
	"osierocone",
	"osiodłane",
	"oskalpowane",
	"oskarżone",
	"oskrobane",
	"oskrzydlane",
	"oskrzydlone",
	"oskubane",
	"oskubywane",
	"osłabiane",
	"osłabione",
	"oślepiane",
	"oślepione",
	"oślepnięte",
	"ośliniane",
	"osłodzone",
	"osłonione",
	"osłuchane",
	"osmalone",
	"ośmielone",
	"ośmieszane",
	"ośmieszone",
	"ostrzegane",
	"ostrzelane",
	"ostrzelite",
	"ostrzone",
	"ostudzone",
	"osunięte",
	"osuszane",
	"osuszone",
	"osuwane",
	"oswajane",
	"oświadczane",
	"oświadczone",
	"oświecane",
	"oświecione",
	"oświetlane",
	"oświetlone",
	"oswobadzane",
	"oswobodzone",
	"oswojone",
	"oszacowane",
	"oszałamiane",
	"oszczane",
	"oszczędzane",
	"oszczędzone",
	"oszklone",
	"oszlifowane",
	"oszołomione",
	"oszpecone",
	"oszukane",
	"oszukiwane",
	"oszwabione",
	"otaczane",
	"otarte",
	"otoczone",
	"otrute",
	"otruwane",
	"otrząsane",
	"otrząśnięte",
	"otrzepane",
	"otrzeźwione",
	"otrzymane",
	"otrzymywane",
	"otulone",
	"otumanione",
	"otwierane",
	"otworzone",
	"otwarte",
	"owane",
	"owdowione",
	"owiane",
	"owijane",
	"owinięte",
	"ozdabiane",
	"ozdobione",
	"ozdrowione",
	"ożenione",
	"oznaczane",
	"oznaczone",
	"oznajmiane",
	"oznajmione",
	"oznakowane",
	"ożyte",
	"ożywane",
	"ożywiane",
	"ożywione",
	"pachnące",
	"pacnąte",
	"pakowane",
	"paktowane",
	"pałane",
	"pałaszowane",
	"palnięte",
	"palone",
	"pamiętane",
	"panoszone",
	"paprane",
	"parafrazowane",
	"paraliżowane",
	"parkowane",
	"parowane",
	"partaczone",
	"parte",
	"parzone",
	"pastowane",
	"paszone",
	"patrolowane",
	"patroszone",
	"patrzone",
	"pauzowane",
	"pchane",
	"pchnięte",
	"pdholowane",
	"pedałowane",
	"pękane",
	"pęknięte",
	"pełnione",
	"penetrowane",
	"perforowane",
	"perfumowane",
	"perswadowane",
	"piastowane",
	"pichcone",
	"pielęgnowane",
	"pielone",
	"pienione",
	"pieszczone",
	"piętnowane",
	"pięte",
	"pijane",
	"pikietowane",
	"piknikowane",
	"pikowane",
	"pilnowane",
	"pilotowane",
	"piłowane",
	"pisane",
	"pisywane",
	"pite",
	"płacone",
	"plądrowane",
	"plamione",
	"planowane",
	"płaszczone",
	"plątane",
	"płatane",
	"pławione",
	"plewione",
	"płonące",
	"płoszone",
	"plotkowane",
	"plugawione",
	"płukane",
	"pluskane",
	"plute",
	"pobaraszkowane",
	"pobierane",
	"pobite",
	"pobłażane",
	"pobłogosławione",
	"pobrane",
	"pobrudzone",
	"pobudzane",
	"pobudzone",
	"pobujane",
	"pocałowane",
	"pocerowane",
	"pochłaniane",
	"pochlapane",
	"pochlebiane",
	"pochłonięte",
	"pochowane",
	"pochwalane",
	"pochwalone",
	"pochwycone",
	"pochylane",
	"pochylone",
	"pociachane",
	"pociągane",
	"pociągnięte",
	"pocierane",
	"pocieszane",
	"pocieszone",
	"pocięte",
	"pocone",
	"pocukrowane",
	"poćwiartowane",
	"poczesane",
	"poczęstowane",
	"poczęte",
	"poczochrane",
	"poczute",
	"poczytane",
	"poczytywane",
	"podane",
	"podarowane",
	"podarte",
	"podawane",
	"podążone",
	"podbierane",
	"podbijane",
	"podbite",
	"podbudowane",
	"podbudowywane",
	"podburzane",
	"podburzone",
	"podchwycone",
	"podciągane",
	"podciągnięte",
	"podcierane",
	"podcięte",
	"podcinane",
	"podczepione",
	"poddane",
	"poddawane",
	"podebrane",
	"podejmowane",
	"podejrzane",
	"podejrzewane",
	"podelektowane",
	"podeptane",
	"poderwane",
	"podesłane",
	"podglądane",
	"podgolone",
	"podgonione",
	"podgryzane",
	"podgrzane",
	"podgrzewane",
	"podjadane",
	"podjedzone",
	"podjęte",
	"podkablowane",
	"podkarmione",
	"podkładane",
	"podklejone",
	"podkolorowane",
	"podkołowane",
	"podkopane",
	"podkopywane",
	"podkradane",
	"podkradnięte",
	"podkręcane",
	"podkręcone",
	"podkreślane",
	"podkreślone",
	"podkształcone",
	"podkulone",
	"podkupione",
	"podkurzone",
	"podkute",
	"podłączane",
	"podłączone",
	"podładowane",
	"podłamane",
	"podlane",
	"podłapane",
	"podleczone",
	"podlegane",
	"podlewane",
	"podliczane",
	"podliczone",
	"podlizane",
	"podlizywane",
	"podłożone",
	"podmalowane",
	"podmieniane",
	"podmienione",
	"podmuchane",
	"podmyte",
	"podnajęte",
	"podniecane",
	"podniecone",
	"podniesione",
	"podnoszone",
	"podołane",
	"podopingowane",
	"podostrzone",
	"podotykane",
	"podpadnięte",
	"podpalane",
	"podpalone",
	"podparte",
	"podpatrywane",
	"podpatrzone",
	"podpieczętowane",
	"podpiekane",
	"podpierane",
	"podpięte",
	"podpiłowane",
	"podpinane",
	"podpisane",
	"podpisywane",
	"podpłacone",
	"podpłynięte",
	"podpompowane",
	"podporządkowane",
	"podporządkowywane",
	"podpowiadane",
	"podpowiedziane",
	"podprowadzane",
	"podpuszczane",
	"podpuszczone",
	"podpychane",
	"podpytane",
	"podrabiane",
	"podrapane",
	"podrasowane",
	"podratowane",
	"podrażnione",
	"podręczone",
	"podregulowane",
	"podreperowane",
	"podretuszowane",
	"podrobione",
	"podroczone",
	"podróżowane",
	"podrygiwane",
	"podrywane",
	"podrzucane",
	"podrzucone",
	"podrzynane",
	"podsadzone",
	"podskubywane",
	"podsłuchane",
	"podsłuchiwane",
	"podsmażane",
	"podsmażone",
	"podśpiewywane",
	"podstawiane",
	"podstawione",
	"podstemplowane",
	"podstrojone",
	"podsumowane",
	"podsumowywane",
	"podsunięte",
	"podsuwane",
	"podświetlane",
	"podsycane",
	"podsycone",
	"podsyłane",
	"podsypane",
	"podszczypywane",
	"podszkolone",
	"podszlifowane",
	"podszykowane",
	"podszyte",
	"podszywane",
	"podtapiane",
	"podtarte",
	"podtopione",
	"podtrzymane",
	"podtrzymywane",
	"podtuczone",
	"poduczane",
	"podupadane",
	"poduszone",
	"podwajane",
	"podwalane",
	"podważane",
	"podwędzone",
	"podwiązane",
	"podwieszane",
	"podwiezione",
	"podwijane",
	"podwinięte",
	"podwojone",
	"podwożone",
	"podwyżane",
	"podwyższane",
	"podwyższone",
	"podyktowane",
	"podyskutowane",
	"podziabane",
	"podziałane",
	"podziałkowane",
	"podziękowane",
	"podzielone",
	"podziurawione",
	"podziwiane",
	"podźwignięte",
	"poeksperymentowane",
	"pofarbowane",
	"pofatygowane",
	"pofilmowane",
	"poganiane",
	"pogardzane",
	"pogardzone",
	"pogarszane",
	"pogaszone",
	"pogładzone",
	"pogłaskane",
	"pogłębiane",
	"pogłębione",
	"pogłośnione",
	"pogmatwane",
	"pognębione",
	"pogniecione",
	"pogodzone",
	"pogonione",
	"pogorszone",
	"pogotowane",
	"pograbione",
	"pogrążane",
	"pogrążone",
	"pogrożone",
	"pogrubiane",
	"pogrubione",
	"pogruchane",
	"pogruchotane",
	"pogrupowane",
	"pogrywane",
	"pogryzane",
	"pogryzione",
	"pogrzane",
	"pogrzebane",
	"pogubione",
	"pogwałcane",
	"pohamowane",
	"pohandlowane",
	"poharatowane",
	"pohuśtane",
	"poinformowane",
	"poinstruowane",
	"pojednane",
	"pojęte",
	"pojmięte",
	"pojmowane",
	"pojone",
	"pokajane",
	"pokaleczone",
	"pokarane",
	"pokarmione",
	"pokąsane",
	"pokatalogowane",
	"pokazane",
	"pokazywane",
	"pokiereszowane",
	"pokierowane",
	"pokiwane",
	"pokładane",
	"poklepane",
	"poklepywane",
	"pokłonione",
	"pokłute",
	"pokochane",
	"pokolorowane",
	"pokoloryzowane",
	"pokołysane",
	"pokombinowane",
	"pokomplikowane",
	"pokonane",
	"pokończone",
	"pokonywane",
	"pokopane",
	"pokrajane",
	"pokrążone",
	"pokręcone",
	"pokrojone",
	"pokruszone",
	"pokryte",
	"pokrywane",
	"pokrzepiane",
	"pokrzepione",
	"pokrzyżowane",
	"pokuszone",
	"pokutowane",
	"połączone",
	"polakierowane",
	"połamane",
	"polane",
	"połapane",
	"połaskotane",
	"połatane",
	"polecane",
	"połechtane",
	"polecone",
	"poleczone",
	"polegane",
	"polemizowane",
	"polepszane",
	"polepszone",
	"polerowane",
	"polewane",
	"policzkowane",
	"policzone",
	"polimeryzowane",
	"polizane",
	"połknięte",
	"polowane",
	"połowione",
	"położone",
	"polubione",
	"poluźnione",
	"poluzowane",
	"połykane",
	"pomacane",
	"pomachane",
	"pomagane",
	"pomalowane",
	"pomarynowane",
	"pomasowane",
	"pomazane",
	"pomęczone",
	"pomiatane",
	"pomieszane",
	"pomieszczone",
	"pomijane",
	"pominięte",
	"pomiziane",
	"pomknięte",
	"pomnażane",
	"pomniejszane",
	"pomniejszone",
	"pomnożone",
	"pomoczone",
	"pompowane",
	"pomydlone",
	"pomylone",
	"pomyszkowane",
	"pomywane",
	"ponabijane",
	"ponaciskane",
	"ponadziewane",
	"ponaglane",
	"ponaglone",
	"ponagrywane",
	"ponaklejane",
	"ponakłuwane",
	"ponakrywane",
	"ponaprawiane",
	"ponawiane",
	"poniańczone",
	"poniechane",
	"ponieiwerane",
	"poniesione",
	"poniszczone",
	"poniżane",
	"poniżone",
	"ponoszone",
	"ponowione",
	"ponudzone",
	"poobcinane",
	"poobcowane",
	"poobczajane",
	"poobijane",
	"poobmacywane",
	"poobracane",
	"poobserwowane",
	"poodbijane",
	"poodcinane",
	"poodgryzane",
	"poodkurzane",
	"poodprawiane",
	"poodsuwane",
	"poodwalane",
	"pooglądane",
	"poograniczane",
	"poopalane",
	"poopiekane",
	"poopwiadane",
	"pootwierane",
	"popadane",
	"popakowane",
	"popalone",
	"poparte",
	"poparzone",
	"popchane",
	"popchnięte",
	"popędzane",
	"popędzone",
	"popękane",
	"popełniane",
	"popełnione",
	"poperfumowane",
	"popierane",
	"popieszczone",
	"popijane",
	"popilnowane",
	"popisane",
	"popite",
	"popłacone",
	"popłakiwane",
	"poplamione",
	"poplątane",
	"popluskane",
	"popodcinane",
	"popodziwiane",
	"popoprawiane",
	"poprane",
	"poprasowane",
	"poprawiane",
	"poprawione",
	"poproszone",
	"poprowadzone",
	"popryskane",
	"poprzebierane",
	"poprzeciągane",
	"poprzecinane",
	"poprzedzane",
	"poprzeglądane",
	"poprzeklinane",
	"poprzekopywane",
	"poprzemieszczane",
	"poprzenoszone",
	"poprzesadzane",
	"poprześladowane",
	"poprzestawiane",
	"poprzesuwane",
	"poprzewieszane",
	"poprzewracane",
	"poprzycinane",
	"poprzymierzane",
	"poprzytulane",
	"poprzywiązywane",
	"popsute",
	"popudrowane",
	"popukane",
	"popularyzowane",
	"popuszczane",
	"popuszczone",
	"popychane",
	"popykane",
	"popytane",
	"porabiane",
	"porachowane",
	"poranione",
	"poratowane",
	"porażone",
	"poręczone",
	"porównane",
	"porozbierane",
	"porozbijane",
	"porozciągane",
	"porozcinane",
	"porozdawane",
	"porozdzielane",
	"porozmieszczane",
	"poróżnione",
	"porozpędzane",
	"porozpieszczane",
	"porozprowadzane",
	"porozpruwane",
	"porozrzucane",
	"porozstawiane",
	"porozsyłane",
	"porozumiewane",
	"porozwalane",
	"porozwiązywane",
	"porozwieszane",
	"porozwożone",
	"portretowane",
	"poruszane",
	"poruszone",
	"porwane",
	"porysowane",
	"porywane",
	"porządkowane",
	"porządzone",
	"porzucane",
	"porzucone",
	"posądzane",
	"posadzone",
	"posądzone",
	"pościągane",
	"pościelone",
	"pościerane",
	"pościgane",
	"pościnane",
	"pościskane",
	"posegregowane",
	"posiadane",
	"posiane",
	"posiekane",
	"posilane",
	"posiłkowane",
	"posilone",
	"posiłowane",
	"posiniaczone",
	"posiorbane",
	"poskąpione",
	"poskładane",
	"posklejane",
	"poskramiane",
	"poskręcane",
	"poskrobane",
	"poskromione",
	"poskubane",
	"posłane",
	"posłodzone",
	"poślubiane",
	"poślubione",
	"posługiwane",
	"posmakowane",
	"posmarowane",
	"posolone",
	"posortowane",
	"pospekulowane",
	"pospieszane",
	"pośpieszane",
	"pośpiewane",
	"pospinane",
	"pospłacane",
	"posprawdzane",
	"posprzątane",
	"posprzedawane",
	"pośredniczone",
	"possane",
	"postanowione",
	"postane",
	"postarane",
	"postawione",
	"postemplowane",
	"posterowane",
	"postradane",
	"postraszone",
	"postrugane",
	"postrzegane",
	"postrzelane",
	"postrzelone",
	"postukane",
	"postymulowane",
	"posunięte",
	"posuwane",
	"poświącane",
	"poświadczone",
	"poświecone",
	"poświęcone",
	"poświętowane",
	"poświntuszone",
	"posyłane",
	"posypane",
	"posypywane",
	"poszarpane",
	"poszastane",
	"poszatkowane",
	"poszczute",
	"poszczycone",
	"poszczypane",
	"poszerzane",
	"poszerzone",
	"poszorowane",
	"poszpiegowane",
	"poszturchane",
	"poszukane",
	"poszukiwane",
	"poszwędane",
	"poszybowane",
	"potakiwane",
	"potarmoszone",
	"potarte",
	"potasowane",
	"potęgowane",
	"potępiane",
	"potępione",
	"potknięte",
	"potoczone",
	"potopione",
	"potorturowane",
	"potrącane",
	"potrącone",
	"potraktowane",
	"potrojone",
	"potrute",
	"potrząsane",
	"potrzaskane",
	"potrząsnięte",
	"potrząśnięte",
	"potrzymane",
	"Poturbowane",
	"poturlane",
	"potwierdzone",
	"potykane",
	"poucinane",
	"pouczane",
	"pouczone",
	"poudawane",
	"poukładane",
	"pouprawiane",
	"poupychane",
	"pourywane",
	"poustawiane",
	"poużywane",
	"powąchane",
	"powachlowane",
	"powalane",
	"powalone",
	"poważane",
	"powbijane",
	"powciągane",
	"powciskane",
	"powdychane",
	"powęszone",
	"powetowane",
	"powiadamiane",
	"powiadomione",
	"powiązane",
	"powiedziane",
	"powiedzone",
	"powiększane",
	"powielane",
	"powielone",
	"powierzane",
	"powierzone",
	"powieszone",
	"powiewane",
	"powinszowane",
	"powitane",
	"powite",
	"powkładane",
	"powlekane",
	"powłóczone",
	"powodowane",
	"powołane",
	"powoływane",
	"powożone",
	"powpychane",
	"powrócone",
	"powrzucane",
	"powsadzane",
	"powściągnięte",
	"powspominane",
	"powstrzymane",
	"powtarzane",
	"powtórzone",
	"powybierane",
	"powybijane",
	"powycierane",
	"powycinane",
	"powyciskane",
	"powydawane",
	"powyganiane",
	"powyginane",
	"powyjaśniane",
	"powyjmowane",
	"powyłączane",
	"powymiatane",
	"powymieniane",
	"powynoszone",
	"powypełniane",
	"powypisywane",
	"powyrywane",
	"powyrzucane",
	"powystrzelane",
	"powysyłane",
	"powywalane",
	"powywieszane",
	"powywracane",
	"powzięte",
	"pozabawiane",
	"pozabijane",
	"pozacierane",
	"pożądane",
	"pożądlone",
	"pozadzierane",
	"pozakładane",
	"pozaklinane",
	"pozałatwiane",
	"pozamiatane",
	"pozamieniane",
	"pozamrażane",
	"pozamykane",
	"pozapalane",
	"pozapinane",
	"pozapisywane",
	"pozapraszane",
	"pożarte",
	"pozasłaniane",
	"pozastrzelane",
	"pozatykane",
	"pozbawiane",
	"pozbawione",
	"pozbierane",
	"pozbyte",
	"pozbywane",
	"pozdejmowane",
	"pozdrawiane",
	"pozdrowione",
	"pożegnane",
	"pożerane",
	"pozmiatane",
	"pozmieniane",
	"pozmywane",
	"poznaczone",
	"poznane",
	"poznawane",
	"poznęcane",
	"pozorowane",
	"pozostawiane",
	"pozostawione",
	"pozowane",
	"pozrywane",
	"pozszywane",
	"pożute",
	"pozwalniane",
	"pozwane",
	"pozwiązywane",
	"pozwiedzane",
	"pozwolone",
	"pożyczane",
	"pożyczone",
	"pozyskane",
	"pożyte",
	"pozywane",
	"pożywiane",
	"pożywione",
	"praktykowane",
	"prane",
	"prasowane",
	"prawione",
	"prażone",
	"precyzowane",
	"preferowane",
	"prenumerowane",
	"prezentowane",
	"próbowane",
	"procesowane",
	"produkowane",
	"profanowane",
	"profilowane",
	"prognozowane",
	"programowane",
	"projektowane",
	"proklamowane",
	"prolongowane",
	"promieniowane",
	"promowane",
	"propagowane",
	"proponowane",
	"prosperowane",
	"prostowane",
	"proszkowane",
	"proszone",
	"protestowane",
	"protokołowane",
	"prowadzone",
	"prowokowane",
	"prute",
	"pryskane",
	"pryśnięte",
	"przeanalizowane",
	"przearanżowane",
	"przebaczane",
	"przebaczone",
	"przebadane",
	"przebiegnięte",
	"przebierane",
	"przebijane",
	"przebite",
	"przebolone",
	"przebrane",
	"przebudowane",
	"przebudowywane",
	"przebudzane",
	"przebudzone",
	"przebukowane",
	"przebyte",
	"przebywane",
	"przeceniane",
	"przecenione",
	"przechlapane",
	"przechodzone",
	"przechowane",
	"przechowywane",
	"przechrzcone",
	"przechwycone",
	"przechwytywane",
	"przechylane",
	"przechylone",
	"przechytrzane",
	"przechytrzone",
	"przeciągane",
	"przeciągnięte",
	"przeciążane",
	"przeciążone",
	"przeciekane",
	"przecierane",
	"przecierpiane",
	"przecięte",
	"przecinane",
	"przeciskane",
	"przeciśnięte",
	"przeciwstawiane",
	"przećwiczone",
	"przeczekane",
	"przeczesane",
	"przeczesywane",
	"przeczołgane",
	"przeczute",
	"przeczuwane",
	"przeczyszczone",
	"przeczytane",
	"przedarte",
	"przedawkowane",
	"przedawkowywane",
	"przedekorowane",
	"przedłożone",
	"przedłużane",
	"przedłużone",
	"przedmuchane",
	"przedobrzone",
	"przedostane",
	"przedostawane",
	"przedsiewzięte",
	"przedstawiane",
	"przedstawione",
	"przedymane",
	"przedyskutowane",
	"przedzierane",
	"przedziurawione",
	"przedziurkowane",
	"przeegzaminowane",
	"przefaksowane",
	"przefarbowane",
	"przefasonowane",
	"przefasowane",
	"przefaxowane",
	"przefiltrowane",
	"przeformowane",
	"przeforsowane",
	"przegadane",
	"przeganane",
	"przeganiane",
	"przegapiane",
	"przegapione",
	"przegięte",
	"przeginane",
	"przeglądane",
	"przeglądnięte",
	"przegłodzone",
	"przegłosowane",
	"przegonione",
	"przegotowane",
	"przegotowywane",
	"przegrabione",
	"przegradzane",
	"przegrane",
	"przegrupowane",
	"przegrupowywane",
	"przegrywane",
	"przegryzane",
	"przegryzione",
	"przegrzane",
	"przegrzebane",
	"przegrzewane",
	"przehandlowane",
	"przeholowane",
	"przeinstalowane",
	"przeistoczone",
	"przejadane",
	"przejaskrawiane",
	"przejaśnione",
	"przejawiane",
	"przejawione",
	"przejechane",
	"przejęte",
	"przejeżdżane",
	"przejmowane",
	"przejrzane",
	"przekabacane",
	"przekabacone",
	"przekablowane",
	"przekalibrowane",
	"przekalkulowane",
	"przekarmiane",
	"przekąszone",
	"przekazywane",
	"przekierowane",
	"przekierowywane",
	"przekimane",
	"przekładane",
	"przeklejone",
	"przeklęte",
	"przeklinane",
	"przeklnięte",
	"przekłute",
	"przekonane",
	"przekonfigurowane",
	"przekonstruowane",
	"przekonwertowane",
	"przekonywane",
	"przekopane",
	"przekopywane",
	"przekoziołkowane",
	"przekraczane",
	"przekręcane",
	"przekręcone",
	"przekreślane",
	"przekreślone",
	"przekroczone",
	"przekrojone",
	"przekrzyczone",
	"przekrzywione",
	"przekształcane",
	"przekształcone",
	"przekupione",
	"przekupywane",
	"przekute",
	"przekwalifikowane",
	"przełączane",
	"przełączone",
	"przeładowane",
	"przeładowywane",
	"przełamane",
	"przełamywane",
	"przelane",
	"przelatywane",
	"przeleciane",
	"przelewane",
	"przeleżane",
	"przelicytowane",
	"przeliczane",
	"przeliczone",
	"przeliterowane",
	"przełknięte",
	"przełożone",
	"przełykane",
	"przełyknięte",
	"przemalowane",
	"przemalowywane",
	"przemaszerowane",
	"przemawiane",
	"przemeblowane",
	"przemęczone",
	"przemielone",
	"przemieniane",
	"przemierzone",
	"przemieszczane",
	"przemieszczone",
	"przemijane",
	"przemilczane",
	"przemilczone",
	"przeminięte",
	"przemknięte",
	"przemodelowane",
	"przemusztrowane",
	"przemycane",
	"przemycone",
	"przemyślane",
	"przemyślone",
	"przemyte",
	"przemywane",
	"przenegocjowane",
	"przeniesione",
	"przenikane",
	"przeniknięte",
	"przenoszone",
	"przeobrażane",
	"przeobrażone",
	"przeoczane",
	"przeoczone",
	"przeorane",
	"przeorganizowane",
	"przeorientowane",
	"przepadane",
	"przepakowane",
	"przepalone",
	"przeparkowane",
	"przepchane",
	"przepchnięte",
	"przepędzane",
	"przepędzone",
	"przepełniane",
	"przepełnione",
	"przepijane",
	"przepiłowane",
	"przepisane",
	"przepisywane",
	"przepite",
	"przepłacane",
	"przepłacone",
	"przepłakane",
	"przeplanowane",
	"przepłoszone",
	"przepłukane",
	"przepłukiwane",
	"przepłynięte",
	"przepływane",
	"przepompowane",
	"przepompowywane",
	"przepowiadane",
	"przepowiedziane",
	"przepracowane",
	"przepracowywane",
	"przeprane",
	"przeprawiane",
	"przeprawione",
	"przeprogramowane",
	"przeprojektowane",
	"przeprowadzane",
	"przeprowadzone",
	"przepuszczane",
	"przepuszczone",
	"przepychane",
	"przepytane",
	"przepytywane",
	"przerąbane",
	"przerabiane",
	"przeradzane",
	"przerastane",
	"przerażone",
	"przeredagowane",
	"przerejestrowane",
	"przerobione",
	"przerodzone",
	"przerośnięte",
	"przerwane",
	"przerysowane",
	"przerywane",
	"przerzedzane",
	"przerzucane",
	"przerzucone",
	"przesączone",
	"przesadzane",
	"przesądzane",
	"przesadzone",
	"przesądzone",
	"prześcigane",
	"prześcignięte",
	"przesiadane",
	"przesiadywane",
	"przesiane",
	"przesiedlane",
	"przesiedlone",
	"przesiedziane",
	"przesiewane",
	"przesilone",
	"przeskakiwane",
	"przeskalowane",
	"przeskanowane",
	"przeskoczone",
	"przeskrobane",
	"prześladowane",
	"przesłaniane",
	"przesłane",
	"prześledzone",
	"prześlizgnięte",
	"przesłodzone",
	"przesłonięte",
	"przesłuchane",
	"przesłuchiwane",
	"przesmarowane",
	"przesolone",
	"przesortowane",
	"przespane",
	"prześpiewane",
	"przessane",
	"przestawiane",
	"przestawione",
	"przestemplowane",
	"przestraszone",
	"przestrojone",
	"przestrzegane",
	"przestrzelone",
	"przestudiowane",
	"przesunięte",
	"przesuwane",
	"prześwietlane",
	"prześwietlone",
	"przesyłane",
	"przesypane",
	"przesypiane",
	"przesypywane",
	"przeszarżowane",
	"przeszczepiane",
	"przeszczepione",
	"przeszkadzane",
	"przeszkolone",
	"przeszmuglowane",
	"przeszukane",
	"przeszukiwane",
	"przeszyte",
	"przeszywane",
	"przetaczane",
	"przetańczone",
	"przetapetowane",
	"przetarte",
	"przetestowane",
	"przetkane",
	"przetoczone",
	"przetopione",
	"przetrącone",
	"przetransformowane",
	"przetransmitowane",
	"przetransponowane",
	"przetransportowane",
	"przetrawione",
	"przetrwane",
	"przetrząsane",
	"przetrząśnięte",
	"przetrzepane",
	"przetrzymane",
	"przetrzymywane",
	"przetwarzane",
	"przetworzone",
	"przewalane",
	"przewalczone",
	"przewaletowane",
	"przewalone",
	"przeważane",
	"przeważone",
	"przewertowane",
	"przewiązane",
	"przewiązywane",
	"przewidywane",
	"przewidziane",
	"przewiercane",
	"przewiercone",
	"przewieszane",
	"przewieszone",
	"przewietrzone",
	"przewiezione",
	"przewijane",
	"przewinięte",
	"przewitane",
	"przewodniczone",
	"przewodzone",
	"przewożone",
	"przewracane",
	"przewrócone",
	"przewyższane",
	"przeymierzane",
	"przeżarte",
	"przeżeglowane",
	"przeżegnane",
	"przeziębione",
	"przezimowane",
	"przeznaczane",
	"przeznaczone",
	"przeżute",
	"przezwyciężane",
	"przezwyciężone",
	"przeżyte",
	"przezywane",
	"przeżywane",
	"przodowane",
	"przpochlebione",
	"przwdziewane",
	"przybastowane",
	"przybierane",
	"przybijane",
	"przybite",
	"przybliżane",
	"przybliżone",
	"przybrane",
	"przycelowane",
	"przycepione",
	"przychylone",
	"przyciągane",
	"przyciągnięte",
	"przyciemnione",
	"przycięte",
	"przycinane",
	"przyciskane",
	"przyciśnięte",
	"przyciszone",
	"przyćmiewane",
	"przyćmione",
	"przycumowane",
	"przyczepiane",
	"przyczesane",
	"przyczołgane",
	"przyczynione",
	"przydepnięte",
	"przydeptane",
	"przyduszone",
	"przydzielane",
	"przydzielone",
	"przygarnięte",
	"przygaszone",
	"przygazowane",
	"przygładzane",
	"przygnębiane",
	"przygniatane",
	"przygniecione",
	"przygotowane",
	"przygruchane",
	"przygrywane",
	"przygryzane",
	"przygryzione",
	"przygrzane",
	"przygwożdżone",
	"przyhamowane",
	"przyholowane",
	"przyjane",
	"przyjęte",
	"przyjmowane",
	"przyjrzane",
	"przykładane",
	"przyklejone",
	"przyklepane",
	"przykopane",
	"przykręcane",
	"przykręcone",
	"przykrócone",
	"przykryte",
	"przykrywane",
	"przykurzone",
	"przykute",
	"przykuwane",
	"przyłączane",
	"przyłączone",
	"przylane",
	"przyłapane",
	"przylegane",
	"przylepiane",
	"przylepione",
	"przyłożone",
	"przymierzone",
	"przymilane",
	"przymknięte",
	"przymocowane",
	"przymuszane",
	"przynależone",
	"przyniesione",
	"przynoszone",
	"przynudzane",
	"przyostrzone",
	"przyozdabiane",
	"przyozdobione",
	"przypadnięte",
	"przypakowane",
	"przypakowywane",
	"przypalane",
	"przypalone",
	"przyparte",
	"przypasowane",
	"przypatrywane",
	"przypatrzone",
	"przypieczętowane",
	"przypiekane",
	"przypierane",
	"przypięte",
	"przypilnowane",
	"przypiłowane",
	"przypinane",
	"przypisane",
	"przypisywane",
	"przypłacone",
	"przyplątane",
	"przypłynięte",
	"przypodobane",
	"przypominane",
	"przypomniane",
	"przyporządkowane",
	"przyprawiane",
	"przyprawione",
	"przyprowadzone",
	"przypucowane",
	"przypudrowane",
	"przypuszczane",
	"przypuszczone",
	"przyrównane",
	"przyrządzane",
	"przyrządzone",
	"przysiadane",
	"przysiągnięte",
	"przyskrzydlone",
	"przyskrzyniane",
	"przyskrzynione",
	"przysłaniane",
	"przysłane",
	"przysłodzone",
	"przysłonione",
	"przysłuchiwane",
	"przysługiwane",
	"przysłużone",
	"przysmażane",
	"przysmażone",
	"przyspieszane",
	"przyspieszone",
	"przysporzone",
	"przysposobione",
	"przyśrubowywane",
	"przyssane",
	"przystąpione",
	"przystawiane",
	"przystawione",
	"przystemplowane",
	"przystopowane",
	"przystosowane",
	"przystrojone",
	"przysunięte",
	"przysuwane",
	"przyswajane",
	"przyświecane",
	"przyświęcone",
	"przyswojone",
	"przysyłane",
	"przysypane",
	"przyszpilone",
	"przyszykowane",
	"przyszyte",
	"przyszywane",
	"przytaczane",
	"przytargane",
	"przytarte",
	"przytaszczane",
	"przytępiane",
	"przytępione",
	"przytkane",
	"przytłaczane",
	"przytłoczone",
	"przytłumione",
	"przytoczone",
	"przytrafione",
	"przytroczone",
	"przytruwane",
	"przytrzasnięte",
	"przytrzymane",
	"przytrzymywane",
	"przytulane",
	"przytulone",
	"przytwierdzane",
	"przytwierdzone",
	"przytykane",
	"przyuczone",
	"przyuważone",
	"przywabione",
	"przywalane",
	"przywalone",
	"przywarowane",
	"przywarte",
	"przywdziane",
	"przywiązane",
	"przywiązywane",
	"przywidziane",
	"przywiezione",
	"przywitane",
	"przywłaszczane",
	"przywłaszczone",
	"przywołane",
	"przywoływane",
	"przywożone",
	"przywracane",
	"przywrócone",
	"przyznaczone",
	"przyznane",
	"przyznawane",
	"przyzwalane",
	"przyzwane",
	"przyzwyczajane",
	"przyzwyczajone",
	"przyzywane",
	"psiamane",
	"pstrykane",
	"pstryknięte",
	"psute",
	"publikowane",
	"puchnięte",
	"pucowane",
	"pudłowane",
	"pudrowane",
	"puknięte",
	"punktowane",
	"pustoszone",
	"puszczane",
	"puszczone",
	"puszkowane",
	"puszone",
	"pykane",
	"pytane",
	"rabowane",
	"rachowane",
	"racjonalizowane",
	"racjonowane",
	"raczone",
	"radowane",
	"ranione",
	"raportowane",
	"ratowane",
	"ratyfikowane",
	"reaktywowane",
	"realizowane",
	"reanimowane",
	"recytowane",
	"ręczone",
	"redagowane",
	"redukowane",
	"reformowane",
	"refowane",
	"regenerowane",
	"regionalizowane",
	"regulowane",
	"reinkarnowane",
	"rejestrowane",
	"reklamowane",
	"rekomendowane",
	"rekompensowane",
	"rekonstruowane",
	"rekreowane",
	"rekrutowane",
	"rekwirowane",
	"relacjonowane",
	"relaksowane",
	"remodulowane",
	"remontowane",
	"renegocjowane",
	"reorganizowane",
	"reperowane",
	"replikowane",
	"represejonowane",
	"reprezentowane",
	"reprodukowane",
	"resetowane",
	"resocjalizowane",
	"respektowane",
	"resuscytowane",
	"retuszowane",
	"rewanżowane",
	"rewidowane",
	"rezerwowane",
	"rezonowane",
	"rezygnowane",
	"reżyserowane",
	"robione",
	"rodzone",
	"rojone",
	"rolowane",
	"romansowane",
	"ronione",
	"rozbawiane",
	"rozbawione",
	"rozbierane",
	"rozbijane",
	"rozbite",
	"rozbłyśnięte",
	"rozbrajane",
	"rozbrojone",
	"rozbudowane",
	"rozbudowywane",
	"rozbudzane",
	"rozbudzone",
	"rozbujane",
	"rozcapierzone",
	"rozchmurzone",
	"rozchodzone",
	"rozchylane",
	"rozchylone",
	"rozciągane",
	"rozciągnięte",
	"rozcieńczane",
	"rozcieńczone",
	"rozcierane",
	"rozcięte",
	"rozcinane",
	"rozczarowane",
	"rozczarowywane",
	"rozczesane",
	"rozczłonkowane",
	"rozczulane",
	"rozczytane",
	"rozdane",
	"rozdawane",
	"rozdeptane",
	"rozdmuchane",
	"rozdmuchiwane",
	"rozdrabniane",
	"rozdrapane",
	"rozdrapywane",
	"rozdrażniane",
	"rozdrażnione",
	"rozduszone",
	"rozdwojone",
	"rozdysponowane",
	"rozdzielane",
	"rozdzielone",
	"rozdzierane",
	"rozdziewiczone",
	"rozebrane",
	"rozedrane",
	"rozegrane",
	"rozegrywane",
	"rozepchane",
	"rozerwane",
	"rozesłane",
	"rozgarnięte",
	"rozgaszczane",
	"rozgięte",
	"rozglaszane",
	"rozgłoszone",
	"rozgniatane",
	"rozgniecione",
	"rozgniewane",
	"rozgonione",
	"rozgraniczone",
	"rozgrane",
	"rozgromione",
	"rozgrywane",
	"rozgryzane",
	"rozgryzione",
	"rozgrzane",
	"rozgrzebywane",
	"rozgrzeszone",
	"rozgrzewane",
	"rozhuśtane",
	"rozjaśniane",
	"rozjaśnione",
	"rozjechane",
	"rozjedzone",
	"rozjuszane",
	"rozjuszone",
	"rozkazane",
	"rozkazywane",
	"rozkładane",
	"rozklejane",
	"rozklejone",
	"rozkołysane",
	"rozkopane",
	"rozkopywane",
	"rozkoszowane",
	"rozkręcane",
	"rozkręcone",
	"rozkrojone",
	"rozkruszone",
	"rozkute",
	"rozkuwane",
	"rozkwaszone",
	"rozkwaterowane",
	"rozkwitane",
	"rozkwitnięte",
	"rozłączone",
	"rozładowane",
	"rozładowywane",
	"rozłamane",
	"rozlane",
	"rozlewane",
	"rozliczane",
	"rozliczone",
	"rozlokowane",
	"rozłożone",
	"rozłupane",
	"rozluźniane",
	"rozmanażane",
	"rozmasowane",
	"rozmawiane",
	"rozmazane",
	"rozmazywane",
	"rozmiękczone",
	"rozmieniane",
	"rozmienione",
	"rozmieszczane",
	"rozmieszczone",
	"rozminięte",
	"rozmnożone",
	"rozmontowane",
	"rozmówione",
	"rozmrażane",
	"rozmrożone",
	"rozmyślane",
	"rozmyte",
	"różnicowane",
	"rozniecane",
	"rozniecione",
	"rozniesione",
	"różnione",
	"roznoszone",
	"rozochocone",
	"rozpaczane",
	"rozpakowane",
	"rozpakowywane",
	"rozpalane",
	"rozpalone",
	"rozpamiętywane",
	"rozpaskudzane",
	"rozpatrywane",
	"rozpatrzone",
	"rozpędzane",
	"rozpędzone",
	"rozpętane",
	"rozpieszczane",
	"rozpieszczone",
	"rozpięte",
	"rozpiłowane",
	"rozpinane",
	"rozpisane",
	"rozpisywane",
	"rozplanowane",
	"rozpłaszczane",
	"rozpłaszczone",
	"rozplątane",
	"rozplątywane",
	"rozpłynięte",
	"rozpoczęte",
	"rozpoczynane",
	"rozpogodzone",
	"rozporządzane",
	"rozporządzone",
	"rozpościerane",
	"rozpostrzone",
	"rozpowiadane",
	"rozpowiedziane",
	"rozpowszechniane",
	"rozpowszechnione",
	"rozpoznane",
	"rozpoznawane",
	"rozpracowane",
	"rozpraszane",
	"rozprawiane",
	"rozprawiczone",
	"rozprawione",
	"rozprostowane",
	"rozproszone",
	"rozprowadzane",
	"rozprowadzone",
	"rozprute",
	"rozpruwane",
	"rozprzestrzeniane",
	"rozprzestrzenione",
	"rozpuszczane",
	"rozpuszczone",
	"rozpychane",
	"rozpylane",
	"rozpylone",
	"rozpytane",
	"rozpytywane",
	"rozrastane",
	"rozreklamowane",
	"rozrobione",
	"rozrośnięte",
	"rozróżniane",
	"rozróżnione",
	"rozruszane",
	"rozrysowane",
	"rozrywane",
	"rozrzucane",
	"rozsadzane",
	"rozsadzone",
	"rozsądzone",
	"rozścielone",
	"rozsiane",
	"rozsiekane",
	"rozsiewane",
	"rozsiodłane",
	"rozsławiane",
	"rozsławione",
	"rozsmarowane",
	"rozsmarowywane",
	"rozśmieszane",
	"rozstane",
	"rozstąpione",
	"rozstawane",
	"rozstawiane",
	"rozstawione",
	"rozstrojone",
	"rozstrząsane",
	"rozstrzeliwane",
	"rozstrzelone",
	"rozstrzygane",
	"rozstrzygnięte",
	"rozsunięte",
	"rozsupłane",
	"rozświetlane",
	"rozświetlone",
	"rozsyłane",
	"rozsypane",
	"rozsypywane",
	"rozszarpane",
	"rozszarpywane",
	"rozszczepiane",
	"rozszczepione",
	"rozszerzane",
	"rozszerzone",
	"rozszyfrowane",
	"roztaczane",
	"roztapiane",
	"roztarte",
	"roztoczone",
	"roztopione",
	"roztrwonione",
	"roztrząsane",
	"roztrzaskane",
	"rozumiane",
	"rozumowane",
	"rozwalane",
	"rozwalone",
	"rozwarte",
	"rozważane",
	"rozważone",
	"rozweselane",
	"rozweselone",
	"rozwiane",
	"rozwiązane",
	"rozwiązywane",
	"rozwidniane",
	"rozwiedzione",
	"rozwierane",
	"rozwiercone",
	"rozwieszane",
	"rozwieszone",
	"rozwiewane",
	"rozwiezione",
	"rozwikłane",
	"rozwinięte",
	"rozwlekane",
	"rozwodzone",
	"rozwścieczane",
	"rozwścieczone",
	"rozzłoszczone",
	"rugane",
	"ruinowane",
	"rujnowane",
	"runięte",
	"ruszane",
	"ruszone",
	"rwane",
	"ryczane",
	"ryglowane",
	"rymowane",
	"rysowane",
	"ryte",
	"ryzykowane",
	"rządzone",
	"rzeźbione",
	"rżnięte",
	"rzucane",
	"rzucone",
	"rzygane",
	"sabotażowane",
	"sączone",
	"sadzane",
	"sadzone",
	"sądzone",
	"salutowane",
	"salwowane",
	"sankcjonowane",
	"satysfakcjonowane",
	"scalone",
	"scementowane",
	"scentrowane",
	"scharakteryzowane",
	"schładzane",
	"schlane",
	"schlapane",
	"schlebione",
	"schłodzone",
	"schowane",
	"schronione",
	"schrupane",
	"schrzanione",
	"schwytane",
	"schylane",
	"ściągnięte",
	"ścielone",
	"ściemniane",
	"ściemnione",
	"ścierane",
	"ścierpione",
	"ścięte",
	"ścigane",
	"ścinane",
	"ściskane",
	"ściśnięte",
	"ściszane",
	"ściszone",
	"sędziowane",
	"segregowane",
	"selekcjonowane",
	"separowane",
	"sępione",
	"serwowane",
	"sfabrykowane",
	"sfajczone",
	"sfałszowane",
	"sfaulowane",
	"sfilmowane",
	"sfinalizowane",
	"sfinansowane",
	"sfingowane",
	"sformalizowane",
	"sformatowane",
	"sformowane",
	"sformułowane",
	"sforsowane",
	"sfotografowane",
	"shimmerowane",
	"siane",
	"siekane",
	"siorbane",
	"skadrowane",
	"skakane",
	"skalane",
	"skaleczone",
	"skalibrowane",
	"skalkulowane",
	"skalpowane",
	"skanalizowane",
	"skandowane",
	"skanowane",
	"skapitulowane",
	"skarcone",
	"skarżone",
	"skasowane",
	"skatalogowane",
	"skazane",
	"skażone",
	"skazywane",
	"skierowane",
	"składane",
	"składowane",
	"skłaniane",
	"sklasyfikowane",
	"sklecione",
	"sklejane",
	"sklejone",
	"sklepane",
	"skłócone",
	"skłonione",
	"sklonowane",
	"sknocone",
	"skojarzone",
	"skolonizowane",
	"skołowane",
	"skombinowane",
	"skomentowane",
	"skompensowane",
	"skompletowane",
	"skomplikowane",
	"skomponowane",
	"skompresowane",
	"skompromitowane",
	"skomunikowane",
	"skonane",
	"skoncentrowane",
	"skończone",
	"skondensowane",
	"skonfigurowane",
	"skonfiskowane",
	"skonfrontowane",
	"skonkretyzowane",
	"skonsolidowane",
	"skonstruowane",
	"skonsultowane",
	"skonsumowane",
	"skontaktowane",
	"skontrolowane",
	"skoordynowane",
	"skopane",
	"skopiowane",
	"skorektowane",
	"skorumpowane",
	"skorygowane",
	"skorzystane",
	"skoszone",
	"skracane",
	"skradzione",
	"skręcane",
	"skręcone",
	"skremowane",
	"skreślane",
	"skreślone",
	"skrobane",
	"skrobnięte",
	"skrócone",
	"skrojone",
	"skropione",
	"skruszone",
	"skrystalizowane",
	"skryte",
	"skrytykowane",
	"skrywane",
	"skrzecowane",
	"skrzepnięte",
	"skrzyczane",
	"skrzyte",
	"skrzywdzone",
	"skrzyżowane",
	"skserowane",
	"skubane",
	"skubnięte",
	"skulone",
	"skumulowane",
	"skupiane",
	"skupione",
	"skupowane",
	"skurczone",
	"skuszone",
	"skute",
	"skuwane",
	"skwitowane",
	"słane",
	"sławione",
	"śledzone",
	"ślinione",
	"ślizgane",
	"słodzone",
	"słuchane",
	"słyszane",
	"smagane",
	"smarowane",
	"smażone",
	"śmiecone",
	"smute",
	"smyrane",
	"snute",
	"sondowane",
	"sortowane",
	"spafycikowane",
	"spakowane",
	"spalane",
	"spałaszowane",
	"spalone",
	"spałowane",
	"spamiętane",
	"spaprane",
	"sparafrazowane",
	"sparaliżowane",
	"sparowane",
	"spartaczone",
	"spartolone",
	"sparzone",
	"spasowane",
	"spatałaszone",
	"spauzowane",
	"spawane",
	"spawione",
	"specjalizowane",
	"spędzane",
	"spędzone",
	"spekulowane",
	"spełniane",
	"spełnione",
	"spenetrowane",
	"spętane",
	"spierane",
	"spięte",
	"śpiewane",
	"spiłowane",
	"spinane",
	"spisane",
	"spiskowane",
	"spisywane",
	"spite",
	"spłacane",
	"spłacone",
	"splądrowane",
	"splajtowane",
	"splamione",
	"spłaszczone",
	"splatane",
	"splątane",
	"spłatane",
	"spławiane",
	"spławione",
	"spłodzone",
	"spłonięte",
	"spłoszone",
	"spłukane",
	"spłukiwane",
	"spluwane",
	"spływane",
	"spoczęte",
	"spoczywane",
	"spodziewane",
	"spojone",
	"spolaryzowane",
	"spoliczkowane",
	"sponiewierane",
	"sponsorowane",
	"spopielane",
	"spopielone",
	"spopularyzowane",
	"sportretowane",
	"sporządzane",
	"sporządzone",
	"spostrzegane",
	"spotęgowane",
	"spotkane",
	"spotykane",
	"spoufalane",
	"spowalniane",
	"spowiadane",
	"spowodowane",
	"spowolnione",
	"spoźnione",
	"spóźnione",
	"spożytkowane",
	"spożyte",
	"spożywane",
	"sprane",
	"sprasowane",
	"spraszane",
	"sprawdzone",
	"sprawione",
	"sprawowane",
	"sprecyzowane",
	"spreparowane",
	"sprężane",
	"sprężone",
	"spróbowane",
	"sprofanowane",
	"sprofilowane",
	"sprostowane",
	"sproszkowane",
	"sproszone",
	"sprowadzane",
	"sprowadzone",
	"sprowokowane",
	"spryskane",
	"spryskiwane",
	"sprywatyzowane",
	"sprzątane",
	"sprzątnięte",
	"sprzeczane",
	"sprzedane",
	"sprzedawane",
	"sprzeniewierzone",
	"spudłowane",
	"spustoszone",
	"spuszczane",
	"spuszczone",
	"spychane",
	"ssane",
	"stabilizowane",
	"stacjonowane",
	"staczane",
	"staranowane",
	"starczane",
	"stargowane",
	"startowane",
	"stawiane",
	"stawione",
	"stemplowane",
	"stenografowane",
	"stepowane",
	"sterowane",
	"sterroryzowane",
	"sterylizowane",
	"stłamszone",
	"stłumione",
	"stnięte",
	"stoczone",
	"stołowane",
	"stonowane",
	"stopione",
	"stopniowane",
	"storpedowane",
	"stosowane",
	"strącane",
	"stracone",
	"strącone",
	"strajkowane",
	"straszone",
	"stratowane",
	"strawione",
	"streamowane",
	"stresowane",
	"streszczane",
	"streszczone",
	"strofowane",
	"strojone",
	"stroszone",
	"strugane",
	"strute",
	"strymowane",
	"strząsane",
	"strzaskane",
	"strząśnięte",
	"strzelone",
	"strzepane",
	"strzępione",
	"strzepnięte",
	"strzepywane",
	"studiowane",
	"studzone",
	"stukane",
	"stuknięte",
	"stulone",
	"stwardnione",
	"stwarzane",
	"stwierdzane",
	"stwierdzone",
	"stworzone",
	"stykane",
	"stylizowane",
	"stymulowane",
	"sugerowane",
	"sumowane",
	"sunięte",
	"swatane",
	"swawolone",
	"świadczone",
	"świecone",
	"święcone",
	"świerzbione",
	"świętowane",
	"świntuszone",
	"sycone",
	"sygnalizowane",
	"symulowane",
	"synchronizowane",
	"sypane",
	"sypnięte",
	"szachrowane",
	"szacowane",
	"szafowane",
	"szamotane",
	"szanowane",
	"szargane",
	"szarpane",
	"szarpnięte",
	"szarżowane",
	"szasowane",
	"szastane",
	"szatkowane",
	"szczędzone",
	"szczepione",
	"szczerzone",
	"szczute",
	"szczycone",
	"szczypane",
	"szczytowane",
	"szefowane",
	"szemrane",
	"szepnięte",
	"szeptane",
	"szerzone",
	"szkalowane",
	"szkicowane",
	"szklone",
	"szkodzone",
	"szkolone",
	"szlachtowane",
	"szlifowane",
	"szmuglowane",
	"szokowane",
	"szorowane",
	"szpachlowane",
	"szpanowane",
	"szperane",
	"szprycowane",
	"sztachnięte",
	"szturchane",
	"szturchnięte",
	"szturmowane",
	"szufladkowane",
	"szuflowane",
	"szukane",
	"szulerowane",
	"szwankowane",
	"szydełkowane",
	"szydzone",
	"szyfrowane",
	"szykanowane",
	"szykowane",
	"szyte",
	"taktowane",
	"tamowane",
	"tankowane",
	"tapetowane",
	"taplane",
	"taranowane",
	"targane",
	"targnięte",
	"targowane",
	"tarmoszone",
	"tarte",
	"tarzane",
	"tasowane",
	"taszczone",
	"tatuowane",
	"tchnięte",
	"telefonowane",
	"telegrfowane",
	"teleportowane",
	"temperowane",
	"teoretyzowane",
	"tępione",
	"terroryzowane",
	"testowane",
	"tkane",
	"tknięte",
	"tłamszone",
	"tłoczone",
	"tłumaczone",
	"tłumione",
	"toczone",
	"tolerowane",
	"tonowane",
	"topione",
	"torowane",
	"torturowane",
	"towarzyszone",
	"trąbione",
	"trącane",
	"tracone",
	"trącone",
	"trafiane",
	"trafione",
	"tragizowane",
	"traktowane",
	"transferowane",
	"transformowane",
	"transmitowane",
	"transportowane",
	"tratowane",
	"trawione",
	"trenowane",
	"tresowane",
	"triumfowane",
	"tropione",
	"troszczone",
	"trute",
	"trwonione",
	"trymowane",
	"tryskane",
	"tryśnięte",
	"tryumfowane",
	"trywializowane",
	"trzaskane",
	"trzasnięte",
	"trzepane",
	"trzepnięte",
	"trzepotane",
	"trzęsione",
	"trzymane",
	"tuczone",
	"tułane",
	"tulone",
	"turlane",
	"tuszowane",
	"twistowane",
	"tworzone",
	"tykane",
	"tyranizowane",
	"tyrane",
	"tytułowane",
	"uaktualniane",
	"uaktualnione",
	"uaktywniane",
	"uaktywnione",
	"uargumentowane",
	"uatrakcyjnione",
	"ubabrane",
	"ubarwiane",
	"ubarwione",
	"ubawione",
	"ubezpieczane",
	"ubezpieczone",
	"ubezwłasnowolnione",
	"ubiczowane",
	"ubiegane",
	"ubierane",
	"ubijane",
	"ubite",
	"ubłagane",
	"ubliżane",
	"ubliżone",
	"ubolewane",
	"ubóstwiane",
	"ubrane",
	"ubroczone",
	"ubrudzone",
	"ucałowane",
	"ucharakteryzowane",
	"uchowane",
	"uchronione",
	"uchwalane",
	"uchwalone",
	"uchwycone",
	"uchylane",
	"uchylone",
	"uciągnięte",
	"ucieleśniane",
	"ucierane",
	"ucierpiane",
	"ucięte",
	"ucinane",
	"uciskane",
	"uciśnięte",
	"uciszane",
	"uciszone",
	"uciułane",
	"ucywilizowane",
	"uczczone",
	"uczepione",
	"uczesane",
	"uczęszczane",
	"uczone",
	"ucztowane",
	"uczute",
	"uczynione",
	"udane",
	"udaremnione",
	"udawane",
	"udekorowane",
	"udeptywane",
	"uderzane",
	"uderzone",
	"udobruchane",
	"udokumentowane",
	"udomawiane",
	"udomowione",
	"udoskonalane",
	"udoskonalone",
	"udostępniane",
	"udostępnione",
	"udowadniane",
	"udowodnione",
	"Udramatyzowane",
	"udręczone",
	"udrożnione",
	"udupione",
	"uduszone",
	"udzielane",
	"udzielone",
	"udźwignięte",
	"ueiwarygodnione",
	"ufane",
	"ufarbowane",
	"uformowane",
	"ufortyfikowane",
	"ufundowane",
	"ugadane",
	"uganiane",
	"ugaszane",
	"ugaszone",
	"ugięte",
	"uginane",
	"ugłaskane",
	"ugniatane",
	"ugodzone",
	"ugoszczone",
	"ugotowane",
	"ugrane",
	"ugruntowane",
	"ugryzione",
	"ugrzęznięte",
	"uhistoryzowane",
	"uhonorowane",
	"uiścite",
	"ujadane",
	"ujarzmiane",
	"ujarzmione",
	"ujawniane",
	"ujawnione",
	"ujęte",
	"ujeżdżane",
	"ujeżdżone",
	"ujmowane",
	"ujrzane",
	"ukamieniowane",
	"ukarane",
	"ukartowane",
	"ukąszone",
	"ukatrupione",
	"ukazane",
	"ukazywane",
	"ukierowane",
	"ukierunkowane",
	"układane",
	"uklepane",
	"ukłonione",
	"ukłute",
	"uknute",
	"ukojone",
	"ukołysane",
	"ukończone",
	"ukonkretnione",
	"ukoronowane",
	"ukradzione",
	"ukręcane",
	"ukręcone",
	"ukrojone",
	"ukryte",
	"ukrywane",
	"ukrzyżowane",
	"ukształtowane",
	"ukute",
	"ułagodzone",
	"ułaskawiane",
	"ułaskawione",
	"ulatniane",
	"ułatwiane",
	"ułatwione",
	"uleczane",
	"uleczone",
	"ulegane",
	"ulepione",
	"ulepszane",
	"ulepszone",
	"ulokowane",
	"ulotnione",
	"ułożone",
	"umacniane",
	"umalowane",
	"umartwiane",
	"umawiane",
	"umazane",
	"umeblowane",
	"umiejscowione",
	"umieszczane",
	"umieszczone",
	"umilane",
	"umilone",
	"umknięte",
	"umniejszane",
	"umniejszone",
	"umocnione",
	"umocowane",
	"umoczone",
	"umodelowane",
	"umorzone",
	"umotywowane",
	"umówione",
	"umożliwiane",
	"umożliwione",
	"umrocznione",
	"umyte",
	"unaocznione",
	"unicestwiane",
	"unicestwione",
	"uniemożliwaine",
	"uniemożliwione",
	"unierochomione",
	"uniesione",
	"unieszczęśliwiane",
	"unieszczęśliwione",
	"unieszkodliwiane",
	"unieszkodliwione",
	"unieważniane",
	"unieważnione",
	"uniewinnione",
	"uniezależnione",
	"unikane",
	"uniknięte",
	"unormowane",
	"unoszone",
	"unowoczesniane",
	"unowocześniane",
	"uodpornione",
	"uogólniane",
	"upakowane",
	"upalane",
	"upalone",
	"upamiętniane",
	"upamiętnione",
	"upaństwowione",
	"upaprane",
	"uparte",
	"upaskudzone",
	"upchane",
	"upchnięte",
	"upewniane",
	"upewnione",
	"upgradowane",
	"upichcone",
	"upiększane",
	"upiększone",
	"upierane",
	"upierdolone",
	"upięte",
	"upijane",
	"upilnowane",
	"upinane",
	"upite",
	"uplastycznione",
	"upłynięte",
	"upodabniane",
	"upodobnione",
	"upojone",
	"upokorzane",
	"upokorzone",
	"upolowane",
	"upominane",
	"uporządkowane",
	"upowszechnione",
	"upozorowane",
	"upozowane",
	"uprane",
	"uprasowane",
	"upraszczane",
	"uprawdopodobnione",
	"uprawiane",
	"uproszczone",
	"uproszone",
	"uprowadzane",
	"uprowadzone",
	"uprzątane",
	"uprzątnięte",
	"uprzedone",
	"uprzedzane",
	"uprzyjemniane",
	"uprzyjemnione",
	"uprzykrzane",
	"uprzytomnione",
	"upubliczniane",
	"upublicznione",
	"upudrowane",
	"upuszczane",
	"upuszczone",
	"upychane",
	"urabiane",
	"uraczane",
	"uradowane",
	"Urągane",
	"uratowane",
	"urażane",
	"urażone",
	"uregulowane",
	"urobione",
	"uronione",
	"urośnięte",
	"urozmaicane",
	"urozmaicone",
	"uruchamiane",
	"uruchomione",
	"urwane",
	"urywane",
	"urządzane",
	"urządzone",
	"urzeczywistniane",
	"urzeczywistnione",
	"urżnięte",
	"usadowione",
	"usadzone",
	"usamowolnione",
	"usankcjonowane",
	"usatyfakcjonowane",
	"uschnięte",
	"uściskane",
	"uścislone",
	"uściśnięte",
	"usidlone",
	"usiedzone",
	"uskładane",
	"uskoczone",
	"uskuteczniane",
	"uskutecznione",
	"usłuchane",
	"usługiwane",
	"usłużone",
	"usłyszane",
	"usmażone",
	"uśmiane",
	"uśmiercane",
	"uśmiercone",
	"uśmierzone",
	"uspane",
	"uśpione",
	"uspokajane",
	"uspokojone",
	"uspołeczniane",
	"usprawiedliwiane",
	"usprawiedliwione",
	"usprawnione",
	"usprzątane",
	"ustabilizowane",
	"ustalane",
	"ustalone",
	"ustanawiane",
	"ustanowione",
	"ustąpione",
	"ustatkowane",
	"ustawiane",
	"ustawione",
	"ustępowane",
	"ustosunkowane",
	"ustrojone",
	"ustrzegane",
	"ustrzelone",
	"usunięte",
	"ususzone",
	"usuwane",
	"uświadamiane",
	"uświadczone",
	"uświadomione",
	"uświęcone",
	"uświnione",
	"usychane",
	"usypane",
	"usypiane",
	"usystematyzowane",
	"usytuowane",
	"uszanowane",
	"uszczelniane",
	"uszczęśliwiane",
	"uszczęśliwione",
	"uszczuplone",
	"uszczypnięte",
	"uszkadzane",
	"uszkodzone",
	"uszlachetniane",
	"uszlachetnione",
	"usztywnione",
	"uszykowane",
	"uszyte",
	"utajnione",
	"utargowane",
	"utarte",
	"utemperowane",
	"utkane",
	"utknięte",
	"utkwione",
	"utoczone",
	"utopione",
	"utorowane",
	"utożsamiane",
	"utożsamione",
	"utracone",
	"utrącone",
	"utrudniane",
	"utrudnione",
	"utrwalane",
	"utrwalone",
	"utrzymywane",
	"utuczone",
	"utulone",
	"utwierdzane",
	"utwierdzone",
	"utworzone",
	"utylizowane",
	"uwalniane",
	"uwalone",
	"uwarunkowane",
	"uważane",
	"uwiązane",
	"uwiązywane",
	"uwidocznione",
	"uwieczniane",
	"uwiecznione",
	"uwielbiane",
	"uwielbione",
	"uwieńczone",
	"uwierane",
	"uwierzone",
	"uwieszone",
	"uwiezione",
	"uwięzione",
	"uwijane",
	"uwikłane",
	"uwinięte",
	"uwite",
	"uwłaczane",
	"uwłaszczone",
	"uwodzone",
	"uwolnione",
	"uwsteczniane",
	"uwstecznione",
	"uwydatniane",
	"uwypiklone",
	"uwzględniane",
	"uwzględnione",
	"użądlone",
	"uzależniane",
	"uzależnione",
	"uzasadniane",
	"uzasadnione",
	"uzbierane",
	"uzbrajane",
	"uzbrojone",
	"uzdrawiane",
	"uzdrowione",
	"użerane",
	"uzewnętrzniane",
	"uzewnętrznione",
	"uzgadniane",
	"uzgodnione",
	"uziemione",
	"uzmysłowione",
	"uznane",
	"uznawane",
	"uzupełniane",
	"uzupełnione",
	"uzurpowane",
	"użyczane",
	"użyczone",
	"uzyskane",
	"uzyskiwane",
	"użyte",
	"używane",
	"wabione",
	"wąchane",
	"wachlowane",
	"wahane",
	"walczone",
	"wałkowane",
	"walnięte",
	"walone",
	"ważone",
	"wbijane",
	"wbite",
	"wcelowane",
	"wchłonięte",
	"wciągane",
	"wciągnięte",
	"wcielane",
	"wcielone",
	"wcierane",
	"wcięte",
	"wcinane",
	"wciskane",
	"wciśnięte",
	"wczepione",
	"wczołgane",
	"wczute",
	"wczytane",
	"wczytywane",
	"wdane",
	"wdarte",
	"wdawane",
	"wdepnięte",
	"wdeptane",
	"wdetonowane",
	"wdmuchiwane",
	"wdrapane",
	"wdrapywane",
	"wdrażane",
	"wdrążone",
	"wdrożone",
	"wduszone",
	"wdychane",
	"wdzierane",
	"wędkowane",
	"wentylowane",
	"wepchane",
	"wepchnięte",
	"werbowane",
	"weryfikowane",
	"wessane",
	"wetkane",
	"wetknięte",
	"wezwane",
	"wgłębiane",
	"wgniatane",
	"wgniecione",
	"wgrane",
	"wgryzane",
	"wgryzione",
	"wiązane",
	"wibrowane",
	"widywane",
	"widziane",
	"wiedzone",
	"wielbione",
	"wiercone",
	"wierzgane",
	"wierzone",
	"wieszane",
	"wietrzone",
	"więżone",
	"wikłane",
	"windowane",
	"winszowane",
	"wiosłowane",
	"wirowane",
	"witane",
	"wite",
	"wizualizowane",
	"wjeżdżane",
	"wkalkulowane",
	"wkładane",
	"wklejane",
	"wklejone",
	"wklepane",
	"wkłute",
	"wkomponowane",
	"wkopane",
	"wkopywane",
	"wkraczane",
	"wkradane",
	"wkradzione",
	"wkręcane",
	"wkręcone",
	"wkupione",
	"wkurwiane",
	"wkute",
	"wkuwane",
	"włączane",
	"włączone",
	"władane",
	"władowane",
	"włamane",
	"włamywane",
	"wlane",
	"wlepiane",
	"wlepione",
	"wlewane",
	"wliczane",
	"wliczone",
	"włożone",
	"wmanewrowane",
	"wmanipulowane",
	"wmawiane",
	"wmieszane",
	"wmówione",
	"wmurowane",
	"wmuszone",
	"wnerwiane",
	"wnerwione",
	"wniesione",
	"wnikane",
	"wniknięte",
	"wnioskowane",
	"wnoszone",
	"wodowane",
	"wojowane",
	"wołane",
	"woskowane",
	"wożone",
	"wpajane",
	"wpakowane",
	"wparowane",
	"wpasowane",
	"wpatrywane",
	"wpędzane",
	"wpędzone",
	"wperswadowane",
	"wpienione",
	"wpięte",
	"wpisane",
	"wpisywane",
	"wpłacane",
	"wpłacone",
	"wplatane",
	"wplątane",
	"wplątywane",
	"wpojone",
	"wpompowane",
	"wpraszane",
	"wprawiane",
	"wproszone",
	"wprowadzane",
	"wprowadzone",
	"wpuszczone",
	"wpychane",
	"wrabiane",
	"wręczane",
	"wrobione",
	"wróżone",
	"wryte",
	"wrzucane",
	"wrzucone",
	"wrzynane",
	"wsadzane",
	"wsadzone",
	"wskazane",
	"wskazywane",
	"wskórane",
	"wskrzeszane",
	"wskrzeszone",
	"wślizgiwane",
	"wślizgnięte",
	"wsłuchane",
	"wsparte",
	"wspierane",
	"wspięte",
	"współczute",
	"współodczuwane",
	"współtworzone",
	"współżyte",
	"wspomagane",
	"wspominane",
	"wspomniane",
	"wstąpione",
	"wstawiane",
	"wstawione",
	"wstrząsane",
	"wstrząśnięte",
	"wstrzelone",
	"wstrzykiwane",
	"wstrzyknięte",
	"wstrzymane",
	"wstrzymywane",
	"wstukane",
	"wsunięte",
	"wsuwane",
	"wsypane",
	"wszamane",
	"wszczepiane",
	"wszczepione",
	"wszczęte",
	"wszczynane",
	"wszyte",
	"wtajemniczane",
	"wtajemniczone",
	"wtapiane",
	"wtargnięte",
	"wtarte",
	"wtaszczone",
	"wtłoczone",
	"wtopione",
	"wtrącone",
	"wtryniane",
	"wtulane",
	"wtulone",
	"wtykane",
	"wwalone",
	"wwiercane",
	"wwiercone",
	"wwiezione",
	"wwożone",
	"wyartykułowane",
	"wyautowane",
	"wybaczane",
	"wybaczone",
	"wybadane",
	"wybatożone",
	"wybawione",
	"wybebeszone",
	"wybełkotane",
	"wybiczowane",
	"wybielane",
	"wybielone",
	"wybierane",
	"wybijane",
	"wybite",
	"wybłagane",
	"wyblaknięte",
	"wybrandzlowane",
	"wybrane",
	"wybronione",
	"wybrzydzane",
	"wybuchane",
	"wybuchnięte",
	"wybudowane",
	"wybudzane",
	"wybudzone",
	"wyburzane",
	"wyburzone",
	"wycackane",
	"wycałowane",
	"wyceniane",
	"wycenione",
	"wychlane",
	"wychłostane",
	"wychodowane",
	"wychowane",
	"wychowywane",
	"wychrobotane",
	"wychwalane",
	"wychwycone",
	"wychylane",
	"wychylone",
	"wyciągane",
	"wyciągnięte",
	"wyciekane",
	"wycieniowane",
	"wycierane",
	"wycięte",
	"wycinane",
	"wyciskane",
	"wyciśnięte",
	"wyciszane",
	"wyciszone",
	"wycofane",
	"wyćwiczone",
	"wycyckane",
	"wycyganione",
	"wyczarowane",
	"wyczarterowane",
	"wyczekane",
	"wyczekiwane",
	"wyczerpane",
	"wyczesane",
	"wyczołgane",
	"wyczołgiwane",
	"wyczute",
	"wyczuwane",
	"wyczyniane",
	"wyczyszczone",
	"wyczytane",
	"wyczytywane",
	"wydalane",
	"wydalone",
	"wydane",
	"wydębione",
	"wydedukowane",
	"wydelegowane",
	"wydepilowane",
	"wydeptywane",
	"wydłubane",
	"wydłubywane",
	"wydłużane",
	"wydłużone",
	"wydmuchane",
	"wydmuchiwane",
	"wydobyte",
	"wydobywane",
	"wydojone",
	"wydoroślane",
	"wydostane",
	"wydrane",
	"wydrapane",
	"wydrapywane",
	"wydrążone",
	"wydrukowane",
	"wydukane",
	"wyduszone",
	"wydychane",
	"wydziedziczone",
	"wydzielane",
	"wydzielone",
	"wydzierane",
	"wydzierżawione",
	"wydziobane",
	"wydziwiane",
	"wydzwaniane",
	"wyedukowane",
	"wyedytowane",
	"wyeeliminowane",
	"wyegzekwowane",
	"wyeksmitowane",
	"wyekspediowane",
	"wyeksploatowane",
	"wyeksponowane",
	"wyeksportowane",
	"wyeliminowane",
	"wyemigrowane",
	"wyemitowane",
	"wyewoluowane",
	"wyfrunięte",
	"wygadane",
	"wygadywane",
	"wyganiane",
	"wygarbowane",
	"wygarniane",
	"wygarnięte",
	"wygasane",
	"wygaśnięte",
	"wygaszane",
	"wygaszone",
	"wygenerowane",
	"wygięte",
	"wyginane",
	"wygładzane",
	"wygładzone",
	"wygłaszane",
	"wygłodzone",
	"wygłosowane",
	"wygłoszone",
	"wygłówkowane",
	"wygnane",
	"wygolone",
	"wygonione",
	"wygooglowane",
	"wygospodarowane",
	"wygotowane",
	"wygrane",
	"wygrawerowane",
	"wygrażane",
	"wygrywane",
	"wygryzione",
	"wygrzane",
	"wygrzebane",
	"wygrzebywane",
	"wygrzewane",
	"wygubione",
	"wyhaczone",
	"wyhaftowane",
	"wyhamowane",
	"wyhodowane",
	"wyizolowane",
	"wyjadane",
	"wyjaśniane",
	"wyjaśnione",
	"wyjawiane",
	"wyjawione",
	"wyjedzone",
	"wyjęte",
	"wyjmowane",
	"wykadrowane",
	"wykalibrowane",
	"wykalkulowane",
	"wykańczane",
	"wykantowane",
	"wykąpane",
	"wykaraskane",
	"wykarczowane",
	"wykarmiane",
	"wykasowane",
	"wykastrowane",
	"wykazane",
	"wykazywane",
	"wykierowane",
	"wykitowane",
	"wykiwane",
	"wykładane",
	"wyklarowane",
	"wyklepane",
	"wyklinane",
	"wykłócane",
	"wykluczane",
	"wykluczone",
	"wyklute",
	"wykłute",
	"wykminione",
	"wykolejone",
	"wykołowane",
	"wykombinowane",
	"wykonane",
	"wykończone",
	"wykonywane",
	"wykopane",
	"wykopnięte",
	"wykopywane",
	"wykorkowane",
	"wykorzeniane",
	"wykorzenione",
	"wykorzystane",
	"wykorzystywane",
	"wykoszone",
	"wykpite",
	"wykradane",
	"wykradnięte",
	"wykręcane",
	"wykręcone",
	"wykreowane",
	"wykreślane",
	"wykreślone",
	"wykrochmalone",
	"wykrojone",
	"wykrwawiane",
	"wykrwawione",
	"wykryte",
	"wykrywane",
	"wykrzesane",
	"wykrztuszone",
	"wykrzyczone",
	"wykrzykiwane",
	"wykrzyknięte",
	"wykrzywiane",
	"wykształcone",
	"wyksztuszone",
	"wykupione",
	"wykupywane",
	"wykute",
	"wykuwane",
	"wyłączane",
	"wyłączone",
	"wylądowane",
	"wyładowane",
	"wyładowywane",
	"wyłajane",
	"wyłamane",
	"wyłamywane",
	"wyłaniane",
	"wylansowane",
	"wylane",
	"wyłapane",
	"wyłapywane",
	"wyławiane",
	"wyleasingowane",
	"wyleczone",
	"wylęgane",
	"wylegimytowane",
	"wylewane",
	"wyłgane",
	"wylicytowane",
	"wyliczane",
	"wyliczone",
	"wylizane",
	"wylizywane",
	"wylogowane",
	"wyłonione",
	"wylosowane",
	"wyłowione",
	"wyłożone",
	"wyłudzane",
	"wyłudzone",
	"wyłupane",
	"wyłuskane",
	"wyłuskiwane",
	"wyłuszczone",
	"wyluzowane",
	"wymacane",
	"wymachiwane",
	"wymagane",
	"wymahiwane",
	"wymalowane",
	"wymamrotane",
	"wymanewrowane",
	"wymarzone",
	"wymasowane",
	"wymawiane",
	"wymazane",
	"wymazywane",
	"wymeldowane",
	"wymeldowywane",
	"wymiatane",
	"wymiecione",
	"wymieniane",
	"wymienione",
	"wymierzane",
	"wymieszane",
	"wymigane",
	"wymigiwane",
	"wymijane",
	"wyminięte",
	"wymknięte",
	"wymoczone",
	"wymodelowane",
	"wymontowane",
	"wymordowane",
	"wymsknięte",
	"wymuszane",
	"wymyślane",
	"wymyślone",
	"wymyte",
	"wynagradzane",
	"wynagrodzone",
	"wynajdowane",
	"wynajdywane",
	"wynajęte",
	"wynajmowane",
	"wynalezione",
	"wynarodowione",
	"wynegocjowane",
	"wyniesione",
	"wyniknięte",
	"wyniszczane",
	"wyniszczone",
	"wyniuchane",
	"wynoszone",
	"wynurzane",
	"wyobrażane",
	"wyobrażone",
	"wyodrębnione",
	"wyolbrzymiane",
	"wyolbrzymione",
	"wyorbowane",
	"wyosiowane",
	"wyostrzane",
	"wyostrzone",
	"wypaczane",
	"wypakowane",
	"wypakowywane",
	"wypalane",
	"wypalone",
	"wypałowane",
	"wyparowane",
	"wyparte",
	"wypasane",
	"wypastowane",
	"wypatroszone",
	"wypatrywane",
	"wypatrzone",
	"wypchane",
	"wypchnięte",
	"wypędzane",
	"wypędzlowane",
	"wypełniane",
	"wypełnione",
	"wypersfadowane",
	"wyperswadowane",
	"wypierane",
	"wypięte",
	"wypijane",
	"wypinane",
	"wypisane",
	"wypisywane",
	"wypite",
	"wypłacane",
	"wypłacone",
	"wypłakane",
	"wypłakiwane",
	"wypłaszczone",
	"wyplatane",
	"wyplątane",
	"wyplenione",
	"wyplewione",
	"wypłoszone",
	"wypłukane",
	"wypłukiwane",
	"wyplute",
	"wypluwane",
	"wypocone",
	"wypoczęte",
	"wypolerowane",
	"wypominane",
	"wypomniane",
	"wypompowane",
	"wypompowywane",
	"wyposażone",
	"wypowiadane",
	"wypowiedziane",
	"wypoziomowane",
	"wypożyczane",
	"wypracowane",
	"wypracowywane",
	"wyprane",
	"wyprasowane",
	"wypraszane",
	"wyprawiane",
	"wyprawione",
	"wypróbowane",
	"wyprodukowane",
	"wyprojektowane",
	"wypromieniowane",
	"wypromowane",
	"wyprostowane",
	"wyprostowywane",
	"wyproszone",
	"wyprowadzane",
	"wyprowadzone",
	"wypróżniane",
	"wypróżnione",
	"wyprute",
	"wypruwane",
	"wyprzedane",
	"wyprzedawane",
	"wyprzedzane",
	"wyprzedzone",
	"wyprzęgane",
	"wypstrykane",
	"wypucowane",
	"wypuszczane",
	"wypuszczone",
	"wypychane",
	"wypytane",
	"wypytywane",
	"wyrąbane",
	"wyrabiane",
	"wyrąbywane",
	"wyratowane",
	"wyrażane",
	"wyrażone",
	"wyrecytowane",
	"wyręczane",
	"wyręczone",
	"wyregulowane",
	"wyrejestrowane",
	"wyremontowane",
	"wyreżyserowane",
	"wyrobione",
	"wyrolowane",
	"wyrośnięte",
	"wyrównane",
	"wyrównywane",
	"wyróżniane",
	"wyróżnione",
	"wyrugowane",
	"wyruszane",
	"wyrwane",
	"wyrypane",
	"wyrysowane",
	"wyryte",
	"wyrywane",
	"wyrządzone",
	"wyrzeźbione",
	"wyrżnięte",
	"wyrzucane",
	"wyrzucone",
	"wyrzygane",
	"wyrzynane",
	"wyrzywane",
	"wysączone",
	"wysadzane",
	"wysadzone",
	"wyschnięte",
	"wyściskane",
	"wyselekcjonowane",
	"wysępione",
	"wysiadywane",
	"wysiedzone",
	"wysilane",
	"wysilone",
	"wyskakiwane",
	"wyskalowane",
	"wyskoczone",
	"wyskrobane",
	"wyskubywane",
	"wysłane",
	"wyśledzone",
	"wyślizgiwane",
	"wyślizgnięte",
	"wysłowione",
	"wysłuchane",
	"wysłuchiwane",
	"wysmagane",
	"wysmarkane",
	"wysmarowane",
	"wysmażane",
	"wysmażone",
	"wyśmiane",
	"wyśmiewane",
	"wysmołowane",
	"wysmyrane",
	"wyśnione",
	"wysnute",
	"wysnuwane",
	"wysondowane",
	"wyspecjalizowane",
	"wyśpiewane",
	"wyśpiewywane",
	"wyspowiadane",
	"wysprzątane",
	"wysprzedane",
	"wyssane",
	"wystartowane",
	"wystawione",
	"wysterelizowane",
	"wysterylizowane",
	"wystosowane",
	"wystosowywane",
	"wystraszone",
	"wystrojone",
	"wystrugane",
	"wystrychnięte",
	"wystrzegane",
	"wystrzelane",
	"wystrzeliwane",
	"wystrzelone",
	"wystudzone",
	"wystukane",
	"wystukiwane",
	"wystygnięte",
	"wysunięte",
	"wysuszane",
	"wysuwane",
	"wyswatane",
	"wyświadczane",
	"wyświadczone",
	"wyświetlane",
	"wyświetlone",
	"wyswobodzone",
	"wysyłane",
	"wysypane",
	"wysypywane",
	"wysysane",
	"wyszabrowane",
	"wyszalane",
	"wyszarpane",
	"wyszarpnięte",
	"wyszasowane",
	"wyszczotkowane",
	"wyszczuplone",
	"wyszeptane",
	"wyszkolone",
	"wyszlifowane",
	"wyszorowane",
	"wyszperane",
	"wyszukane",
	"wyszukiwane",
	"wyszumione",
	"wyszykowane",
	"wyszyte",
	"wytapetowane",
	"wytargane",
	"wytargowane",
	"wytarte",
	"wytarzane",
	"wytaszczone",
	"wytatuowane",
	"wytchnięte",
	"wytępione",
	"wytknięte",
	"wytłoczone",
	"wytłumaczone",
	"wytłumione",
	"wytoczone",
	"wytrąbione",
	"wytrącane",
	"wytrącone",
	"wytransmitowane",
	"wytransportowane",
	"wytrenowane",
	"wytresowane",
	"wytriangulowane",
	"wytropione",
	"wytrute",
	"wytrząsane",
	"wytrzasnięte",
	"wytrząśnięte",
	"wytrzebione",
	"wytrzepane",
	"wytrzeszczane",
	"wytrzeźwiane",
	"wytrzymane",
	"wytrzymywane",
	"wytwarzane",
	"wytworzone",
	"wytyczone",
	"wytykane",
	"wytypowane",
	"wyuczone",
	"wywabiane",
	"wywabione",
	"wywąchane",
	"wywalane",
	"wywalczone",
	"wywalone",
	"wywarte",
	"wywarzane",
	"wyważane",
	"wyważone",
	"wywęszane",
	"wywężykowane",
	"wywiane",
	"wywiązane",
	"wywiązywane",
	"wywierane",
	"wywiercone",
	"wywieszane",
	"wywieszone",
	"wywietrzone",
	"wywiezione",
	"wywijane",
	"wywindowane",
	"wywinięte",
	"wywłaszczone",
	"wywlekane",
	"wywnętrznione",
	"wywnioskowane",
	"wywodzone",
	"wywolane",
	"wywoływane",
	"wywoskowane",
	"wywożone",
	"wywracane",
	"wywrócone",
	"wywróżone",
	"wywyższane",
	"wyżalone",
	"wyzbyte",
	"wyzdrowione",
	"wyżebrane",
	"wyżerane",
	"wyzerowane",
	"wyzionięte",
	"wyznaczane",
	"wyznaczone",
	"wyznane",
	"wyznawane",
	"wyzwalane",
	"wyzwane",
	"wyzwolone",
	"wyzygzakowane",
	"wyżynane",
	"wyzyskane",
	"wyzyskiwane",
	"wyżyte",
	"wyzywane",
	"wyżywane",
	"wyżywione",
	"wzbijane",
	"wzbite",
	"wzbogacane",
	"wzbogacone",
	"wzbraniane",
	"wzbudzane",
	"wzbudzone",
	"wzburzane",
	"wzburzone",
	"wżenione",
	"wzięte",
	"wzmacnione",
	"wzmagane",
	"wzmocnione",
	"wznawiane",
	"wzniecane",
	"wzniecione",
	"wzniesięte",
	"wznoszone",
	"wznowione",
	"wzorowane",
	"wzrośnięte",
	"wzruszone",
	"wzwyżane",
	"wzywane",
	"zaabordowane",
	"zaadaptowane",
	"zaadoptowane",
	"zaadresowane",
	"zaakcentowane",
	"zaakceptowane",
	"zaaklimatyzowane",
	"zaalarmowane",
	"zaanektowane",
	"zaangażowane",
	"zaanonsowane",
	"zaapelowane",
	"zaaplikowane",
	"zaaportowane",
	"zaaprobowane",
	"zaaranżowane",
	"zaaresztowane",
	"zaatakowane",
	"zabaczone",
	"zabalowane",
	"zabandażowane",
	"zabarwione",
	"zabarykadowane",
	"zabawiane",
	"zabawione",
	"zabepieczane",
	"zabetonowane",
	"zabezpieczone",
	"zabierane",
	"zabite",
	"zabłądzone",
	"zablefowane",
	"zabłocone",
	"zablokowane",
	"zabraniane",
	"zabrane",
	"zabrnięte",
	"zabronione",
	"zabrudzone",
	"zabudowane",
	"zabukowane",
	"zabulone",
	"zaburzone",
	"zabutelkowane",
	"zacementowane",
	"zacerowane",
	"zachciane",
	"zachęcane",
	"zachęcone",
	"zachlapane",
	"zachodzone",
	"zachomikowane",
	"zachorowane",
	"zachowane",
	"zachowywane",
	"zachwalane",
	"zachwalone",
	"zachwiane",
	"zachwycone",
	"zaciągane",
	"zaciągnięte",
	"zaciążone",
	"zaciekawione",
	"zaciemniane",
	"zaciemnione",
	"zacierane",
	"zacieśnione",
	"zacięte",
	"zacinane",
	"zaciskane",
	"zaciśnięte",
	"zaćmione",
	"zacumowane",
	"zacytowane",
	"zaczadzone",
	"zaczarowane",
	"Zaczepiane",
	"zaczepione",
	"zaczerpane",
	"zaczesane",
	"zaczęte",
	"zaczołgane",
	"zaczynane",
	"zadarte",
	"zadawalane",
	"zadawane",
	"zadbane",
	"zadebiutowane",
	"zadedykowane",
	"zadeklamowane",
	"zadeklarowane",
	"zademonstrowane",
	"zadenucjowane",
	"zadepeszowane",
	"zadeptane",
	"zadeptywane",
	"zadęte",
	"zadławione",
	"żądlone",
	"zadłużane",
	"zadłużone",
	"zadokowane",
	"zadomowione",
	"zadowalane",
	"zadrapane",
	"zadraśnięte",
	"zadręczane",
	"zadręczone",
	"zadrutowane",
	"zadurzane",
	"zadurzone",
	"zaduszone",
	"zadymione",
	"zadźgane",
	"zadziobane",
	"zadziwiane",
	"zadziwione",
	"zafakturowane",
	"zafałszowane",
	"zafarbowane",
	"zafiksowane",
	"zafundowane",
	"zagadane",
	"zagadnięte",
	"zagadywane",
	"zagajone",
	"zaganiane",
	"zagapione",
	"zagarażowane",
	"zagarniane",
	"zagarnięte",
	"zagaszone",
	"zagazowane",
	"zagęszczone",
	"zagięte",
	"zaginane",
	"zaginięte",
	"zagłębiane",
	"zagłębione",
	"zagłodzone",
	"zagłuszane",
	"zagłuszone",
	"zagmatwane",
	"zagnane",
	"zagnieżdżone",
	"zagojone",
	"zagonione",
	"zagospodarowane",
	"zagotowane",
	"zagrabione",
	"zagradzane",
	"zagrażane",
	"zagrodzone",
	"zagrywane",
	"zagryzane",
	"zagryzione",
	"zagrzane",
	"zagrzebane",
	"zagrzewane",
	"zagubione",
	"zagwarantowane",
	"zahaczone",
	"zahamowane",
	"zahandlowane",
	"zaharowane",
	"zahartowane",
	"zahipnotyzowane",
	"zaholowane",
	"zaimitowane",
	"zaimplantowane",
	"zaimplementowane",
	"zaimprowizowane",
	"zainaugurowane",
	"zainfekowane",
	"zainicjowane",
	"zainkasowane",
	"zainscenizowane",
	"zainspirowane",
	"zainstalowane",
	"zainteresowane",
	"zaintrygowane",
	"zaintubowane",
	"zainwestowane",
	"zaizolowane",
	"zajadane",
	"zajane",
	"zajarane",
	"zajechane",
	"zajęte",
	"zajmowane",
	"zakablowane",
	"zakamuflowane",
	"zakasane",
	"zakasowane",
	"zakąszane",
	"zakatalogowane",
	"zakatowane",
	"zakatrupione",
	"zakazane",
	"zakażane",
	"zakazywane",
	"zakiszone",
	"zakładane",
	"zaklasyfikowane",
	"zaklejane",
	"zaklejone",
	"zaklepane",
	"zaklepywane",
	"zaklinane",
	"zaklinowane",
	"zakłócane",
	"zakłócone",
	"zaklopotane",
	"zakłute",
	"zakneblowane",
	"zakodowane",
	"zakolczykowane",
	"zakolorowane",
	"zakołysane",
	"zakomunikowane",
	"zakończone",
	"zakonserwowane",
	"zakopane",
	"zakopywane",
	"zakorzeniane",
	"zakorzenione",
	"zakoszone",
	"zakosztowane",
	"zakotwiczane",
	"zakotwiczone",
	"zakpione",
	"zakradane",
	"zakręcane",
	"zakręcone",
	"zakreślane",
	"zakreślone",
	"zakrwawione",
	"zakryte",
	"zakrywane",
	"zakrzyczane",
	"zakrzyknięte",
	"zakrzywiane",
	"zakrzywione",
	"zaksięgowane",
	"zaktualizowane",
	"zaktywizowane",
	"zaktywowane",
	"zakumane",
	"zakupione",
	"zakurzone",
	"zakute",
	"zakuwane",
	"zakwaterowane",
	"zakwestionowae",
	"zakwitnięte",
	"załączone",
	"załadowane",
	"załagodzone",
	"zalamane",
	"zalaminowane",
	"załamywane",
	"zalane",
	"załapane",
	"załatane",
	"załatwiane",
	"załatwione",
	"zalatywane",
	"zalecane",
	"zalecone",
	"zaleczone",
	"zalegalizowane",
	"zalegane",
	"zalepiane",
	"zalepione",
	"zalewane",
	"zaliczane",
	"zaliczone",
	"załkane",
	"zalogowane",
	"żałowane",
	"założone",
	"zaludnione",
	"zamacane",
	"zamachnięte",
	"zamącone",
	"zamalowane",
	"zamanewrowane",
	"zamanifestowane",
	"zamarkowane",
	"zamartwiane",
	"zamarynowane",
	"zamarzane",
	"zamarznięte",
	"zamaskowane",
	"zamawiane",
	"zamazane",
	"zamazywane",
	"zamęczane",
	"zamęczone",
	"zameldowane",
	"zamelinowane",
	"zamerykanizowane",
	"zamiatane",
	"zamieniane",
	"zamienione",
	"zamieszane",
	"zamieszczane",
	"zamieszczone",
	"zamieszkane",
	"zamieszkiwane",
	"zaminowane",
	"zamknięte",
	"zamocowane",
	"zamoczone",
	"zamontowane",
	"zamordowane",
	"zamortyzowane",
	"zamotane",
	"zamówione",
	"zamrażane",
	"zamroczone",
	"zamrożone",
	"zamulane",
	"zamurowane",
	"zamydlone",
	"zamykane",
	"zanalizowane",
	"zanegowane",
	"zaniechane",
	"zanieczyszczane",
	"zanieczyszczone",
	"zaniedbane",
	"zaniedbywane",
	"zaniepokojone",
	"zaniesione",
	"zanihilowane",
	"zanikane",
	"zaniknięte",
	"zaniżane",
	"zaniżone",
	"zanoszone",
	"zanotowane",
	"zanucone",
	"zanudzane",
	"zanudzone",
	"zanurzane",
	"zanurzone",
	"zanużone",
	"zaobaczone",
	"zaobserwowane",
	"zaoferowane",
	"zaofiarowane",
	"zaogniane",
	"zaognione",
	"zaokrąglane",
	"zaokrąglone",
	"zaokrętowane",
	"zaopatrywane",
	"zaopatrzone",
	"zaopiekowane",
	"zaorane",
	"zaostrzane",
	"zaostrzone",
	"zaoszczędzone",
	"zapadane",
	"zapakowane",
	"zapalane",
	"zapalone",
	"zapamiętane",
	"zapamiętywane",
	"zapanowane",
	"zaparkowane",
	"zaparowywane",
	"zaparzane",
	"zaparzone",
	"zapaskudzone",
	"zapauzowane",
	"zapchane",
	"zapędzane",
	"zapełniane",
	"zapełnione",
	"zaperfumowane",
	"zapeszane",
	"zapewniane",
	"zapewnione",
	"zapieczętowane",
	"zapierane",
	"zapięte",
	"zapijane",
	"zapinane",
	"zapisane",
	"zapisuwane",
	"zapite",
	"zapłacone",
	"zapładniane",
	"zaplamione",
	"zaplanowane",
	"zaplątane",
	"zapłodnione",
	"zaplombowane",
	"zapobiegane",
	"zapodane",
	"zapodawane",
	"zapodziane",
	"zapokojone",
	"zapolowane",
	"zapominane",
	"zapomniane",
	"zapowiadane",
	"zapowiedziane",
	"zapoznane",
	"zapoznawane",
	"zapożyczone",
	"zapracowywane",
	"zaprane",
	"zaprasowywane",
	"zapraszane",
	"zaprawione",
	"zaprenumerowane",
	"zaprezentowane",
	"Zaprogramowane",
	"zaprojektowane",
	"zaproponowane",
	"zaproszone",
	"zaprotokołowane",
	"zaprowadzane",
	"zaprowadzone",
	"zaprzątane",
	"zaprzeczane",
	"zaprzeczone",
	"zaprzedane",
	"zaprzedawane",
	"zaprzęgane",
	"zaprzepaszczane",
	"zaprzestane",
	"zaprzestawane",
	"zaprzyjaźnione",
	"zapudłowane",
	"zapunktowane",
	"zapuszczane",
	"zapuszczone",
	"zapuszkowane",
	"zapychane",
	"zapylane",
	"zapylone",
	"zapytane",
	"zarabiane",
	"zaranżowane",
	"zarażane",
	"zarażone",
	"zarecytowane",
	"zaręczane",
	"zaręczone",
	"zarejestrowane",
	"zareklamowane",
	"zarekomendowane",
	"zarekomondowane",
	"zarekwirowane",
	"zarezerwowane",
	"zarobione",
	"żartowane",
	"zarwane",
	"zaryglowane",
	"zarymowane",
	"zarysowane",
	"zarywane",
	"zaryzykowane",
	"zarządzane",
	"zarżnięte",
	"zarzucane",
	"zarzynane",
	"zasadzone",
	"zaścielone",
	"zasegurowane",
	"zaserwowane",
	"zasiadane",
	"zasiane",
	"zasiedlone",
	"zasięgane",
	"zasięgnięte",
	"zasiewane",
	"zasilane",
	"zasilone",
	"zaskakiwane",
	"zaskarbione",
	"zaskoczone",
	"zaskrobane",
	"zasłaniane",
	"zaślepiane",
	"zaślepione",
	"zasłodzone",
	"zasłonione",
	"zasłużone",
	"zasmakowane",
	"zaśmiecane",
	"zaśmiecone",
	"zasmradzane",
	"zasmrodzone",
	"zasmucane",
	"zasmucone",
	"zasolone",
	"zaspakajane",
	"zaśpiewane",
	"zaspokajane",
	"zaspokojone",
	"zasponsorowane",
	"zaśrubowywane",
	"zassane",
	"zastane",
	"zastąpione",
	"zastawiane",
	"zastawione",
	"zastępowane",
	"zastopowane",
	"zastosowane",
	"zastraszane",
	"zastraszone",
	"zastrzelone",
	"zasugerowane",
	"zasunięte",
	"zasuwane",
	"zaświadczone",
	"zaświecone",
	"zaświonione",
	"zasyfione",
	"zasygnalizowane",
	"zasymilowane",
	"zasymulowane",
	"zasypane",
	"zasypywane",
	"zasysane",
	"zaszachowane",
	"zaszantażowane",
	"zaszargane",
	"zaszczepiane",
	"zaszczepione",
	"zaszczute",
	"zaszczycane",
	"zaszczycone",
	"zaszeptane",
	"zaszeregowane",
	"zaszlachtowane",
	"zasznurowane",
	"zaszpachlowane",
	"zasztyletowane",
	"zaszufladkowane",
	"zaszyfrowane",
	"zaszyte",
	"zaszywane",
	"zataczane",
	"zatajane",
	"zatajone",
	"zatamowane",
	"zatankowane",
	"zatapiane",
	"zatargane",
	"zatarte",
	"zatelegrafowane",
	"zatemperowane",
	"zatęsknione",
	"zatkane",
	"zatknięte",
	"zatoczone",
	"zatonięte",
	"zatopione",
	"zatracane",
	"zatracone",
	"zatriumfowane",
	"zatrudniane",
	"zatrudnione",
	"zatrute",
	"zatruwane",
	"zatrzaskiwane",
	"zatrzaśnięte",
	"zatrząśnięte",
	"zatrzymane",
	"zatrzymywane",
	"zatuszowane",
	"zatwierdzane",
	"zatwierdzone",
	"zatykane",
	"zatynkowane",
	"zatytułowane",
	"zauploadowane",
	"zauroczone",
	"zautomatyzowane",
	"zauważane",
	"zauważone",
	"zawadzane",
	"zawalane",
	"zawalczone",
	"zawalone",
	"zawarte",
	"zaważone",
	"zawdzięczane",
	"zawetowane",
	"zawężone",
	"zawiadamiane",
	"zawiadomione",
	"zawiązane",
	"zawiązywane",
	"zawiedzone",
	"zawierane",
	"zawierzone",
	"zawieszane",
	"zawieszone",
	"zawiezione",
	"zawijane",
	"zawinięte",
	"zawinione",
	"zawiśnięte",
	"zawitane",
	"zawładnięte",
	"zawłaszczone",
	"zawodzone",
	"zawojowane",
	"zawołane",
	"zawoskowane",
	"zawożone",
	"zawracane",
	"zawrócone",
	"zawstydzane",
	"zażądane",
	"zażartowane",
	"zazdroszczone",
	"zażegnane",
	"zażenowane",
	"zaznaczane",
	"zaznajomione",
	"zaznane",
	"zaznawane",
	"zażyczone",
	"zażyte",
	"zażywane",
	"zbaczane",
	"zbadane",
	"zbagatelizowane",
	"zbajerowane",
	"zbałamucone",
	"zbalansowane",
	"zbalsamowane",
	"zbankrutowane",
	"zbawiane",
	"zbawione",
	"zbesztane",
	"zbezczeszczone",
	"zbierane",
	"zbijane",
	"zbite",
	"zbliżone",
	"zbluzgane",
	"zbojkotowane",
	"zbrojone",
	"zbrukane",
	"zbszczecone",
	"zbudowane",
	"zbudzone",
	"zbuntowane",
	"zburzone",
	"zbyte",
	"zbywane",
	"zchwytane",
	"zcięte",
	"zciszone",
	"zdane",
	"zdarte",
	"zdeaktywowane",
	"zdecydowane",
	"zdefiniowane",
	"zdeflorowane",
	"zdegradowane",
	"zdejmowane",
	"zdeklarowane",
	"zdekodowane",
	"zdekompresowane",
	"zdekoncentrowane",
	"zdekonstruowane",
	"zdelegalizowane",
	"zdemaskowane",
	"zdementowane",
	"zdemolowane",
	"zdemontowane",
	"zdemoralizowane",
	"zdenerwowane",
	"zdeponowane",
	"zdeprymowane",
	"zdeptane",
	"zderzane",
	"zderzone",
	"zdestabilizowane",
	"Zdetonowane",
	"zdetronizowane",
	"zdewastowane",
	"zdewaulowane",
	"zdezerterowane",
	"zdezintegrowane",
	"zdezorientowane",
	"zdezynfektowane",
	"zdiagnozowane",
	"zdjęte",
	"zdławione",
	"zdmuchiwane",
	"zdmuchnięte",
	"zdobyte",
	"zdobywane",
	"zdołowane",
	"zdominowane",
	"zdopingowane",
	"zdrabniane",
	"zdradzane",
	"zdradzone",
	"zdrapane",
	"zdrapywane",
	"zdrutowane",
	"zdruzgotane",
	"zduplikowane",
	"zduszone",
	"zdwojone",
	"zdyscyplinowane",
	"zdyskredytowane",
	"zdyskwalifikowane",
	"zdystansowane",
	"zdzielone",
	"zdzierane",
	"zdzierżone",
	"zdziesiątkowane",
	"Zdzwonione",
	"zebrane",
	"zechciane",
	"zedytowane",
	"żegnane",
	"żenione",
	"zepchnięte",
	"zepsute",
	"żerowane",
	"zerwane",
	"zerżnięte",
	"zeskakiwane",
	"zeskanowane",
	"zeskrobywane",
	"zesłane",
	"ześlizgiwane",
	"ześlizgnięte",
	"zesmolone",
	"zespawiane",
	"zespolone",
	"zessane",
	"zestawiane",
	"zestawione",
	"zestresowane",
	"zestrzeliwane",
	"zestrzelone",
	"zeswatane",
	"zeszklone",
	"zeszlifowane",
	"zetknięte",
	"zezłoszczone",
	"zeznane",
	"zeznawane",
	"zezwalane",
	"zezwolone",
	"zfinansowane",
	"zgadane",
	"zgadywane",
	"zgajane",
	"zganione",
	"zgarnięte",
	"zgaśnięte",
	"zgaszone",
	"zgięte",
	"zginane",
	"zgładzone",
	"zgłaszane",
	"zgłębiane",
	"zgłębione",
	"zgłośnione",
	"zgłoszone",
	"zgłuszone",
	"zgniatane",
	"zgniecione",
	"zgnite",
	"zgnojone",
	"zgodzone",
	"zgolone",
	"zgonione",
	"zgotowane",
	"zgrabione",
	"zgrillowane",
	"zgromadzane",
	"zgromadzone",
	"zgrupowane",
	"zgrzeszone",
	"zgrzytane",
	"zgubione",
	"zgwałcone",
	"zhackowane",
	"zhakowane",
	"zhańbione",
	"zhandlowane",
	"zharmonizowane",
	"zidentyfikowane",
	"ziewane",
	"zignorowane",
	"zilustrowane",
	"zinfiltrowane",
	"zintegrowane",
	"zintensyfikowane",
	"zinterpretowane",
	"zinwentaryzowane",
	"zirytowane",
	"zjadane",
	"zjawiane",
	"zjednane",
	"zjednoczone",
	"zjedzone",
	"zjeżdżone",
	"zkontaktowane",
	"zkserowane",
	"złączone",
	"złagodzone",
	"złajane",
	"złamane",
	"zlane",
	"złapane",
	"zlecane",
	"zlecone",
	"zlekceważone",
	"zlepiane",
	"zlepione",
	"zlewane",
	"zlicytowane",
	"zliczane",
	"zliczone",
	"zlikwidowane",
	"zlinczowane",
	"zlitowane",
	"zlizane",
	"zlizywane",
	"złoite",
	"zlokalizowane",
	"złomowane",
	"żłopane",
	"złowione",
	"złożone",
	"złupione",
	"złuszczane",
	"zluzowane",
	"zmacane",
	"zmącone",
	"zmagane",
	"zmagazynowane",
	"zmajstrowane",
	"zmaksylizowane",
	"zmanipulowane",
	"zmarnowane",
	"zmartwychwstane",
	"zmarznięte",
	"zmasakrowane",
	"zmaterializowane",
	"zmawiane",
	"zmazane",
	"zmazywane",
	"zmbobardowane",
	"zmiatane",
	"zmiażdżone",
	"zmiękczone",
	"zmielone",
	"zmieniane",
	"zmienione",
	"zmierzane",
	"zmierzone",
	"zmierzwione",
	"zmieszane",
	"zmieszczone",
	"zmiksowane",
	"zminiaturyzowane",
	"zminimalizowane",
	"zmniejszane",
	"zmniejszone",
	"zmobilizowane",
	"zmoczone",
	"zmodernizowane",
	"zmodyfikowane",
	"zmoknięte",
	"zmonopolizowane",
	"zmontowane",
	"zmostkowane",
	"zmotywowane",
	"zmówione",
	"zmrożone",
	"zmrużone",
	"zmumifikowane",
	"zmuszane",
	"zmuszone",
	"zmutowane",
	"zmyślane",
	"zmyte",
	"zmywane",
	"znacjonalizowane",
	"znajdowane",
	"znajdywane",
	"znakowane",
	"znalezione",
	"znane",
	"znęcane",
	"zneutralizowane",
	"zniechęcone",
	"znieczulone",
	"zniekształcane",
	"zniekształcone",
	"znienawidzone",
	"znieprawione",
	"zniesione",
	"zniesławiane",
	"zniesławione",
	"zniewalane",
	"znieważane",
	"znieważone",
	"zniewolone",
	"zniszczone",
	"zniweczone",
	"zniwelowane",
	"zniżane",
	"zniżone",
	"znokautowane",
	"znormalnione",
	"znoszone",
	"znudzone",
	"zobaczone",
	"zobowiązane",
	"zobrazowane",
	"zogniskowane",
	"żonglowane",
	"zoomowane",
	"zoperowane",
	"zoptymalizowane",
	"zorbite",
	"zorganizowane",
	"zorientowane",
	"zostawiane",
	"zostawione",
	"zpłacone",
	"zprowokowane",
	"zrabowane",
	"zrachowane",
	"zracjonalizowane",
	"zranione",
	"zraportowane",
	"zrażane",
	"zrażone",
	"zrealizowane",
	"zrecenzowane",
	"zredagowane",
	"zredukowane",
	"zreferowane",
	"zreformowane",
	"zrefowane",
	"zrefundowane",
	"zregenerowane",
	"zrehabilitowane",
	"zreinkarnowane",
	"zreintegrowane",
	"zrekonfigurowane",
	"zrekonstruowane",
	"zrekrutowane",
	"zrekrystalizowane",
	"zrelacjonowane",
	"zrelaksowane",
	"zremiksowane",
	"zremisowane",
	"zreorganizowane",
	"zreperowane",
	"zreplikowane",
	"zresetowane",
	"zresocjalizowane",
	"zrestartowane",
	"zrestrukturyzowane",
	"zrewanżowane",
	"zrewidowane",
	"zrewolucjonizowane",
	"zrezygnowane",
	"zrobione",
	"zrolowane",
	"zroszone",
	"zrównane",
	"zrównoważone",
	"zrównywane",
	"zróżnicowane",
	"zrozumiane",
	"zrugane",
	"zruinowane",
	"zrujnowane",
	"zrymowane",
	"zrywane",
	"zrzędzone",
	"zrzeszone",
	"zrzucane",
	"zrzucone",
	"zsumowane",
	"zsunięte",
	"zsuwane",
	"zsynchronizowane",
	"zsyntetyzowane",
	"zsypywane",
	"zszargane",
	"zszokowane",
	"zszyte",
	"zszywane",
	"ztarte",
	"żute",
	"zutylizowane",
	"zużyte",
	"zużywane",
	"zwabiane",
	"zwabione",
	"zwalane",
	"zwalczone",
	"zwalniane",
	"zwalone",
	"zwane",
	"zwaporyzowane",
	"zwątpione",
	"zważane",
	"zważone",
	"zwędzone",
	"zwerbalizowane",
	"zwerbowane",
	"zweryfikowane",
	"zwęszone",
	"zwężone",
	"zwiastowane",
	"związane",
	"związywane",
	"zwichnięte",
	"zwiedzane",
	"zwiedzone",
	"zwiększone",
	"zwieńczone",
	"zwierzane",
	"zwieszane",
	"zwieszone",
	"zwietrzone",
	"zwijane",
	"zwilżone",
	"zwinięte",
	"zwizualizowane",
	"zwlekane",
	"zwodowane",
	"zwodzone",
	"zwołane",
	"zwolnione",
	"zwoływane",
	"zwożone",
	"zwracane",
	"zwrócone",
	"zwyciężane",
	"zwymiotowane",
	"życzone",
	"żygane",
	"zygzakowane",
	"zyskane",
	"zyskiwane",
	"żyte",
	"zżarte",
	"zżerane",
	"zżynane",
	"zżyte",
	"bici",
	"brnięci",
	"capnięci",
	"chlapnięci",
	"chuci",
	"ciachnięci",
	"ciągnięci",
	"cięci",
	"ciśnięci",
	"cmoknięci",
	"cofnięci",
	"czuci",
	"czyci",
	"darci",
	"dmuchnięci",
	"dobici",
	"dobyci",
	"dociągnięci",
	"docięci",
	"dociśnięci",
	"doglądnięci",
	"domknięci",
	"domyci",
	"dopadnięci",
	"dopchnięci",
	"dopięci",
	"dopici",
	"dopłynięci",
	"doścignięci",
	"dosięgnięci",
	"dosunięci",
	"doszyci",
	"dotknięci",
	"dożyci",
	"drapnięci",
	"draśnięci",
	"drgnięci",
	"dźgnięci",
	"dziabnięci",
	"dźwignięci",
	"gięci",
	"gnici",
	"golnięci",
	"gruchnięci",
	"gwizdnięci",
	"hajtnięci",
	"huknięci",
	"kantowanci",
	"kiwnięci",
	"klapnięci",
	"klepnięci",
	"kliknięci",
	"kłuci",
	"knuci",
	"kojfnięci",
	"kopnięci",
	"kpici",
	"kryci",
	"krzepnięci",
	"krzyknięci",
	"kuci",
	"liznięci",
	"łyknięci",
	"machnięci",
	"marznięci",
	"maznięci",
	"minięci",
	"myci",
	"nabici",
	"nabyci",
	"naciągnięci",
	"nacięci",
	"naciśnięci",
	"nadciągnięci",
	"nadcięci",
	"nadszarpnięci",
	"nadużyci",
	"nagięci",
	"najęci",
	"nakłuci",
	"nakryci",
	"napadnięci",
	"napięci",
	"napluci",
	"napoczęci",
	"napsuci",
	"nasunięci",
	"naszyci",
	"natarci",
	"natchnięci",
	"natknięci",
	"natrząsnięci",
	"nawinięci",
	"obciągnięci",
	"obcięci",
	"obdarci",
	"obici",
	"objęci",
	"obmyci",
	"obsunięci",
	"obtarci",
	"obwinięci",
	"obyci",
	"ochłonięci",
	"ocknięci",
	"ocuci",
	"odarci",
	"odbici",
	"odbyci",
	"odciągnięci",
	"odcięci",
	"odcisnięci",
	"odczuci",
	"odepchnięci",
	"odetnięci",
	"odgadnięci",
	"odgarnięci",
	"odgięci",
	"odjęci",
	"odkryci",
	"odkuci",
	"odparci",
	"odpięci",
	"odpłynięci",
	"odpruci",
	"odrośnięci",
	"odsłonięci",
	"odsunięci",
	"odtruci",
	"odwinięci",
	"odżyci",
	"ogarnięci",
	"okryci",
	"okrzyknięci",
	"olśnięci",
	"ominięci",
	"opadnięci",
	"oparci",
	"opchnięci",
	"opici",
	"opluci",
	"orżnięci",
	"osiągnięci",
	"oślepnięci",
	"ostrzelici",
	"osunięci",
	"otarci",
	"otruci",
	"otrząśnięci",
	"owinięci",
	"ożyci",
	"pacnąci",
	"palnięci",
	"parci",
	"pchnięci",
	"pęknięci",
	"pięci",
	"pici",
	"pluci",
	"pobici",
	"pochłonięci",
	"pociągnięci",
	"pocięci",
	"poczęci",
	"poczuci",
	"podarci",
	"podbici",
	"podciągnięci",
	"podcięci",
	"podjęci",
	"podkradnięci",
	"podkuci",
	"podmyci",
	"podnajęci",
	"podpadnięci",
	"podparci",
	"podpięci",
	"podpłynięci",
	"podsunięci",
	"podszyci",
	"podtarci",
	"podwinięci",
	"podźwignięci",
	"pojęci",
	"pojmięci",
	"pokłuci",
	"pokryci",
	"połknięci",
	"pominięci",
	"pomknięci",
	"poparci",
	"popchnięci",
	"popici",
	"popsuci",
	"posunięci",
	"poszczuci",
	"potarci",
	"potknięci",
	"potruci",
	"potrząsnięci",
	"potrząśnięci",
	"powici",
	"powściągnięci",
	"powzięci",
	"pożarci",
	"pozbyci",
	"pożuci",
	"pożyci",
	"pruci",
	"pryśnięci",
	"przebiegnięci",
	"przebici",
	"przebyci",
	"przeciągnięci",
	"przecięci",
	"przeciśnięci",
	"przeczuci",
	"przedarci",
	"przedsiewzięci",
	"przegięci",
	"przeglądnięci",
	"przejęci",
	"przeklęci",
	"przeklnięci",
	"przekłuci",
	"przekuci",
	"przełknięci",
	"przełyknięci",
	"przeminięci",
	"przemknięci",
	"przemyci",
	"przeniknięci",
	"przepchnięci",
	"przepici",
	"przepłynięci",
	"przerośnięci",
	"prześcignięci",
	"prześlizgnięci",
	"przesłonięci",
	"przesunięci",
	"przeszyci",
	"przetarci",
	"przetrząśnięci",
	"przewinięci",
	"przeżarci",
	"przeżuci",
	"przeżyci",
	"przybici",
	"przyciągnięci",
	"przycięci",
	"przyciśnięci",
	"przydepnięci",
	"przygarnięci",
	"przyjęci",
	"przykryci",
	"przykuci",
	"przymknięci",
	"przypadnięci",
	"przyparci",
	"przypięci",
	"przypłynięci",
	"przysiągnięci",
	"przysunięci",
	"przyszyci",
	"przytarci",
	"przytrzasnięci",
	"przywarci",
	"pstryknięci",
	"psuci",
	"puchnięci",
	"puknięci",
	"rozbici",
	"rozbłyśnięci",
	"rozciągnięci",
	"rozcięci",
	"rozgarnięci",
	"rozgięci",
	"rozkuci",
	"rozkwitnięci",
	"rozminięci",
	"rozmyci",
	"rozpięci",
	"rozpłynięci",
	"rozpoczęci",
	"rozpruci",
	"rozrośnięci",
	"rozstrzygnięci",
	"rozsunięci",
	"roztarci",
	"rozwarci",
	"rozwinięci",
	"runięci",
	"ryci",
	"rżnięci",
	"ściągnięci",
	"ścięci",
	"ściśnięci",
	"skrobnięci",
	"skryci",
	"skrzepnięci",
	"skrzyci",
	"skubnięci",
	"skuci",
	"smuci",
	"snuci",
	"spięci",
	"spici",
	"spłonięci",
	"spoczęci",
	"spożyci",
	"sprzątnięci",
	"stnięci",
	"struci",
	"strząśnięci",
	"strzepnięci",
	"stuknięci",
	"sunięci",
	"sypnięci",
	"szarpnięci",
	"szczuci",
	"szepnięci",
	"sztachnięci",
	"szturchnięci",
	"szyci",
	"targnięci",
	"tarci",
	"tchnięci",
	"tknięci",
	"truci",
	"tryśnięci",
	"trzasnięci",
	"trzepnięci",
	"ubici",
	"uciągnięci",
	"ucięci",
	"uciśnięci",
	"uczuci",
	"udźwignięci",
	"ugięci",
	"ugrzęznięci",
	"uiścici",
	"ujęci",
	"ukłuci",
	"uknuci",
	"ukryci",
	"ukuci",
	"umknięci",
	"umyci",
	"uniknięci",
	"uparci",
	"upchnięci",
	"upięci",
	"upici",
	"upłynięci",
	"uprzątnięci",
	"urośnięci",
	"urżnięci",
	"uschnięci",
	"uściśnięci",
	"usunięci",
	"uszczypnięci",
	"uszyci",
	"utarci",
	"utknięci",
	"uwinięci",
	"uwici",
	"użyci",
	"walnięci",
	"wbici",
	"wchłonięci",
	"wciągnięci",
	"wcięci",
	"wciśnięci",
	"wczuci",
	"wdarci",
	"wdepnięci",
	"wepchnięci",
	"wetknięci",
	"wici",
	"wkłuci",
	"wkuci",
	"wniknięci",
	"wpięci",
	"wryci",
	"wślizgnięci",
	"wsparci",
	"wspięci",
	"współczuci",
	"współżyci",
	"wstrząśnięci",
	"wstrzyknięci",
	"wsunięci",
	"wszczęci",
	"wszyci",
	"wtargnięci",
	"wtarci",
	"wybici",
	"wyblaknięci",
	"wybuchnięci",
	"wyciągnięci",
	"wycięci",
	"wyciśnięci",
	"wyczuci",
	"wydobyci",
	"wyfrunięci",
	"wygarnięci",
	"wygaśnięci",
	"wygięci",
	"wyjęci",
	"wykluci",
	"wykłuci",
	"wykopnięci",
	"wykpici",
	"wykradnięci",
	"wykryci",
	"wykrzyknięci",
	"wykuci",
	"wyminięci",
	"wymknięci",
	"wymsknięci",
	"wymyci",
	"wynajęci",
	"wyniknięci",
	"wyparci",
	"wypchnięci",
	"wypięci",
	"wypici",
	"wypluci",
	"wypoczęci",
	"wypruci",
	"wyrośnięci",
	"wyryci",
	"wyrżnięci",
	"wyschnięci",
	"wyślizgnięci",
	"wysnuci",
	"wystrychnięci",
	"wystygnięci",
	"wysunięci",
	"wyszarpnięci",
	"wyszyci",
	"wytarci",
	"wytchnięci",
	"wytknięci",
	"wytruci",
	"wytrzasnięci",
	"wytrząśnięci",
	"wywarci",
	"wywinięci",
	"wyzbyci",
	"wyzionięci",
	"wyżyci",
	"wzbici",
	"wzięci",
	"wzniesięci",
	"wzrośnięci",
	"zabici",
	"zabrnięci",
	"zaciągnięci",
	"zacięci",
	"zaciśnięci",
	"zaczęci",
	"zadarci",
	"zadęci",
	"zadraśnięci",
	"zagadnięci",
	"zagarnięci",
	"zagięci",
	"zaginięci",
	"zajęci",
	"zakłuci",
	"zakryci",
	"zakrzyknięci",
	"zakuci",
	"zakwitnięci",
	"zamachnięci",
	"zamarznięci",
	"zamknięci",
	"zaniknięci",
	"zapięci",
	"zapici",
	"zarżnięci",
	"zasięgnięci",
	"zasunięci",
	"zaszczuci",
	"zaszyci",
	"zatarci",
	"zatknięci",
	"zatonięci",
	"zatruci",
	"zatrzaśnięci",
	"zatrząśnięci",
	"zawarci",
	"zawinięci",
	"zawiśnięci",
	"zawładnięci",
	"zażyci",
	"zbici",
	"zbyci",
	"zcięci",
	"zdarci",
	"zdjęci",
	"zdmuchnięci",
	"zdobyci",
	"zepchnięci",
	"zepsuci",
	"zerżnięci",
	"ześlizgnięci",
	"zetknięci",
	"zgarnięci",
	"zgaśnięci",
	"zgięci",
	"zgnici",
	"złoici",
	"zmarznięci",
	"zmoknięci",
	"zmyci",
	"zorbici",
	"zsunięci",
	"zszyci",
	"ztarci",
	"żuci",
	"zużyci",
	"zwichnięci",
	"zwinięci",
	"życi",
	"zżarci",
	"zżyci",
	"abdykowani",
	"absorbowani",
	"adaptowani",
	"administrowani",
	"adoptowani",
	"adorowani",
	"adresowani",
	"afiszowani",
	"agitowani",
	"akcentowani",
	"akceptowani",
	"aklimatyzowani",
	"akompaniowani",
	"aktualizowani",
	"aktywowani",
	"akumulowani",
	"alaromowani",
	"alienowani",
	"amerykanizowani",
	"amortyzowani",
	"amputowani",
	"analizowani",
	"angażowani",
	"anihilowani",
	"animowani",
	"anonsowani",
	"antropomorfizowani",
	"antydatowani",
	"anulowani",
	"apelowani",
	"aportowani",
	"aranżowani",
	"archiwizowani",
	"aresztowani",
	"argumentowani",
	"artykułowani",
	"ascendowani",
	"asekurowani",
	"asymilowani",
	"asystowani",
	"atakowani",
	"autoryzowani",
	"awanturowani",
	"babrani",
	"baczeni",
	"badani",
	"bagatelizowani",
	"bajerowani",
	"bałamuceni",
	"balangowani",
	"balansowani",
	"banalizowani",
	"bandażowani",
	"bankrutowani",
	"baraszkowani",
	"barwieni",
	"bawieni",
	"bazgrani",
	"bazowani",
	"bębnieni",
	"bełkotani",
	"besztani",
	"biczowani",
	"błagani",
	"błaznowani",
	"blefowani",
	"błogosławieni",
	"blokowani",
	"bluzgani",
	"błyskani",
	"boczeni",
	"bogaceni",
	"bojkotowani",
	"boksowani",
	"bombardowani",
	"bopowani",
	"borowani",
	"brandzlowani",
	"brani",
	"brasowani",
	"bratani",
	"brodzeni",
	"bronieni",
	"brudzeni",
	"brylowani",
	"budowani",
	"budzeni",
	"bujani",
	"buleni",
	"bulwersowani",
	"bumelowani",
	"burzeni",
	"butelkowani",
	"bywani",
	"cackani",
	"całowani",
	"cechowani",
	"celebrowani",
	"celowani",
	"cenieni",
	"cenzurowani",
	"chciani",
	"chlani",
	"chlapani",
	"chlastani",
	"chłodzeni",
	"chlostani",
	"chlubieni",
	"chodowani",
	"chomikowani",
	"chorowani",
	"chowani",
	"chronieni",
	"chrupani",
	"chrzczeni",
	"chwaleni",
	"chwyceni",
	"chwytani",
	"chybotani",
	"chyleni",
	"ciągani",
	"ciemiężeni",
	"cierpiani",
	"cieszeni",
	"ciskani",
	"ciułani",
	"cmokani",
	"cofani",
	"ćpani",
	"cuceni",
	"cudzołożeni",
	"cumowani",
	"ćwiartowani",
	"ćwiczeni",
	"cykani",
	"cytowani",
	"czajeni",
	"czarowani",
	"czczeni",
	"czepiani",
	"czepieni",
	"czerpani",
	"czesani",
	"częstowani",
	"czochrani",
	"czołgani",
	"czytani",
	"darowani",
	"darzeni",
	"datowani",
	"dawani",
	"dbani",
	"deaktywowani",
	"debatowani",
	"dedukowani",
	"dedykowani",
	"defibrylowani",
	"defilowani",
	"definiowani",
	"defraudowani",
	"degradowani",
	"degustowani",
	"deklamowani",
	"deklarowani",
	"dekodowani",
	"dekompresowani",
	"dekorowani",
	"dekretowani",
	"delegowani",
	"delektowani",
	"deliberowani",
	"demaskowani",
	"dementowani",
	"demolowani",
	"demonizowani",
	"demonstrowani",
	"demoralizowani",
	"denerwowani",
	"denuncjowani",
	"depeszowani",
	"depilowani",
	"deportowani",
	"deprawowani",
	"deptani",
	"deratyzowani",
	"destabilizowani",
	"destylowani",
	"desygnowani",
	"determinowani",
	"detonowani",
	"dewastowani",
	"dewaulowani",
	"dezaktywowani",
	"dezorientowani",
	"dezynfekowani",
	"diagnozowani",
	"dilowani",
	"dłubani",
	"dłużeni",
	"dmuchani",
	"dobiegani",
	"dobierani",
	"dobijani",
	"dobrani",
	"dobudzeni",
	"doceniani",
	"docenieni",
	"dochodzeni",
	"dochowani",
	"dochowywani",
	"dociekani",
	"docinani",
	"dociskani",
	"doczekani",
	"doczepieni",
	"doczołgani",
	"doczyszczeni",
	"doczytani",
	"dodani",
	"dodawani",
	"dodrukowani",
	"dodrukowywani",
	"dofinansowani",
	"dofinansowywani",
	"dogadani",
	"dogadywani",
	"dogadzani",
	"doganiani",
	"doglądani",
	"dognani",
	"dogodzeni",
	"dogonieni",
	"dograni",
	"dogryzani",
	"dogryzioni",
	"dogrzani",
	"dogrzebani",
	"doinformowani",
	"dojeżdżani",
	"dojeni",
	"dojrzani",
	"dojrzewani",
	"dokańczani",
	"dokarmiani",
	"dokarmieni",
	"dokazani",
	"dokazywani",
	"dokładani",
	"doklejeni",
	"dokonani",
	"dokończeni",
	"dokonywani",
	"dokopani",
	"dokopywani",
	"dokowani",
	"dokręcani",
	"dokręceni",
	"dokształcani",
	"dokształceni",
	"dokuczani",
	"dokumentowani",
	"dokupieni",
	"dołączani",
	"dołączeni",
	"doładowani",
	"dolani",
	"dolewani",
	"doliczeni",
	"dołowani",
	"dołożeni",
	"domagani",
	"domalowani",
	"domniewywani",
	"domówieni",
	"domyślani",
	"domyśleni",
	"doniesieni",
	"donoszeni",
	"dopadani",
	"dopakowani",
	"dopaleni",
	"dopasowani",
	"dopasowywani",
	"dopatrywani",
	"dopatrzeni",
	"dopchani",
	"dopełniani",
	"dopełnieni",
	"dopieszczeni",
	"dopijani",
	"dopilnowani",
	"dopingowani",
	"dopisani",
	"dopisywani",
	"dopłacani",
	"dopłaceni",
	"dopolerowani",
	"dopompowani",
	"dopowiedziani",
	"dopracowani",
	"dopracowywani",
	"doprani",
	"doprawieni",
	"doprecyzowani",
	"doproszeni",
	"doprowadzani",
	"doprowadzeni",
	"dopucowani",
	"dopuszczani",
	"dopuszczeni",
	"dopytywani",
	"dorabiani",
	"doradzani",
	"doradzeni",
	"doręczani",
	"doręczeni",
	"dorobieni",
	"dorównani",
	"dorównywani",
	"dorwani",
	"dorysowani",
	"dorzucani",
	"dorzuceni",
	"dosiadani",
	"doskoczeni",
	"doskonaleni",
	"dosładzani",
	"dosłani",
	"dosłyszani",
	"dosoleni",
	"dośrodkowani",
	"dossani",
	"dostani",
	"dostąpieni",
	"dostarczani",
	"dostarczeni",
	"dostawani",
	"dostawiani",
	"dostawieni",
	"dostosowani",
	"dostosowywani",
	"dostrajani",
	"dostrojeni",
	"dostrzegani",
	"dosuwani",
	"doświadczani",
	"doświetleni",
	"dosypani",
	"dosypywani",
	"doszkoleni",
	"doszlifowani",
	"doszorowani",
	"doszukani",
	"doszukiwani",
	"dotankowani",
	"dotankowywani",
	"dotargani",
	"dotaszczeni",
	"dotlenieni",
	"dotłumaczeni",
	"dotowani",
	"dotrwani",
	"dotrzymani",
	"dotrzymywani",
	"dotykani",
	"douczani",
	"douczeni",
	"dowaleni",
	"dowiezieni",
	"dowodzeni",
	"dowożeni",
	"doznani",
	"doznawani",
	"dozorowani",
	"dozowani",
	"dożywieni",
	"dramatyzowani",
	"drapani",
	"drażnieni",
	"drążeni",
	"dręczeni",
	"drenowani",
	"drgani",
	"drukowani",
	"dryblowani",
	"dryfowani",
	"drzemani",
	"dubbingowani",
	"dublowani",
	"duplikowani",
	"duszeni",
	"dworowani",
	"dygotani",
	"dyktowani",
	"dymani",
	"dymieni",
	"dyrygowani",
	"dyscyplinowani",
	"dyskredytowani",
	"dyskryminowani",
	"dyskutowani",
	"dyskwalifikowani",
	"dysponowani",
	"dystansowani",
	"dystrybuowani",
	"dywagowani",
	"dźgani",
	"dziedziczeni",
	"dziękowani",
	"dzieleni",
	"dziergani",
	"dzierżeni",
	"dziobani",
	"dziurawieni",
	"dziurkowani",
	"dźwigani",
	"edukowani",
	"edytowani",
	"egzaminowani",
	"egzekutowani",
	"egzekwowani",
	"ekscytowani",
	"ekshumowani",
	"ekskomunikowani",
	"eksmitowani",
	"ekspandowani",
	"eksperymentowani",
	"eksploatowani",
	"eksplorowani",
	"eksponowani",
	"eksportowani",
	"eksterminowani",
	"ekstradowani",
	"ekstrapolowani",
	"eliminowani",
	"emancypowani",
	"emigrowani",
	"emitowani",
	"energetyzowani",
	"eskortowani",
	"etykietowani",
	"ewakuowani",
	"ewaluowani",
	"fabrykowani",
	"falowani",
	"fałszowani",
	"farbowani",
	"faszerowani",
	"faulowani",
	"faworyzowani",
	"fechtowani",
	"fermentowani",
	"ferowani",
	"figurowani",
	"filetowani",
	"filmowani",
	"filtrowani",
	"finalizowani",
	"finansowani",
	"firmowani",
	"fleszowani",
	"folgowani",
	"formułowani",
	"forsowani",
	"fotografowani",
	"fundowani",
	"gadani",
	"ganiani",
	"garbieni",
	"gardzeni",
	"garnirowani",
	"gaszeni",
	"gawędzeni",
	"gaworzeni",
	"gazowani",
	"gdakani",
	"gderani",
	"generalizowani",
	"generowani",
	"gilgotani",
	"gładzeni",
	"głaskani",
	"głodowani",
	"głodzeni",
	"gloryfikowani",
	"głosowani",
	"głoszeni",
	"głowieni",
	"gmatwani",
	"gmerani",
	"gnani",
	"gnębieni",
	"gnieceni",
	"gnojeni",
	"godzeni",
	"goleni",
	"gonieni",
	"googlowani",
	"gospodarowani",
	"goszczeni",
	"gotowani",
	"grabieni",
	"grani",
	"grasowani",
	"gratulowani",
	"grillowani",
	"grilowani",
	"gromadzeni",
	"gromieni",
	"grożeni",
	"gruchani",
	"grupowani",
	"grywani",
	"gryzieni",
	"grzani",
	"grzechotani",
	"gubieni",
	"gustowani",
	"gwałceni",
	"gwarantowani",
	"gwizdani",
	"hackowani",
	"haftowani",
	"hamowani",
	"hańbieni",
	"handlowani",
	"harcowani",
	"harmonizowani",
	"harowani",
	"hartowani",
	"hibernowani",
	"hipnotyzowani",
	"hodowani",
	"holowani",
	"hołubieni",
	"honorowani",
	"hospitalizowani",
	"hulani",
	"huśtani",
	"idealizowani",
	"identyfikowani",
	"ignorowani",
	"igrani",
	"ilustrowani",
	"imitowani",
	"implantowani",
	"implodowani",
	"imponowani",
	"importowani",
	"improwizowani",
	"indokrynowani",
	"indukowani",
	"infekowani",
	"infiltrowani",
	"informowani",
	"ingerowani",
	"inhalowani",
	"inscenizowani",
	"inspirowani",
	"instalowani",
	"instruowani",
	"insynuowani",
	"integrowani",
	"interpretowani",
	"interweniowani",
	"intonowani",
	"intubowani",
	"inwestowani",
	"inwigilowani",
	"irytowani",
	"iskrzeni",
	"izolowani",
	"jadani",
	"jawieni",
	"jazgotani",
	"jednoczeni",
	"jedzeni",
	"kablowani",
	"kadzeni",
	"kalani",
	"kaleczeni",
	"kalkulowani",
	"kamerowani",
	"kamienowani",
	"kamuflowani",
	"kanalizowani",
	"kąpani",
	"kapitulowani",
	"kapowani",
	"karani",
	"karbonizowani",
	"karceni",
	"karczowani",
	"karmieni",
	"kartkowani",
	"kąsani",
	"kasowani",
	"kastrowani",
	"katalogowani",
	"katapultowani",
	"katowani",
	"katrupieni",
	"kierowani",
	"kimani",
	"kiszeni",
	"kiwani",
	"kłaniani",
	"klapani",
	"klarowani",
	"klasyfikowani",
	"klębieni",
	"klejeni",
	"klepani",
	"klikani",
	"klonowani",
	"kłopotani",
	"knoceni",
	"kochani",
	"koczowani",
	"kodowani",
	"kojarzeni",
	"kojeni",
	"kolekcjonowani",
	"kolektywizowani",
	"kolidowani",
	"kolonizowani",
	"kolorowani",
	"koloryzowani",
	"kołowani",
	"kołysani",
	"kombinowani",
	"komenderowani",
	"komentowani",
	"komercjalizowani",
	"kompensowani",
	"komplementowani",
	"komplikowani",
	"komponowani",
	"kompromitowani",
	"komunikowani",
	"konani",
	"koncentrowani",
	"kończeni",
	"konfabulowani",
	"konfiskowani",
	"konfrontowani",
	"konserwowani",
	"konspirowani",
	"konstruowani",
	"konsultowani",
	"konsumowani",
	"kontaktowani",
	"kontestowani",
	"kontrastowani",
	"kontrolowani",
	"kontrowani",
	"kontynuowani",
	"kontynuuowani",
	"konwertowani",
	"konwojowani",
	"koordynowani",
	"kopani",
	"kopceni",
	"kopiowani",
	"kopulowani",
	"korelowani",
	"korkowani",
	"koronowani",
	"korygowani",
	"korzystani",
	"koszeni",
	"kotwiczeni",
	"kozaczeni",
	"kozłowani",
	"kradzieni",
	"krajani",
	"krążeni",
	"kręceni",
	"kremowani",
	"kreowani",
	"krochmaleni",
	"krojeni",
	"kropieni",
	"kruszeni",
	"krystalizowani",
	"krytykowani",
	"krzyczani",
	"krzywdzeni",
	"krzywieni",
	"krzyżowani",
	"kserowani",
	"księgowani",
	"kształceni",
	"kształtowani",
	"kuleni",
	"kultywowani",
	"kumulowani",
	"kupczeni",
	"kupieni",
	"kupowani",
	"kupywani",
	"kurczeni",
	"kurowani",
	"kursowani",
	"kurzeni",
	"kuszeni",
	"kwalifikowani",
	"kwestionowani",
	"łączeni",
	"ładowani",
	"łagodzeni",
	"łajdaczeni",
	"lakierowani",
	"łamani",
	"lamentowani",
	"lansowani",
	"lani",
	"łapani",
	"łaskotani",
	"łaszeni",
	"latani",
	"łatani",
	"lawirowani",
	"leczeni",
	"legalizowani",
	"legitymowani",
	"lekceważeni",
	"lepieni",
	"lewitowani",
	"liberowani",
	"licencjonowani",
	"licytowani",
	"liczeni",
	"likwidowani",
	"linczowani",
	"liniowani",
	"literowani",
	"litowani",
	"lizani",
	"lobbowani",
	"lokalizowani",
	"losowani",
	"łowieni",
	"łożeni",
	"lubiani",
	"łudzeni",
	"lunatykowani",
	"łupani",
	"łupieni",
	"łuskani",
	"lustrowani",
	"łuszczeni",
	"luzowani",
	"łykani",
	"łyżeczkowani",
	"macani",
	"machani",
	"mąceni",
	"maczani",
	"maganyzowani",
	"maglowani",
	"majaczeni",
	"majsterkowani",
	"majtani",
	"maksymalizowani",
	"malowani",
	"maltretowani",
	"mamieni",
	"mamrotani",
	"manewrowani",
	"manifestowani",
	"manipulowani",
	"markowani",
	"marnotrawieni",
	"marnowani",
	"marszczeni",
	"marynowani",
	"masakrowani",
	"maskowani",
	"masowani",
	"masturbowani",
	"mataczeni",
	"materializowani",
	"mawiani",
	"mazani",
	"męczeni",
	"meldowani",
	"merdani",
	"metabolizowani",
	"miażdżeni",
	"mieleni",
	"mierzeni",
	"mierzwieni",
	"mieszani",
	"miętoleni",
	"migani",
	"migdaleni",
	"migotani",
	"mijani",
	"miksowani",
	"milowani",
	"minimalizowani",
	"miotani",
	"mistyfikowani",
	"mitygowani",
	"mizdrzeni",
	"mlani",
	"mniemani",
	"mnożeni",
	"mobilizowani",
	"mocowani",
	"moczeni",
	"modelowani",
	"modernizowani",
	"modleni",
	"modulowani",
	"modyfikowani",
	"molestowani",
	"monitorowani",
	"monopolizowani",
	"montowani",
	"mordowani",
	"motywowani",
	"mrożeni",
	"mrugani",
	"mrużeni",
	"muskani",
	"mutowani",
	"mydleni",
	"myleni",
	"myszkowani",
	"nabazgrani",
	"nabiegani",
	"nabierani",
	"nabrani",
	"nabrojeni",
	"nabrudzeni",
	"nabywani",
	"nacelowani",
	"nachapani",
	"nachodzeni",
	"nachwaleni",
	"nachyleni",
	"naciągani",
	"nacierani",
	"nacinani",
	"naciskani",
	"nacjonalizowani",
	"naczepieni",
	"nadani",
	"nadawani",
	"nadchodzeni",
	"nadciągani",
	"nadesłani",
	"nadgonieni",
	"nadgryzani",
	"nadgryzieni",
	"nadinterpretowani",
	"nadłożeni",
	"nadmieniani",
	"nadmienieni",
	"nadmuchani",
	"nadrabiani",
	"nadrobieni",
	"nadskakiwani",
	"nadsłuchiwani",
	"nadstawiani",
	"nadstawieni",
	"naduszeni",
	"nadużywani",
	"nadwerężani",
	"nadwyrężani",
	"nadwyrężeni",
	"nadziani",
	"nadzorowani",
	"naelektryzowani",
	"nafaszerowani",
	"nagabywani",
	"nagadani",
	"naginani",
	"nagłaszani",
	"nagłośnieni",
	"nagonieni",
	"nagradzani",
	"nagrani",
	"nagrodzeni",
	"nagromadzeni",
	"nagrywani",
	"nagryzmoleni",
	"nagrzani",
	"nagrzebani",
	"nagrzewani",
	"nagwizdani",
	"naigrywani",
	"najechani",
	"najmowani",
	"nakarmiani",
	"nakarmieni",
	"nakazani",
	"nakazywani",
	"nakierowani",
	"nakierowywani",
	"nakładani",
	"nakłamani",
	"nakłaniani",
	"naklejani",
	"naklejeni",
	"naklepani",
	"nakłonieni",
	"nakłuwani",
	"nakopani",
	"nakręcani",
	"nakręceni",
	"nakreślani",
	"nakreśleni",
	"nakruszeni",
	"nakrywani",
	"nakrzyczani",
	"nakupieni",
	"naładowani",
	"nalani",
	"nałapani",
	"nalepieni",
	"nalewani",
	"naliczeni",
	"nałowieni",
	"nałożeni",
	"namaczani",
	"namagnetyzowani",
	"namalowani",
	"namaszczani",
	"namaszczeni",
	"namawiani",
	"namęczeni",
	"namierzani",
	"namieszani",
	"namoczeni",
	"namówieni",
	"namydlani",
	"namyśleni",
	"naniesieni",
	"naoliwiani",
	"naoliwieni",
	"naopowiadani",
	"naostrzeni",
	"napadani",
	"napakowani",
	"napaleni",
	"naparzani",
	"napastowani",
	"napawani",
	"napchani",
	"napędzani",
	"napełniani",
	"napełnieni",
	"napierani",
	"napiętnowani",
	"napinani",
	"napisani",
	"napływani",
	"napojeni",
	"napompowani",
	"napotkani",
	"napotykani",
	"napraszani",
	"naprawiani",
	"naprawieni",
	"naprężani",
	"naprężeni",
	"napromieniowani",
	"naprostowani",
	"naprowadzani",
	"naprowadzeni",
	"napuszczani",
	"napuszczeni",
	"napychani",
	"napytani",
	"narąbani",
	"naradzani",
	"naradzeni",
	"narastani",
	"narażani",
	"narażeni",
	"nareperowani",
	"narkotyzowani",
	"narodzeni",
	"naruszani",
	"naruszeni",
	"narwani",
	"narysowani",
	"narzucani",
	"narzuceni",
	"nasączani",
	"nasączeni",
	"nasadzeni",
	"nasiąkani",
	"nasilani",
	"nasileni",
	"naskakiwani",
	"naskoczeni",
	"naskrobani",
	"naśladowani",
	"nasłani",
	"nasłuchani",
	"nasłuchiwani",
	"nasmarowani",
	"nastąpieni",
	"nastawiani",
	"nastawieni",
	"nastraszani",
	"nastrojeni",
	"nastukani",
	"nasuwani",
	"naświetlani",
	"nasyceni",
	"nasyłani",
	"nasypani",
	"naszczani",
	"naszkicowani",
	"naszpikowani",
	"naszprycowani",
	"naszykowani",
	"naszywani",
	"natlenieni",
	"natłuszczeni",
	"natrafieni",
	"natrząsani",
	"nauczani",
	"nauczeni",
	"nawadniani",
	"nawaleni",
	"nawiązani",
	"nawiązywani",
	"nawiedzani",
	"nawiedzeni",
	"nawierceni",
	"nawiewani",
	"nawiezieni",
	"nawigowani",
	"nawijani",
	"nawilżani",
	"nawilżeni",
	"nawlekani",
	"nawodnieni",
	"nawoływani",
	"nawoskowani",
	"nawożeni",
	"nawpychani",
	"nawracani",
	"nawróceni",
	"nawrzucani",
	"nawtykani",
	"nawymyślani",
	"nazbierani",
	"nazmyślani",
	"naznaczani",
	"naznaczeni",
	"nazrywani",
	"nazwani",
	"nazywani",
	"nęceni",
	"negocjowani",
	"negowani",
	"nękani",
	"neutralizowani",
	"niańczeni",
	"niecierpliwieni",
	"niedoceniani",
	"niedowidziani",
	"nienawidzeni",
	"niesieni",
	"nikoleni",
	"niszczeni",
	"nitkowani",
	"niuchani",
	"niweczeni",
	"niwelowani",
	"nokautowani",
	"nominowani",
	"notowani",
	"nuceni",
	"numerowani",
	"nurtowani",
	"obaczeni",
	"obadani",
	"obalani",
	"obaleni",
	"obandażowani",
	"obarczani",
	"obarczeni",
	"obawiani",
	"obchodzeni",
	"obciążeni",
	"obcinani",
	"obcyndalani",
	"obczajani",
	"obczajeni",
	"obdarowani",
	"obdarzani",
	"obdarzeni",
	"obdzieleni",
	"obdzierani",
	"obdzwaniani",
	"obdzwonieni",
	"obejmowani",
	"oberwani",
	"obessani",
	"obezwładniani",
	"obezwładnieni",
	"obfotografowani",
	"obfotografowywani",
	"obgadani",
	"obgadywani",
	"obgryzani",
	"obgryzieni",
	"obiecani",
	"obiecywani",
	"obierani",
	"obijani",
	"objadani",
	"objaśniani",
	"objawiani",
	"objawieni",
	"objechani",
	"objeżdżani",
	"obkręcani",
	"oblani",
	"obłapiani",
	"obłapywani",
	"obłaskawiani",
	"obłaskawieni",
	"obleciani",
	"oblewani",
	"obliczani",
	"obliczeni",
	"oblizani",
	"obłowieni",
	"obłożeni",
	"obluzowani",
	"obluzowywani",
	"obmacani",
	"obmacywani",
	"obmawiani",
	"obmyślani",
	"obmyśleni",
	"obmywani",
	"obnażani",
	"obniżani",
	"obniżeni",
	"obnoszeni",
	"obowiązywani",
	"obozowani",
	"obrabiani",
	"obrabowani",
	"obracani",
	"obradowani",
	"obramowani",
	"obraniani",
	"obrani",
	"obrastani",
	"obrażani",
	"obrażeni",
	"obrobieni",
	"obróceni",
	"obrodzeni",
	"obronieni",
	"obrysowani",
	"obrywani",
	"obryzgani",
	"obrzezani",
	"obrzucani",
	"obrzuceni",
	"obrzygani",
	"obsadzani",
	"obsadzeni",
	"obściskiwani",
	"obserwowani",
	"obsiani",
	"obsikani",
	"obsikiwani",
	"obskakiwani",
	"obskoczeni",
	"obskubani",
	"obskubywani",
	"obśliniani",
	"obślinieni",
	"obsługiwani",
	"obsłużeni",
	"obsmarowani",
	"obstawiani",
	"obstawieni",
	"obstrzeliwani",
	"obsuwani",
	"obsypani",
	"obsypywani",
	"obszukani",
	"obszukiwani",
	"obtaczani",
	"obtoczeni",
	"obudzeni",
	"obwąchani",
	"obwąchiwani",
	"obwiązani",
	"obwiązywani",
	"obwieszani",
	"obwieszczani",
	"obwieszczeni",
	"obwieszeni",
	"obwijani",
	"obwiniani",
	"obwołani",
	"obżerani",
	"ocalani",
	"ocaleni",
	"ocechowani",
	"oceniani",
	"ocenieni",
	"ocenzurowani",
	"ochładzani",
	"ochlapani",
	"ochlapywani",
	"ochłodzeni",
	"ochraniani",
	"ochronieni",
	"ochrzaniani",
	"ochrzczeni",
	"ociągani",
	"ocieleni",
	"ocieplani",
	"ociepleni",
	"ocierani",
	"ocuceni",
	"oczarowywani",
	"oczekiwani",
	"oczerniani",
	"oczernieni",
	"oczyszczani",
	"oczyszczeni",
	"odbębnieni",
	"odbetonowani",
	"odbezpieczani",
	"odbezpieczeni",
	"odbijani",
	"odblokowani",
	"odbudowani",
	"odbudowywani",
	"odbutowani",
	"odcedzani",
	"odchorowani",
	"odchowani",
	"odchudzani",
	"odchudzeni",
	"odchylani",
	"odchyleni",
	"odciągani",
	"odciążeni",
	"odcierpieni",
	"odcinani",
	"odcumowani",
	"odcyfrowani",
	"odcyfrowywani",
	"odczarowani",
	"odczekani",
	"odczepiani",
	"odczepieni",
	"odczuwani",
	"odczynieni",
	"odczytani",
	"odczytywani",
	"oddalani",
	"oddani",
	"oddawani",
	"oddelegowani",
	"oddychani",
	"oddzielani",
	"oddzieleni",
	"odebrani",
	"odegnani",
	"odegrani",
	"odejmowani",
	"oderwani",
	"odeskortowani",
	"odesłani",
	"odespani",
	"odessani",
	"odetkani",
	"odezwani",
	"odfiltrowani",
	"odgadywani",
	"odganiani",
	"odgarniani",
	"odgniatani",
	"odgonieni",
	"odgradzani",
	"odgrażani",
	"odgrodzeni",
	"odgruzowani",
	"odgrywani",
	"odgryzani",
	"odgryzieni",
	"odgrzani",
	"odgrzebani",
	"odgrzebywani",
	"odgrzewani",
	"odgwizdani",
	"odhaczeni",
	"odholowani",
	"odinstalowani",
	"odizolowani",
	"odjedzeni",
	"odjonizowani",
	"odkażani",
	"odkażeni",
	"odkładani",
	"odklejeni",
	"odkochani",
	"odkodowani",
	"odkodowywani",
	"odkopani",
	"odkopywani",
	"odkorkowani",
	"odkręcani",
	"odkręceni",
	"odkrojeni",
	"odkrywani",
	"odkupieni",
	"odkupywani",
	"odkurzani",
	"odkurzeni",
	"odłączani",
	"odłączeni",
	"odłamywani",
	"odlani",
	"odlatywani",
	"odlepiani",
	"odlewani",
	"odliczani",
	"odliczeni",
	"odłożeni",
	"odłupani",
	"odmachani",
	"odmachiwani",
	"odmalowani",
	"odmarszczeni",
	"odmawiani",
	"odmeldowani",
	"odmieniani",
	"odmienieni",
	"odmierzani",
	"odmierzeni",
	"odmieszani",
	"odmontowani",
	"odmówieni",
	"odmrażani",
	"odmrożeni",
	"odnajdowani",
	"odnalezieni",
	"odnawiani",
	"odniesieni",
	"odnoszeni",
	"odnotowani",
	"odnotowywani",
	"odnowieni",
	"odpakowani",
	"odpakowywani",
	"odpalani",
	"odpaleni",
	"odpałzowani",
	"odparowani",
	"odpędzani",
	"odpicowani",
	"odpieczętowani",
	"odpierani",
	"odpiłowani",
	"odpiłowywani",
	"odpinani",
	"odpisani",
	"odpisywani",
	"odpłacani",
	"odplamieni",
	"odplątani",
	"odpowietrzeni",
	"odpracowani",
	"odpracowywani",
	"odprasowani",
	"odprawiani",
	"odprawieni",
	"odprężani",
	"odprostowani",
	"odprowadzani",
	"odprowadzeni",
	"odpryskani",
	"odpukani",
	"odpukiwani",
	"odpuszczani",
	"odpuszczeni",
	"odpychani",
	"odrąbani",
	"odrabiani",
	"odrąbywani",
	"odradzani",
	"odradzeni",
	"odrapani",
	"odrastani",
	"odratowani",
	"odreagowani",
	"odremontowani",
	"odrestaurowani",
	"odrestaurowywani",
	"odrobaczani",
	"odrobieni",
	"odroczeni",
	"odrodzeni",
	"odróżniani",
	"odróżnieni",
	"odrysowani",
	"odrywani",
	"odrzucani",
	"odrzuceni",
	"odsączani",
	"odsączeni",
	"odsadzeni",
	"odseparowani",
	"odsiadywani",
	"odsiani",
	"odsiewani",
	"odsłaniani",
	"odsłuchani",
	"odsłuchiwani",
	"odsłużeni",
	"odśnieżani",
	"odśnieżeni",
	"odsoleni",
	"odśpiewani",
	"odsprzedani",
	"odsprzedawani",
	"odstąpieni",
	"odstawiani",
	"odstawieni",
	"odstępowani",
	"odstraszani",
	"odstręczeni",
	"odstresowani",
	"odstrzeliwani",
	"odstrzeleni",
	"odsuwani",
	"odświeżani",
	"odświeżeni",
	"odsyłani",
	"odsypywani",
	"odsysani",
	"odszczekani",
	"odszczekiwani",
	"odsztafirowani",
	"odszukani",
	"odszyfrowani",
	"odszyfrowywani",
	"odszykowani",
	"odtrąbieni",
	"odtrąceni",
	"odtwarzani",
	"odtworzeni",
	"oduczeni",
	"odurzeni",
	"odwalani",
	"odwaleni",
	"odwiązani",
	"odwiązywani",
	"odwiedzani",
	"odwiedzeni",
	"odwieszeni",
	"odwiezieni",
	"odwijani",
	"odwlekani",
	"odwodnieni",
	"odwodzeni",
	"odwołani",
	"odwoływani",
	"odwożeni",
	"odwracani",
	"odwróceni",
	"odwzajemnieni",
	"odwzorowani",
	"odżegnani",
	"odziani",
	"odziedziczeni",
	"odznaczani",
	"odznaczeni",
	"odzwieciedleni",
	"odzwierciedlani",
	"odzwonieni",
	"odzwyczajeni",
	"odzyskani",
	"odzyskiwani",
	"odzywiani",
	"odżywieni",
	"oferowani",
	"ofiarowani",
	"ofiarowywani",
	"ogarniani",
	"oglądani",
	"ogłaszani",
	"ogłoszeni",
	"ogłupiani",
	"ogłupieni",
	"ogłuszeni",
	"ogołoceni",
	"ogoleni",
	"ograbiani",
	"ograbieni",
	"ograniczani",
	"ograniczni",
	"ograni",
	"ogrodzeni",
	"ogryzieni",
	"ogrzani",
	"ogrzewani",
	"okablowani",
	"okaleczeni",
	"okantowani",
	"okąpani",
	"okazani",
	"okazywani",
	"okiełznani",
	"okładani",
	"okłamani",
	"okłamywani",
	"oklaskiwani",
	"oklejeni",
	"oklepani",
	"okopani",
	"okopywani",
	"okpieni",
	"okradani",
	"okradzieni",
	"okraszeni",
	"okrążani",
	"okrążeni",
	"okręcani",
	"okręceni",
	"określani",
	"określeni",
	"okrojeni",
	"okrywani",
	"okulawieni",
	"okupieni",
	"okupowani",
	"olani",
	"olewani",
	"omamieni",
	"omawiani",
	"omdlewani",
	"omijani",
	"omotani",
	"omówieni",
	"onanizowani",
	"onieśmielani",
	"onieśmieleni",
	"opakowani",
	"opalani",
	"opaleni",
	"opancerzeni",
	"opanowani",
	"opanowywani",
	"oparzeni",
	"opasani",
	"opatentowani",
	"opatrywani",
	"opatrzeni",
	"opatuleni",
	"opędzani",
	"opędzeni",
	"operowani",
	"opętani",
	"opętywani",
	"opieczętowani",
	"opiekowani",
	"opierani",
	"opijani",
	"opisani",
	"opisywani",
	"opłacani",
	"opłaceni",
	"opłakani",
	"opłakiwani",
	"opłukani",
	"opluwani",
	"opływani",
	"opodatkowani",
	"opodatkowywani",
	"oponowani",
	"oporządzani",
	"oporządzeni",
	"opowiadani",
	"opowiedziani",
	"opóźniani",
	"opóźnieni",
	"opracowani",
	"opracowywani",
	"oprawiani",
	"oprawieni",
	"oprowadzani",
	"oprowadzeni",
	"opróżniani",
	"opróżnieni",
	"opryskani",
	"opryskiwani",
	"opublikowani",
	"opukani",
	"opuszczani",
	"opuszczeni",
	"opychani",
	"opyleni",
	"orani",
	"orbowani",
	"organizowani",
	"orientowani",
	"oroszeni",
	"orzekani",
	"osaczani",
	"osaczeni",
	"osadzani",
	"osądzani",
	"osadzeni",
	"osądzeni",
	"oscylowani",
	"osiadani",
	"osiągani",
	"osiedlani",
	"osiedleni",
	"osiedzeni",
	"osieroceni",
	"osiodłani",
	"oskalpowani",
	"oskarżeni",
	"oskrobani",
	"oskrzydlani",
	"oskrzydleni",
	"oskubani",
	"oskubywani",
	"osłabiani",
	"osłabieni",
	"oślepiani",
	"oślepieni",
	"ośliniani",
	"osłodzeni",
	"osłonieni",
	"osłuchani",
	"osmaleni",
	"ośmieleni",
	"ośmieszani",
	"ośmieszeni",
	"ostrzegani",
	"ostrzelani",
	"ostrzeni",
	"ostudzeni",
	"osuszani",
	"osuszeni",
	"osuwani",
	"oswajani",
	"oświadczani",
	"oświadczeni",
	"oświecani",
	"oświecieni",
	"oświetlani",
	"oświetleni",
	"oswobadzani",
	"oswobodzeni",
	"oswojeni",
	"oszacowani",
	"oszałamiani",
	"oszczani",
	"oszczędzani",
	"oszczędzeni",
	"oszkleni",
	"oszlifowani",
	"oszołomieni",
	"oszpeceni",
	"oszukani",
	"oszukiwani",
	"oszwabieni",
	"otaczani",
	"otoczeni",
	"otruwani",
	"otrząsani",
	"otrzepani",
	"otrzeźwieni",
	"otrzymani",
	"otrzymywani",
	"otuleni",
	"otumanieni",
	"otwierani",
	"otwarci",
	"owani",
	"owdowieni",
	"owiani",
	"owijani",
	"ozdabiani",
	"ozdobieni",
	"ozdrowieni",
	"ożenieni",
	"oznaczani",
	"oznaczeni",
	"oznajmiani",
	"oznajmieni",
	"oznakowani",
	"ożywani",
	"ożywiani",
	"ożywieni",
	"pakowani",
	"paktowani",
	"pałani",
	"pałaszowani",
	"paleni",
	"pamiętani",
	"panoszeni",
	"paprani",
	"parafrazowani",
	"paraliżowani",
	"parkowani",
	"parowani",
	"partaczeni",
	"parzeni",
	"pastowani",
	"paszeni",
	"patrolowani",
	"patroszeni",
	"pauzowani",
	"pchani",
	"pdholowani",
	"pedałowani",
	"pękani",
	"pełnieni",
	"penetrowani",
	"perforowani",
	"perfumowani",
	"perswadowani",
	"piastowani",
	"pichceni",
	"pielęgnowani",
	"pieleni",
	"pienieni",
	"pieszczeni",
	"piętnowani",
	"pijani",
	"pikietowani",
	"piknikowani",
	"pikowani",
	"pilnowani",
	"pilotowani",
	"piłowani",
	"pisani",
	"pisywani",
	"płaceni",
	"plądrowani",
	"planowani",
	"płaszczeni",
	"plątani",
	"płatani",
	"pławieni",
	"plewieni",
	"płoszeni",
	"plotkowani",
	"plugawieni",
	"płukani",
	"pluskani",
	"pobaraszkowani",
	"pobierani",
	"pobłażani",
	"pobłogosławieni",
	"pobrani",
	"pobrudzeni",
	"pobudzani",
	"pobudzeni",
	"pobujani",
	"pocałowani",
	"pocerowani",
	"pochłaniani",
	"pochlapani",
	"pochlebiani",
	"pochowani",
	"pochwalani",
	"pochwaleni",
	"pochwyceni",
	"pochylani",
	"pochyleni",
	"pociachani",
	"pociągani",
	"pocierani",
	"pocieszani",
	"pocieszeni",
	"poceni",
	"pocukrowani",
	"poćwiartowani",
	"poczesani",
	"poczęstowani",
	"poczochrani",
	"poczytani",
	"poczytywani",
	"podani",
	"podarowani",
	"podawani",
	"podążeni",
	"podbierani",
	"podbijani",
	"podbudowani",
	"podbudowywani",
	"podburzani",
	"podburzeni",
	"podchwyceni",
	"podciągani",
	"podcierani",
	"podcinani",
	"podczepieni",
	"poddani",
	"poddawani",
	"podebrani",
	"podejmowani",
	"podejrzani",
	"podejrzewani",
	"podelektowani",
	"podeptani",
	"poderwani",
	"podesłani",
	"podglądani",
	"podgoleni",
	"podgonieni",
	"podgryzani",
	"podgrzani",
	"podgrzewani",
	"podjadani",
	"podjedzeni",
	"podkablowani",
	"podkarmieni",
	"podkładani",
	"podklejeni",
	"podkolorowani",
	"podkołowani",
	"podkopani",
	"podkopywani",
	"podkradani",
	"podkręcani",
	"podkręceni",
	"podkreślani",
	"podkreśleni",
	"podkształceni",
	"podkuleni",
	"podkupieni",
	"podkurzeni",
	"podłączani",
	"podłączeni",
	"podładowani",
	"podłamani",
	"podlani",
	"podłapani",
	"podleczeni",
	"podlegani",
	"podlewani",
	"podliczani",
	"podliczeni",
	"podlizani",
	"podlizywani",
	"podłożeni",
	"podmalowani",
	"podmieniani",
	"podmienieni",
	"podmuchani",
	"podniecani",
	"podnieceni",
	"podniesieni",
	"podnoszeni",
	"podołani",
	"podopingowani",
	"podostrzeni",
	"podotykani",
	"podpalani",
	"podpaleni",
	"podpatrywani",
	"podpatrzeni",
	"podpieczętowani",
	"podpiekani",
	"podpierani",
	"podpiłowani",
	"podpinani",
	"podpisani",
	"podpisywani",
	"podpłaceni",
	"podpompowani",
	"podporządkowani",
	"podporządkowywani",
	"podpowiadani",
	"podpowiedziani",
	"podprowadzani",
	"podpuszczani",
	"podpuszczeni",
	"podpychani",
	"podpytani",
	"podrabiani",
	"podrapani",
	"podrasowani",
	"podratowani",
	"podrażnieni",
	"podręczeni",
	"podregulowani",
	"podreperowani",
	"podretuszowani",
	"podrobieni",
	"podroczeni",
	"podróżowani",
	"podrygiwani",
	"podrywani",
	"podrzucani",
	"podrzuceni",
	"podrzynani",
	"podsadzeni",
	"podskubywani",
	"podsłuchani",
	"podsłuchiwani",
	"podsmażani",
	"podsmażeni",
	"podśpiewywani",
	"podstawiani",
	"podstawieni",
	"podstemplowani",
	"podstrojeni",
	"podsumowani",
	"podsumowywani",
	"podsuwani",
	"podświetlani",
	"podsycani",
	"podsyceni",
	"podsyłani",
	"podsypani",
	"podszczypywani",
	"podszkoleni",
	"podszlifowani",
	"podszykowani",
	"podszywani",
	"podtapiani",
	"podtopieni",
	"podtrzymani",
	"podtrzymywani",
	"podtuczeni",
	"poduczani",
	"podupadani",
	"poduszeni",
	"podwajani",
	"podwalani",
	"podważani",
	"podwędzeni",
	"podwiązani",
	"podwieszani",
	"podwiezieni",
	"podwijani",
	"podwojeni",
	"podwożeni",
	"podwyżani",
	"podwyższani",
	"podwyższeni",
	"podyktowani",
	"podyskutowani",
	"podziabani",
	"podziałani",
	"podziałkowani",
	"podziękowani",
	"podzieleni",
	"podziurawieni",
	"podziwiani",
	"poeksperymentowani",
	"pofarbowani",
	"pofatygowani",
	"pofilmowani",
	"poganiani",
	"pogardzani",
	"pogardzeni",
	"pogarszani",
	"pogaszeni",
	"pogładzeni",
	"pogłaskani",
	"pogłębiani",
	"pogłębieni",
	"pogłośnieni",
	"pogmatwani",
	"pognębieni",
	"pogniecieni",
	"pogodzeni",
	"pogonieni",
	"pogorszeni",
	"pogotowani",
	"pograbieni",
	"pogrążani",
	"pogrążeni",
	"pogrożeni",
	"pogrubiani",
	"pogrubieni",
	"pogruchani",
	"pogruchotani",
	"pogrupowani",
	"pogrywani",
	"pogryzani",
	"pogryzieni",
	"pogrzani",
	"pogrzebani",
	"pogubieni",
	"pogwałcani",
	"pohamowani",
	"pohandlowani",
	"poharatowani",
	"pohuśtani",
	"poinformowani",
	"poinstruowani",
	"pojednani",
	"pojmowani",
	"pojeni",
	"pokajani",
	"pokaleczeni",
	"pokarani",
	"pokarmieni",
	"pokąsani",
	"pokatalogowani",
	"pokazani",
	"pokazywani",
	"pokiereszowani",
	"pokierowani",
	"pokiwani",
	"pokładani",
	"poklepani",
	"poklepywani",
	"pokłonieni",
	"pokochani",
	"pokolorowani",
	"pokoloryzowani",
	"pokołysani",
	"pokombinowani",
	"pokomplikowani",
	"pokonani",
	"pokończeni",
	"pokonywani",
	"pokopani",
	"pokrajani",
	"pokrążeni",
	"pokręceni",
	"pokrojeni",
	"pokruszeni",
	"pokrywani",
	"pokrzepiani",
	"pokrzepieni",
	"pokrzyżowani",
	"pokuszeni",
	"pokutowani",
	"połączeni",
	"polakierowani",
	"połamani",
	"polani",
	"połapani",
	"połaskotani",
	"połatani",
	"polecani",
	"połechtani",
	"poleceni",
	"poleczeni",
	"polegani",
	"polemizowani",
	"polepszani",
	"polepszeni",
	"polerowani",
	"polewani",
	"policzkowani",
	"policzeni",
	"polimeryzowani",
	"polizani",
	"polowani",
	"połowieni",
	"położeni",
	"polubieni",
	"poluźnieni",
	"poluzowani",
	"połykani",
	"pomacani",
	"pomachani",
	"pomagani",
	"pomalowani",
	"pomarynowani",
	"pomasowani",
	"pomazani",
	"pomęczeni",
	"pomiatani",
	"pomieszani",
	"pomieszczeni",
	"pomijani",
	"pomiziani",
	"pomnażani",
	"pomniejszani",
	"pomniejszeni",
	"pomnożeni",
	"pomoczeni",
	"pompowani",
	"pomydleni",
	"pomyleni",
	"pomyszkowani",
	"pomywani",
	"ponabijani",
	"ponaciskani",
	"ponadziewani",
	"ponaglani",
	"ponagleni",
	"ponagrywani",
	"ponaklejani",
	"ponakłuwani",
	"ponakrywani",
	"ponaprawiani",
	"ponawiani",
	"poniańczeni",
	"poniechani",
	"ponieiwerani",
	"poniesieni",
	"poniszczeni",
	"poniżani",
	"poniżeni",
	"ponoszeni",
	"ponowieni",
	"ponudzeni",
	"poobcinani",
	"poobcowani",
	"poobczajani",
	"poobijani",
	"poobmacywani",
	"poobracani",
	"poobserwowani",
	"poodbijani",
	"poodcinani",
	"poodgryzani",
	"poodkurzani",
	"poodprawiani",
	"poodsuwani",
	"poodwalani",
	"pooglądani",
	"poograniczani",
	"poopalani",
	"poopiekani",
	"poopwiadani",
	"pootwierani",
	"popadani",
	"popakowani",
	"popaleni",
	"poparzeni",
	"popchani",
	"popędzani",
	"popędzeni",
	"popękani",
	"popełniani",
	"popełnieni",
	"poperfumowani",
	"popierani",
	"popieszczeni",
	"popijani",
	"popilnowani",
	"popisani",
	"popłaceni",
	"popłakiwani",
	"poplamieni",
	"poplątani",
	"popluskani",
	"popodcinani",
	"popodziwiani",
	"popoprawiani",
	"poprani",
	"poprasowani",
	"poprawiani",
	"poprawieni",
	"poproszeni",
	"poprowadzeni",
	"popryskani",
	"poprzebierani",
	"poprzeciągani",
	"poprzecinani",
	"poprzedzani",
	"poprzeglądani",
	"poprzeklinani",
	"poprzekopywani",
	"poprzemieszczani",
	"poprzenoszeni",
	"poprzesadzani",
	"poprześladowani",
	"poprzestawiani",
	"poprzesuwani",
	"poprzewieszani",
	"poprzewracani",
	"poprzycinani",
	"poprzymierzani",
	"poprzytulani",
	"poprzywiązywani",
	"popudrowani",
	"popukani",
	"popularyzowani",
	"popuszczani",
	"popuszczeni",
	"popychani",
	"popykani",
	"popytani",
	"porabiani",
	"porachowani",
	"poranieni",
	"poratowani",
	"porażeni",
	"poręczeni",
	"porównani",
	"porozbierani",
	"porozbijani",
	"porozciągani",
	"porozcinani",
	"porozdawani",
	"porozdzielani",
	"porozmieszczani",
	"poróżnieni",
	"porozpędzani",
	"porozpieszczani",
	"porozprowadzani",
	"porozpruwani",
	"porozrzucani",
	"porozstawiani",
	"porozsyłani",
	"porozumiewani",
	"porozwalani",
	"porozwiązywani",
	"porozwieszani",
	"porozwożeni",
	"portretowani",
	"poruszani",
	"poruszeni",
	"porwani",
	"porysowani",
	"porywani",
	"porządkowani",
	"porządzeni",
	"porzucani",
	"porzuceni",
	"posądzani",
	"posadzeni",
	"posądzeni",
	"pościągani",
	"pościeleni",
	"pościerani",
	"pościgani",
	"pościnani",
	"pościskani",
	"posegregowani",
	"posiadani",
	"posiani",
	"posiekani",
	"posilani",
	"posiłkowani",
	"posileni",
	"posiłowani",
	"posiniaczeni",
	"posiorbani",
	"poskąpieni",
	"poskładani",
	"posklejani",
	"poskramiani",
	"poskręcani",
	"poskrobani",
	"poskromieni",
	"poskubani",
	"posłani",
	"posłodzeni",
	"poślubiani",
	"poślubieni",
	"posługiwani",
	"posmakowani",
	"posmarowani",
	"posoleni",
	"posortowani",
	"pospekulowani",
	"pospieszani",
	"pośpieszani",
	"pośpiewani",
	"pospinani",
	"pospłacani",
	"posprawdzani",
	"posprzątani",
	"posprzedawani",
	"pośredniczeni",
	"possani",
	"postanowieni",
	"postani",
	"postarani",
	"postawieni",
	"postemplowani",
	"posterowani",
	"postradani",
	"postraszeni",
	"postrugani",
	"postrzegani",
	"postrzelani",
	"postrzeleni",
	"postukani",
	"postymulowani",
	"posuwani",
	"poświącani",
	"poświadczeni",
	"poświeceni",
	"poświęceni",
	"poświętowani",
	"poświntuszeni",
	"posyłani",
	"posypani",
	"posypywani",
	"poszarpani",
	"poszastani",
	"poszatkowani",
	"poszczyceni",
	"poszczypani",
	"poszerzani",
	"poszerzeni",
	"poszorowani",
	"poszpiegowani",
	"poszturchani",
	"poszukani",
	"poszukiwani",
	"poszwędani",
	"poszybowani",
	"potakiwani",
	"potarmoszeni",
	"potasowani",
	"potęgowani",
	"potępiani",
	"potępieni",
	"potoczeni",
	"potopieni",
	"potorturowani",
	"potrącani",
	"potrąceni",
	"potraktowani",
	"potrojeni",
	"potrząsani",
	"potrzaskani",
	"potrzymani",
	"Poturbowani",
	"poturlani",
	"potwierdzeni",
	"potykani",
	"poucinani",
	"pouczani",
	"pouczeni",
	"poudawani",
	"poukładani",
	"pouprawiani",
	"poupychani",
	"pourywani",
	"poustawiani",
	"poużywani",
	"powąchani",
	"powachlowani",
	"powalani",
	"powaleni",
	"poważani",
	"powbijani",
	"powciągani",
	"powciskani",
	"powdychani",
	"powęszeni",
	"powetowani",
	"powiadamiani",
	"powiadomieni",
	"powiązani",
	"powiedziani",
	"powiedzeni",
	"powiększani",
	"powielani",
	"powieleni",
	"powierzani",
	"powierzeni",
	"powieszeni",
	"powiewani",
	"powinszowani",
	"powitani",
	"powkładani",
	"powlekani",
	"powłóczeni",
	"powodowani",
	"powołani",
	"powoływani",
	"powożeni",
	"powpychani",
	"powróceni",
	"powrzucani",
	"powsadzani",
	"powspominani",
	"powstrzymani",
	"powtarzani",
	"powtórzeni",
	"powybierani",
	"powybijani",
	"powycierani",
	"powycinani",
	"powyciskani",
	"powydawani",
	"powyganiani",
	"powyginani",
	"powyjaśniani",
	"powyjmowani",
	"powyłączani",
	"powymiatani",
	"powymieniani",
	"powynoszeni",
	"powypełniani",
	"powypisywani",
	"powyrywani",
	"powyrzucani",
	"powystrzelani",
	"powysyłani",
	"powywalani",
	"powywieszani",
	"powywracani",
	"pozabawiani",
	"pozabijani",
	"pozacierani",
	"pożądani",
	"pożądleni",
	"pozadzierani",
	"pozakładani",
	"pozaklinani",
	"pozałatwiani",
	"pozamiatani",
	"pozamieniani",
	"pozamrażani",
	"pozamykani",
	"pozapalani",
	"pozapinani",
	"pozapisywani",
	"pozapraszani",
	"pozasłaniani",
	"pozastrzelani",
	"pozatykani",
	"pozbawiani",
	"pozbawieni",
	"pozbierani",
	"pozbywani",
	"pozdejmowani",
	"pozdrawiani",
	"pozdrowieni",
	"pożegnani",
	"pożerani",
	"pozmiatani",
	"pozmieniani",
	"pozmywani",
	"poznaczeni",
	"poznani",
	"poznawani",
	"poznęcani",
	"pozorowani",
	"pozostawiani",
	"pozostawieni",
	"pozowani",
	"pozrywani",
	"pozszywani",
	"pozwalniani",
	"pozwani",
	"pozwiązywani",
	"pozwiedzani",
	"pozwoleni",
	"pożyczani",
	"pożyczeni",
	"pozyskani",
	"pozywani",
	"pożywiani",
	"pożywieni",
	"praktykowani",
	"prani",
	"prasowani",
	"prawieni",
	"prażeni",
	"precyzowani",
	"preferowani",
	"prenumerowani",
	"prezentowani",
	"próbowani",
	"procesowani",
	"produkowani",
	"profanowani",
	"profilowani",
	"prognozowani",
	"programowani",
	"projektowani",
	"proklamowani",
	"prolongowani",
	"promieniowani",
	"promowani",
	"propagowani",
	"proponowani",
	"prosperowani",
	"prostowani",
	"proszkowani",
	"proszeni",
	"protestowani",
	"protokołowani",
	"prowadzeni",
	"prowokowani",
	"pryskani",
	"przeanalizowani",
	"przearanżowani",
	"przebaczani",
	"przebaczeni",
	"przebadani",
	"przebierani",
	"przebijani",
	"przeboleni",
	"przebrani",
	"przebudowani",
	"przebudowywani",
	"przebudzani",
	"przebudzeni",
	"przebukowani",
	"przebywani",
	"przeceniani",
	"przecenieni",
	"przechlapani",
	"przechodzeni",
	"przechowani",
	"przechowywani",
	"przechrzceni",
	"przechwyceni",
	"przechwytywani",
	"przechylani",
	"przechyleni",
	"przechytrzani",
	"przechytrzeni",
	"przeciągani",
	"przeciążani",
	"przeciążeni",
	"przeciekani",
	"przecierani",
	"przecierpiani",
	"przecinani",
	"przeciskani",
	"przeciwstawiani",
	"przećwiczeni",
	"przeczekani",
	"przeczesani",
	"przeczesywani",
	"przeczołgani",
	"przeczuwani",
	"przeczyszczeni",
	"przeczytani",
	"przedawkowani",
	"przedawkowywani",
	"przedekorowani",
	"przedłożeni",
	"przedłużani",
	"przedłużeni",
	"przedmuchani",
	"przedobrzeni",
	"przedostani",
	"przedostawani",
	"przedstawiani",
	"przedstawieni",
	"przedymani",
	"przedyskutowani",
	"przedzierani",
	"przedziurawieni",
	"przedziurkowani",
	"przeegzaminowani",
	"przefaksowani",
	"przefarbowani",
	"przefasonowani",
	"przefasowani",
	"przefaxowani",
	"przefiltrowani",
	"przeformowani",
	"przeforsowani",
	"przegadani",
	"przeganani",
	"przeganiani",
	"przegapiani",
	"przegapieni",
	"przeginani",
	"przeglądani",
	"przegłodzeni",
	"przegłosowani",
	"przegonieni",
	"przegotowani",
	"przegotowywani",
	"przegrabieni",
	"przegradzani",
	"przegrani",
	"przegrupowani",
	"przegrupowywani",
	"przegrywani",
	"przegryzani",
	"przegryzieni",
	"przegrzani",
	"przegrzebani",
	"przegrzewani",
	"przehandlowani",
	"przeholowani",
	"przeinstalowani",
	"przeistoczeni",
	"przejadani",
	"przejaskrawiani",
	"przejaśnieni",
	"przejawiani",
	"przejawieni",
	"przejechani",
	"przejeżdżani",
	"przejmowani",
	"przejrzani",
	"przekabacani",
	"przekabaceni",
	"przekablowani",
	"przekalibrowani",
	"przekalkulowani",
	"przekarmiani",
	"przekąszeni",
	"przekazywani",
	"przekierowani",
	"przekierowywani",
	"przekimani",
	"przekładani",
	"przeklejeni",
	"przeklinani",
	"przekonani",
	"przekonfigurowani",
	"przekonstruowani",
	"przekonwertowani",
	"przekonywani",
	"przekopani",
	"przekopywani",
	"przekoziołkowani",
	"przekraczani",
	"przekręcani",
	"przekręceni",
	"przekreślani",
	"przekreśleni",
	"przekroczeni",
	"przekrojeni",
	"przekrzyczeni",
	"przekrzywieni",
	"przekształcani",
	"przekształceni",
	"przekupieni",
	"przekupywani",
	"przekwalifikowani",
	"przełączani",
	"przełączeni",
	"przeładowani",
	"przeładowywani",
	"przełamani",
	"przełamywani",
	"przelani",
	"przelatywani",
	"przeleciani",
	"przelewani",
	"przeleżani",
	"przelicytowani",
	"przeliczani",
	"przeliczeni",
	"przeliterowani",
	"przełożeni",
	"przełykani",
	"przemalowani",
	"przemalowywani",
	"przemaszerowani",
	"przemawiani",
	"przemeblowani",
	"przemęczeni",
	"przemieleni",
	"przemieniani",
	"przemierzeni",
	"przemieszczani",
	"przemieszczeni",
	"przemijani",
	"przemilczani",
	"przemilczeni",
	"przemodelowani",
	"przemusztrowani",
	"przemycani",
	"przemyceni",
	"przemyślani",
	"przemyśleni",
	"przemywani",
	"przenegocjowani",
	"przeniesieni",
	"przenikani",
	"przenoszeni",
	"przeobrażani",
	"przeobrażeni",
	"przeoczani",
	"przeoczeni",
	"przeorani",
	"przeorganizowani",
	"przeorientowani",
	"przepadani",
	"przepakowani",
	"przepaleni",
	"przeparkowani",
	"przepchani",
	"przepędzani",
	"przepędzeni",
	"przepełniani",
	"przepełnieni",
	"przepijani",
	"przepiłowani",
	"przepisani",
	"przepisywani",
	"przepłacani",
	"przepłaceni",
	"przepłakani",
	"przeplanowani",
	"przepłoszeni",
	"przepłukani",
	"przepłukiwani",
	"przepływani",
	"przepompowani",
	"przepompowywani",
	"przepowiadani",
	"przepowiedziani",
	"przepracowani",
	"przepracowywani",
	"przeprani",
	"przeprawiani",
	"przeprawieni",
	"przeprogramowani",
	"przeprojektowani",
	"przeprowadzani",
	"przeprowadzeni",
	"przepuszczani",
	"przepuszczeni",
	"przepychani",
	"przepytani",
	"przepytywani",
	"przerąbani",
	"przerabiani",
	"przeradzani",
	"przerastani",
	"przerażeni",
	"przeredagowani",
	"przerejestrowani",
	"przerobieni",
	"przerodzeni",
	"przerwani",
	"przerysowani",
	"przerywani",
	"przerzedzani",
	"przerzucani",
	"przerzuceni",
	"przesączeni",
	"przesadzani",
	"przesądzani",
	"przesadzeni",
	"przesądzeni",
	"prześcigani",
	"przesiadani",
	"przesiadywani",
	"przesiani",
	"przesiedlani",
	"przesiedleni",
	"przesiedziani",
	"przesiewani",
	"przesileni",
	"przeskakiwani",
	"przeskalowani",
	"przeskanowani",
	"przeskoczeni",
	"przeskrobani",
	"prześladowani",
	"przesłaniani",
	"przesłani",
	"prześledzeni",
	"przesłodzeni",
	"przesłuchani",
	"przesłuchiwani",
	"przesmarowani",
	"przesoleni",
	"przesortowani",
	"przespani",
	"prześpiewani",
	"przessani",
	"przestawiani",
	"przestawieni",
	"przestemplowani",
	"przestraszeni",
	"przestrojeni",
	"przestrzegani",
	"przestrzeleni",
	"przestudiowani",
	"przesuwani",
	"prześwietlani",
	"prześwietleni",
	"przesyłani",
	"przesypani",
	"przesypiani",
	"przesypywani",
	"przeszarżowani",
	"przeszczepiani",
	"przeszczepieni",
	"przeszkadzani",
	"przeszkoleni",
	"przeszmuglowani",
	"przeszukani",
	"przeszukiwani",
	"przeszywani",
	"przetaczani",
	"przetapetowani",
	"przetestowani",
	"przetkani",
	"przetoczeni",
	"przetopieni",
	"przetrąceni",
	"przetransformowani",
	"przetransmitowani",
	"przetransponowani",
	"przetransportowani",
	"przetrawieni",
	"przetrwani",
	"przetrząsani",
	"przetrzepani",
	"przetrzymani",
	"przetrzymywani",
	"przetwarzani",
	"przetworzeni",
	"przewalani",
	"przewalczeni",
	"przewaletowani",
	"przewaleni",
	"przeważani",
	"przeważeni",
	"przewertowani",
	"przewiązani",
	"przewiązywani",
	"przewidywani",
	"przewidziani",
	"przewiercani",
	"przewierceni",
	"przewieszani",
	"przewieszeni",
	"przewietrzeni",
	"przewiezieni",
	"przewijani",
	"przewitani",
	"przewodniczeni",
	"przewodzeni",
	"przewożeni",
	"przewracani",
	"przewróceni",
	"przewyższani",
	"przeymierzani",
	"przeżeglowani",
	"przeżegnani",
	"przeziębieni",
	"przezimowani",
	"przeznaczani",
	"przeznaczeni",
	"przezwyciężani",
	"przezwyciężeni",
	"przezywani",
	"przeżywani",
	"przodowani",
	"przpochlebieni",
	"przwdziewani",
	"przybastowani",
	"przybierani",
	"przybijani",
	"przybliżani",
	"przybliżeni",
	"przybrani",
	"przycelowani",
	"przycepieni",
	"przychyleni",
	"przyciągani",
	"przyciemnieni",
	"przycinani",
	"przyciskani",
	"przyciszeni",
	"przyćmiewani",
	"przyćmieni",
	"przycumowani",
	"przyczepiani",
	"przyczesani",
	"przyczołgani",
	"przyczynieni",
	"przydeptani",
	"przyduszeni",
	"przydzielani",
	"przydzieleni",
	"przygaszeni",
	"przygazowani",
	"przygładzani",
	"przygnębiani",
	"przygniatani",
	"przygniecieni",
	"przygotowani",
	"przygruchani",
	"przygrywani",
	"przygryzani",
	"przygryzieni",
	"przygrzani",
	"przygwożdżeni",
	"przyhamowani",
	"przyholowani",
	"przyjani",
	"przyjmowani",
	"przyjrzani",
	"przykładani",
	"przyklejeni",
	"przyklepani",
	"przykopani",
	"przykręcani",
	"przykręceni",
	"przykróceni",
	"przykrywani",
	"przykurzeni",
	"przykuwani",
	"przyłączani",
	"przyłączeni",
	"przylani",
	"przyłapani",
	"przylegani",
	"przylepiani",
	"przylepieni",
	"przyłożeni",
	"przymierzeni",
	"przymilani",
	"przymocowani",
	"przymuszani",
	"przynależeni",
	"przyniesieni",
	"przynoszeni",
	"przynudzani",
	"przyostrzeni",
	"przyozdabiani",
	"przyozdobieni",
	"przypakowani",
	"przypakowywani",
	"przypalani",
	"przypaleni",
	"przypasowani",
	"przypatrywani",
	"przypatrzeni",
	"przypieczętowani",
	"przypiekani",
	"przypierani",
	"przypilnowani",
	"przypiłowani",
	"przypinani",
	"przypisani",
	"przypisywani",
	"przypłaceni",
	"przyplątani",
	"przypodobani",
	"przypominani",
	"przypomniani",
	"przyporządkowani",
	"przyprawiani",
	"przyprawieni",
	"przyprowadzeni",
	"przypucowani",
	"przypudrowani",
	"przypuszczani",
	"przypuszczeni",
	"przyrównani",
	"przyrządzani",
	"przyrządzeni",
	"przysiadani",
	"przyskrzydleni",
	"przyskrzyniani",
	"przyskrzynieni",
	"przysłaniani",
	"przysłani",
	"przysłodzeni",
	"przysłonieni",
	"przysłuchiwani",
	"przysługiwani",
	"przysłużeni",
	"przysmażani",
	"przysmażeni",
	"przyspieszani",
	"przyspieszeni",
	"przysporzeni",
	"przysposobieni",
	"przyśrubowywani",
	"przyssani",
	"przystąpieni",
	"przystawiani",
	"przystawieni",
	"przystemplowani",
	"przystopowani",
	"przystosowani",
	"przystrojeni",
	"przysuwani",
	"przyswajani",
	"przyświecani",
	"przyświęceni",
	"przyswojeni",
	"przysyłani",
	"przysypani",
	"przyszpileni",
	"przyszykowani",
	"przyszywani",
	"przytaczani",
	"przytargani",
	"przytaszczani",
	"przytępiani",
	"przytępieni",
	"przytkani",
	"przytłaczani",
	"przytłoczeni",
	"przytłumieni",
	"przytoczeni",
	"przytrafieni",
	"przytroczeni",
	"przytruwani",
	"przytrzymani",
	"przytrzymywani",
	"przytulani",
	"przytuleni",
	"przytwierdzani",
	"przytwierdzeni",
	"przytykani",
	"przyuczeni",
	"przyuważeni",
	"przywabieni",
	"przywalani",
	"przywaleni",
	"przywarowani",
	"przywdziani",
	"przywiązani",
	"przywiązywani",
	"przywidziani",
	"przywiezieni",
	"przywitani",
	"przywłaszczani",
	"przywłaszczeni",
	"przywołani",
	"przywoływani",
	"przywożeni",
	"przywracani",
	"przywróceni",
	"przyznaczeni",
	"przyznani",
	"przyznawani",
	"przyzwalani",
	"przyzwani",
	"przyzwyczajani",
	"przyzwyczajeni",
	"przyzywani",
	"psiamani",
	"pstrykani",
	"publikowani",
	"pucowani",
	"pudłowani",
	"pudrowani",
	"punktowani",
	"pustoszeni",
	"puszczani",
	"puszczeni",
	"puszkowani",
	"puszeni",
	"pykani",
	"pytani",
	"rabowani",
	"rachowani",
	"racjonalizowani",
	"racjonowani",
	"raczeni",
	"radowani",
	"ranieni",
	"raportowani",
	"ratowani",
	"ratyfikowani",
	"reaktywowani",
	"realizowani",
	"reanimowani",
	"recytowani",
	"ręczeni",
	"redagowani",
	"redukowani",
	"reformowani",
	"refowani",
	"regenerowani",
	"regionalizowani",
	"regulowani",
	"reinkarnowani",
	"rejestrowani",
	"reklamowani",
	"rekomendowani",
	"rekompensowani",
	"rekonstruowani",
	"rekreowani",
	"rekrutowani",
	"rekwirowani",
	"relacjonowani",
	"relaksowani",
	"remodulowani",
	"remontowani",
	"renegocjowani",
	"reorganizowani",
	"reperowani",
	"replikowani",
	"represejonowani",
	"reprezentowani",
	"reprodukowani",
	"resetowani",
	"resocjalizowani",
	"respektowani",
	"resuscytowani",
	"retuszowani",
	"rewanżowani",
	"rewidowani",
	"rezerwowani",
	"rezonowani",
	"rezygnowani",
	"reżyserowani",
	"robieni",
	"rodzeni",
	"rojeni",
	"rolowani",
	"romansowani",
	"ronieni",
	"rozbawiani",
	"rozbawieni",
	"rozbierani",
	"rozbijani",
	"rozbrajani",
	"rozbrojeni",
	"rozbudowani",
	"rozbudowywani",
	"rozbudzani",
	"rozbudzeni",
	"rozbujani",
	"rozcapierzeni",
	"rozchmurzeni",
	"rozchodzeni",
	"rozchylani",
	"rozchyleni",
	"rozciągani",
	"rozcieńczani",
	"rozcieńczeni",
	"rozcierani",
	"rozcinani",
	"rozczarowani",
	"rozczarowywani",
	"rozczesani",
	"rozczłonkowani",
	"rozczulani",
	"rozczytani",
	"rozdani",
	"rozdawani",
	"rozdeptani",
	"rozdmuchani",
	"rozdmuchiwani",
	"rozdrabniani",
	"rozdrapani",
	"rozdrapywani",
	"rozdrażniani",
	"rozdrażnieni",
	"rozduszeni",
	"rozdwojeni",
	"rozdysponowani",
	"rozdzielani",
	"rozdzieleni",
	"rozdzierani",
	"rozdziewiczeni",
	"rozebrani",
	"rozedrani",
	"rozegrani",
	"rozegrywani",
	"rozepchani",
	"rozerwani",
	"rozesłani",
	"rozgaszczani",
	"rozglaszani",
	"rozgłoszeni",
	"rozgniatani",
	"rozgniecieni",
	"rozgniewani",
	"rozgonieni",
	"rozgraniczeni",
	"rozgrani",
	"rozgromieni",
	"rozgrywani",
	"rozgryzani",
	"rozgryzieni",
	"rozgrzani",
	"rozgrzebywani",
	"rozgrzeszeni",
	"rozgrzewani",
	"rozhuśtani",
	"rozjaśniani",
	"rozjaśnieni",
	"rozjechani",
	"rozjedzeni",
	"rozjuszani",
	"rozjuszeni",
	"rozkazani",
	"rozkazywani",
	"rozkładani",
	"rozklejani",
	"rozklejeni",
	"rozkołysani",
	"rozkopani",
	"rozkopywani",
	"rozkoszowani",
	"rozkręcani",
	"rozkręceni",
	"rozkrojeni",
	"rozkruszeni",
	"rozkuwani",
	"rozkwaszeni",
	"rozkwaterowani",
	"rozkwitani",
	"rozłączeni",
	"rozładowani",
	"rozładowywani",
	"rozłamani",
	"rozlani",
	"rozlewani",
	"rozliczani",
	"rozliczeni",
	"rozlokowani",
	"rozłożeni",
	"rozłupani",
	"rozluźniani",
	"rozmanażani",
	"rozmasowani",
	"rozmawiani",
	"rozmazani",
	"rozmazywani",
	"rozmiękczeni",
	"rozmieniani",
	"rozmienieni",
	"rozmieszczani",
	"rozmieszczeni",
	"rozmnożeni",
	"rozmontowani",
	"rozmówieni",
	"rozmrażani",
	"rozmrożeni",
	"rozmyślani",
	"różnicowani",
	"rozniecani",
	"rozniecieni",
	"rozniesieni",
	"różnieni",
	"roznoszeni",
	"rozochoceni",
	"rozpaczani",
	"rozpakowani",
	"rozpakowywani",
	"rozpalani",
	"rozpaleni",
	"rozpamiętywani",
	"rozpaskudzani",
	"rozpatrywani",
	"rozpatrzeni",
	"rozpędzani",
	"rozpędzeni",
	"rozpętani",
	"rozpieszczani",
	"rozpieszczeni",
	"rozpiłowani",
	"rozpinani",
	"rozpisani",
	"rozpisywani",
	"rozplanowani",
	"rozpłaszczani",
	"rozpłaszczeni",
	"rozplątani",
	"rozplątywani",
	"rozpoczynani",
	"rozpogodzeni",
	"rozporządzani",
	"rozporządzeni",
	"rozpościerani",
	"rozpostrzeni",
	"rozpowiadani",
	"rozpowiedziani",
	"rozpowszechniani",
	"rozpowszechnieni",
	"rozpoznani",
	"rozpoznawani",
	"rozpracowani",
	"rozpraszani",
	"rozprawiani",
	"rozprawiczeni",
	"rozprawieni",
	"rozprostowani",
	"rozproszeni",
	"rozprowadzani",
	"rozprowadzeni",
	"rozpruwani",
	"rozprzestrzeniani",
	"rozprzestrzenieni",
	"rozpuszczani",
	"rozpuszczeni",
	"rozpychani",
	"rozpylani",
	"rozpyleni",
	"rozpytani",
	"rozpytywani",
	"rozrastani",
	"rozreklamowani",
	"rozrobieni",
	"rozróżniani",
	"rozróżnieni",
	"rozruszani",
	"rozrysowani",
	"rozrywani",
	"rozrzucani",
	"rozsadzani",
	"rozsadzeni",
	"rozsądzeni",
	"rozścieleni",
	"rozsiani",
	"rozsiekani",
	"rozsiewani",
	"rozsiodłani",
	"rozsławiani",
	"rozsławieni",
	"rozsmarowani",
	"rozsmarowywani",
	"rozśmieszani",
	"rozstani",
	"rozstąpieni",
	"rozstawani",
	"rozstawiani",
	"rozstawieni",
	"rozstrojeni",
	"rozstrząsani",
	"rozstrzeliwani",
	"rozstrzeleni",
	"rozstrzygani",
	"rozsupłani",
	"rozświetlani",
	"rozświetleni",
	"rozsyłani",
	"rozsypani",
	"rozsypywani",
	"rozszarpani",
	"rozszarpywani",
	"rozszczepiani",
	"rozszczepieni",
	"rozszerzani",
	"rozszerzeni",
	"rozszyfrowani",
	"roztaczani",
	"roztapiani",
	"roztoczeni",
	"roztopieni",
	"roztrwonieni",
	"roztrząsani",
	"roztrzaskani",
	"rozumiani",
	"rozumowani",
	"rozwalani",
	"rozwaleni",
	"rozważani",
	"rozważeni",
	"rozweselani",
	"rozweseleni",
	"rozwiani",
	"rozwiązani",
	"rozwiązywani",
	"rozwidniani",
	"rozwiedzieni",
	"rozwierani",
	"rozwierceni",
	"rozwieszani",
	"rozwieszeni",
	"rozwiewani",
	"rozwiezieni",
	"rozwikłani",
	"rozwlekani",
	"rozwodzeni",
	"rozwścieczani",
	"rozwścieczeni",
	"rozzłoszczeni",
	"rugani",
	"ruinowani",
	"rujnowani",
	"ruszani",
	"ruszeni",
	"rwani",
	"ryczani",
	"ryglowani",
	"rymowani",
	"rysowani",
	"ryzykowani",
	"rządzeni",
	"rzeźbieni",
	"rzucani",
	"rzuceni",
	"rzygani",
	"sabotażowani",
	"sączeni",
	"sadzani",
	"sadzeni",
	"sądzeni",
	"salutowani",
	"salwowani",
	"sankcjonowani",
	"satysfakcjonowani",
	"scaleni",
	"scementowani",
	"scentrowani",
	"scharakteryzowani",
	"schładzani",
	"schlani",
	"schlapani",
	"schlebieni",
	"schłodzeni",
	"schowani",
	"schronieni",
	"schrupani",
	"schrzanieni",
	"schwytani",
	"schylani",
	"ścieleni",
	"ściemniani",
	"ściemnieni",
	"ścierani",
	"ścierpieni",
	"ścigani",
	"ścinani",
	"ściskani",
	"ściszani",
	"ściszeni",
	"sędziowani",
	"segregowani",
	"selekcjonowani",
	"separowani",
	"sępieni",
	"serwowani",
	"sfabrykowani",
	"sfajczeni",
	"sfałszowani",
	"sfaulowani",
	"sfilmowani",
	"sfinalizowani",
	"sfinansowani",
	"sfingowani",
	"sformalizowani",
	"sformatowani",
	"sformowani",
	"sformułowani",
	"sforsowani",
	"sfotografowani",
	"shimmerowani",
	"siani",
	"siekani",
	"siorbani",
	"skadrowani",
	"skakani",
	"skalani",
	"skaleczeni",
	"skalibrowani",
	"skalkulowani",
	"skalpowani",
	"skanalizowani",
	"skandowani",
	"skanowani",
	"skapitulowani",
	"skarceni",
	"skarżeni",
	"skasowani",
	"skatalogowani",
	"skazani",
	"skażeni",
	"skazywani",
	"skierowani",
	"składani",
	"składowani",
	"skłaniani",
	"sklasyfikowani",
	"sklecieni",
	"sklejani",
	"sklejeni",
	"sklepani",
	"skłóceni",
	"skłonieni",
	"sklonowani",
	"sknoceni",
	"skojarzeni",
	"skolonizowani",
	"skołowani",
	"skombinowani",
	"skomentowani",
	"skompensowani",
	"skompletowani",
	"skomplikowani",
	"skomponowani",
	"skompresowani",
	"skompromitowani",
	"skomunikowani",
	"skonani",
	"skoncentrowani",
	"skończeni",
	"skondensowani",
	"skonfigurowani",
	"skonfiskowani",
	"skonfrontowani",
	"skonkretyzowani",
	"skonsolidowani",
	"skonstruowani",
	"skonsultowani",
	"skonsumowani",
	"skontaktowani",
	"skontrolowani",
	"skoordynowani",
	"skopani",
	"skopiowani",
	"skorektowani",
	"skorumpowani",
	"skorygowani",
	"skorzystani",
	"skoszeni",
	"skracani",
	"skradzieni",
	"skręcani",
	"skręceni",
	"skremowani",
	"skreślani",
	"skreśleni",
	"skrobani",
	"skróceni",
	"skrojeni",
	"skropieni",
	"skruszeni",
	"skrystalizowani",
	"skrytykowani",
	"skrywani",
	"skrzecowani",
	"skrzyczani",
	"skrzywdzeni",
	"skrzyżowani",
	"skserowani",
	"skubani",
	"skuleni",
	"skumulowani",
	"skupiani",
	"skupieni",
	"skupowani",
	"skurczeni",
	"skuszeni",
	"skuwani",
	"skwitowani",
	"słani",
	"sławieni",
	"śledzeni",
	"ślinieni",
	"ślizgani",
	"słodzeni",
	"słuchani",
	"słyszani",
	"smagani",
	"smarowani",
	"smażeni",
	"śmieceni",
	"smyrani",
	"sondowani",
	"sortowani",
	"spafycikowani",
	"spakowani",
	"spalani",
	"spałaszowani",
	"spaleni",
	"spałowani",
	"spamiętani",
	"spaprani",
	"sparafrazowani",
	"sparaliżowani",
	"sparowani",
	"spartaczeni",
	"spartoleni",
	"sparzeni",
	"spasowani",
	"spatałaszeni",
	"spauzowani",
	"spawani",
	"spawieni",
	"specjalizowani",
	"spędzani",
	"spędzeni",
	"spekulowani",
	"spełniani",
	"spełnieni",
	"spenetrowani",
	"spętani",
	"spierani",
	"śpiewani",
	"spiłowani",
	"spinani",
	"spisani",
	"spiskowani",
	"spisywani",
	"spłacani",
	"spłaceni",
	"splądrowani",
	"splajtowani",
	"splamieni",
	"spłaszczeni",
	"splatani",
	"splątani",
	"spłatani",
	"spławiani",
	"spławieni",
	"spłodzeni",
	"spłoszeni",
	"spłukani",
	"spłukiwani",
	"spluwani",
	"spływani",
	"spoczywani",
	"spodziewani",
	"spojeni",
	"spolaryzowani",
	"spoliczkowani",
	"sponiewierani",
	"sponsorowani",
	"spopielani",
	"spopieleni",
	"spopularyzowani",
	"sportretowani",
	"sporządzani",
	"sporządzeni",
	"spostrzegani",
	"spotęgowani",
	"spotkani",
	"spotykani",
	"spoufalani",
	"spowalniani",
	"spowiadani",
	"spowodowani",
	"spowolnieni",
	"spoźnieni",
	"spóźnieni",
	"spożytkowani",
	"spożywani",
	"sprani",
	"sprasowani",
	"spraszani",
	"sprawdzeni",
	"sprawieni",
	"sprawowani",
	"sprecyzowani",
	"spreparowani",
	"sprężani",
	"sprężeni",
	"spróbowani",
	"sprofanowani",
	"sprofilowani",
	"sprostowani",
	"sproszkowani",
	"sproszeni",
	"sprowadzani",
	"sprowadzeni",
	"sprowokowani",
	"spryskani",
	"spryskiwani",
	"sprywatyzowani",
	"sprzątani",
	"sprzeczani",
	"sprzedani",
	"sprzedawani",
	"sprzeniewierzeni",
	"spudłowani",
	"spustoszeni",
	"spuszczani",
	"spuszczeni",
	"spychani",
	"ssani",
	"stabilizowani",
	"stacjonowani",
	"staczani",
	"staranowani",
	"starczani",
	"stargowani",
	"startowani",
	"stawiani",
	"stawieni",
	"stemplowani",
	"stenografowani",
	"stepowani",
	"sterowani",
	"sterroryzowani",
	"sterylizowani",
	"stłamszeni",
	"stłumieni",
	"stoczeni",
	"stołowani",
	"stonowani",
	"stopieni",
	"stopniowani",
	"storpedowani",
	"stosowani",
	"strącani",
	"straceni",
	"strąceni",
	"strajkowani",
	"straszeni",
	"stratowani",
	"strawieni",
	"streamowani",
	"stresowani",
	"streszczani",
	"streszczeni",
	"strofowani",
	"strojeni",
	"stroszeni",
	"strugani",
	"strymowani",
	"strząsani",
	"strzaskani",
	"strzeleni",
	"strzepani",
	"strzępieni",
	"strzepywani",
	"studiowani",
	"studzeni",
	"stukani",
	"stuleni",
	"stwardnieni",
	"stwarzani",
	"stwierdzani",
	"stwierdzeni",
	"stworzeni",
	"stykani",
	"stylizowani",
	"stymulowani",
	"sugerowani",
	"sumowani",
	"swatani",
	"swawoleni",
	"świadczeni",
	"świeceni",
	"święceni",
	"świerzbieni",
	"świętowani",
	"świntuszeni",
	"syceni",
	"sygnalizowani",
	"symulowani",
	"synchronizowani",
	"sypani",
	"szachrowani",
	"szacowani",
	"szafowani",
	"szamotani",
	"szanowani",
	"szargani",
	"szarpani",
	"szarżowani",
	"szasowani",
	"szastani",
	"szatkowani",
	"szczędzeni",
	"szczepieni",
	"szczerzeni",
	"szczyceni",
	"szczypani",
	"szczytowani",
	"szefowani",
	"szemrani",
	"szeptani",
	"szerzeni",
	"szkalowani",
	"szkicowani",
	"szkleni",
	"szkodzeni",
	"szkoleni",
	"szlachtowani",
	"szlifowani",
	"szmuglowani",
	"szokowani",
	"szorowani",
	"szpachlowani",
	"szpanowani",
	"szperani",
	"szprycowani",
	"szturchani",
	"szturmowani",
	"szufladkowani",
	"szuflowani",
	"szukani",
	"szulerowani",
	"szwankowani",
	"szydełkowani",
	"szydzeni",
	"szyfrowani",
	"szykanowani",
	"szykowani",
	"taktowani",
	"tamowani",
	"tankowani",
	"tapetowani",
	"taplani",
	"taranowani",
	"targani",
	"targowani",
	"tarmoszeni",
	"tarzani",
	"tasowani",
	"taszczeni",
	"tatuowani",
	"telefonowani",
	"telegrfowani",
	"teleportowani",
	"temperowani",
	"teoretyzowani",
	"tępieni",
	"terroryzowani",
	"testowani",
	"tkani",
	"tłamszeni",
	"tłoczeni",
	"tłumaczeni",
	"tłumieni",
	"toczeni",
	"tolerowani",
	"tonowani",
	"topieni",
	"torowani",
	"torturowani",
	"towarzyszeni",
	"trąbieni",
	"trącani",
	"traceni",
	"trąceni",
	"trafiani",
	"trafieni",
	"tragizowani",
	"traktowani",
	"transferowani",
	"transformowani",
	"transmitowani",
	"transportowani",
	"tratowani",
	"trawieni",
	"trenowani",
	"tresowani",
	"triumfowani",
	"tropieni",
	"troszczeni",
	"trwonieni",
	"trymowani",
	"tryskani",
	"tryumfowani",
	"trywializowani",
	"trzaskani",
	"trzepani",
	"trzepotani",
	"trzęsieni",
	"trzymani",
	"tuczeni",
	"tułani",
	"tuleni",
	"turlani",
	"tuszowani",
	"twistowani",
	"tworzeni",
	"tykani",
	"tyranizowani",
	"tyrani",
	"tytułowani",
	"uaktualniani",
	"uaktualnieni",
	"uaktywniani",
	"uaktywnieni",
	"uargumentowani",
	"uatrakcyjnieni",
	"ubabrani",
	"ubarwiani",
	"ubarwieni",
	"ubawieni",
	"ubezpieczani",
	"ubezpieczeni",
	"ubezwłasnowolnieni",
	"ubiczowani",
	"ubiegani",
	"ubierani",
	"ubijani",
	"ubłagani",
	"ubliżani",
	"ubliżeni",
	"ubolewani",
	"ubóstwiani",
	"ubrani",
	"ubroczeni",
	"ubrudzeni",
	"ucałowani",
	"ucharakteryzowani",
	"uchowani",
	"uchronieni",
	"uchwalani",
	"uchwaleni",
	"uchwyceni",
	"uchylani",
	"uchyleni",
	"ucieleśniani",
	"ucierani",
	"ucierpiani",
	"ucinani",
	"uciskani",
	"uciszani",
	"uciszeni",
	"uciułani",
	"ucywilizowani",
	"uczczeni",
	"uczepieni",
	"uczesani",
	"uczęszczani",
	"uczeni",
	"ucztowani",
	"uczynieni",
	"udani",
	"udaremnieni",
	"udawani",
	"udekorowani",
	"udeptywani",
	"uderzani",
	"uderzeni",
	"udobruchani",
	"udokumentowani",
	"udomawiani",
	"udomowieni",
	"udoskonalani",
	"udoskonaleni",
	"udostępniani",
	"udostępnieni",
	"udowadniani",
	"udowodnieni",
	"Udramatyzowani",
	"udręczeni",
	"udrożnieni",
	"udupieni",
	"uduszeni",
	"udzielani",
	"udzieleni",
	"ueiwarygodnieni",
	"ufani",
	"ufarbowani",
	"uformowani",
	"ufortyfikowani",
	"ufundowani",
	"ugadani",
	"uganiani",
	"ugaszani",
	"ugaszeni",
	"uginani",
	"ugłaskani",
	"ugniatani",
	"ugodzeni",
	"ugoszczeni",
	"ugotowani",
	"ugrani",
	"ugruntowani",
	"ugryzieni",
	"uhistoryzowani",
	"uhonorowani",
	"ujadani",
	"ujarzmiani",
	"ujarzmieni",
	"ujawniani",
	"ujawnieni",
	"ujeżdżani",
	"ujeżdżeni",
	"ujmowani",
	"ujrzani",
	"ukamieniowani",
	"ukarani",
	"ukartowani",
	"ukąszeni",
	"ukatrupieni",
	"ukazani",
	"ukazywani",
	"ukierowani",
	"ukierunkowani",
	"układani",
	"uklepani",
	"ukłonieni",
	"ukojeni",
	"ukołysani",
	"ukończeni",
	"ukonkretnieni",
	"ukoronowani",
	"ukradzieni",
	"ukręcani",
	"ukręceni",
	"ukrojeni",
	"ukrywani",
	"ukrzyżowani",
	"ukształtowani",
	"ułagodzeni",
	"ułaskawiani",
	"ułaskawieni",
	"ulatniani",
	"ułatwiani",
	"ułatwieni",
	"uleczani",
	"uleczeni",
	"ulegani",
	"ulepieni",
	"ulepszani",
	"ulepszeni",
	"ulokowani",
	"ulotnieni",
	"ułożeni",
	"umacniani",
	"umalowani",
	"umartwiani",
	"umawiani",
	"umazani",
	"umeblowani",
	"umiejscowieni",
	"umieszczani",
	"umieszczeni",
	"umilani",
	"umileni",
	"umniejszani",
	"umniejszeni",
	"umocnieni",
	"umocowani",
	"umoczeni",
	"umodelowani",
	"umorzeni",
	"umotywowani",
	"umówieni",
	"umożliwiani",
	"umożliwieni",
	"umrocznieni",
	"unaocznieni",
	"unicestwiani",
	"unicestwieni",
	"uniemożliwaini",
	"uniemożliwieni",
	"unierochomieni",
	"uniesieni",
	"unieszczęśliwiani",
	"unieszczęśliwieni",
	"unieszkodliwiani",
	"unieszkodliwieni",
	"unieważniani",
	"unieważnieni",
	"uniewinnieni",
	"uniezależnieni",
	"unikani",
	"unormowani",
	"unoszeni",
	"unowoczesniani",
	"unowocześniani",
	"uodpornieni",
	"uogólniani",
	"upakowani",
	"upalani",
	"upaleni",
	"upamiętniani",
	"upamiętnieni",
	"upaństwowieni",
	"upaprani",
	"upaskudzeni",
	"upchani",
	"upewniani",
	"upewnieni",
	"upgradowani",
	"upiększani",
	"upiększeni",
	"upierani",
	"upierdoleni",
	"upijani",
	"upilnowani",
	"upinani",
	"uplastycznieni",
	"upodabniani",
	"upodobnieni",
	"upojeni",
	"upokorzani",
	"upokorzeni",
	"upolowani",
	"upominani",
	"uporządkowani",
	"upowszechnieni",
	"upozorowani",
	"upozowani",
	"uprani",
	"uprasowani",
	"upraszczani",
	"uprawdopodobnieni",
	"uprawiani",
	"uproszczeni",
	"uproszeni",
	"uprowadzani",
	"uprowadzeni",
	"uprzątani",
	"uprzedeni",
	"uprzedzani",
	"uprzyjemniani",
	"uprzyjemnieni",
	"uprzykrzani",
	"uprzytomnieni",
	"upubliczniani",
	"upublicznieni",
	"upudrowani",
	"upuszczani",
	"upuszczeni",
	"upychani",
	"urabiani",
	"uraczani",
	"uradowani",
	"Urągani",
	"uratowani",
	"urażani",
	"urażeni",
	"uregulowani",
	"urobieni",
	"uronieni",
	"urozmaicani",
	"urozmaiceni",
	"uruchamiani",
	"uruchomieni",
	"urwani",
	"urywani",
	"urządzani",
	"urządzeni",
	"urzeczywistniani",
	"urzeczywistnieni",
	"usadowieni",
	"usadzeni",
	"usamowolnieni",
	"usankcjonowani",
	"usatyfakcjonowani",
	"uściskani",
	"uścisleni",
	"usidleni",
	"usiedzeni",
	"uskładani",
	"uskoczeni",
	"uskuteczniani",
	"uskutecznieni",
	"usłuchani",
	"usługiwani",
	"usłużeni",
	"usłyszani",
	"usmażeni",
	"uśmiani",
	"uśmiercani",
	"uśmierceni",
	"uśmierzeni",
	"uspani",
	"uśpieni",
	"uspokajani",
	"uspokojeni",
	"uspołeczniani",
	"usprawiedliwiani",
	"usprawiedliwieni",
	"usprawnieni",
	"usprzątani",
	"ustabilizowani",
	"ustalani",
	"ustaleni",
	"ustanawiani",
	"ustanowieni",
	"ustąpieni",
	"ustatkowani",
	"ustawiani",
	"ustawieni",
	"ustępowani",
	"ustosunkowani",
	"ustrojeni",
	"ustrzegani",
	"ustrzeleni",
	"ususzeni",
	"usuwani",
	"uświadamiani",
	"uświadczeni",
	"uświadomieni",
	"uświęceni",
	"uświnieni",
	"usychani",
	"usypani",
	"usypiani",
	"usystematyzowani",
	"usytuowani",
	"uszanowani",
	"uszczelniani",
	"uszczęśliwiani",
	"uszczęśliwieni",
	"uszczupleni",
	"uszkadzani",
	"uszkodzeni",
	"uszlachetniani",
	"uszlachetnieni",
	"usztywnieni",
	"uszykowani",
	"utajnieni",
	"utargowani",
	"utemperowani",
	"utkani",
	"utkwieni",
	"utoczeni",
	"utopieni",
	"utorowani",
	"utożsamiani",
	"utożsamieni",
	"utraceni",
	"utrąceni",
	"utrudniani",
	"utrudnieni",
	"utrwalani",
	"utrwaleni",
	"utrzymywani",
	"utuczeni",
	"utuleni",
	"utwierdzani",
	"utwierdzeni",
	"utworzeni",
	"utylizowani",
	"uwalniani",
	"uwaleni",
	"uwarunkowani",
	"uważani",
	"uwiązani",
	"uwiązywani",
	"uwidocznieni",
	"uwieczniani",
	"uwiecznieni",
	"uwielbiani",
	"uwielbieni",
	"uwieńczeni",
	"uwierani",
	"uwierzeni",
	"uwieszeni",
	"uwiezieni",
	"uwięzieni",
	"uwijani",
	"uwikłani",
	"uwłaczani",
	"uwłaszczeni",
	"uwodzeni",
	"uwolnieni",
	"uwsteczniani",
	"uwstecznieni",
	"uwydatniani",
	"uwypikleni",
	"uwzględniani",
	"uwzględnieni",
	"użądleni",
	"uzależniani",
	"uzależnieni",
	"uzasadniani",
	"uzasadnieni",
	"uzbierani",
	"uzbrajani",
	"uzbrojeni",
	"uzdrawiani",
	"uzdrowieni",
	"użerani",
	"uzewnętrzniani",
	"uzewnętrznieni",
	"uzgadniani",
	"uzgodnieni",
	"uziemieni",
	"uzmysłowieni",
	"uznani",
	"uznawani",
	"uzupełniani",
	"uzupełnieni",
	"uzurpowani",
	"użyczani",
	"użyczeni",
	"uzyskani",
	"uzyskiwani",
	"używani",
	"wabieni",
	"wąchani",
	"wachlowani",
	"wahani",
	"walczeni",
	"wałkowani",
	"waleni",
	"ważeni",
	"wbijani",
	"wcelowani",
	"wciągani",
	"wcielani",
	"wcieleni",
	"wcierani",
	"wcinani",
	"wciskani",
	"wczepieni",
	"wczołgani",
	"wczytani",
	"wczytywani",
	"wdani",
	"wdawani",
	"wdeptani",
	"wdetonowani",
	"wdmuchiwani",
	"wdrapani",
	"wdrapywani",
	"wdrażani",
	"wdrążeni",
	"wdrożeni",
	"wduszeni",
	"wdychani",
	"wdzierani",
	"wędkowani",
	"wentylowani",
	"wepchani",
	"werbowani",
	"weryfikowani",
	"wessani",
	"wetkani",
	"wezwani",
	"wgłębiani",
	"wgniatani",
	"wgniecieni",
	"wgrani",
	"wgryzani",
	"wgryzieni",
	"wiązani",
	"wibrowani",
	"widywani",
	"widziani",
	"wiedzeni",
	"wielbieni",
	"wierceni",
	"wierzgani",
	"wierzeni",
	"wieszani",
	"wietrzeni",
	"więżeni",
	"wikłani",
	"windowani",
	"winszowani",
	"wiosłowani",
	"wirowani",
	"witani",
	"wizualizowani",
	"wjeżdżani",
	"wkalkulowani",
	"wkładani",
	"wklejani",
	"wklejeni",
	"wklepani",
	"wkomponowani",
	"wkopani",
	"wkopywani",
	"wkraczani",
	"wkradani",
	"wkradzieni",
	"wkręcani",
	"wkręceni",
	"wkupieni",
	"wkurwiani",
	"wkuwani",
	"włączani",
	"włączeni",
	"władani",
	"władowani",
	"włamani",
	"włamywani",
	"wlani",
	"wlepiani",
	"wlepieni",
	"wlewani",
	"wliczani",
	"wliczeni",
	"włożeni",
	"wmanewrowani",
	"wmanipulowani",
	"wmawiani",
	"wmieszani",
	"wmówieni",
	"wmurowani",
	"wmuszeni",
	"wnerwiani",
	"wnerwieni",
	"wniesieni",
	"wnikani",
	"wnioskowani",
	"wnoszeni",
	"wodowani",
	"wojowani",
	"wołani",
	"woskowani",
	"wożeni",
	"wpajani",
	"wpakowani",
	"wparowani",
	"wpasowani",
	"wpatrywani",
	"wpędzani",
	"wpędzeni",
	"wperswadowani",
	"wpienieni",
	"wpisani",
	"wpisywani",
	"wpłacani",
	"wpłaceni",
	"wplatani",
	"wplątani",
	"wplątywani",
	"wpojeni",
	"wpompowani",
	"wpraszani",
	"wprawiani",
	"wproszeni",
	"wprowadzani",
	"wprowadzeni",
	"wpuszczeni",
	"wpychani",
	"wrabiani",
	"wręczani",
	"wrobieni",
	"wróżeni",
	"wrzucani",
	"wrzuceni",
	"wrzynani",
	"wsadzani",
	"wsadzeni",
	"wskazani",
	"wskazywani",
	"wskórani",
	"wskrzeszani",
	"wskrzeszeni",
	"wślizgiwani",
	"wsłuchani",
	"wspierani",
	"współodczuwani",
	"współtworzeni",
	"wspomagani",
	"wspominani",
	"wspomniani",
	"wstąpieni",
	"wstawiani",
	"wstawieni",
	"wstrząsani",
	"wstrzeleni",
	"wstrzykiwani",
	"wstrzymani",
	"wstrzymywani",
	"wstukani",
	"wsuwani",
	"wsypani",
	"wszamani",
	"wszczepiani",
	"wszczepieni",
	"wszczynani",
	"wtajemniczani",
	"wtajemniczeni",
	"wtapiani",
	"wtaszczeni",
	"wtłoczeni",
	"wtopieni",
	"wtrąceni",
	"wtryniani",
	"wtulani",
	"wtuleni",
	"wtykani",
	"wwaleni",
	"wwiercani",
	"wwierceni",
	"wwiezieni",
	"wwożeni",
	"wyartykułowani",
	"wyautowani",
	"wybaczani",
	"wybaczeni",
	"wybadani",
	"wybatożeni",
	"wybawieni",
	"wybebeszeni",
	"wybełkotani",
	"wybiczowani",
	"wybielani",
	"wybieleni",
	"wybierani",
	"wybijani",
	"wybłagani",
	"wybrandzlowani",
	"wybrani",
	"wybronieni",
	"wybrzydzani",
	"wybuchani",
	"wybudowani",
	"wybudzani",
	"wybudzeni",
	"wyburzani",
	"wyburzeni",
	"wycackani",
	"wycałowani",
	"wyceniani",
	"wycenieni",
	"wychlani",
	"wychłostani",
	"wychodowani",
	"wychowani",
	"wychowywani",
	"wychrobotani",
	"wychwalani",
	"wychwyceni",
	"wychylani",
	"wychyleni",
	"wyciągani",
	"wyciekani",
	"wycieniowani",
	"wycierani",
	"wycinani",
	"wyciskani",
	"wyciszani",
	"wyciszeni",
	"wycofani",
	"wyćwiczeni",
	"wycyckani",
	"wycyganieni",
	"wyczarowani",
	"wyczarterowani",
	"wyczekani",
	"wyczekiwani",
	"wyczerpani",
	"wyczesani",
	"wyczołgani",
	"wyczołgiwani",
	"wyczuwani",
	"wyczyniani",
	"wyczyszczeni",
	"wyczytani",
	"wyczytywani",
	"wydalani",
	"wydaleni",
	"wydani",
	"wydębieni",
	"wydedukowani",
	"wydelegowani",
	"wydepilowani",
	"wydeptywani",
	"wydłubani",
	"wydłubywani",
	"wydłużani",
	"wydłużeni",
	"wydmuchani",
	"wydmuchiwani",
	"wydobywani",
	"wydojeni",
	"wydoroślani",
	"wydostani",
	"wydrani",
	"wydrapani",
	"wydrapywani",
	"wydrążeni",
	"wydrukowani",
	"wydukani",
	"wyduszeni",
	"wydychani",
	"wydziedziczeni",
	"wydzielani",
	"wydzieleni",
	"wydzierani",
	"wydzierżawieni",
	"wydziobani",
	"wydziwiani",
	"wydzwaniani",
	"wyedukowani",
	"wyedytowani",
	"wyeeliminowani",
	"wyegzekwowani",
	"wyeksmitowani",
	"wyekspediowani",
	"wyeksploatowani",
	"wyeksponowani",
	"wyeksportowani",
	"wyeliminowani",
	"wyemigrowani",
	"wyemitowani",
	"wyewoluowani",
	"wygadani",
	"wygadywani",
	"wyganiani",
	"wygarbowani",
	"wygarniani",
	"wygasani",
	"wygaszani",
	"wygaszeni",
	"wygenerowani",
	"wyginani",
	"wygładzani",
	"wygładzeni",
	"wygłaszani",
	"wygłodzeni",
	"wygłosowani",
	"wygłoszeni",
	"wygłówkowani",
	"wygnani",
	"wygoleni",
	"wygonieni",
	"wygooglowani",
	"wygospodarowani",
	"wygotowani",
	"wygrani",
	"wygrawerowani",
	"wygrażani",
	"wygrywani",
	"wygryzieni",
	"wygrzani",
	"wygrzebani",
	"wygrzebywani",
	"wygrzewani",
	"wygubieni",
	"wyhaczeni",
	"wyhaftowani",
	"wyhamowani",
	"wyhodowani",
	"wyizolowani",
	"wyjadani",
	"wyjaśniani",
	"wyjaśnieni",
	"wyjawiani",
	"wyjawieni",
	"wyjedzeni",
	"wyjmowani",
	"wykadrowani",
	"wykalibrowani",
	"wykalkulowani",
	"wykańczani",
	"wykantowani",
	"wykąpani",
	"wykaraskani",
	"wykarczowani",
	"wykarmiani",
	"wykasowani",
	"wykastrowani",
	"wykazani",
	"wykazywani",
	"wykierowani",
	"wykitowani",
	"wykiwani",
	"wykładani",
	"wyklarowani",
	"wyklepani",
	"wyklinani",
	"wykłócani",
	"wykluczani",
	"wykluczeni",
	"wykminieni",
	"wykolejeni",
	"wykołowani",
	"wykombinowani",
	"wykonani",
	"wykończeni",
	"wykonywani",
	"wykopani",
	"wykopywani",
	"wykorkowani",
	"wykorzeniani",
	"wykorzenieni",
	"wykorzystani",
	"wykorzystywani",
	"wykoszeni",
	"wykradani",
	"wykręcani",
	"wykręceni",
	"wykreowani",
	"wykreślani",
	"wykreśleni",
	"wykrochmaleni",
	"wykrojeni",
	"wykrwawiani",
	"wykrwawieni",
	"wykrywani",
	"wykrzesani",
	"wykrztuszeni",
	"wykrzyczeni",
	"wykrzykiwani",
	"wykrzywiani",
	"wykształceni",
	"wyksztuszeni",
	"wykupieni",
	"wykupywani",
	"wykuwani",
	"wyłączani",
	"wyłączeni",
	"wylądowani",
	"wyładowani",
	"wyładowywani",
	"wyłajani",
	"wyłamani",
	"wyłamywani",
	"wyłaniani",
	"wylansowani",
	"wylani",
	"wyłapani",
	"wyłapywani",
	"wyławiani",
	"wyleasingowani",
	"wyleczeni",
	"wylęgani",
	"wylegimytowani",
	"wylewani",
	"wyłgani",
	"wylicytowani",
	"wyliczani",
	"wyliczeni",
	"wylizani",
	"wylizywani",
	"wylogowani",
	"wyłonieni",
	"wylosowani",
	"wyłowieni",
	"wyłożeni",
	"wyłudzani",
	"wyłudzeni",
	"wyłupani",
	"wyłuskani",
	"wyłuskiwani",
	"wyłuszczeni",
	"wyluzowani",
	"wymacani",
	"wymachiwani",
	"wymagani",
	"wymahiwani",
	"wymalowani",
	"wymamrotani",
	"wymanewrowani",
	"wymarzeni",
	"wymasowani",
	"wymawiani",
	"wymazani",
	"wymazywani",
	"wymeldowani",
	"wymeldowywani",
	"wymiatani",
	"wymiecieni",
	"wymieniani",
	"wymienieni",
	"wymierzani",
	"wymieszani",
	"wymigani",
	"wymigiwani",
	"wymijani",
	"wymoczeni",
	"wymodelowani",
	"wymontowani",
	"wymordowani",
	"wymuszani",
	"wymyślani",
	"wymyśleni",
	"wynagradzani",
	"wynagrodzeni",
	"wynajdowani",
	"wynajdywani",
	"wynajmowani",
	"wynalezieni",
	"wynarodowieni",
	"wynegocjowani",
	"wyniesieni",
	"wyniszczani",
	"wyniszczeni",
	"wyniuchani",
	"wynoszeni",
	"wynurzani",
	"wyobrażani",
	"wyobrażeni",
	"wyodrębnieni",
	"wyolbrzymiani",
	"wyolbrzymieni",
	"wyorbowani",
	"wyosiowani",
	"wyostrzani",
	"wyostrzeni",
	"wypaczani",
	"wypakowani",
	"wypakowywani",
	"wypalani",
	"wypaleni",
	"wypałowani",
	"wyparowani",
	"wypasani",
	"wypastowani",
	"wypatroszeni",
	"wypatrywani",
	"wypatrzeni",
	"wypchani",
	"wypędzani",
	"wypędzlowani",
	"wypełniani",
	"wypełnieni",
	"wypersfadowani",
	"wyperswadowani",
	"wypierani",
	"wypijani",
	"wypinani",
	"wypisani",
	"wypisywani",
	"wypłacani",
	"wypłaceni",
	"wypłakani",
	"wypłakiwani",
	"wypłaszczeni",
	"wyplatani",
	"wyplątani",
	"wyplenieni",
	"wyplewieni",
	"wypłoszeni",
	"wypłukani",
	"wypłukiwani",
	"wypluwani",
	"wypoceni",
	"wypolerowani",
	"wypominani",
	"wypomniani",
	"wypompowani",
	"wypompowywani",
	"wyposażeni",
	"wypowiadani",
	"wypowiedziani",
	"wypoziomowani",
	"wypożyczani",
	"wypracowani",
	"wypracowywani",
	"wyprani",
	"wyprasowani",
	"wypraszani",
	"wyprawiani",
	"wyprawieni",
	"wypróbowani",
	"wyprodukowani",
	"wyprojektowani",
	"wypromieniowani",
	"wypromowani",
	"wyprostowani",
	"wyprostowywani",
	"wyproszeni",
	"wyprowadzani",
	"wyprowadzeni",
	"wypróżniani",
	"wypróżnieni",
	"wypruwani",
	"wyprzedani",
	"wyprzedawani",
	"wyprzedzani",
	"wyprzedzeni",
	"wyprzęgani",
	"wypstrykani",
	"wypucowani",
	"wypuszczani",
	"wypuszczeni",
	"wypychani",
	"wypytani",
	"wypytywani",
	"wyrąbani",
	"wyrabiani",
	"wyrąbywani",
	"wyratowani",
	"wyrażani",
	"wyrażeni",
	"wyrecytowani",
	"wyręczani",
	"wyręczeni",
	"wyregulowani",
	"wyrejestrowani",
	"wyremontowani",
	"wyreżyserowani",
	"wyrobieni",
	"wyrolowani",
	"wyrównani",
	"wyrównywani",
	"wyróżniani",
	"wyróżnieni",
	"wyrugowani",
	"wyruszani",
	"wyrwani",
	"wyrypani",
	"wyrysowani",
	"wyrywani",
	"wyrządzeni",
	"wyrzeźbieni",
	"wyrzucani",
	"wyrzuceni",
	"wyrzygani",
	"wyrzynani",
	"wyrzywani",
	"wysączeni",
	"wysadzani",
	"wysadzeni",
	"wyściskani",
	"wyselekcjonowani",
	"wysępieni",
	"wysiadywani",
	"wysiedzeni",
	"wysilani",
	"wysileni",
	"wyskakiwani",
	"wyskalowani",
	"wyskoczeni",
	"wyskrobani",
	"wyskubywani",
	"wysłani",
	"wyśledzeni",
	"wyślizgiwani",
	"wysłowieni",
	"wysłuchani",
	"wysłuchiwani",
	"wysmagani",
	"wysmarkani",
	"wysmarowani",
	"wysmażani",
	"wysmażeni",
	"wyśmiani",
	"wyśmiewani",
	"wysmołowani",
	"wysmyrani",
	"wyśnieni",
	"wysnuwani",
	"wysondowani",
	"wyspecjalizowani",
	"wyśpiewani",
	"wyśpiewywani",
	"wyspowiadani",
	"wysprzątani",
	"wysprzedani",
	"wyssani",
	"wystartowani",
	"wystawieni",
	"wysterelizowani",
	"wysterylizowani",
	"wystosowani",
	"wystosowywani",
	"wystraszeni",
	"wystrojeni",
	"wystrugani",
	"wystrzegani",
	"wystrzelani",
	"wystrzeliwani",
	"wystrzeleni",
	"wystudzeni",
	"wystukani",
	"wystukiwani",
	"wysuszani",
	"wysuwani",
	"wyswatani",
	"wyświadczani",
	"wyświadczeni",
	"wyświetlani",
	"wyświetleni",
	"wyswobodzeni",
	"wysyłani",
	"wysypani",
	"wysypywani",
	"wysysani",
	"wyszabrowani",
	"wyszalani",
	"wyszarpani",
	"wyszasowani",
	"wyszczotkowani",
	"wyszczupleni",
	"wyszeptani",
	"wyszkoleni",
	"wyszlifowani",
	"wyszorowani",
	"wyszperani",
	"wyszukani",
	"wyszukiwani",
	"wyszumieni",
	"wyszykowani",
	"wytapetowani",
	"wytargani",
	"wytargowani",
	"wytarzani",
	"wytaszczeni",
	"wytatuowani",
	"wytępieni",
	"wytłoczeni",
	"wytłumaczeni",
	"wytłumieni",
	"wytoczeni",
	"wytrąbieni",
	"wytrącani",
	"wytrąceni",
	"wytransmitowani",
	"wytransportowani",
	"wytrenowani",
	"wytresowani",
	"wytriangulowani",
	"wytropieni",
	"wytrząsani",
	"wytrzebieni",
	"wytrzepani",
	"wytrzeszczani",
	"wytrzeźwiani",
	"wytrzymani",
	"wytrzymywani",
	"wytwarzani",
	"wytworzeni",
	"wytyczeni",
	"wytykani",
	"wytypowani",
	"wyuczeni",
	"wywabiani",
	"wywabieni",
	"wywąchani",
	"wywalani",
	"wywalczeni",
	"wywaleni",
	"wywarzani",
	"wyważani",
	"wyważeni",
	"wywęszani",
	"wywężykowani",
	"wywiani",
	"wywiązani",
	"wywiązywani",
	"wywierani",
	"wywierceni",
	"wywieszani",
	"wywieszeni",
	"wywietrzeni",
	"wywiezieni",
	"wywijani",
	"wywindowani",
	"wywłaszczeni",
	"wywlekani",
	"wywnętrznieni",
	"wywnioskowani",
	"wywodzeni",
	"wywolani",
	"wywoływani",
	"wywoskowani",
	"wywożeni",
	"wywracani",
	"wywróceni",
	"wywróżeni",
	"wywyższani",
	"wyżaleni",
	"wyzdrowieni",
	"wyżebrani",
	"wyżerani",
	"wyzerowani",
	"wyznaczani",
	"wyznaczeni",
	"wyznani",
	"wyznawani",
	"wyzwalani",
	"wyzwani",
	"wyzwoleni",
	"wyzygzakowani",
	"wyżynani",
	"wyzyskani",
	"wyzyskiwani",
	"wyzywani",
	"wyżywani",
	"wyżywieni",
	"wzbijani",
	"wzbogacani",
	"wzbogaceni",
	"wzbraniani",
	"wzbudzani",
	"wzbudzeni",
	"wzburzani",
	"wzburzeni",
	"wżenieni",
	"wzmacnieni",
	"wzmagani",
	"wzmocnieni",
	"wznawiani",
	"wzniecani",
	"wzniecieni",
	"wznoszeni",
	"wznowieni",
	"wzorowani",
	"wzruszeni",
	"wzwyżani",
	"wzywani",
	"zaabordowani",
	"zaadaptowani",
	"zaadoptowani",
	"zaadresowani",
	"zaakcentowani",
	"zaakceptowani",
	"zaaklimatyzowani",
	"zaalarmowani",
	"zaanektowani",
	"zaangażowani",
	"zaanonsowani",
	"zaapelowani",
	"zaaplikowani",
	"zaaportowani",
	"zaaprobowani",
	"zaaranżowani",
	"zaaresztowani",
	"zaatakowani",
	"zabaczeni",
	"zabalowani",
	"zabandażowani",
	"zabarwieni",
	"zabarykadowani",
	"zabawiani",
	"zabawieni",
	"zabepieczani",
	"zabetonowani",
	"zabezpieczeni",
	"zabierani",
	"zabłądzeni",
	"zablefowani",
	"zabłoceni",
	"zablokowani",
	"zabraniani",
	"zabrani",
	"zabronieni",
	"zabrudzeni",
	"zabudowani",
	"zabukowani",
	"zabuleni",
	"zaburzeni",
	"zabutelkowani",
	"zacementowani",
	"zacerowani",
	"zachciani",
	"zachęcani",
	"zachęceni",
	"zachlapani",
	"zachodzeni",
	"zachomikowani",
	"zachorowani",
	"zachowani",
	"zachowywani",
	"zachwalani",
	"zachwaleni",
	"zachwiani",
	"zachwyceni",
	"zaciągani",
	"zaciążeni",
	"zaciekawieni",
	"zaciemniani",
	"zaciemnieni",
	"zacierani",
	"zacieśnieni",
	"zacinani",
	"zaciskani",
	"zaćmieni",
	"zacumowani",
	"zacytowani",
	"zaczadzeni",
	"zaczarowani",
	"zaczepiani",
	"zaczepieni",
	"zaczerpani",
	"zaczesani",
	"zaczołgani",
	"zaczynani",
	"zadawalani",
	"zadawani",
	"zadbani",
	"zadebiutowani",
	"zadedykowani",
	"zadeklamowani",
	"zadeklarowani",
	"zademonstrowani",
	"zadenucjowani",
	"zadepeszowani",
	"zadeptani",
	"zadeptywani",
	"zadławieni",
	"żądleni",
	"zadłużani",
	"zadłużeni",
	"zadokowani",
	"zadomowieni",
	"zadowalani",
	"zadrapani",
	"zadręczani",
	"zadręczeni",
	"zadrutowani",
	"zadurzani",
	"zadurzeni",
	"zaduszeni",
	"zadymieni",
	"zadźgani",
	"zadziobani",
	"zadziwiani",
	"zadziwieni",
	"zafakturowani",
	"zafałszowani",
	"zafarbowani",
	"zafiksowani",
	"zafundowani",
	"zagadani",
	"zagadywani",
	"zagajeni",
	"zaganiani",
	"zagapieni",
	"zagarażowani",
	"zagarniani",
	"zagaszeni",
	"zagazowani",
	"zagęszczeni",
	"zaginani",
	"zagłębiani",
	"zagłębieni",
	"zagłodzeni",
	"zagłuszani",
	"zagłuszeni",
	"zagmatwani",
	"zagnani",
	"zagnieżdżeni",
	"zagojeni",
	"zagonieni",
	"zagospodarowani",
	"zagotowani",
	"zagrabieni",
	"zagradzani",
	"zagrażani",
	"zagrodzeni",
	"zagrywani",
	"zagryzani",
	"zagryzieni",
	"zagrzani",
	"zagrzebani",
	"zagrzewani",
	"zagubieni",
	"zagwarantowani",
	"zahaczeni",
	"zahamowani",
	"zahandlowani",
	"zaharowani",
	"zahartowani",
	"zahipnotyzowani",
	"zaholowani",
	"zaimitowani",
	"zaimplantowani",
	"zaimplementowani",
	"zaimprowizowani",
	"zainaugurowani",
	"zainfekowani",
	"zainicjowani",
	"zainkasowani",
	"zainscenizowani",
	"zainspirowani",
	"zainstalowani",
	"zainteresowani",
	"zaintrygowani",
	"zaintubowani",
	"zainwestowani",
	"zaizolowani",
	"zajadani",
	"zajani",
	"zajarani",
	"zajechani",
	"zajmowani",
	"zakablowani",
	"zakamuflowani",
	"zakasani",
	"zakasowani",
	"zakąszani",
	"zakatalogowani",
	"zakatowani",
	"zakatrupieni",
	"zakazani",
	"zakażani",
	"zakazywani",
	"zakiszeni",
	"zakładani",
	"zaklasyfikowani",
	"zaklejani",
	"zaklejeni",
	"zaklepani",
	"zaklepywani",
	"zaklinani",
	"zaklinowani",
	"zakłócani",
	"zakłóceni",
	"zaklopotani",
	"zakneblowani",
	"zakodowani",
	"zakolczykowani",
	"zakolorowani",
	"zakołysani",
	"zakomunikowani",
	"zakończeni",
	"zakonserwowani",
	"zakopani",
	"zakopywani",
	"zakorzeniani",
	"zakorzenieni",
	"zakoszeni",
	"zakosztowani",
	"zakotwiczani",
	"zakotwiczeni",
	"zakpieni",
	"zakradani",
	"zakręcani",
	"zakręceni",
	"zakreślani",
	"zakreśleni",
	"zakrwawieni",
	"zakrywani",
	"zakrzyczani",
	"zakrzywiani",
	"zakrzywieni",
	"zaksięgowani",
	"zaktualizowani",
	"zaktywizowani",
	"zaktywowani",
	"zakumani",
	"zakupieni",
	"zakurzeni",
	"zakuwani",
	"zakwaterowani",
	"załączeni",
	"załadowani",
	"załagodzeni",
	"zalamani",
	"zalaminowani",
	"załamywani",
	"zalani",
	"załapani",
	"załatani",
	"załatwiani",
	"załatwieni",
	"zalatywani",
	"zalecani",
	"zaleceni",
	"zaleczeni",
	"zalegalizowani",
	"zalegani",
	"zalepiani",
	"zalepieni",
	"zalewani",
	"zaliczani",
	"zaliczeni",
	"załkani",
	"zalogowani",
	"żałowani",
	"założeni",
	"zaludnieni",
	"zamacani",
	"zamąceni",
	"zamalowani",
	"zamanewrowani",
	"zamanifestowani",
	"zamarkowani",
	"zamartwiani",
	"zamarynowani",
	"zamarzani",
	"zamaskowani",
	"zamawiani",
	"zamazani",
	"zamazywani",
	"zamęczani",
	"zamęczeni",
	"zameldowani",
	"zamelinowani",
	"zamerykanizowani",
	"zamiatani",
	"zamieniani",
	"zamienieni",
	"zamieszani",
	"zamieszczani",
	"zamieszczeni",
	"zamieszkani",
	"zamieszkiwani",
	"zaminowani",
	"zamocowani",
	"zamoczeni",
	"zamontowani",
	"zamordowani",
	"zamortyzowani",
	"zamotani",
	"zamówieni",
	"zamrażani",
	"zamroczeni",
	"zamrożeni",
	"zamulani",
	"zamurowani",
	"zamydleni",
	"zamykani",
	"zanalizowani",
	"zanegowani",
	"zaniechani",
	"zanieczyszczani",
	"zanieczyszczeni",
	"zaniedbani",
	"zaniedbywani",
	"zaniepokojeni",
	"zaniesieni",
	"zanihilowani",
	"zanikani",
	"zaniżani",
	"zaniżeni",
	"zanoszeni",
	"zanotowani",
	"zanuceni",
	"zanudzani",
	"zanudzeni",
	"zanurzani",
	"zanurzeni",
	"zanużeni",
	"zaobaczeni",
	"zaobserwowani",
	"zaoferowani",
	"zaofiarowani",
	"zaogniani",
	"zaognieni",
	"zaokrąglani",
	"zaokrągleni",
	"zaokrętowani",
	"zaopatrywani",
	"zaopatrzeni",
	"zaopiekowani",
	"zaorani",
	"zaostrzani",
	"zaostrzeni",
	"zaoszczędzeni",
	"zapadani",
	"zapakowani",
	"zapalani",
	"zapaleni",
	"zapamiętani",
	"zapamiętywani",
	"zapanowani",
	"zaparkowani",
	"zaparowywani",
	"zaparzani",
	"zaparzeni",
	"zapaskudzeni",
	"zapauzowani",
	"zapchani",
	"zapędzani",
	"zapełniani",
	"zapełnieni",
	"zaperfumowani",
	"zapeszani",
	"zapewniani",
	"zapewnieni",
	"zapieczętowani",
	"zapierani",
	"zapijani",
	"zapinani",
	"zapisani",
	"zapisuwani",
	"zapłaceni",
	"zapładniani",
	"zaplamieni",
	"zaplanowani",
	"zaplątani",
	"zapłodnieni",
	"zaplombowani",
	"zapobiegani",
	"zapodani",
	"zapodawani",
	"zapodziani",
	"zapokojeni",
	"zapolowani",
	"zapominani",
	"zapomniani",
	"zapowiadani",
	"zapowiedziani",
	"zapoznani",
	"zapoznawani",
	"zapożyczeni",
	"zapracowywani",
	"zaprani",
	"zaprasowywani",
	"zapraszani",
	"zaprawieni",
	"zaprenumerowani",
	"zaprezentowani",
	"Zaprogramowani",
	"zaprojektowani",
	"zaproponowani",
	"zaproszeni",
	"zaprotokołowani",
	"zaprowadzani",
	"zaprowadzeni",
	"zaprzątani",
	"zaprzeczani",
	"zaprzeczeni",
	"zaprzedani",
	"zaprzedawani",
	"zaprzęgani",
	"zaprzepaszczani",
	"zaprzestani",
	"zaprzestawani",
	"zaprzyjaźnieni",
	"zapudłowani",
	"zapunktowani",
	"zapuszczani",
	"zapuszczeni",
	"zapuszkowani",
	"zapychani",
	"zapylani",
	"zapyleni",
	"zapytani",
	"zarabiani",
	"zaranżowani",
	"zarażani",
	"zarażeni",
	"zarecytowani",
	"zaręczani",
	"zaręczeni",
	"zarejestrowani",
	"zareklamowani",
	"zarekomendowani",
	"zarekomondowani",
	"zarekwirowani",
	"zarezerwowani",
	"zarobieni",
	"żartowani",
	"zarwani",
	"zaryglowani",
	"zarymowani",
	"zarysowani",
	"zarywani",
	"zaryzykowani",
	"zarządzani",
	"zarzucani",
	"zarzynani",
	"zasadzeni",
	"zaścieleni",
	"zasegurowani",
	"zaserwowani",
	"zasiadani",
	"zasiani",
	"zasiedleni",
	"zasięgani",
	"zasiewani",
	"zasilani",
	"zasileni",
	"zaskakiwani",
	"zaskarbieni",
	"zaskoczeni",
	"zaskrobani",
	"zasłaniani",
	"zaślepiani",
	"zaślepieni",
	"zasłodzeni",
	"zasłonieni",
	"zasłużeni",
	"zasmakowani",
	"zaśmiecani",
	"zaśmieceni",
	"zasmradzani",
	"zasmrodzeni",
	"zasmucani",
	"zasmuceni",
	"zasoleni",
	"zaspakajani",
	"zaśpiewani",
	"zaspokajani",
	"zaspokojeni",
	"zasponsorowani",
	"zaśrubowywani",
	"zassani",
	"zastani",
	"zastąpieni",
	"zastawiani",
	"zastawieni",
	"zastępowani",
	"zastopowani",
	"zastosowani",
	"zastraszani",
	"zastraszeni",
	"zastrzeleni",
	"zasugerowani",
	"zasuwani",
	"zaświadczeni",
	"zaświeceni",
	"zaświonieni",
	"zasyfieni",
	"zasygnalizowani",
	"zasymilowani",
	"zasymulowani",
	"zasypani",
	"zasypywani",
	"zasysani",
	"zaszachowani",
	"zaszantażowani",
	"zaszargani",
	"zaszczepiani",
	"zaszczepieni",
	"zaszczycani",
	"zaszczyceni",
	"zaszeptani",
	"zaszeregowani",
	"zaszlachtowani",
	"zasznurowani",
	"zaszpachlowani",
	"zasztyletowani",
	"zaszufladkowani",
	"zaszyfrowani",
	"zaszywani",
	"zataczani",
	"zatajani",
	"zatajeni",
	"zatamowani",
	"zatankowani",
	"zatapiani",
	"zatargani",
	"zatelegrafowani",
	"zatemperowani",
	"zatęsknieni",
	"zatkani",
	"zatoczeni",
	"zatopieni",
	"zatracani",
	"zatraceni",
	"zatriumfowani",
	"zatrudniani",
	"zatrudnieni",
	"zatruwani",
	"zatrzaskiwani",
	"zatrzymani",
	"zatrzymywani",
	"zatuszowani",
	"zatwierdzani",
	"zatwierdzeni",
	"zatykani",
	"zatynkowani",
	"zatytułowani",
	"zauploadowani",
	"zauroczeni",
	"zautomatyzowani",
	"zauważani",
	"zauważeni",
	"zawadzani",
	"zawalani",
	"zawalczeni",
	"zawaleni",
	"zaważeni",
	"zawdzięczani",
	"zawetowani",
	"zawężeni",
	"zawiadamiani",
	"zawiadomieni",
	"zawiązani",
	"zawiązywani",
	"zawiedzeni",
	"zawierani",
	"zawierzeni",
	"zawieszani",
	"zawieszeni",
	"zawiezieni",
	"zawijani",
	"zawinieni",
	"zawitani",
	"zawłaszczeni",
	"zawodzeni",
	"zawojowani",
	"zawołani",
	"zawoskowani",
	"zawożeni",
	"zawracani",
	"zawróceni",
	"zawstydzani",
	"zażądani",
	"zażartowani",
	"zazdroszczeni",
	"zażegnani",
	"zażenowani",
	"zaznaczani",
	"zaznajomieni",
	"zaznani",
	"zaznawani",
	"zażyczeni",
	"zażywani",
	"zbaczani",
	"zbadani",
	"zbagatelizowani",
	"zbajerowani",
	"zbałamuceni",
	"zbalansowani",
	"zbalsamowani",
	"zbankrutowani",
	"zbawiani",
	"zbawieni",
	"zbesztani",
	"zbezczeszczeni",
	"zbierani",
	"zbijani",
	"zbliżeni",
	"zbluzgani",
	"zbojkotowani",
	"zbrojeni",
	"zbrukani",
	"zbszczeceni",
	"zbudowani",
	"zbudzeni",
	"zbuntowani",
	"zburzeni",
	"zbywani",
	"zchwytani",
	"zciszeni",
	"zdani",
	"zdeaktywowani",
	"zdecydowani",
	"zdefiniowani",
	"zdeflorowani",
	"zdegradowani",
	"zdejmowani",
	"zdeklarowani",
	"zdekodowani",
	"zdekompresowani",
	"zdekoncentrowani",
	"zdekonstruowani",
	"zdelegalizowani",
	"zdemaskowani",
	"zdementowani",
	"zdemolowani",
	"zdemontowani",
	"zdemoralizowani",
	"zdenerwowani",
	"zdeponowani",
	"zdeprymowani",
	"zdeptani",
	"zderzani",
	"zderzeni",
	"zdestabilizowani",
	"Zdetonowani",
	"zdetronizowani",
	"zdewastowani",
	"zdewaulowani",
	"zdezerterowani",
	"zdezintegrowani",
	"zdezorientowani",
	"zdezynfektowani",
	"zdiagnozowani",
	"zdławieni",
	"zdmuchiwani",
	"zdobywani",
	"zdołowani",
	"zdominowani",
	"zdopingowani",
	"zdrabniani",
	"zdradzani",
	"zdradzeni",
	"zdrapani",
	"zdrapywani",
	"zdrutowani",
	"zdruzgotani",
	"zduplikowani",
	"zduszeni",
	"zdwojeni",
	"zdyscyplinowani",
	"zdyskredytowani",
	"zdyskwalifikowani",
	"zdystansowani",
	"zdzieleni",
	"zdzierani",
	"zdzierżeni",
	"zdziesiątkowani",
	"zdzwonieni",
	"zebrani",
	"zechciani",
	"zedytowani",
	"żegnani",
	"żenieni",
	"żerowani",
	"zerwani",
	"zeskakiwani",
	"zeskanowani",
	"zeskrobywani",
	"zesłani",
	"ześlizgiwani",
	"zesmoleni",
	"zespawiani",
	"zespoleni",
	"zessani",
	"zestawiani",
	"zestawieni",
	"zestresowani",
	"zestrzeliwani",
	"zestrzeleni",
	"zeswatani",
	"zeszkleni",
	"zeszlifowani",
	"zezłoszczeni",
	"zeznani",
	"zeznawani",
	"zezwalani",
	"zezwoleni",
	"zfinansowani",
	"zgadani",
	"zgadywani",
	"zgajani",
	"zganieni",
	"zgaszeni",
	"zginani",
	"zgładzeni",
	"zgłaszani",
	"zgłębiani",
	"zgłębieni",
	"zgłośnieni",
	"zgłoszeni",
	"zgłuszeni",
	"zgniatani",
	"zgniecieni",
	"zgnojeni",
	"zgodzeni",
	"zgoleni",
	"zgonieni",
	"zgotowani",
	"zgrabieni",
	"zgrillowani",
	"zgromadzani",
	"zgromadzeni",
	"zgrupowani",
	"zgrzeszeni",
	"zgrzytani",
	"zgubieni",
	"zgwałceni",
	"zhackowani",
	"zhakowani",
	"zhańbieni",
	"zhandlowani",
	"zharmonizowani",
	"zidentyfikowani",
	"ziewani",
	"zignorowani",
	"zilustrowani",
	"zinfiltrowani",
	"zintegrowani",
	"zintensyfikowani",
	"zinterpretowani",
	"zinwentaryzowani",
	"zirytowani",
	"zjadani",
	"zjawiani",
	"zjednani",
	"zjednoczeni",
	"zjedzeni",
	"zjeżdżeni",
	"zkontaktowani",
	"zkserowani",
	"złączeni",
	"złagodzeni",
	"złajani",
	"złamani",
	"zlani",
	"złapani",
	"zlecani",
	"zleceni",
	"zlekceważeni",
	"zlepiani",
	"zlepieni",
	"zlewani",
	"zlicytowani",
	"zliczani",
	"zliczeni",
	"zlikwidowani",
	"zlinczowani",
	"zlitowani",
	"zlizani",
	"zlizywani",
	"zlokalizowani",
	"złomowani",
	"żłopani",
	"złowieni",
	"złożeni",
	"złupieni",
	"złuszczani",
	"zluzowani",
	"zmacani",
	"zmąceni",
	"zmagani",
	"zmagazynowani",
	"zmajstrowani",
	"zmaksylizowani",
	"zmanipulowani",
	"zmarnowani",
	"zmartwychwstani",
	"zmasakrowani",
	"zmaterializowani",
	"zmawiani",
	"zmazani",
	"zmazywani",
	"zmbobardowani",
	"zmiatani",
	"zmiażdżeni",
	"zmiękczeni",
	"zmieleni",
	"zmieniani",
	"zmienieni",
	"zmierzani",
	"zmierzeni",
	"zmierzwieni",
	"zmieszani",
	"zmieszczeni",
	"zmiksowani",
	"zminiaturyzowani",
	"zminimalizowani",
	"zmniejszani",
	"zmniejszeni",
	"zmobilizowani",
	"zmoczeni",
	"zmodernizowani",
	"zmodyfikowani",
	"zmonopolizowani",
	"zmontowani",
	"zmostkowani",
	"zmotywowani",
	"zmówieni",
	"zmrożeni",
	"zmrużeni",
	"zmumifikowani",
	"zmuszani",
	"zmuszeni",
	"zmutowani",
	"zmyślani",
	"zmywani",
	"znacjonalizowani",
	"znajdowani",
	"znajdywani",
	"znakowani",
	"znalezieni",
	"znani",
	"znęcani",
	"zneutralizowani",
	"zniechęceni",
	"znieczuleni",
	"zniekształcani",
	"zniekształceni",
	"znienawidzeni",
	"znieprawieni",
	"zniesieni",
	"zniesławiani",
	"zniesławieni",
	"zniewalani",
	"znieważani",
	"znieważeni",
	"zniewoleni",
	"zniszczeni",
	"zniweczeni",
	"zniwelowani",
	"zniżani",
	"zniżeni",
	"znokautowani",
	"znormalnieni",
	"znoszeni",
	"znudzeni",
	"zobaczeni",
	"zobowiązani",
	"zobrazowani",
	"zogniskowani",
	"żonglowani",
	"zoomowani",
	"zoperowani",
	"zoptymalizowani",
	"zorganizowani",
	"zorientowani",
	"zostawiani",
	"zostawieni",
	"zpłaceni",
	"zprowokowani",
	"zrabowani",
	"zrachowani",
	"zracjonalizowani",
	"zranieni",
	"zraportowani",
	"zrażani",
	"zrażeni",
	"zrealizowani",
	"zrecenzowani",
	"zredagowani",
	"zredukowani",
	"zreferowani",
	"zreformowani",
	"zrefowani",
	"zrefundowani",
	"zregenerowani",
	"zrehabilitowani",
	"zreinkarnowani",
	"zreintegrowani",
	"zrekonfigurowani",
	"zrekonstruowani",
	"zrekrutowani",
	"zrekrystalizowani",
	"zrelacjonowani",
	"zrelaksowani",
	"zremiksowani",
	"zremisowani",
	"zreorganizowani",
	"zreperowani",
	"zreplikowani",
	"zresetowani",
	"zresocjalizowani",
	"zrestartowani",
	"zrestrukturyzowani",
	"zrewanżowani",
	"zrewidowani",
	"zrewolucjenizowani",
	"zrezygnowani",
	"zrobieni",
	"zrolowani",
	"zroszeni",
	"zrównani",
	"zrównoważeni",
	"zrównywani",
	"zróżnicowani",
	"zrozumiani",
	"zrugani",
	"zruinowani",
	"zrujnowani",
	"zrymowani",
	"zrywani",
	"zrzędzeni",
	"zrzeszeni",
	"zrzucani",
	"zrzuceni",
	"zsumowani",
	"zsuwani",
	"zsynchronizowani",
	"zsyntetyzowani",
	"zsypywani",
	"zszargani",
	"zszokowani",
	"zszywani",
	"zutylizowani",
	"zużywani",
	"zwabiani",
	"zwabieni",
	"zwalani",
	"zwalczeni",
	"zwalniani",
	"zwaleni",
	"zwani",
	"zwaporyzowani",
	"zwątpieni",
	"zważani",
	"zważeni",
	"zwędzeni",
	"zwerbalizowani",
	"zwerbowani",
	"zweryfikowani",
	"zwęszeni",
	"zwężeni",
	"zwiastowani",
	"związani",
	"związywani",
	"zwiedzani",
	"zwiedzeni",
	"zwiększeni",
	"zwieńczeni",
	"zwierzani",
	"zwieszani",
	"zwieszeni",
	"zwietrzeni",
	"zwijani",
	"zwilżeni",
	"zwizualizowani",
	"zwlekani",
	"zwodowani",
	"zwodzeni",
	"zwołani",
	"zwolnieni",
	"zwoływani",
	"zwożeni",
	"zwracani",
	"zwróceni",
	"zwyciężani",
	"zwymiotowani",
	"życzeni",
	"żygani",
	"zygzakowani",
	"zyskani",
	"zyskiwani",
	"zżerani",
	"zżynani",
	"konsakrowany",
	"konsakrowana",
	"konsakrowane",
	"konsakrowani",
];
